webpackJsonp([1],{

/***/ 170:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAACCAYAAACpDacGAAAAAXNSR0IArs4c6QAAABxJREFUCB1jZPjvaM/A8N+BgeaA8QATze1AsgAAnrEDg9H2nR0AAAAASUVORK5CYII="

/***/ }),

/***/ 269:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(690)
}
var Component = __webpack_require__(46)(
  /* script */
  __webpack_require__(336),
  /* template */
  __webpack_require__(719),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7773b796",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 294:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(182);




__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

var state = {
  count: 10,
  language: 'en',
  langs: [{ lang: true, ab: 'en' }, { lang: false, ab: 'zh' }, { lang: false, ab: 'fr' }, { lang: false, ab: 'de' }, { lang: false, ab: 'sw' }, { lang: false, ab: 'en' }, { lang: false, ab: 'hk' }, { lang: false, ab: 'en' }, { lang: false, ab: 'it' }, { lang: false, ab: 'du' }, { lang: false, ab: 'en' }, { lang: false, ab: 'po' }, { lang: false, ab: 'es' }, { lang: false, ab: 'tr' }, { lang: false, ab: 'en' }, { lang: false, ab: 'en' }, { lang: false, ab: 'cz' }, { lang: false, ab: 'en' }, { lang: false, ab: 'en' }, { lang: false, ab: 'pl' }, { lang: false, ab: 'dk' }, { lang: false, ab: 'fi' }, { lang: false, ab: 'en' }, { lang: false, ab: 'en' }, { lang: false, ab: 'en' }, { lang: false, ab: 'en' }, { lang: false, ab: 'en' }, { lang: false, ab: 'en' }, { lang: false, ab: 'en' }, { lang: false, ab: 'en' }, { lang: false, ab: 'en' }, { lang: false, ab: 'en' }, { lang: false, ab: 'en' }, { lang: false, ab: 'en' }, { lang: false, ab: 'en' }, { lang: false, ab: 'en' }, { lang: false, ab: 'en' }, { lang: false, ab: 'en' }, { lang: false, ab: 'en' }, { lang: false, ab: 'en' }],
  country: [true, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false],
  users: [],
  header: false,
  patientName: '',

  DataS: [],
  DataSG: [],
  DataBasal: [],
  DataBolus: [],

  DataD: [],
  olDataSG: [],

  settingData: {},
  sessions: [],

  sensor: {},
  pump: {},
  compileTimeout1: '',

  events: [],
  Request: [],

  alarm_display: 'Off',
  unRead: 0,
  patientPage: 0

};

var mutations = {
  changLanguage: function changLanguage(context, info) {
    context.langs.map(function (e, i) {
      if (i === info[1]) {
        e.lang = true;
        context.language = e.ab;
        if (info[2] === 1) {
          localStorage.setItem('language', e.ab);
        }
        sessionStorage.setItem('language', e.ab);
      } else {
        e.lang = false;
      }
      return e;
    });
    for (var i = 0; i < context.country.length; i++) {
      context.country[i] = i === info[0] ? true : false;
    }

    if (info[2] === 1) {
      localStorage.setItem('index', info[0]);
      localStorage.setItem('languageIndex', info[1]);
    }
  },
  updatePatientPage: function updatePatientPage(context, data) {
    context.patientPage = data;
  },
  updateUsers: function updateUsers(context, data) {
    context.users = data;
    sessionStorage.setItem('users', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
  },
  updateDataS: function updateDataS(context, data) {
    context.DataS = data;
  },
  updateDataSG: function updateDataSG(context, data) {
    context.DataSG = data;
  },
  updateOlDataSG: function updateOlDataSG(context, data) {
    context.olDataSG = data;
  },
  updateBasal: function updateBasal(context, data) {
    context.DataBasal = data;
  },
  updateBolus: function updateBolus(context, data) {
    context.DataBolus = data;
  },
  updateDataD: function updateDataD(context, data) {
    context.DataD = data;
  },
  updatePatientName: function updatePatientName(context, data) {
    context.patientName = data;
  },
  updateUnRead: function updateUnRead(context, data) {
    context.unRead = data;
  },
  updateAlarm: function updateAlarm(context, data) {
    context.alarm_display = data;
  },
  updateRequest: function updateRequest(context, data) {
    if (!data) {
      context.Request = [];
    } else {
      context.Request.push(data);
    }
  },
  updateEvents: function updateEvents(context, data) {
    context.events = data;
  },
  updateSensor: function updateSensor(context, data) {
    context.sensor = data;
  },
  updatePump: function updatePump(context, data) {
    context.pump = data;
  },
  updateSettingData: function updateSettingData(context, data) {
    context.settingData = data;
  },
  updateSessions: function updateSessions(context, data) {
    context.sessions = data;
    sessionStorage.setItem('sessions', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
  }
};

var actions = {
  add: function add(_add) {
    _add.commit('add');
  },
  oddAdd: function oddAdd(_ref) {
    var commit = _ref.commit,
        state = _ref.state;

    if (state.count % 2 === 0) {
      commit('add');
    }
  }
};

var getters = {
  count: function count(context) {
    return context.count;
  },
  getOdd: function getOdd(context) {
    return context.count % 2 === 0 ? '偶数' : '奇数';
  }
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}));

/***/ }),

/***/ 295:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return zhMessages; });
var zhMessages = {
  "Raw data": "数据",
  "Data Export": "导出数据",
  "Data Export Settings": "导出数据设置",
  "Select data to export": "导出数据选择",
  "Bolus": "大剂量",
  "Basal": "基础量",
  "Events": "事件",
  "Device Settings": "设备设置",
  "BG Export": "指尖血糖",

  "country_region": "国家/地区",

  "privacy_policy_and_terms_of_use": "隐私政策和服务协定",
  "privacy_confirm_text": "我们最近更新了<a href='https://www.medtrum.com/privacy_pilicy.html' target='_blank'>隐私政策</a>和<a href='https://www.medtrum.com/terms_of_use.html' target='_blank'>服务协定</a>。请仔细阅读，同意并接受全部条款后再使用EasyView</p>",
  "privacy_confirm_disagree": "不同意",
  "privacy_confirm_accept": "接受",

  "title": "EasyView Personal",
  "title1": "EasyView Pro",
  "user": "邮箱",
  "password": "密码",
  "remember": "记住密码",
  "forget": "忘记密码？",
  "sign in": "登录",
  "login": "登录",
  "sign up now": "立即注册",
  "apply": "立即申请账号",
  "contact us": "联系我们",
  "Privacy Policy": "隐私政策",
  "Terms of Use": "服务协议",
  "copyright": "2021，上海移宇科技有限公司，保留所有权利。",

  "chooseLang": "选择国家/地区和语言",
  "asia": "亚洲",
  "europe": "欧洲",
  "middleEast": "中东",

  "applyHcp": "申请HCP账号",
  "sign up": "注册",
  "Patient": "患者",
  "Caregiver": "监护人",
  "Email": "邮箱/用户名",
  "Mobile": "手机",
  "Enter email": "输入邮箱地址",
  "Enter mobile": "输入手机号",
  "Verification": "验证码",
  "Invitation": "邀请码",
  "full name": "输入真实姓名",
  "Enter pass": "输入密码",
  "org": "组织机构",
  "Register": "注册",
  "createAccount": "创建账户",
  "send": "发送",
  "agree": "我已阅读并同意此Medtrum的 ",
  "privacy": "隐私政策",
  "and": "及 ",
  "use": "服务协议",
  "errtip1-1": "您的邮箱地址将会成为您的用户名，",
  "errtip1-2": " 请输入有效的邮箱地址",
  "errtip2": "请输入正确的手机号",
  "errtip3": "验证码输入错误",
  "errtip4": "邀请码错误",
  "errtip5": "未输入姓名",
  "errtip6": "你的密码必须不少于6位",
  "errtip7": "请输入您的组织机构",

  "errp1": "密码必须由至少三种字符组成:",
  "errp2": "大写字母、小写字母、数字或特殊字符",
  "errp3": "密码长度为6~20个字符",
  "errp4": "密码不能使用用户名",
  "errp5": "不能有三个以上连续的数字(如:123,321)",
  "errp6": "不能有三个以上连续的字母(如:abc,cba)",
  "errp7": "不能包含空格",

  "Find account": "找回密码",
  "Enter username": "请输入用户名",
  "Next": "下一步",
  "Cancel": "取消",
  "Back": "返回",
  "Enter veri": "请输入验证码",
  "Create new": "创建新密码",
  "Verify notice": "请输入您邮箱/手机中Medtrum公司发送的验证码",
  "Create new notice": "请输入6位新密码",
  "New pass": "新密码",
  "Completed": "完成",
  "Created": "新密码已创建.",
  "Login Now": "立即登录",

  "Delete": "删除",
  "New Patient": "添加患者",
  "Add Patient": "查找患者",
  "Filter": "筛选",
  "Name": "姓名",
  "Gender": "性别",
  "Age": "年龄",
  "Type": "糖尿病类型",
  "Duration": "病龄",
  "Connections": "账号创建者",
  "UploadTime": "上传时间",
  "Year": "年",
  "Years": "年龄",
  "Month": "月",
  "Month2": "月",
  "Months": "月",
  "Invite": "邀请",
  "Invited": "已邀请",
  "All": "全部",
  "Female": "女性",
  "Male": "  男",
  "Not Set": "未填写",
  "Type 1": "类型 1",
  "Type 2": "类型 2",
  "Gestational": "妊娠糖尿病",
  "Prediabetes": "糖尿病前期",
  "LADA": "成人隐匿性免疫性糖尿病",
  "Apply": "保存",
  "addP": "添加患者",
  "newP": "新建患者",
  "findP": "查找患者",
  "disUn": "糖尿病类型 未填写",
  "ageUn": "未填写年龄",
  "genUn": "未填写性别",
  "GDRNF": "未填写",
  "GDRF": "女",
  "GDRM": "男",
  "女": "男性",

  "DBTNF": "未填写",
  "DBT1": "类型 1",
  "DBT2": "类型 2",
  "DBTLADA": "LADA",
  "DBTPRE": "前期",
  "DBTGEST": "DBTGEST",
  "前期": "前期",
  "beFore": "前期",
  "MODY": "其他",

  "No selection": "未填写",
  "unspecif": "未填写",
  "register": "患者",
  "hcp": "医生",

  "BG": "血糖值",
  "CARB": "食物",
  "INS": "胰岛素注射",
  "EXR": "运动",
  "OTR": "其他",
  "HBA1C": "HbA1c",
  "DOSE": "药物",
  "URINEK": "尿酮",
  "HEL": "HEL",
  "OTR1": "其他",
  "Loading": "加载中",

  "home": "首页",
  "pID": "患者编号",
  "fullName": "姓名",
  "gender": "性别",
  "height": "高",
  "weight": "体重",
  "cm": "厘米",
  "kg": "千克",
  "birthday": "出生日期",
  "disType": "糖尿病类型",
  "disDate": "确诊日期",
  "Address": "地址",
  "Postcode": "邮编",
  "Inpatient": "住院信息",
  "Yes": "是",
  "No": "否",
  "Pno": "住院编号",
  "Bno": "床位编号",
  "create": "创建",
  "Telephone": "座机",

  "enterU": "输入用户名（邮箱/手机号）",
  "search": "搜索",
  "noU": "未输入用户名",
  "searchR": "搜索结果",
  "uername": "用户名",
  "alias": "昵称",
  "remove": "移除",
  "viewG": "查看图表",
  "sendR": "发送请求",
  "rSent": "请求已发送",
  "cancelR": "取消申请监护的患者",
  "VcodeTip1": "验证码已发送到 ",
  "VcodeTip2": "中，请等待一分钟，若仍然未收到，请点击",
  "VcodeTip3": "重试",
  "Entercode": "输入验证码",
  "Getcode": "获取验证码",

  "messages": "消息",
  "profile": "个人信息",
  "sign out": "退出",
  "changeP": "修改密码",
  "connection": "联系人",

  "myP": "个人信息",
  "Portrait": "头像",
  "Profession": "职业",
  "DPRONF": "未填写",
  "DPROENDOCRIN": "内分泌医师",
  "DPRODIABTRA": "糖尿病护理教育者",
  "DPRONURSE": "护理医师",
  "DPRODIATIT": "营养师",
  "DPROOTR": "其他医疗服务人员",
  "Organization": "组织机构",
  "Bio": "简介",
  "save": "保存",
  "oldPa": "旧密码",
  "newPa": "新密码",
  "RePa": "确认密码",
  "forgetY": "忘记密码",
  "applyM": "应用",
  "oldErr": "旧密码错误。",
  "EntTheSame": "再次输入新密码。",
  "EnterOld": "输入旧密码",

  "pList": "患者列表",
  "connections": "患者列表",
  "settings": "设置",
  "monitor": "实时监控",
  "graphs": "报告",
  "events": "事件",
  "records": "病程记录",
  "qPrint": "快速打印",

  "sensorIn": "血糖信息",
  "timeOfLaRead": "最近血糖更新时间",
  "tranSn": "发射器序列号",
  "status": "状态",
  "sensorLife": "血糖探头剩余使用时间",
  "lastSenorRead": "最近血糖读数",
  "TranBattery": "发射器电量",
  "sg": "血糖",
  "alert": "告警",
  "target": "目标范围",
  "hypo": "低限",
  "sensorGlucose": "血糖读数",
  "calib": "校准",
  "newSen": "新探头",
  "warm": "初始化",
  "InsulinPump": "胰岛素泵",
  "timeOfLaPump": "最近一次泵数据更新时间",
  "pumpSN": "泵体控制器序列号",
  "ReserviorLife": "储药贴剩余时间",
  "InsulinLeft": "胰岛素剩余量",
  "basal": "基础量",
  "bolus": "大剂量",
  "totalBasal": "基础量总量",
  "lastBolus": "最近大剂量",
  "activeInsulin": "活性胰岛素",
  "totalBolus": "大剂量总量",
  "tampBasal": "临时基础量",
  "normalBolus": "正常大剂量",
  "extendBolus": "扩展大剂量",
  "manualStop": "手动暂停",
  "autoStop": "自动暂停",
  "auto suspend": "自动暂停",
  "stop": "输注停止",
  "newPatch": "新储药贴",
  "tempBasal": "临时基础量",
  "N": "正",
  "E": "扩",
  "CN1": "组正",
  "CE": "组扩",

  "staticSettings": "报告设置",
  "dataSource": "数据源",
  "unit": "单位",
  "glucoseTarget": "血糖目标范围",
  "overall": "总计",
  "Hypoglycemia": "低于3.1mmol/L（56mg/dL）",
  "timePeriod": "时间段",
  "postMeal": "餐后分析",
  "Breakfast": "早餐",
  "Lunch": "中餐",
  "Dinner": "晚餐",
  "night": "夜间",
  "Before": "前",
  "After": "后",
  "Low": "低限",
  "High": "高限",
  "From": "开始",
  "To": "结束",
  "Hours": "小时",
  "Reset": "恢复默认设置",
  "RealTime": "实时",
  "uploaded": "上传",
  "sensor": "血糖探头",
  "pdmSN": "手持机序列号",
  "startTime": "开始时间",
  "endTime": "结束时间",
  "uploadTime": "上传时间",
  "pdm": "手持机",
  "Uploaded": "上传",
  "Patch Pump": "贴片泵",
  "overLapp": "时间段重叠",
  "showAlert": "显示告警",

  "dashboard": "综合报表",
  "dboard_glucose_statistics": "统计",
  "dboard_glucose": "指尖血糖",
  "dboard_cgm": "动态血糖",
  "dboard_insulin": "胰岛素",
  "dboard_carbs": "食物",
  "dboard_exercise": "运动",
  "dboard_glucose_avg": "平均值",
  "dboard_cgm_avg": "平均值",
  "dboard_insulin_avg": "平均每天输注的胰岛素",
  "dboard_carbs_avg": "平均每天摄入量",
  "dboard_exercise_avg": "平均每天运动时间",
  "dboard_sd": "标准方差",
  "dboard_num": "次数",
  "dboard_num_days": "# days",
  "dboard_statistics": "统计",
  "dboard_BG": "血糖值",
  "dboard_BG_calibration": "BG/校准（每天）",
  "dboard_SG": "动态血糖值",
  "dboard_AUC_high": "AUC高 >",
  "dboard_AUC_low": "AUC低 <",
  "dboard_highest_value": "最高价值",
  "dboard_lowest_value": "最低价值",

  "dboard_pump": "泵",
  "dboard_avg_daily_dose": "平均每天输注的胰岛素",
  "dboard_SD": "标准方差",
  "dboard_daily_basal": "每日基础量",
  "dboard_daily_bolus": "每日大剂量",
  "dboard_avg_bolus_num": "平均每天输注大剂量次数",
  "dboard_avg_suspend_time": "平均暂停时间",
  "dboard_avg_reservoir_usage": "储药贴平均寿命",
  "dboard_days": "days",

  "dboard_manual_bolus": "手动大剂量（数量/次数）",
  "dboard_normal": "-正常",
  "dboard_extend": "-扩展",
  "dboard_combo": "-组合",

  "dboard_bolus_calculator": "大剂量向导（数量/次数）",
  "dboard_food_bolus": "-食物大剂量",
  "dboard_corr_bolus": "-校正大剂量",
  "dboard_override_add": "-向上调整(+)",
  "dboard_override_sub": "-向下调整(-)",

  "dboard_report": "综合报表报告",

  "daily": "每日总结",
  "date": "日期",
  "print": "打印",
  "carbs": "食物",
  "exercise": "运动",
  "heavy": "剧烈",
  "Medium": "中度",
  "Light": "轻度",
  "dailyReport": "每日总结报告",
  "devices": "设备",
  "tran": "发射器",
  "pumpBase": "泵体控制器",
  "HbA1c": "糖化血红蛋白",
  "statics": "统计",
  "glucose": "血糖",
  "item": "项",
  "BG1": "指尖血糖",
  "SG1": "血糖",
  "avgSD": "平均值(mmol/L)±标准差",
  "avgSD1": "平均值±标准差",
  "min": "最小值",
  "max": "最大值",
  "ofRead": "读数",
  "ofHypo": "低血糖次数/持续时间",
  "ofAlert": "告警次数",
  "insulin": "胰岛素",
  "insulin2": "胰岛素",
  "totalDose": "全天输注总量",
  "foodBolus": "食物大剂量",
  "Food+coor": "食物和校正大剂量",
  "calibBolus": "校正大剂量",
  "durationStop": "暂停输注时间(分钟)",
  "ofPumpAlert": "泵告警次数",
  "ofMeal": "进餐次数",
  "totalExerTime": "运动总时间",
  "exerNum": "运动次数",
  "avgInten": "平均强度",
  "target1": "目标范围",
  "high1": "高",
  "low1": "低",
  "BG Reading": "指尖血糖读数",

  "dayByday": "多日浏览",
  "dayBydayRe": "多日总结报告",
  "period": "时间段",

  "sensorOverlay": "血糖叠加图",
  "set": "设置",
  "setPeriod": "设置时间段",
  "Weekdays": "工作日",
  "Weekends": "周末",
  "Mon": "星期一",
  "Tue": "星期二",
  "Wed": "星期三",
  "Thur": "星期四",
  "Thu": "星期四",
  "Fri": "星期五",
  "Sat": "星期六",
  "Sun": "星期日",
  "Average": "平均值",
  "sensorOlRe": "血糖叠加图报告",
  "Avg": "平均值",
  "±SD": "±标准差",
  "ofhypo": "低血糖次数",
  "Everyday": "每天",

  "TrendAna": "趋势分析",
  "TrendRe": "趋势分析报告",
  "sensorGlu": "血糖探头读数",
  "ofBGtest": "指尖血糖读数（次数）",
  "Basics": "基本统计",
  "static": "统计",
  "Med": "中位数",
  "med": "中位数",
  "Q1": "1/4分位",
  "Q3": "3/4分位",
  "Q11": "1/4分位数",
  "Q31": "3/4分位数",
  "IQR": "四分位距",
  "SD": "标准差",
  "CV": "变异系数",
  "SE1": "均值标准误差",
  "distri": "分布",
  "stab": "稳定性",
  "#high": "#偏高",
  "#low": "#偏低",
  "aucBelow": "低限线下积分",
  "aucAbove": "高限线下积分",
  "bgRead": "指尖血糖读数",
  "total": "总量",
  "ofBolus": "大剂量次数",
  "avgBolus": "大剂量平均值",
  "Dura1": "运动（分）",
  "Avg/Total": "平均值/总计",
  "high": "高",
  "low": "低限",
  "#hypo": "低血糖次数",
  "ofExer": "运动次数",

  "logbook": "日志",
  "dailyTotal": "全天总量",
  "High Glucose": "血糖高",
  "Low Glucose": "血糖低",
  "No Active Patch": "无激活储药贴",
  "Missed Meal": "错过用餐时间",
  "Multiple BG Readings": "多个指尖血糖读数",
  "Stop Patch": "储药贴终止",
  "Others": "其他",
  "Other Events": "其他事件",
  "logRe": "日志报告",

  "DeviceSetting": "设备设置报告",
  "Insulin Pump": "胰岛素泵",
  "MaxBasalRate": "基础量最大值",
  "BasalPatterns": "基础量程序",
  "Selected Basal Pattern": "激活的基础量程序",
  "Maximum Bolus": "大剂量最大值",
  "Combo/Extended Bolus": "组合/扩展大剂量",
  "BG Reminder": "指尖血糖提醒",
  "Bolus Increment": "大剂量步长",
  "Bolus Calculator": "大剂量向导",
  "Active Insulin Time": "活性胰岛素",
  "IC Ratios": "胰岛素食物比",
  "Insulin Sensitivity": "胰岛素灵敏度",
  "BG Target": "目标血糖",
  "Bolus Reminder": "大剂量提醒",
  "CGM": "动态血糖",
  "CGM System": "动态血糖系统",
  "Glucose Unit": "血糖单位",
  "Glucose Limits": "血糖门限",
  "Predicitive Alerts": "血糖异常预测告警",
  "Rate Alerts": "血糖变化异常告警",
  "type": "类型",
  "time": "时间",
  "data": "数据",
  "Rate": "速率",
  "Calibration Reminder": "校准提醒",
  "Calibration Repeat": "校准重复告警",
  "Snooze": "重复告警间隔",
  "Audio Options": "声音选项",
  "Confidence Reminder": "指令响应提示",
  "Backlight": "背光",
  "Sec": "秒",
  "Alarm Clock": "闹钟",
  "Patch Expiration": "储药贴过期告警",
  "Sensor Expiration": "探头过期告警",
  "Hourly Max": "每小时最大输注量",
  "Daily Max": "每天最大输注总量",
  "Low Reservoir": "低储药量告警",
  "Low Suspend": "低血糖暂停输注",
  "Predictive Low Suspend": "预测低血糖暂停输注",
  "Rise": "上升",
  "Fall": "下降",
  "Auto Off": "自动暂停输注",
  "Standard": "标准",
  "Exercise": "锻炼",
  "Holiday": "假日",
  "ProgramA": "程序A",
  "ProgramB": "程序B",
  "--": "--",
  "Insulin": "胰岛素",

  "SUSA": "自动暂停输注告警",
  "SUSHM": "超出每小时最大量暂停输注",
  "SUSDM": "超出每天最大量暂停输注",
  "SUSLSG": "低血糖暂停输注",
  "SUSPLSG": "预测低血糖暂停输注",
  "Pump Restarted": "贴片泵重启",
  "Meter BG Now": "立即输入指尖血",
  "Sensor Exp in 2 Hours": "探头2小时内过期",
  "Sensor Exp in 6 Hours": "探头6小时内过期",
  "Sensor Exp in 30 Min": "探头30分钟内过期",
  "Sensor Calibration Error": "探头校准错误",
  "Sensor Error": "无血糖读数",

  "Device Settings Report": "设备设置报告",
  "Device Settings at": "设备设置时间",
  "24h Total": "24小时总量",
  "Start": "开始",
  "Combo/Ext Bolus": "组合/扩展大剂量",
  "Time Format": "时间制",
  "Device Options（CGM System)": "动态血糖系统",
  "Device Options（Insulin Pump)": "胰岛素泵系统",
  "Dispay Settings (Screen)": "显示（屏幕）",
  "Dispay Settings (Backlight)": "显示（背光）",
  "Graph Range": "血糖趋势图显示",
  "Range": "范围",
  "Repeat": "模式",
  "Glucose Alerts": "血糖告警",
  "Alert Silence": "血糖告警静音",

  "Create": "添加",
  "Event Filter": "筛选",
  "HbA1c1": "糖化血红蛋白",
  "Urine Ketone": "尿酮",
  "Injection": "胰岛素注射",
  "Other": "其他",
  "Event Type": "事件类型",
  "Details": "详情",
  "Notes": "备注",
  "Source": "来源",
  "edit": "编辑",
  "Action": "操作",
  "EventReport": "事件汇总报告",
  "By Date": "按日期",
  "By Category": "按项目",
  "Event Summary": "事件汇总",
  "No data": "无数据",
  "No1": "无",
  "data1": "数据",
  "#": "次数",
  "BG Summary": "指尖血糖统计",
  "Carbs Summary": "食物统计",
  "Injection Summary": "胰岛素注射统计",
  "Exercise Summary": "运动统计",
  "Input Notes": "输入备注",

  "Profile": "个人信息",
  "Complications": "并发症",
  "Concomitant diseases": "伴发病",
  "Suggestion": "建议",
  "Coronary heart disease": "冠心病",
  "High blood lipids": "高血脂",
  "High blood pressure": "高血压",
  "Kidney disease": "肾病",
  "Neuropathy": "神经病变",
  "Obesity": "肥胖症",
  "Peripheral arterial disease": "外周动脉疾病",
  "Retinopathy": "视网膜病变",
  "Smoking addiction": "吸烟者",
  "Enter date": "输入日期",
  "Enter suggestion": "输入建议",
  "Enter Notes": "输入备注",
  "Select": "选择",
  "Prescription": "药方",
  "Medicine": "药物类型",
  "Dose": "用量",
  "Enter medicine": "输入药物类型",
  "Enter dose": "输入药量",
  "Enterdis": "输入并发症",
  "Add note": "输入备注",
  "Add Content": "最大长度为1000字符。",
  "Other suggestions": "其他建议",
  "OK": "确定",
  "HCP": "医护人员",
  "Content": "内容",
  "Records Report": "病程记录报告",

  "Quick Print": "快速打印",
  "Quick Print Settings": "快速打印设置",
  "Select duration": "选择时间间隔",
  "One Week": "一周",
  "One Month": "一月",
  "One Quarter": "一个季度",
  "End date": "截止日期",
  "Yesterday": "昨天",
  "Last Sunday": "上周日",
  "Last Saturday": "上周六",
  "Last Day of Last Month": "上个月最后一天",
  "Last Day of Last Quarter": "上个季度最后一天",
  "Customized": "设置",
  "Week Filter": "星期删选",
  "Select reports to print": "选择需要打印的报告",
  "Daily Summary": "每日总结",
  "Day By Day Overview": "多日总结",
  "Sensor Overlay": "血糖叠加图",
  "Trend Analysis": "趋势分析",
  "Logbook": "日志",
  "Device Settings Review": "设备设置",
  "createReport": "创建报告",

  "Segment Analysis": "分段分析",
  "Sensor Glucose Profile": "动态血糖",
  "# of Boluses": "大剂量次数",
  "Bolus Insulin": "大剂量",
  "Basal Pattern": "基础量程序",
  "Segment Analysis Report": "分段分析报告",
  "Avg Glucose": "血糖平均值",
  "Below": "低于",
  "In Target Range": "目标范围",
  "Coefficient of variation": "变异系数",
  "% Time CGM Active": "CGM激活时间百分比",
  "est_a1c_t1": "估算糖化血红蛋白：",
  "est_a1c_t2": "基于动态血糖值计算所得",
  "est_a1c_t3": "说明：估算的糖化血红蛋白值不能替代实验室所测量的值",

  "acceptTip": " 已授权监护。",
  "cancelTip": " 已取消对您的授权，如需远程监护，请重新申请。",
  "rejectTip": " 拒绝了您的申请。",
  "Read": "阅读",

  "Connection": "患者",
  "connections1": "联系人",
  "Add Connection": "添加患者",
  "SG": "血糖值",
  "Active Insulin": "活性胰岛素",
  "Stop following": "停止监护",
  "Enter username (email)": "输入用户名（邮箱/手机号）",
  "Search results": "搜索结果",
  "Send request": "发送请求",
  "View graphs": "查看图表",
  "Agree": "同意",
  "Deny": "拒绝",
  "Remove": "移除",
  "Cancel Requset": "取消申请监护的患者",
  "Remark": "备注",

  "Patient Profile": "患者信息",

  "Warm up": "初始化",
  "Monitoring": "正常监控中",
  "Transmitter Error": "发射器故障",
  "Sensor Failure": "血糖探头失败",
  "Sensor Expired": "血糖探头过期",
  "Lost Sensor": "血糖探头丢失",
  "Not Calibrated": "未校准",
  "Calibrating": "校准中",
  "Calibration Needed": "校准过期",
  "Calibration Error": "校准错误",
  "Charging Battery": "充电中",
  "Battery Charged": "充电完成",

  "To be filled": "等待灌药",
  "Filled with insulin": "已灌药",
  "Priming": "充盈中",
  "Priming completed": "充盈已完成",
  "Inserting needle": "正在注针过程中",
  "Patch activated": "注针已完成",
  "Delivering Basal": "正在输注基础量",
  "Exceeds Max 1 Hour Delivery": "超出每小时最大量暂停输注",
  "Exceeds Max TDD": "超出每天最大量暂停输注",
  "Suspend": "用户手动暂停输注",
  "Occlusion Detected": "储药贴堵塞",
  "Patch Expired": "储药贴过期",
  "Empty Reservoir": "储药贴空",
  "Patch Error": "储药贴故障",
  "Pump Base Error": "泵控制器故障",
  "Patch Battery Depleted": "电池没电",
  "Magnetic sensor not calibrated": "磁传感器未校准",

  "On": "开启",
  "on": "开启",
  "Off": "关闭",
  "off": "关闭",

  "CORONARY_HEART_DISEASE": "冠心病",
  "HIGH_BLOOD_LIPIDS": "高脂血",
  "HIGH_BLOOD_PRESSURE": "高血压",
  "KIDNEY_DISEASE": "肾病",
  "NEUROPATHY": "神经病变",
  "OBESITY": "肥胖症",
  "PERIPHERAL_ARTERIAL_DISEASE": "外周动脉疾病",
  "RETINOPATHY": "视网膜病变",
  "SMOKING_ADDICTION": "吸烟者",

  "saveTip": "保存成功!",
  "changePaTip": "密码修改成功",
  "enterEmTip": "请输入您的邮箱/手机",
  "verErrTip": "验证码输入错误",
  "chooseEventTip": "选择需要打印的事件",
  "chooseDataTip": "选择要打印的数据",
  "dateWrongTip": "截止日期不能小于起始日期",
  "infoWrongTip": "信息未填写完成",
  "createdSuccssTip": "创建成功",
  "selectData": "选择要保存的数据",

  "acceSu": "已接受的联系人申请",
  "acceEr": "添加新联系人失败",
  "rejeSu": "已拒绝的联系人申请",
  "rejeEr": "拒绝联系人申请失败",

  "userNotExist": "用户名不存在",
  "Password incorrect": "密码错误。",
  "UserType incorrect": "账号类型错误",
  "registSuccess": "您的账号已成功创建。",
  "registFailed": "注册新账号失败。",
  "sentSuccess": "发送消息成功",
  "sentFailed": "发送消息失败",

  "Input error": "输入错误",

  "deletePtip": "确定需要删除这些患者吗？",
  "deleteEvents": "请确认是否需要删除这些事件？",
  "deleteData": "Real-time and uploaded data will be deleted. The deleted data can't be restored. Are you sure to delete data?",
  "deleteThis": "请确认是否需要删除这个事件？",
  "confirm": "确定",
  "deleteSuccess": "已删除",
  "deleteFailed": "删除项失败",
  "modifySuccess": "修改成功",
  "modifyFailed": "修改失败",
  "createSuccess": "创建成功",
  "createFailed": "创建成功",
  "editSuccess": "编辑成功",
  "editFailed": "编辑失败",
  "Time overlapped": "选择的时间段重叠。",

  "stopFollow": "你确定要停止监护此患者吗？",
  "CancelTip1": "请确认是否需要删除此联系人？",

  "Warning": "提示",
  "agreeConnect": "点击“同意”后，联系人将会看到您的血糖数据、胰岛素泵数据及个人相关信息。",
  "denyConnect": "请确认是否拒绝联系人申请？",
  "deleteConnect": "请确认是否需要删除此联系人？如果确认删除，此联系人将无法远程查看您的血糖数据、胰岛素泵数据及个人相关信息。",

  "Choose the events to print": "选择要打印的事件",
  "tryAgain": "重试",
  "username and password is required": "请输入用户名和密码",
  "A name is required": "请输入姓名",
  "username is required": "请输入用户名",
  "The date choose wrong": "时间选择错误",
  "Date no more than 14 days": "所选的日期不能操过14天",

  "CancelTip": "请确认是否需要删除此联系人？",
  "removeConnect": "删除成功",

  "dateErr1": "日期选择范围不能超过90天.",
  "dateErr2": "截止日期不能小于起始日期",

  "Not Filled": "未填写",
  "Today": "今天",
  "duration": "病龄",
  "interval": "Interval",
  "7 days": "7天",
  "14 days": "14天",
  "30 days": "30 天",
  "90 days": "90 天",
  "g": "克",

  "Sound+Vibrate": "声音+振动",
  "Sound": "声音",
  "Vibrate": "振动",
  "Silent": "免打扰",
  "1": "一次",
  "2": "每天",
  "noMes": "无消息",
  "noConnect": "无联系人",
  "Customize": "设置",
  "GB": "United Kingdom",
  "CN": "China",
  "FR": "France",
  "DD": "Germany",
  "DE": "Germany",
  "SE": "Sweden",
  "AU": "Australia",
  "HKF": "Hongkong",
  "HU": "Hungary",
  "IT": "Italy",
  "NL": "Netherlands",
  "Nor": "Norway",
  "PT": "Portugal",
  "ES": "Spain",
  "TR": "Turkey",

  "Jan": "一月",
  "Feb": "二月",
  "Mar": "三月",
  "Apr": "四月",
  "May": "五月",
  "Jun": "六月",
  "Jul": "七月",
  "Aug": "八月",
  "Sep": "九月",
  "Oct": "十月",
  "Nov": "十一月",
  "Dec": "十二月",
  "ApplyTip": " 申请监护您的数据.",
  "noReadings": "无血糖读数",

  "daop_A6_system": "A6 Touchcare System",
  "daop_easytouch_easyview": "EasyTouch / EasyView iPad",
  "daop_TY012_TY015": "TY012/TY015",
  "daop_easysense": "EasySense",
  "daop_delete_data": "删除数据",
  "daop_uploaded_data": "已上传数据",
  "daop_uploaded_data_text": "数据来源于EasyTouch移动应用程序或EasyView iPad移动应用",
  "daop_realtime_data": "实时数据",
  "daop_realtime_data_text": "数据来源于EasySense移动应用程序",

  "ins_unit": "(U)",
  "ins_unit2": "U",
  "basal_unit": "（U/H）",
  "basal_unit2": "U/H",

  "dump_last": "Dump End",

  "Alerts_Patch_Battery_Low": "储药贴电量低",
  "Alerts_Patch_Battery_Depleted": "储药贴没电",
  "Alerts_Lost_Pump": "Lost Pump",
  "Alerts_Low_Reservoir": "储药量低",
  "Alerts_Empty_Reservoir": "储药贴空",
  "Alerts_Patch_Expiration_Advisory": "储药贴过期预警",
  "Alerts_Patch_Exp_In_1_Hour": "Patch Exp In 1 Hour",
  "Alerts_Patch_Expired": "储药贴过期",
  "Alerts_Patch_Error": "储药贴故障",
  "Alerts_Pump_Base_Error": "泵控制器故障",
  "Alerts_Basal_Rate_Key_Error": "Basal Rate Key Error",
  "Alerts_Occlusion_Detected": "储药贴堵塞",
  "Alerts_End_Of_Suspend": "End Of Suspend",
  "Alerts_Exceeds_Max_TDD": "超过每天最大输注量",
  "Alerts_Exceeds_Max_1Hr_Delivery": "超过每小时最大输注量",

  "Alerts_Predictive_Low_Suspend": "预测低血糖暂停输注",
  "Alerts_Low_Suspend": "低血糖暂停输注",
  "Alerts_Auto_Off": "自动暂停输注",

  "Alerts_Pump_Restart": "Pump Restart",
  "Alerts_Auto_Off_Warning": "Auto Off Warning",
  "Alerts_Pump_Out_Of_Range": "Pump Out Of Range",

  "Alerts_Lost_Sensor": "血糖探头丢失",
  "Alerts_Transmitter_Battery_Low": "发射器电量低",
  "Alerts_Charge_Transmitter": "发射器需充电",
  "Alerts_Sensor_Error": "无血糖读数",
  "Alerts_Transmitter_Error": "发射器故障",
  "Alerts_Sensor_Calibration_Error": "探头校准错误",

  "Alerts_Sensor_Failure": "血糖探头失败",
  "Alerts_Sensor_Calibration_Reminder": "探头校准提醒",
  "Alerts_Meter_BG_Now": "立即输入指尖血",
  "Alerts_Sensor_Exp_in_6_Hours": "探头6小时内过期",
  "Alerts_Sensor_Exp_in_2_Hours": "探头2小时内过期",
  "Alerts_Sensor_Exp_in_30_Min": "探头30分钟内过期",
  "Alerts_Sensor_Expired": "血糖探头过期",
  "Alerts_Rapid_Rise": "上升快",
  "Alerts_Rapid_Fall": "下降低",
  "Alerts_High_Predicted": "预期血糖高",
  "Alerts_Low_Predicted": "预期血糖低",
  "Alerts_High_Glucose": "血糖高",
  "Alerts_Low_Glucose": "血糖低",
  "Alerts_Below_3.1_mmol/L": "低于3.1mmol/L",
  "Alerts_Transmitter_Battery_Low_2": "发射器电量低",

  "Alerts_PDM_Battery_Low": "手持机电量低",
  "Alerts_Replace_Battery": "手持机立即充电",

  "Alert": "告警",
  "Alerts": "告警",
  "Alert Filter": "Alert Filter",
  "PDM": "PDM",
  "Pump": "泵",

  "alert_Time": "时间",
  "alert_Type": "类型",

  "Out Of Range": "超出范围",

  "t1221_Auto_Mode": "Auto Mode",
  "t1221_Time_in_Auto_Mode": "Time in Auto Mode",
  "t1221_Average_SG_SD": "Average SG ± SD",
  "t1221_Time_in_Target_Range": "Time in Target Range",
  "t1221_Time_above_Range": "Time above Range",
  "t1221_Time_below_Range": "Time below Range",
  "t1221_Auto_Basal_per_day": "Auto Basal (per day)",
  "t1221_Auto_Bolus_per_day": "Auto Bolus (per day)",
  "t1221_Auto_Mode_Exits": "Auto Mode Exits",
  "t1221_No_Sensor_readings": "No Sensor readings",
  "t1221_Max_Delivery": "Max Delivery",
  "t1221_Min_Delivery": "Min Delivery",

  "t1222_autoModeBasal": "Auto Mode Basal",
  "t1222_autoModeCorrBolus": "Auto Mode Correct Bolus",
  "t1222_autoSnack": "Auto Snack",
  "t1222_autoBreakfast": "Auto Breakfast",
  "t1222_autoLunch": "Auto Lunch",
  "t1222_autoDinner": "Auto Dinner",
  "t1222_autoExercise": "Auto Exercise",
  "t1222_Snack": "Snack",
  "t1222_auto_basal": "Auto Basal",
  "t1222_auto_bolus": "Auto Bolus",
  "t1222_Auto_Mode": "Auto Mode",
  "t1222_Time_in_Auto_Mode": "Time in Auto Mode(%)",
  "t1222_Avg_SD": "Avg.(mmol/L)±SD",
  "t1222_Target_Range": "Target Range(%)",
  "t1222_Above_Range": "Above Range(%)",
  "t1222_Below_Range": "Below Range(%)",
  "t1222_Auto_Mode_Exits": "# of Auto Mode Exits"

};

/***/ }),

/***/ 296:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_HCGMReport_vue__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_HCGMReport_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_HCGMReport_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HCGMReportPrepare_vue__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HCGMReportPrepare_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_HCGMReportPrepare_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_LoginReport_vue__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_LoginReport_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_LoginReport_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ReportList_vue__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ReportList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_ReportList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ReportHeader_vue__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ReportHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_ReportHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_UserTypeSelect_vue__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_UserTypeSelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_UserTypeSelect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_UploadMachineCode_vue__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_UploadMachineCode_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_UploadMachineCode_vue__);








var paths = '/path';

var routes = [{
    path: '/',
    redirect: '/select'
}, {
    path: '/select',
    component: __WEBPACK_IMPORTED_MODULE_5__components_UserTypeSelect_vue___default.a
}, {
    path: '/login',
    components: {
        default: __WEBPACK_IMPORTED_MODULE_2__components_LoginReport_vue___default.a
    }
}, {
    path: '/reportList',
    components: {
        default: __WEBPACK_IMPORTED_MODULE_3__components_ReportList_vue___default.a,
        header: __WEBPACK_IMPORTED_MODULE_4__components_ReportHeader_vue___default.a
    }
}, {
    path: '/report1',
    components: {
        default: __WEBPACK_IMPORTED_MODULE_0__components_HCGMReport_vue___default.a
    }
}, {
    path: '/reportPrepare',
    components: {
        header: __WEBPACK_IMPORTED_MODULE_4__components_ReportHeader_vue___default.a,
        default: __WEBPACK_IMPORTED_MODULE_1__components_HCGMReportPrepare_vue___default.a
    }
}, {
    path: '/UploadMachine',
    components: {
        header: __WEBPACK_IMPORTED_MODULE_4__components_ReportHeader_vue___default.a,
        default: __WEBPACK_IMPORTED_MODULE_6__components_UploadMachineCode_vue___default.a
    }
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ 301:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 302:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 305:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(46)(
  /* script */
  __webpack_require__(332),
  /* template */
  __webpack_require__(720),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 332:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  computed: {
    key: function key() {
      return this.$route.name !== undefined ? this.$route.name + new Date() : this.$route + new Date();
    }
  }
});

/***/ }),

/***/ 333:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_auth__ = __webpack_require__(54);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _ref;

    return _ref = {
      org_name: sessionStorage.getItem('org_name'),
      event: [], loading: true,
      followID: sessionStorage.getItem('followID'),
      target_high: +sessionStorage.getItem('high_glucose'),
      target_low: +sessionStorage.getItem('low_glucose'),
      endHour: +sessionStorage.getItem('endHour'),
      startHour: +sessionStorage.getItem('startHour'),
      startTime: 0,
      endTime: 0,
      patient_info: {},
      info: {},
      time_range: '-',
      date_list: [],
      statistics: [],
      report_date: '',
      ds_title: [{ avg: '-' }, { avg: '-' }, { avg: '-' }, { avg: '-' }, { avg: '-' }, { avg: '-' }, { avg: '-' }],
      sg_data: [],
      bg_data: [],
      ts: [],
      isMg: false,
      DataS: {
        blos_high: +sessionStorage.getItem('high_glucose') || 8.9,
        blos_low: +sessionStorage.getItem('low_glucose') || 3.9
      },
      textStyle: {
        color: '#282828',
        fontWeight: 'normal',
        fontSize: '11',
        fontFamily: 'SFUIText-Regular'
      },
      titlePadding: [20, 0, 0, 930],
      sgMax: 25,
      grid: { x: '5%', y: '13%', width: '92%', height: '60%', top: '19' },
      grid2: { x: '5%', y: '13%', width: '92%', height: '60%' },
      yAxisLabel: { interval: 0, margin: 5, textStyle: { color: '#282828', baseline: 'middle' }, showMinLabel: false },
      startRender: false,

      XTimeMin: 0,
      XTimeMax: 0,
      XData: [],

      YDataMin: [],
      YDataMax: [],
      YDataMed: [],
      YData10P: [],
      YDataQ1: [],
      YDataQ3: [],
      YData90P: [],

      AGPStat: {
        cgmUse: '-',
        avgSD: '-',
        hba1c: '--',
        cv: '-',
        avgMage: '-',
        avgModd: '-',
        highDistPercent: '-',
        targetDistPercent: '-',
        lowDistPercent: '-',
        highSGNum: '-',
        lowSGNum: '-'
      },
      chartIndexStart: [],
      target_ge_10: "",
      target_bt_3d9_10: "",
      target_le_3d9: "",
      totalPage: 3
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'event', {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'bg', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'reportNum', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'total_stat', {
      'num': ['-'],
      'avg': ['-'],
      'sd': ['-'],
      'cv': ['-'],
      'mage': ['-'],
      'max': ['-'],
      'min': ['-'],
      'ge_13d9': ['-'],
      'ge_10': ['-'],
      'ge_7d8': ['-'],
      'le_3d9': ['-'],
      'le_2d8': ['-'],
      'bt_3d9_10': ['-']
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'printLoading', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'printObj', {
      id: "printMe",
      preview: false,
      previewTitle: "print Title",
      popTitle: "good print",
      extraCss: "https://cdn.bootcdn.net/ajax/libs/animate.css/4.1.1/animate.compat.css, https://cdn.bootcdn.net/ajax/libs/hover.css/2.3.1/css/hover-min.css",
      extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>'
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'dayNum', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'target_veryhigh', 13.9), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'target_verylow', 3.0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'target_over_13d9', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'target_low_3', ''), _ref;
  },

  computed: {
    getLanguage: function getLanguage() {},
    pageOneOpen: function pageOneOpen() {
      var params = sessionStorage.getItem('hcgm_report_params');
      if (params) {

        return JSON.parse(params).radio1;
      } else {
        return false;
      }
    },
    pageTwoOpen: function pageTwoOpen() {

      var params = sessionStorage.getItem('hcgm_report_params');
      if (params) {

        return JSON.parse(params).radio2;
      } else {
        return false;
      }
    },
    pageThrOpen: function pageThrOpen() {
      var params = sessionStorage.getItem('hcgm_report_params');
      if (params) {

        return JSON.parse(params).radio3;
      } else {
        return false;
      }
    }
  },
  created: function created() {

    var req = this.getRequest();

    var report_prams = sessionStorage.getItem('hcgm_report_params');
    report_prams = JSON.parse(report_prams);
    var report_num = localStorage.getItem('hcgm_report_num');
    if (!report_num) {
      report_num = 1;
      localStorage.setItem('hcgm_report_num', report_num);
    } else {
      report_num = parseInt(report_num);
      localStorage.setItem('hcgm_report_num', report_num + 1);
    }
    if (report_prams.patient_info) {
      this.patient_info = report_prams.patient_info;
    }

    function PrefixInteger(num, len) {
      return (Array(len).join('0') + num).slice(-len);
    }

    var endDateTime = new Date(report_prams.endDate).setHours(0, 0, 0, 0) / 1000;
    var dayNum = report_prams.dayNum;
    var startDateTime = endDateTime - (dayNum - 1) * 86400;
    var ts = [];
    for (var i = 0; i < dayNum; i++) {
      ts.push([startDateTime + i * 86400, startDateTime + i * 86400 + 86400]);
    }
    this.ts = ts;
    var date_list = ts.map(function (e, i) {
      var d = new Date(e[0] * 1000);
      return d.getFullYear() + '年' + (d.getMonth() + 1) + '月' + d.getDate() + '日';
    });
    this.time_range = date_list[0] + '-' + date_list[dayNum - 1] + '(' + dayNum + '天)';
    var d = new Date();
    this.report_date = d.getFullYear() + '年' + (d.getMonth() + 1) + '月' + d.getDate() + '日';
    this.date_list = date_list;
    var ds_title = ts.map(function (e, i) {
      var week = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
      var d = new Date(e[0] * 1000);
      return {
        'title': __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].formatterDate1b(d) + ' ' + week[d.getDay()],
        'avg': '-',
        'TIR': '-'
      };
    });
    this.ds_title = ds_title;

    var title = [['测定次数'], ['平均值（MG，mmol/L）'], ['标准差（SD，mmol/L）'], ['变异系数(CV，%)'], ['平均血糖波动幅度（MAGE，mmol/L）'], ['最大值（mmol/L）'], ['最小值（mmol/L）'], [this.target_low + '-' + this.target_high + 'mmol/L（TIR）的时长(小时：分钟)<br/>百分比'], ['>13.9mmol/L的时长(小时：分钟)<br/>百分比'], ['>' + this.target_high + 'mmol/L的时长(小时：分钟)<br/>百分比'], ['>7.8mmol/L的时长(小时：分钟)<br/>百分比'], ['<' + this.target_low + 'mmol/L的时长(小时：分钟)<br/>百分比'], ['<2.8mmol/L的时长(小时：分钟)<br/>百分比']];
    var statistics = title.map(function (e, i) {
      var c = new Array(ts.length).fill('-');
      return e.concat(c);
    });
    this.statistics = statistics;

    this.$http.post('/api/v2.1/data/' + report_prams.uid, {
      sg: {
        ts: ts
      },
      calib: {
        ts: ts
      },
      event: {
        ts: ts
      }
    }).then(function (res) {
      var _this = this;

      if (0 === res.data.error) {
        var events = res.data.data.event;
        var dayEvent = {};
        var carbs = [];
        var exercises = [];
        var ins = [];
        var bg = [];

        if (events) {
          events.map(function (d, n) {
            carbs[n] = [];
            exercises[n] = [];
            ins[n] = [];
            bg[n] = [];
            if (d.length > 0) {

              d.map(function (e) {
                dayEvent = {
                  start: e[1],
                  type: e[2]
                };

                var content = e[3];

                if (e[2] === 'EXR' && content.value) {
                  dayEvent['value'] = content.value;
                  dayEvent['exetype'] = content.exerciseType;
                  exercises[n].push(dayEvent);
                } else if (e[2] === 'INS' && content.value) {
                  dayEvent['value'] = content.value;
                  dayEvent['instype'] = content.insulinType;
                  dayEvent['insName'] = content.name;
                  ins[n].push(dayEvent);
                } else if (e[2] === 'BG' && content.value) {
                  dayEvent['value'] = content.value;
                  dayEvent['note'] = content.note;
                  bg[n].push(dayEvent);
                } else if (e[2] === 'CARB' && content.value) {
                  dayEvent['value'] = content.value;
                  dayEvent['name'] = content.name;
                  carbs[n].push(dayEvent);
                } else if (content.value) {
                  dayEvent['value'] = content.value;
                  if ('AutoExercise' === e[2]) {
                    exercises[n].push(dayEvent);
                  }
                }
              });
            }
          });
        }
        this.event = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
          carb: carbs,
          exercise: exercises,
          ins: ins,
          bg: bg }, 'bg', bg);

        console.log(this.event);
        var day_num = res.data.data.sg.length;
        this.startTime = ts[0][0] + this.startHour * 3600;
        this.endTime = ts[day_num - 1][0] + this.endHour * 3600;
        if (7 == day_num) {
          this.totalPage = 1;
        }

        var curDate = new Date();
        this.reportNum = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].formatterDate1c(curDate) + '-' + PrefixInteger(report_num, 2);

        this.sg_data = res.data.data.sg.map(function (dayData, index) {
          if (index === 0 && dayData.length) {
            return dayData.filter(function (item) {
              return item[1] > _this.startTime;
            });
          } else if (index === day_num - 1 && dayData.length) {
            return dayData.filter(function (item) {
              return item[1] < _this.endTime;
            });
          } else {
            return dayData;
          }
        });
        var cali_data = res.data.data.calib.map(function (dayData, index) {
          if (index === 0 && dayData.length) {
            return dayData.filter(function (item) {
              return item[0] > _this.startTime;
            });
          } else if (index === day_num - 1 && dayData.length) {
            return dayData.filter(function (item) {
              return item[0] < _this.endTime;
            });
          } else {
            return dayData;
          }
        });
        res.data.data.event.map(function (dayData, index) {
          _this.bg.push([]);
          if (dayData.length > 0) {
            dayData.map(function (e) {
              if (e[2] == 'BG') {
                var value = e[3].value ? (e[3].value / 18).toFixed(1) : '';
                if (e[3].glucoseType == 0) {
                  cali_data[index].push([e[1], value, e[3].glucoseType]);
                } else {
                  _this.bg[index].push([e[1], value, e[3].glucoseType]);
                }
              }
            });
          }
        });
        console.log('cali_data', this.bg);
        this.bg_data = cali_data;
        this.calStatistics(this.sg_data);
        __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getDashboardSg(this, this.sg_data);
        this.prepareAGPData(this.sg_data);

        this.prepareDSData(this.sg_data);
        this.startRender = true;
        this.$nextTick(function () {

          _this.drawAGPChart();
          for (var _i = 0; _i < _this.dayNum; _i++) {
            _this.drawCGMChart(_i);
          }
          _this.loading = false;
          setTimeout(function () {
            _this.makeCarb(_this.dayNum, ts[0][0]);
          }, 500);
        });
      }
    });
  },

  methods: {
    getCarb: function getCarb(data) {
      if (data) {
        var date = new Date(data.start * 1000);
        var time = this.getTooltipTime(date);

        var name = data.name || '';
        var value = data.value + ' g';
        return name + '  ' + time + value;
      }
    },
    getExerciseTooltip: function getExerciseTooltip(data) {
      if (data) {
        var date = new Date(data.start * 1000);
        var time = this.getTooltipTime(date);

        var type = data.exetype;
        var hour = Math.floor(data.value / 60);
        var minutes = Math.floor(data.value % 60);
        var duration = '';
        if (hour > 0) {
          duration += hour + 'h';
        }
        if (minutes !== 0 || hour === 0) {
          duration += minutes + 'min';
        }
        return type + '  ' + time + duration;
      }
    },
    getInstip: function getInstip(data) {
      if (data) {
        var date = new Date(data.start * 1000);
        var time = this.getTooltipTime(date);
        var arr = ['未选择', '速效', '短效', '中效', '长效', '预混'];
        var type = arr[data.instype] || '未选择';
        var name = data.insName;
        var hour = Math.floor(data.value / 60);
        var minutes = Math.floor(data.value % 60);
        var duration = '';
        if (hour > 0) {
          duration += hour + 'h';
        }
        if (minutes !== 0 || hour === 0) {
          duration += minutes + 'min';
        }
        return name + '  ' + type + '  ' + time + duration;
      }
    },
    getTooltipTime: function getTooltipTime(date) {
      var hour = date.getHours();
      var minute = date.getMinutes();
      return ('00' + hour).slice(-2) + ': ' + ('00' + minute).slice(-2) + '; ';
    },
    makeCarb: function makeCarb(dayNum, startTime) {

      var events = this.event;
      var carbClassName = 'event-item';

      var _loop = function _loop(i) {
        var id = 'event' + i;
        var time = startTime + i * 86400;
        var OBJ = document.getElementById(id);
        if (events['carb'][i].length && OBJ) {
          events['carb'][i].map(function (item, index) {
            var el = OBJ.getElementsByClassName('carb')[index];

            var w = ((item.start - time) / 900).toFixed(1) + '%';
            if (el) {
              el.style.left = w;
            }
          });
        }
        if (events['exercise'][i].length && OBJ) {
          events['exercise'][i].map(function (item, index) {
            var el = OBJ.getElementsByClassName('exe');
            var w = ((item.start - time) / 900).toFixed(1) + '%';
            if (el[index]) {

              el[index].style.left = w;
            }
          });
        }
        if (events['ins'][i].length && OBJ) {
          events['ins'][i].map(function (item, index) {
            var el = OBJ.getElementsByClassName('ins');
            var w = ((item.start - time) / 900).toFixed(1) + '%';
            if (el[index]) {

              el[index].style.left = w;
            }
          });
        }
      };

      for (var i = 0; i < dayNum; i++) {
        _loop(i);
      }
    },
    printPdf: function printPdf() {

      if (!!window.ActiveXObject || "ActiveXObject" in window) {
        var hkey_path = void 0;
        hkey_path = "HKEY_CURRENT_USER\\Software\\Microsoft\\Internet Explorer\\PageSetup\\";
        try {
          var RegWsh = new ActiveXObject("WScript.Shell");
          RegWsh.RegWrite(hkey_path + "header", "");
          RegWsh.RegWrite(hkey_path + "footer", "");
        } catch (e) {}
      }
      document.getElementsByClassName('noprint')[0].style.opacity = 0;
      document.getElementsByClassName('noprint')[1].style.opacity = 0;
      document.title = this.patient_info.Name + this.time_range;
      setTimeout(function () {
        window.print();
        document.getElementsByClassName('noprint')[0].style.opacity = 1;
        document.getElementsByClassName('noprint')[1].style.opacity = 1;
      }, 300);
    },
    routeBack: function routeBack() {
      this.$router.go(-1);
    },
    calMAGE: function calMAGE(data, index) {

      var logFlag = false;
      data = data.map(function (e, i) {
        return [i, e];
      });

      if (data.length == 0) {
        return '-';
      }
      var data2 = data.map(function (e, i) {
        return e[1];
      });
      var avgSD = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getAvgSD(data2);
      var sd = avgSD.sd;
      var max = Math.max.apply(Math, data2);
      var min = Math.min.apply(Math, data2);
      var trend = '';

      function filterSame(data) {
        if (data.length < 3) {
          return data;
        }
        var res = [];
        res.push(data[0]);
        for (var i = 1; i < data.length; i++) {
          if (data[i][1] == data[i - 1][1]) {
            continue;
          }
          res.push(data[i]);
        }
        return res;
      }
      function filterNotPeak(data) {
        if (data.length < 3) {
          return data;
        }
        var res = [];
        res.push(data[0]);
        for (var i = 1; i < data.length - 1; i++) {
          if (data[i][1] > data[i - 1][1] && data[i][1] > data[i + 1][1]) {
            res.push(data[i]);
          } else if (data[i][1] < data[i - 1][1] && data[i][1] < data[i + 1][1]) {
            res.push(data[i]);
          }
        }
        res.push(data[data.length - 1]);
        return res;
      }

      function filterOneSide(data, sd, max, min) {

        var procLoop = 10;

        var res = [];
        var resFilter = [];
        for (var p = 0; p < procLoop; p++) {
          if (data.length < 3) {
            return data;
          }
          res = [];
          res.push(data[0]);
          for (var i = 1; i < data.length - 1; i++) {
            if (data[i][1] == max || data[i][1] == min) {
              res.push(data[i]);
              continue;
            }
            var leftSide = Math.abs(data[i][1] - data[i - 1][1]);
            var rightSide = Math.abs(data[i][1] - data[i + 1][1]);
            if (leftSide >= sd || rightSide >= sd) {
              res.push(data[i]);
            } else if (i == 1) {
              if (data[i][1] < data[i - 1][1] && true && data[i][1] <= data[i + 2][1]) {
                res.push(data[i]);
              } else if (data[i][1] > data[i - 1][1] && true && data[i][1] >= data[i + 2][1]) {
                res.push(data[i]);
              }
            } else if (i == data.length - 1 - 1) {
              if (data[i][1] < data[i - 1][1] && data[i][1] <= data[i - 2][1] && true) {
                res.push(data[i]);
              } else if (data[i][1] > data[i - 1][1] && data[i][1] >= data[i - 2][1] && true) {
                res.push(data[i]);
              }
            } else if (i >= 2 && i <= data.length - 1 - 2) {
              if (data[i][1] < data[i - 1][1] && data[i][1] <= data[i - 2][1] && data[i][1] <= data[i + 2][1]) {
                res.push(data[i]);
              } else if (data[i][1] > data[i - 1][1] && data[i][1] >= data[i - 2][1] && data[i][1] >= data[i + 2][1]) {
                res.push(data[i]);
              }
            }
          }
          res.push(data[data.length - 1]);
          var resFilterSame = filterSame(res);
          resFilter = filterNotPeak(resFilterSame);
          if (resFilter.length == data.length) {
            break;
          }
          data = resFilter;
        }
        return resFilter;
      }

      function filterTwoSide(data, sd, max, min) {

        var procLoop = 10;

        var res = [];
        var resFilter = [];
        for (var p = 0; p < procLoop; p++) {
          if (data.length < 3) {
            return data;
          }
          res = [];
          for (var i = 0; i < data.length; i++) {
            if (data[i][1] == max || data[i][1] == min) {
              res.push(data[i]);
              continue;
            }
            if (0 == i) {
              var rightSide = Math.abs(data[i][1] - data[i + 1][1]);
              if (rightSide >= sd) {
                res.push(data[0]);
              }
            } else if (data.length - 1 == i) {
              var leftSide = Math.abs(data[i][1] - data[i - 1][1]);
              if (leftSide >= sd) {
                res.push(data[data.length - 1]);
              }
            } else {
              var _leftSide = Math.abs(data[i][1] - data[i - 1][1]);
              var _rightSide = Math.abs(data[i][1] - data[i + 1][1]);
              if (_leftSide >= sd && _rightSide >= sd) {
                res.push(data[i]);
              } else if (i == 1) {
                if (data[i][1] < data[i - 1][1] && true && data[i][1] <= data[i + 2][1]) {
                  res.push(data[i]);
                } else if (data[i][1] > data[i - 1][1] && true && data[i][1] >= data[i + 2][1]) {
                  res.push(data[i]);
                }
              } else if (i == data.length - 1 - 1) {
                if (data[i][1] < data[i - 1][1] && data[i][1] <= data[i - 2][1] && true) {
                  res.push(data[i]);
                } else if (data[i][1] > data[i - 1][1] && data[i][1] >= data[i - 2][1] && true) {
                  res.push(data[i]);
                }
              } else if (i >= 2 && i <= data.length - 1 - 2) {
                if (data[i][1] < data[i - 1][1] && data[i][1] <= data[i - 2][1] && data[i][1] <= data[i + 2][1]) {
                  res.push(data[i]);
                } else if (data[i][1] > data[i - 1][1] && data[i][1] >= data[i - 2][1] && data[i][1] >= data[i + 2][1]) {
                  res.push(data[i]);
                }
              }
            }
          }
          var resFilterSame = filterSame(res);
          resFilter = filterNotPeak(resFilterSame);
          if (resFilter.length == data.length) {
            break;
          }
          data = resFilter;
        }
        return resFilter;
      }

      function filterStartEnd(data, sd, max, min) {
        if (data.length <= 1) {
          return [];
        }
        if (2 == data.length) {
          if (Math.abs(data[0][1] - data[1][1]) < sd) {
            return [];
          } else {
            return data;
          }
        }
        if (Math.abs(data[0][1] - data[1][1]) < sd && data[0][1] != max && data[0][1] != min) {
          data = data.slice(1);
        }
        var size = data.length;
        if (Math.abs(data[size - 1][1] - data[size - 2][1]) < sd && data[size - 1][1] != max && data[size - 1][1] != min) {
          data = data.slice(0, size - 1);
        }
        return data;
      }

      var proc = filterSame(data);
      proc = filterNotPeak(proc);
      proc = filterOneSide(proc, sd, max, min);
      proc = filterStartEnd(proc, sd, max, min);
      proc = filterTwoSide(proc, sd, max, min);
      proc = proc.map(function (e, i) {
        return e[1];
      });
      if (proc.length > 1) {
        var total = 0;
        for (var i = 0; i < proc.length - 1; i++) {
          total += Math.abs(proc[i] - proc[i + 1]);
        }
        var mage = total / (proc.length - 1);
        return mage;
      }
      return '-';
    },
    calModd: function calModd(sg_proc) {

      var dayNum = sg_proc.length;
      var data = [];

      for (var i = 0; i < 720; i++) {
        var dayList = [];
        for (var d = 0; d < dayNum; d++) {
          dayList.push(-1);
        }
        data.push(dayList);
      }

      for (var _d = 0; _d < dayNum; _d++) {
        for (var _i2 = 0; _i2 < sg_proc[_d].length; _i2++) {
          var p = sg_proc[_d][_i2];
          var t = new Date(p[0] * 1000);
          var m = t.getHours() * 60 + t.getMinutes();
          var index = Math.floor(m / 2);
          if (index >= 720) {}
          if (-1 == data[index][_d]) {
            data[index][_d] = p[1];
          }
        }
      }

      var diff = [];
      var diff_debug = [];
      data.map(function (e, i) {

        for (var n = 1; n < e.length; n++) {
          if (e[n] != -1 && e[n - 1] != -1) {
            diff.push(Math.abs(e[n] - e[n - 1]));
            diff_debug.push([i, n, Math.abs(e[n] - e[n - 1]) * 18.0]);
          }
        }
      });
      var res = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getAvgSD(diff);
      if (diff.length > 0) {
        this.AGPStat.avgModd = res['avg'].toFixed(1) + 'mmol/L';
      }
    },
    calStatistics: function calStatistics(sg_data) {
      var _this2 = this;

      var dayNum = sg_data.length;
      var sg_proc = sg_data.map(function (day_records, d) {
        var day_proc = [];
        for (var i = 0; i < day_records.length; i++) {
          var s = day_records[i];
          if ((s[4] == 'C' || s[4] == 'NC' || s[4] == 'CX') && s[3] > 0.1) {
            var val = s[3];
            val = val > 22.2 ? 22.2 : val;
            val = val < 2.2 ? 2.2 : val;
            day_proc.push(val);
          }
        }
        return day_proc;
      });

      var row = ['num', 'avg', 'sd', 'cv', 'mage', 'max', 'min', 'bt_3d9_10', 'ge_13d9', 'ge_10', 'ge_7d8', 'le_3d9', 'le_2d8'];
      var that = this;

      function calSGStat(value, flag) {
        function fillPreZero(s, num) {
          var pre = '';
          var lack = 0;
          if (s.length >= num) {
            lack = 0;
          } else {
            lack = num - s.length;
          }
          for (var i = 0; i < lack; i++) {
            pre += '0';
          }
          return pre + s;
        }
        function minite_format(m, total, flag) {
          var percent = (m * 100.0 / total).toFixed(1);
          if (1 == flag) {
            return '%h小时%m分钟（%p%）'.replace('%h', Math.floor(m / 60)).replace('%m', m % 60).replace('%p', percent);
          }
          return '%h:%m<br/>%p%'.replace('%h', fillPreZero(Math.floor(m / 60) + '', 2)).replace('%m', fillPreZero(m % 60 + '', 2)).replace('%p', percent);
        }
        function percent_format(m, total) {
          var percent = (m * 100.0 / total).toFixed(1) + '%';
          return percent;
        }

        var res_dict = {};
        var sg_value = value;
        var size = sg_value.length;
        res_dict['num'] = size;
        if (size) {
          res_dict['max'] = Math.max.apply(null, sg_value).toFixed(1);
          res_dict['min'] = Math.min.apply(null, sg_value).toFixed(1);
          var avg_sd = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getAvgSD(sg_value);
          if (avg_sd.num) {
            res_dict['avg'] = avg_sd.avg.toFixed(1);
            res_dict['sd'] = avg_sd.sd.toFixed(1);

            if (avg_sd.num && avg_sd.avg > 0.1) {
              var cv = parseFloat(avg_sd.sd.toFixed(1)) / parseFloat(avg_sd.avg.toFixed(1));
              res_dict['cv'] = (cv * 100).toFixed(1) + '%';
            }
          }
          if (avg_sd.num < 72) {
            res_dict['sd'] = '-';
            res_dict['cv'] = '-';
          }
        } else {
          res_dict['max'] = '-';
          res_dict['min'] = '-';
          res_dict['avg'] = '-';
          res_dict['sd'] = '-';
          res_dict['cv'] = '-';
        }
        res_dict['mage'] = '-';

        var ge_13d9 = [];
        var ge_10 = [];
        var ge_7d8 = [];
        var le_3d9 = [];
        var le_2d8 = [];
        var bt_3d9_10 = [];
        var le_3 = [];
        var ge_ov13d9 = [];
        var ge_ov10 = [];
        var ge_be3d9 = [];
        sg_value.map(function (e, i) {
          if (e > 13.9) {
            ge_13d9.push(e);
          }
          if (e >= 13.9) {
            ge_ov13d9.push(e);
          }
          if (e > that.target_high && e <= 13.9) {
            ge_10.push(e);
          }
          if (e >= 7.8) {
            ge_7d8.push(e);
          }
          if (e >= that.target_high) {
            ge_ov10.push(e);
          }
          if (e < that.target_low && e >= 3.0) {
            le_3d9.push(e);
          }
          if (e < 3.0) {
            le_3.push(e);
          }
          if (e < that.target_low) {
            ge_be3d9.push(e);
          }
          if (e <= 2.8) {
            le_2d8.push(e);
          }
          if (that.target_low <= e && e <= that.target_high) {
            bt_3d9_10.push(e);
          }
        });

        if (size) {
          that.target_over_13d9 = percent_format(ge_13d9.length * 2, size * 2);
          that.target_ge_10 = percent_format(ge_10.length * 2, size * 2);
          that.target_bt_3d9_10 = percent_format(bt_3d9_10.length * 2, size * 2);
          that.target_le_3d9 = percent_format(le_3d9.length * 2, size * 2);
          that.target_low_3 = percent_format(le_3.length * 2, size * 2);
          res_dict['ge_13d9'] = minite_format(ge_ov13d9.length * 2, size * 2, flag);
          res_dict['ge_10'] = minite_format(ge_ov10.length * 2, size * 2, flag);
          res_dict['ge_7d8'] = minite_format(ge_7d8.length * 2, size * 2, flag);
          res_dict['le_3d9'] = minite_format(ge_be3d9.length * 2, size * 2, flag);
          res_dict['le_2d8'] = minite_format(le_2d8.length * 2, size * 2, flag);
          res_dict['bt_3d9_10'] = minite_format(bt_3d9_10.length * 2, size * 2, flag);
        } else {
          res_dict['ge_13d9'] = '-';
          res_dict['ge_10'] = '-';
          res_dict['ge_7d8'] = '-';
          res_dict['le_3d9'] = '-';
          res_dict['le_2d8'] = '-';
          res_dict['bt_3d9_10'] = '-';
        }
        return res_dict;
      }

      var stat_res = sg_proc.map(function (e, i) {
        var res = calSGStat(e, 0);
        return res;
      });


      for (var d = 0; d < dayNum; d++) {
        for (var i = 0; i < row.length; i++) {
          this.statistics[i][d + 1] = stat_res[d][row[i]];
        }
      }

      var mage = sg_proc.map(function (e, i) {
        if (e.length >= 576) {
          return _this2.calMAGE(e, i);
        } else {
          return '-';
        }
      });

      var totalNormalSG = 0;
      var total_sg = [];
      var avgSD = sg_proc.map(function (e, i) {
        totalNormalSG += e.length;
        total_sg = total_sg.concat(e);
        return __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getAvgSD(e);
      });

      var total_res = calSGStat(total_sg, 1);
      for (var p in total_res) {
        if (this.total_stat[p]) {
          this.total_stat[p][0] = total_res[p];
        }
      }

      var mageStat = [];
      var mageSum = 0;
      for (var _i3 = 0; _i3 < mage.length; _i3++) {
        if (typeof mage[_i3] == "number") {
          this.statistics[4][_i3 + 1] = mage[_i3].toFixed(1);
          mageStat.push(parseFloat(mage[_i3].toFixed(1)));
          mageSum += parseFloat(mage[_i3].toFixed(1));
        }
      }
      if (mageStat.length > 0) {
        var avgMage = (mageSum * 1.0 / mageStat.length).toFixed(1);
        this.AGPStat.avgMage = avgMage + 'mmol/L';
      }
    },
    prepareDSData: function prepareDSData(sg_day) {
      var _this3 = this;

      var dayNum = sg_day.length;
      var context = this;
      sg_day.map(function (d, n) {
        var day_sg = [];
        var day_target_num = 0;

        if (d.length > 0) {
          d.map(function (e, i) {
            if ((e[4] == 'C' || e[4] == 'NC' || e[4] == 'CX') && e[3] > 0.00001) {
              var val = e[3];
              val = val > 22.2 ? 22.2 : val;
              val = val < 2.2 ? 2.2 : val;
              day_sg.push(val);

              if (val > _this3.target_high) {} else if (val < _this3.target_low) {} else {
                day_target_num += 1;
              }
            }
          });
        }

        var result = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getAvgSD(day_sg);
        if (result.num) {
          context.ds_title[n].avg = result.avg.toFixed(1);
          context.ds_title[n].TIR = (day_target_num * 100.0 / day_sg.length).toFixed(1) + '%';
        }
      });
    },
    calHighLowSGEvent: function calHighLowSGEvent(data, dayNum) {

      var highFlag = false;
      var lowFlag = false;
      var highData = [];
      var lowData = [];
      var highDataList = [];
      var lowDataList = [];
      var highEvent = 0;
      var lowEvent = 0;

      for (var i = 0; i < data.length; i++) {
        var sgValue = data[i][1];

        if (sgValue > this.target_high) {
          highData.push(data[i]);
        } else {
          if (highData.leprepareAGPDatacreatedngth) {
            if (highData.length < 8) {
              highData = [];
            } else if (data[i][0] - highData[highData.length - 1][0] > 15 * 60) {
              highDataList.push(highData);
              highData = [];
            }
          }
        }

        if (sgValue < this.target_low) {
          lowData.push(data[i]);
        } else {
          if (lowData.length) {
            if (lowData.length < 8) {
              lowData = [];
            } else if (data[i][0] - lowData[lowData.length - 1][0] > 15 * 60) {
              lowDataList.push(lowData);
              lowData = [];
            }
          }
        }
      }
      if (highData.length) {
        highDataList.push(highData);
      }
      if (lowData.length) {
        lowDataList.push(lowData);
      }

      function SplitBy15MinutesGap(data) {
        var res = [];
        var pos = 0;
        for (var _i4 = 1; _i4 < data.length; _i4++) {
          var gap = data[_i4][0] - data[_i4 - 1][0];
          if (gap > 15 * 60) {
            var seg = data.slice(pos, _i4);
            res.push(seg);
            pos = _i4;
          }
        }
        res.push(data.slice(pos, data.length));
        return res;
      }

      var highRes = [];
      var lowRes = [];
      for (var p = 0; p < highDataList.length; p++) {
        var s = SplitBy15MinutesGap(highDataList[p]);
        highRes = highRes.concat(s);
      }
      for (var _p = 0; _p < lowDataList.length; _p++) {
        var _s = SplitBy15MinutesGap(lowDataList[_p]);
        lowRes = lowRes.concat(_s);
      }

      highRes = highRes.filter(function (e, i) {
        return e.length >= 8;
      });
      lowRes = lowRes.filter(function (e, i) {
        return e.length >= 8;
      });

      highEvent = highRes.length;
      lowEvent = lowRes.length;
      this.AGPStat.highSGNum = (highEvent / (data.length / 720.0)).toFixed(1);
      this.AGPStat.lowSGNum = (lowEvent / (data.length / 720.0)).toFixed(1);
    },
    prepareAGPData: function prepareAGPData(sg_day) {
      var _this4 = this;

      var dayNum = sg_day.length;
      this.dayNum = dayNum;
      var dataTotalNum = 0;

      var lastDayTime = this.ts[this.ts.length - 1][0];
      var curDate = new Date();
      var curDateStart = new Date(curDate.getFullYear(), curDate.getMonth(), curDate.getDate());
      var totalDayReal = this.ts.length;
      if (curDateStart.getTime() == lastDayTime * 1000) {
        totalDayReal = this.ts.length - 1 + (curDate.getHours() * 60 + curDate.getMinutes()) / 1440.0;
      }
      for (var i = 0; i < totalDayReal; i += 7) {
        this.chartIndexStart.push(i);
      }
      var sg_data = [];
      var sg_data2 = [];
      var sg_data3 = [];
      var sg_high = [];
      var sg_low = [];
      var sg_high_total_num = 0;
      var sg_low_total_num = 0;
      var sg_target_total_num = 0;
      var sg_very_high_total_num = 0;
      var sg_very_low_total_num = 0;
      sg_day.map(function (d, n) {
        var day_proc = [];
        if (d.length > 0) {
          d.map(function (e, i) {
            if ((e[4] == 'C' || e[4] == 'NC' || e[4] == 'CX') && e[3] > 0.00001) {
              var val = e[3];
              val = val > 22.2 ? 22.2 : val;
              val = val < 2.2 ? 2.2 : val;
              sg_data.push(val);
              sg_data2.push([e[1], e[3]]);
              day_proc.push([e[1], e[3]]);
              if (val > 13.9) {
                sg_very_high_total_num += 1;
              }
              if (val > _this4.target_high && val <= 13.9) {
                sg_high_total_num += 1;
              } else if (val >= _this4.target_low && val <= _this4.target_high) {
                sg_target_total_num += 1;
              } else if (val < _this4.target_low && val >= 3.0) {
                sg_low_total_num += 1;
              } else if (val < 3.0) {
                sg_very_low_total_num += 1;
              }
            }
          });
        }
        sg_data3.push(day_proc);
      });
      dataTotalNum = sg_data.length;

      this.AGPStat.highSGNum = (sg_high_total_num * 1.0 / dayNum).toFixed(1);
      this.AGPStat.lowSGNum = (sg_low_total_num * 1.0 / dayNum).toFixed(1);
      this.calHighLowSGEvent(sg_data2, dayNum);
      this.calModd(sg_data3);

      var result = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getAvgSD(sg_data);
      if (result.num) {
        this.AGPStat.avgSD = result.avg.toFixed(1) + '±' + result.sd.toFixed(1);
        this.AGPStat.cv = (parseFloat(result.sd.toFixed(1)) * 100.0 / parseFloat(result.avg.toFixed(1))).toFixed(1) + '%';
        var highDist = sg_high_total_num * 1.0 / result.num;
        var lowDist = sg_low_total_num * 1.0 / result.num;
        var veryHighDist = sg_very_high_total_num * 1.0 / result.num;
        var veryLowDist = sg_very_low_total_num * 1.0 / result.num;
        var targetDist = 1 - lowDist - highDist - veryHighDist - veryLowDist;
        var highDistPercent = parseFloat((highDist * 100).toFixed(1));
        var lowDistPercent = parseFloat((lowDist * 100).toFixed(1));

        var targetDistPercent = parseFloat((100 - lowDistPercent - highDistPercent).toFixed(1));
        this.AGPStat.highDistPercent = highDistPercent + '%';
        this.AGPStat.lowDistPercent = lowDistPercent + '%';
        this.AGPStat.targetDistPercent = targetDistPercent + '%';
        var highHeight = highDist * 30;
        this.$nextTick(function () {
          if (document.getElementById('dist_high')) {
            document.getElementById('dist_high').style.height = (highDist * 30).toFixed(1) + 'mm';
            document.getElementById('dist_high').style.backgroundColor = '#ffad00';
          }
          if (document.getElementById('dist_target')) {
            document.getElementById('dist_target').style.height = (targetDist * 30).toFixed(1) + 'mm';
            document.getElementById('dist_target').style.backgroundColor = '#21ca3b';
          }
          if (document.getElementById('dist_low')) {
            document.getElementById('dist_low').style.height = (lowDist * 30).toFixed(1) + 'mm';
            document.getElementById('dist_low').style.backgroundColor = '#ff4e4e';
          }
          if (document.getElementById('dist_very_high')) {
            document.getElementById('dist_very_high').style.height = (veryHighDist * 40).toFixed(1) + 'mm';
            document.getElementById('dist_very_high').style.backgroundColor = '#F58C4A';
          }
          if (document.getElementById('dist_very_low')) {
            document.getElementById('dist_very_low').style.height = (veryLowDist * 40).toFixed(1) + 'mm';
            document.getElementById('dist_very_low').style.backgroundColor = '#9A292F';
          }
        });
      }
      this.AGPStat.cgmUse = (sg_data.length * 100.0 / (totalDayReal * 720)).toFixed(1);
      if (result.num > 0 && result.avg > 0) {
        this.AGPStat.hba1c = (result.avg * 18.0 * 0.02392 + 3.31).toFixed(1) + '%';
      }
    },
    getRequest: function getRequest() {

      var href = location.href;
      var theRequest = {};
      if (href.indexOf("?") != -1) {
        var search = href.substring(href.indexOf("?") + 1);
        var strs = search.split("&");
        for (var i = 0; i < strs.length; i++) {
          var pair = strs[i].split("=");
          theRequest[pair[0]] = unescape(pair[1]);
        }
      }
      return theRequest;
    },
    drawAGPChart: function drawAGPChart() {
      if (!this.pageTwoOpen) return;
      if (this.dayNum > 2) {
        var sel_time = new Date(2019, 0, 1).getTime();
        this.XTimeMin = sel_time;
        this.XTimeMax = sel_time + 86400 * 1000;
        var that = this;
        this.chart1_4 = __WEBPACK_IMPORTED_MODULE_1_echarts__["a" /* init */](document.getElementById('agp-chart'), null, { renderer: 'svg' });
        this.chart1_4.setOption({
          title: {
            text: '血糖值（mmol/L）',
            textStyle: this.textStyle,
            padding: this.titlePadding
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              label: {
                backgroundColor: '#6a7985'
              }
            },
            formatter: function formatter(params, ticket, callback) {
              if (params instanceof Array) {
                var minuteFormat = function minuteFormat(minute) {
                  var h = Math.floor(minute / 60);
                  var m = Math.floor(minute % 60);
                  if (h < 10) {
                    h = '0' + h;
                  }
                  if (m < 10) {
                    m = '0' + m;
                  }
                  return h + ':' + m;
                };

                var paramSize = params.length;
                var strMinute = params[0].axisValueLabel;
                var strTooptip = strMinute.slice(0, 5);
                var t = new Date(params[0].axisValue);
                var minute = t.getHours() * 60 + t.getMinutes();
                var startMinute = minute - 5;
                var endMinute = minute + 5;

                strTooptip = minuteFormat(startMinute) + ' ~ ' + minuteFormat(endMinute);
                for (var i = paramSize - 1; i >= 0; i--) {
                  var series = params[i];
                  strTooptip += '<br/>' + series.seriesName + ': ' + series.value[2];
                }
                return strTooptip;
              }
              return 'Loading';
            }
          },
          xAxis: [{
            type: 'time',
            interval: 3600 * 1000,
            min: this.XTimeMin,
            max: this.XTimeMax,
            splitNumber: 24,
            axisLabel: {
              show: true, interval: 2,
              formatter: function formatter(value, index) {

                if (index === 0) return;
                var minute = index * 30;
                function PrefixInteger(num, len) {
                  return (Array(len).join('0') + num).slice(-len);
                }
                var texts = [PrefixInteger(minute / 30, 2) - 1, PrefixInteger(minute % 30, 2)];
                if ((index - 1) % 3 == 0) {
                  return texts.join(':');
                } else {
                  return '';
                }
              }
            },
            axisLine: { lineStyle: { color: '#000' } }
          }],

          yAxis: [{
            type: 'value',
            min: 0,
            max: this.sgMax,
            axisLabel: this.yAxisLabel,
            axisLine: { lineStyle: { color: '#ccc' } },
            boundaryGap: false,
            axisTick: { length: 0 }
          }, {
            type: 'value',
            min: 0,
            max: this.sgMax,
            axisLabel: { show: false },
            axisLine: { lineStyle: { color: '#ccc' } },
            boundaryGap: false,
            axisTick: { length: 0 }
          }],
          grid: this.grid2,

          legend: {
            selectedMode: false,
            itemWidth: 40,
            itemHeight: 15,
            itemGap: 25,
            symbolKeepAspect: false,
            bottom: 30,
            formatter: function formatter(name) {
              if ('50%' == name) {
                return '50%(中位数)';
              } else if ('25%' == name) {
                return '25% - 75%';
              } else if ('5%' == name) {
                return '5% - 95%';
              } else if ('Min' == name) {
                return '最大/最小值';
              } else if ('Max' == name) {
                return '目标范围';
              }

              return name;
            },
            data: [{
              name: '50%', icon: 'image://static/dashboardLegend/Medium.png'
            }, {
              name: '25%', icon: 'image://static/dashboardLegend/IQR.png'
            }, {
              name: '5%', icon: 'image://static/dashboardLegend/10_90.png'
            }, {
              name: 'Min', icon: 'image://static/dashboardLegend/Min_Max.png'
            }, {
              name: 'Max', icon: 'image://static/dashboardLegend/TargetRange.png'
            }]
          },
          series: [{
            name: 'Min',
            type: 'line',
            data: this.YDataMin,
            stack: 'total',
            lineStyle: {
              normal: {
                color: '#979797',
                width: 1,
                type: 'dashed'
              }
            },
            symbol: 'none',
            markArea: {
              data: [[{ yAxis: this.isMg ? this.target_low * 18 : this.target_low }, { yAxis: this.isMg ? this.target_high * 18 : this.target_high }]],
              tooltip: { show: false },
              itemStyle: {
                normal: {
                  color: 'rgba(211,255,213,0.6)'
                }
              }
            }
          }, {
            name: '5%',
            type: 'line',
            data: this.YData10P,
            stack: 'total',
            symbol: 'none',
            lineStyle: {
              normal: {
                color: 'rgba(140, 201, 239, 0.5)',
                width: 1
              }
            }

          }, {
            name: '25%',
            type: 'line',
            data: this.YDataQ1,
            stack: 'total',
            areaStyle: {
              normal: {
                color: 'rgba(140, 201, 239, 0.5)'
              }
            },
            lineStyle: {
              normal: {
                color: 'rgba(62, 176, 245, 0.6)',
                width: 1
              }
            },
            symbol: 'none'

          }, {
            name: '50%',
            type: 'line',
            data: this.YDataMed,
            stack: 'total',
            areaStyle: {
              normal: { color: 'rgba(62, 176, 245, 0.6)' }
            },
            lineStyle: {
              normal: {
                color: '#505050',
                width: 1
              }
            },
            symbol: 'none'
          }, {
            name: '75%',
            type: 'line',
            data: this.YDataQ3,
            stack: 'total',
            areaStyle: { normal: { color: 'rgba(62, 176, 245, 0.6)' } },
            lineStyle: {
              normal: {
                color: 'rgba(62, 176, 245, 0.6)',
                width: 1
              }
            },
            symbol: 'none'
          }, {
            name: '95%',
            type: 'line',
            data: this.YData90P,
            stack: 'total',
            areaStyle: { normal: { color: 'rgba(140, 201, 239, 0.5)' } },
            lineStyle: {
              normal: {
                color: 'rgba(62, 176, 245, 0.6)',
                width: 1
              }
            },
            symbol: 'none'
          }, {
            name: 'Max',
            type: 'line',
            data: this.YDataMax,
            stack: 'total',
            lineStyle: {
              normal: {
                color: '#979797',
                width: 1,
                type: 'dashed'
              }
            },
            symbol: 'none'
          }]
        });
      }
    },
    drawCGMChart: function drawCGMChart(index) {
      var _this5 = this;

      if (!this.pageThrOpen) return;
      var i = index;
      var chartId = 'chart' + index;
      var charHandle = __WEBPACK_IMPORTED_MODULE_1_echarts__["a" /* init */](document.getElementById(chartId), null, { renderer: 'svg' });
      var chart_st = new Date(this.ts[i][0] * 1000);
      var chart_et = new Date(this.ts[i][1] * 1000);
      var chart_sleepTime = [[new Date((this.ts[i][0] + 3600 * 23) * 1000), chart_et, 25], [chart_st, new Date((this.ts[i][0] + 3600 * 6) * 1000), 25]];
      var day_sg = this.sg_data[i];
      var chart_sg = [];
      for (var _i5 = 0; _i5 < day_sg.length; _i5++) {
        if (day_sg[_i5][4] == 'C' && day_sg[_i5][3] < 0.1) {
          continue;
        }
        if (day_sg[_i5][4] == 'H') {
          day_sg[_i5][3] = 0.0;
        }
        chart_sg.push([new Date(day_sg[_i5][1] * 1000), parseFloat(day_sg[_i5][3].toFixed(1)), day_sg[_i5][4]]);
      }
      var day_bg = this.bg_data[i];
      var bgarr = this.bg[i];
      var bg_calib = [];
      for (var m = 0; m < bgarr.length; m++) {
        bg_calib.push([new Date(bgarr[m][0] * 1000), bgarr[m][1]]);
      }
      var chart_calib = [];
      for (var n = 0; n < day_bg.length; n++) {
        chart_calib.push([new Date(day_bg[n][0] * 1000), day_bg[n][1]]);
      }
      var that = this;
      charHandle.setOption({
        title: {
          text: this.isMg ? this.$t('SG') + ' (mg/dL)' : this.$t('SG') + ' (mmol/L)',
          textStyle: this.textStyle,
          padding: this.titlePadding
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line',
            axis: 'x',
            lineStyle: { color: '#333' }
          },
          textStyle: {
            color: '#ffffff'
          },
          backgroundColor: '#555',
          formatter: function formatter(params) {
            var tip = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].formatterTip1(params, that, 'ds');
            return tip;
          }
        },
        xAxis: [{
          type: 'time',
          boundaryGap: false,
          min: chart_st,
          max: chart_et,
          offset: 20,
          axisLabel: {
            margin: 10, textStyle: { color: '#282828', baseline: 'middle' },
            formatter: function formatter(value, index) {
              var H = new Date(value).getHours();
              if (index < 24) {
                if (index % 3 === 0) {
                  H = H < 10 ? '0' + H + ':00' : H + ':00';
                  return H;
                } else {
                  return ' ';
                }
              } else {
                return '24:00';
              }
            }
          },

          axisLine: { lineStyle: { color: '#ccc' } },
          splitNumber: 24,
          axisPointer: { snap: true }
        }],
        yAxis: [{
          type: 'value',
          min: 0,
          max: this.sgMax,
          axisLabel: this.yAxisLabel,
          axisLine: { lineStyle: { color: '#ccc' } },
          boundaryGap: false,
          axisTick: { length: 0 }
        }],
        grid: this.grid,
        series: [{
          name: 'SG',
          type: 'scatter',
          data: chart_sg,
          markArea: {
            data: [[{ yAxis: this.target_low }, { yAxis: this.target_high }]],
            tooltip: { show: false },
            itemStyle: {
              normal: {
                color: 'rgba(211,255,213,0.6)'
              }
            }
          },
          markLine: {
            data: [{ yAxis: 3.1 }],
            symbol: ['circle', 'circle'],
            silent: true,
            symbolSize: 1,
            lineStyle: {
              normal: {
                color: 'rgba(255,0,0,0.5)',
                type: 'solid'
              }
            },
            label: { normal: { show: false } }
          },
          itemStyle: {
            normal: {
              color: function color(params) {
                var color = '#2cd200';
                if (params.value[2] === 'H') {
                  color = '#a4a4a4';
                } else {
                  {
                    if (params.value[1] > _this5.target_high) {
                      color = '#e6be00';
                    }
                    if (params.value[1] < _this5.target_low) {
                      color = '#ff5c5c';
                    }
                  }
                }
                var type = params.value[2];
                if (type === 'NC' && params.value[1] == 0 || type === 'DE' || type === 'CE0' || type === 'CE1') {
                  color = 'transparent';
                }
                return color;
              }
            }
          },
          tooltip: {
            backgroundColor: '#333',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].formatterDate5(date);
              if (params.value[1] > 0) {
                if (params.value[2] === 'CX' || params.value[2] === 'NC') {
                  return time[0] + ':' + time[1] + ', ' + params.value[1].toFixed(1) + '<hr style="width: 20px;background:#FFF;height:1px;border:none;margin-left: 42px;">';
                }
                return time[0] + ':' + time[1] + ', ' + params.value[1].toFixed(1);
              } else {
                if (params.value[2] === 'NC') {
                  return time[0] + ':' + time[1] + ', Not Calibrated';
                }
                if (params.value[2] === 'DE') {
                  return time[0] + ':' + time[1] + ', No Readings';
                }
                if (params.value[2] === 'CE0' || params.value[2] === 'CE1') {
                  return time[0] + ':' + time[1] + ',Calib Error';
                }
                return time[0] + ':' + time[1] + ', warm up';
              }
            }
          },
          symbolSize: 2
        }, {
          type: 'scatter',
          data: chart_calib,
          symbol: 'image://static/legend/calib.png',
          tooltip: {
            trigger: 'item',
            z: 999,
            backgroundColor: '#555',
            formatter: function formatter(params) {
              var tip = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].formatterTip1([params], that, 'ds');
              return tip;
            }
          }
        }, {
          type: 'scatter',
          data: bg_calib,
          symbol: 'image://static/legend/calibrate_1.png',
          tooltip: {
            backgroundColor: '#555',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].formatterDate5(date);
              return time[0] + ':' + time[1] + ',BG ' + params.value[1];
            }
          }
        }, {
          type: 'scatter',
          data: this.transmtr,
          symbol: 'rect',
          symbolSize: 5,
          itemStyle: { normal: { color: '#00a107' } },
          tooltip: {
            backgroundColor: '#333',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].formatterDate5(date);
              return time[0] + ':' + time[1] + ', ' + 'New Sensor';
            }
          }
        }, {
          type: 'scatter',
          data: this.sensor_alarm,
          symbol: 'image://static/legend/Alert.png',
          symbolSize: 13,
          tooltip: {
            backgroundColor: '#333',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].formatterDate5(date);
              return time[0] + ':' + time[1] + ', ' + params.value[2];
            }
          }
        }, {
          type: 'custom',
          data: chart_sleepTime,
          z: -1,
          renderItem: function renderItem(params, api) {
            var y = api.value(2);
            var start = api.coord([api.value(0), y]);
            var size = api.size([api.value(1) - api.value(0), y]);
            var style = api.style();
            return {
              type: 'rect',
              shape: {
                x: start[0],
                y: start[1],
                width: size[0],
                height: size[1]
              },
              style: style
            };
          },
          tooltip: { show: false },
          itemStyle: { normal: { color: 'rgba(170,170,170,0.2)' } }
        }]
      });
    }
  }
});

/***/ }),

/***/ 334:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth_auth__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ReportFooter__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ReportFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ReportFooter__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: { ReportFooter: __WEBPACK_IMPORTED_MODULE_2__ReportFooter___default.a },
  data: function data() {
    var _this = this;

    return {
      low_glucose: 3.9,
      tmpLow_glucose: 3.9,
      high_glucose: 10,
      tmpHigh_glucose: 10,
      endHourSelectKey: 'endHourSelectKey',
      startHourSelectKey: "startHourSelectKey",
      startHourSelectOptions: new Array(25).fill(1).map(function (_, index) {
        return { value: index, disable: false };
      }),
      endHourSelectOptions: new Array(25).fill(1).map(function (_, index) {
        return { value: index, disable: false };
      }),
      patient_info: {
        Name: '-'
      },
      minHourRange: 72,
      maxHourRange: 336,
      startHour: 0,
      endHour: 24,
      oneHour: 3600000,
      info: {},
      time_range: '-',
      date_list: [],
      statistics: [],
      report_date: '',
      sg_data: [],
      ts: [],
      radio1: true,
      radio2: true,
      radio3: true,
      isMg: false,
      startDate: null,
      endDate: null,
      startDateText: '',
      dayNum: 14,
      startDateSave: null,
      endDateSave: null,
      data_map: [],
      cureNo: '',
      uid: 0,
      starDateLim: 0,
      hasData: true,
      noData: false,
      loading: false,
      exportBtnEnable: false,
      clearDateEnable: false,
      startDatePickerOptions: {
        disabledDate: function disabledDate(time) {
          if (_this.starDateLim == 0) {
            return time.getTime() + (_this.minHourRange - _this.endHour + _this.startHour) * _this.oneHour > new Date().getTime();
          } else {
            return time.getTime() >= new Date(_this.starDateLim * 1000).getTime();
          }
        }
      },
      endDatePickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > new Date().getTime() || time.getTime() > _this.startDate.getTime() + (_this.maxHourRange - _this.endHour + _this.startHour) * _this.oneHour || time.getTime() < _this.startDate.getTime() + (_this.minHourRange - _this.endHour + _this.startHour) * _this.oneHour;
        }
      },
      total: [],
      pageInfo: {
        curIndex: 0,
        pageNum: 0
      },
      perPage: 6,
      selectIndex: null,
      timer: null,
      flagTypeFollow: false,
      headList: [{ label: '姓名' }, { label: '手机号' }, { label: '住院号/门诊号' }, { label: '年龄' }, { label: '性别' }, { label: '科室' }]
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.fromPath = from.path;
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    var app_type = sessionStorage.getItem('app_type');
    if (app_type == 'EasyFollow') {
      this.flagTypeFollow = true;
      this.headList = [{ label: '姓名' }, { label: '手机号' }, { label: '出生日期' }, { label: '性别' }];
    }
    this.$nextTick(function () {
      if (!_this2.fromPath || !_this2.fromPath.match(/report/g)) {
        _this2.pageInfo.curIndex = 0;
      }
    });
    this.low_glucose = sessionStorage.getItem('low_glucose') || 3.9;
    this.high_glucose = sessionStorage.getItem('high_glucose') || 10;
    var req = this.getRequest();
    this.cureNo = req.cureNo;
    var patientInfo = sessionStorage.getItem('ReportPatientInfo');
    try {
      patientInfo = JSON.parse(patientInfo);
    } catch (e) {
      return;
    }
    this.patient_info.Name = patientInfo.name;
    this.patient_info.Mobile = patientInfo.mobile;
    this.patient_info.Age = patientInfo.age > 0 ? patientInfo.age : '';
    this.patient_info.AdmitNo = patientInfo.cureNo;
    this.patient_info.Dept = patientInfo.dept;
    this.patient_info.Sex = patientInfo.sex;
    this.patient_info.Diag = patientInfo.follow_diagnosis;
    this.patient_info.bed = patientInfo.bed;
    if (this.flagTypeFollow) {
      this.patient_info.birthday = patientInfo.birthday ? __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].formatterDate3(new Date(patientInfo.birthday).getTime() / 1000) : '';
    } else {
      this.patient_info.birthday = patientInfo.birthday ? __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].formatterDate3(patientInfo.birthday) : '';
    }

    this.uid = patientInfo.uid;
    this.pageInfo.curIndex = new Number(sessionStorage.getItem('pageIndex')).valueOf();
    setTimeout(function () {
      var curDate = new Date();

      _this2.$http.get('/api/v2.1/device/' + patientInfo.uid + '/records?flag=report').then(function (res) {
        var error = res.data.error;
        if (0 == error) {
          var data_map = [];
          var total = [];
          for (var i = res.data.data.tyDeviceRecord.length - 1; i >= 0; i--) {
            total.push(res.data.data.tyDeviceRecord[i]);
          }
          if (res.data.data.tyDeviceRecord.length > 0) {
            this.starDateLim = res.data.data.tyDeviceRecord[res.data.data.tyDeviceRecord.length - 1][1];
          }
          if (this.starDateLim) {
            curDate = new Date(this.starDateLim * 1000);
            this.endDate = new Date(curDate.getFullYear(), curDate.getMonth(), curDate.getDate());
            this.startDate = new Date(this.endDate.getTime() - this.minHourRange * this.oneHour);
          } else {
            this.endDate = new Date(curDate.getFullYear(), curDate.getMonth(), curDate.getDate());
            this.startDate = new Date(this.endDate.getTime() - this.minHourRange * this.oneHour);
          }
          this.total = total;
          this.pageInfo.pageNum = Math.ceil(this.total.length / this.perPage);
          this.updatePage(this.pageInfo.curIndex);
        }
      }, function (err) {});

      return;
    }, 0);
  },

  methods: {
    debounce: function debounce(func, delay, agm) {
      var _this3 = this;

      return function () {
        if (_this3.timer) clearTimeout(_this3.timer);
        _this3.timer = setTimeout(function () {
          func.apply(_this3, agm);
        }, delay);
      }();
    },
    checkInputValue: function checkInputValue(value, flag) {
      var isBlur = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (typeof value === 'number' || value.match(/^[\d]+(\.[\d])?$/g)) {
        var num = +value;
        if (flag === "high_glucose") {
          if (num > 13.8 || num < 3.1) {
            this.$message.warning("输入的血糖值范围为3.1~13.8mol/L");
            if (isBlur) {
              this.high_glucose = this.tmpHigh_glucose;
            }
          } else if (+this.high_glucose <= +this.low_glucose) {
            this.$message.warning("血糖低限应小于血糖高限");
            if (isBlur) {
              this.high_glucose = Math.round(this.low_glucose + 0.1);
            }
          } else {
            this.tmpHigh_glucose = value;
          }
        } else {
          if (num > 13.8 || num < 3.1) {
            this.$message.warning("输入的血糖值范围为3.1~13.8mol/L");
            if (isBlur) {
              this.low_glucose = this.tmpLow_glucose;
            }
          } else if (+this.high_glucose <= +this.low_glucose) {
            this.$message.warning("血糖低限应小于血糖高限");
            if (isBlur) {
              this.low_glucose = Math.round(this.high_glucose - 0.1);
            }
          } else {
            this.tmpLow_glucose = value;
          }
        }
      } else {
        this.$message.warning("请输入数字，保留一位小数");
        if (flag === "high_glucose") {
          if (isBlur) {
            this.high_glucose = this.tmpHigh_glucose;
          }
        } else {
          if (isBlur) {
            this.low_glucose = this.tmpLow_glucose;
          }
        }
      }
    },
    setEndHourSelectOptions: function setEndHourSelectOptions() {
      var _this4 = this;

      this.endHourSelectOptions = this.endHourSelectOptions.map(function (item) {
        return {
          value: item.value,
          disable: _this4.isEndHourDisable(item.value)
        };
      });
      this.endHourSelectKey += 1;
    },
    setStartHourSelectOptions: function setStartHourSelectOptions() {
      var _this5 = this;

      this.startHourSelectOptions = this.startHourSelectOptions.map(function (item) {
        return {
          value: item.value,
          disable: _this5.isStartHourDisable(item.value)
        };
      });
      this.startHourSelectKey += 1;
    },
    isEndHourDisable: function isEndHourDisable(hour) {
      return this.endDate.getTime() - this.startDate.getTime() > (this.maxHourRange - hour + this.startHour) * this.oneHour || this.endDate.getTime() - this.startDate.getTime() < (this.minHourRange - hour + this.startHour) * this.oneHour;
    },
    isStartHourDisable: function isStartHourDisable(hour) {
      return this.endDate.getTime() - this.startDate.getTime() > (this.maxHourRange - this.endHour + hour) * this.oneHour || this.endDate.getTime() - this.startDate.getTime() < (this.minHourRange - this.endHour + hour) * this.oneHour || this.startDate.getTime() + hour * this.oneHour >= new Date(this.starDateLim * 1000).getTime();
    },
    updateHourSelectOptions: function updateHourSelectOptions() {
      this.setStartHourSelectOptions();
      this.setEndHourSelectOptions();
    },
    change: function change() {
      var _this6 = this;

      var unable = document.getElementsByClassName('normal disabled');
      unable.onclick = function () {
        _this6.$message.error('\u62A5\u544A\u5468\u671F\u6700\u591A\u53EF\u9009\u62E9' + _this6.maxTimeRange + '\u5929');
      };
    },
    changeStartDate: function changeStartDate(newStartDate, newEndDate, index) {
      this.selectIndex = index;
      newStartDate = new Date(newStartDate);
      newEndDate = new Date(newEndDate);
      this.startDate = new Date(newStartDate.getFullYear(), newStartDate.getMonth(), newStartDate.getDate());
      this.startHour = newStartDate.getHours();
      var endDate = new Date(newEndDate.getFullYear(), newEndDate.getMonth(), newEndDate.getDate());
      var endHour = newEndDate.getHours() + 1;
      var timeRange = newEndDate - newStartDate + (endHour - this.startHour) * this.oneHour;
      var minRange = this.minHourRange * this.oneHour;
      var maxRange = this.maxHourRange * this.oneHour;
      if (timeRange < minRange) {
        if (this.startHour === 0) {
          this.endDate = new Date(this.startDate.getTime() + minRange - 24 * this.oneHour);
          this.endHour = 24;
        } else {
          this.endDate = new Date(this.startDate.getTime() + minRange);
          this.endHour = this.startHour;
        }
      } else if (timeRange > maxRange) {
        if (this.startHour === 0) {
          this.endDate = new Date(this.startDate.getTime() + maxRange - 24 * this.oneHour);
          this.endHour = 24;
        } else {
          this.endDate = new Date(this.startDate.getTime() + maxRange);
          this.endHour = this.startHour;
        }
      } else {
        this.endDate = endDate;
        this.endHour = endHour;
      }
      this.updateHourSelectOptions();
    },
    prevPage: function prevPage() {
      if (this.pageInfo.curIndex > 0) {
        this.updatePage(this.pageInfo.curIndex - 1);
      }
    },
    nextPage: function nextPage() {
      if (this.pageInfo.curIndex < this.pageInfo.pageNum - 1) {
        this.updatePage(this.pageInfo.curIndex + 1);
      }
    },
    updatePage: function updatePage(pageIndex) {
      var size = this.total.length;
      var curIndex = pageIndex;
      var perPage = this.perPage;
      this.pageInfo.curIndex = curIndex;
      sessionStorage.setItem('pageIndex', pageIndex);
      var data_map = [];
      for (var i = 0; i < perPage; i++) {
        var pos = curIndex * perPage + i;
        if (pos >= size) {
          break;
        }
        var item = this.total[pos];

        if (item[1] == 0) {
          item[1] = new Date().getTime() / 1000;
        }
        data_map.push([__WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].deviceSNFormatV2(item[2], 'TRANS'), __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].formatterDate1a(new Date(item[0] * 1000)), __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].formatterDate1a(new Date(item[1] * 1000))]);
      }
      this.data_map = data_map;
    },
    backToList: function backToList() {
      this.$router.push('/reportList');
    },
    formatDate: function formatDate(d) {
      return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
    },
    exportPDF: function exportPDF() {
      console.log(this.radio1);
      if (!this.radio1 && !this.radio2 && !this.radio3) return;
      var params = {};
      params['cureNo'] = this.cureNo;
      params['uid'] = this.uid;
      params['radio1'] = this.radio1;
      params['radio2'] = this.radio2;
      params['radio3'] = this.radio3;
      params['endDate'] = this.formatDate(this.endDate);
      params['endDateTime'] = this.endDate.getTime() / 1000;
      params['dayNum'] = (this.endDate.setHours(0, 0, 0, 0) - this.startDate.setHours(0, 0, 0, 0)) / (this.oneHour * 24) + 1 || 1;
      params['dayNum'] = params['dayNum'] > 15 ? 15 : params['dayNum'];
      sessionStorage.setItem('low_glucose', this.low_glucose);
      sessionStorage.setItem('high_glucose', this.high_glucose);
      sessionStorage.setItem('startHour', this.startHour);
      sessionStorage.setItem('endHour', this.endHour);
      if (this.patient_info) {
        params['patient_info'] = this.patient_info;
      }
      if (this.info) {
        params['info'] = this.info;
      }
      sessionStorage.setItem('hcgm_report_params', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params));
      this.$router.push('/report1');
    },
    getRequest: function getRequest() {
      var href = location.href;
      var theRequest = {};
      if (href.indexOf("?") != -1) {
        var search = href.substring(href.indexOf("?") + 1);
        var strs = search.split("&");
        for (var i = 0; i < strs.length; i++) {
          var pair = strs[i].split("=");
          theRequest[pair[0]] = unescape(pair[1]);
        }
      }
      return theRequest;
    }
  },
  watch: {
    startDate: function startDate(newvalue, oldvalue) {
      if (newvalue) {
        var addTime = this.endDate.getTime() - newvalue.getTime() + (this.endHour - this.startHour) * this.oneHour;
        if (addTime > this.oneHour * this.maxHourRange) {
          this.endDate = new Date(newvalue.getTime() + this.oneHour * this.maxHourRange);
        } else if (addTime < this.oneHour * this.minHourRange) {
          this.endDate = new Date(newvalue.getTime() + this.oneHour * this.minHourRange);
        }
        this.updateHourSelectOptions();
      }
    },
    endDate: function endDate(val) {
      if (val) {
        this.updateHourSelectOptions();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    sessionStorage.setItem('low_glucose', this.low_glucose);
    sessionStorage.setItem('high_glucose', this.high_glucose);
  }
});

/***/ }),

/***/ 335:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_auth__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      contactURL: '',
      privacyURL: '',
      termsOfUseURL: '',
      username: '',
      password: '',
      flag: true

    };
  },

  computed: {},
  watch: {},
  mounted: function mounted() {
    var _this = this;

    var req = this.getRequest();
    this.cureNo = req.cureNo;
    if (sessionStorage.getItem('1061Flag') == 'true') {
      this.flag = false;
      sessionStorage.setItem('1061Flag', false);
    }
    setTimeout(function () {
      var host = 'https://www.medtrum.com.cn';
      _this.contactURL = host + '/contact.html';
      _this.privacyURL = host + '/privacy_policy.html';
      _this.termsOfUseURL = host + '/terms_of_use.html';
    }, 50);
  },

  methods: {
    onBtnLogin: function onBtnLogin() {
      if (!this.username || !this.password) {
        this.$message.error("请输入账号密码");
        return;
      }
      this.flag = true;
      sessionStorage.setItem('1061Flag', 'false');
      this.$http.post('/api/v2.1/login', {
        'user_name': this.username,
        'password': this.password,
        'user_type': 'M',
        'flag': 'clinic_report_login'
      }).then(function (res) {
        var error = res.data.error;
        if (0 == error) {
          var username = res.data.username;
          var org_name = res.data.org_name;
          sessionStorage.setItem('created_by', res.data.created_by);
          sessionStorage.setItem('username', username);
          sessionStorage.setItem('org_name', org_name);
          sessionStorage.setItem('app_type', res.data.app_type);
          this.$router.push('/reportList');
        } else if (error === 9) {
          var tip = '\u5BC6\u7801\u8F93\u5165\u9519\u8BEF\uFF0C\u8FD8\u5269' + res.body.left_try_num + '\u6B21\u5C1D\u8BD5\uFF0C\u8BF7\u786E\u8BA4\u767B\u5F55\u5BC6\u7801\u6B63\u786E';
          this.$message.error(tip);
        } else if (error === 62) {
          var _tip = '\u5BC6\u7801\u9519\u8BEF\u6B21\u6570\u8D85\u8FC7\u9650\u5236\uFF0C\u8D26\u6237\u5DF2\u88AB\u9501\u5B9A\uFF0C\u8BF7' + res.body.unlock_time_left + '\u5206\u949F\u540E\u518D\u8BD5';
          this.$message.error(_tip);
        } else if (error === 1061) {
          this.flag = false;
          sessionStorage.setItem('1061Flag', 'true');
        } else {
          this.$message.error("登录失败");
        }
      }, function (err) {
        this.$message.error("请稍后重试");
      });
    },
    getRequest: function getRequest() {
      var href = location.href;
      var theRequest = {};
      if (href.indexOf("?") != -1) {
        var search = href.substring(href.indexOf("?") + 1);
        var strs = search.split("&");
        for (var i = 0; i < strs.length; i++) {
          var pair = strs[i].split("=");
          theRequest[pair[0]] = unescape(pair[1]);
        }
      }
      return theRequest;
    }
  }
});

/***/ }),

/***/ 336:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_auth__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      contactURL: '',
      privacyURL: '',
      termsOfUseURL: '',
      username: 'xxxxx'
    };
  },

  computed: {},
  watch: {},
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      var host = 'https://www.medtrum.com.cn';
      _this.contactURL = host + '/contact.html';
      _this.privacyURL = host + '/privacy_policy.html';
      _this.termsOfUseURL = host + '/terms_of_use.html';
    }, 50);
  },

  methods: {}
});

/***/ }),

/***/ 337:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_auth__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      username: 'xxxxx'
    };
  },

  computed: {},
  watch: {},
  mounted: function mounted() {
    var username = sessionStorage.getItem('username');
    this.username = username;
  },

  methods: {
    logout: function logout() {
      this.$http.post('/api/v2.1/logout', {}).then(function (res) {
        if (0 == res.data.error) {
          sessionStorage.clear();
          this.$router.push('/login');
        }
      }, function (err) {});
    }
  }
});

/***/ }),

/***/ 338:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_auth__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ReportFooter__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ReportFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ReportFooter__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { ReportFooter: __WEBPACK_IMPORTED_MODULE_3__ReportFooter___default.a },
  data: function data() {
    return {
      patientList: [],
      tablist: [],
      total: [],
      saveTotal: [],
      pageInfo: {
        curIndex: 0,
        pageNum: 0
      },
      perPage: 8,
      flagTypeFollow: false,
      searchWord: sessionStorage.getItem('WeitanReportInput') || '',
      typeSelect: sessionStorage.getItem('weitanTypeSelect') || 'all',
      headerList: [{ label: '姓名' }, { label: '科室' }, { label: '手机号' }, { label: '血糖值mmol/L' }, { label: '住院号/门诊号' }, { label: '操作' }]
    };
  },

  computed: {},
  watch: {
    typeSelect: function typeSelect() {
      sessionStorage.setItem('weitanTypeSelect', this.typeSelect);
      this.updatePage(0);
    }
  },
  mounted: function mounted() {
    var app_type = sessionStorage.getItem('app_type');
    if (app_type == 'EasyFollow') {
      this.flagTypeFollow = true;
      this.headerList = [{ label: '姓名' }, { label: '手机号/邮箱' }, { label: '血糖值mmol/L' }, { label: '操作' }];
    }
    var req = this.getRequest();
    this.cureNo = req.cureNo;

    this.$http.post('/api/v2.1/monitor/connections', {
      per_page: 9999
    }).then(function (res) {
      if (0 == res.data.error) {
        var datas = res.data.data.items.sort(function (a, b) {

          if (a.create_time < b.create_time) {
            return 1;
          } else {
            return -1;
          }
        });
        this.total = [];
        var name = sessionStorage.getItem('username');
        var created_by = sessionStorage.getItem('created_by');

        if (created_by == 'register') {
          this.total = datas;
        } else {
          for (var i = 0; i < datas.length; i++) {
            var str = datas[i].data.follow_list.join(',');
            var arr = str.toLocaleLowerCase().split(',');
            if (arr.includes(name.toLocaleLowerCase())) {
              this.total.push(datas[i]);
            }
          }
        }

        for (var j = 0; j < this.total.length; j++) {
          var item = this.total[j];
          item.used = 'noused';
          if (item.sensor_status) {
            if (item.sensor_status.updateTime) {
              var num = (new Date().getTime() - item.sensor_status.updateTime * 1000) / 3600000;
              if (num < 1) {
                item.used = 'used';
              }
            }
          }
        }
        this.saveTotal = this.total;
        this.pageInfo.pageNum = Math.ceil(this.total.length / this.perPage);
        this.pageInfo.curIndex = this.$store.state.patientPage;

        this.pageInfo.curIndex = Number(sessionStorage.getItem('weitanCurIndex')) || 0;
        this.updatePage(this.pageInfo.curIndex);
      } else {}
    }, function (err) {});
  },

  methods: {
    startSearch: function startSearch() {
      this.updatePage(0);
    },
    prevPage: function prevPage() {
      if (this.pageInfo.curIndex > 0) {

        this.updatePage(this.pageInfo.curIndex - 1);
      }
    },
    nextPage: function nextPage() {
      if (this.pageInfo.curIndex < this.pageInfo.pageNum - 1) {

        this.updatePage(this.pageInfo.curIndex + 1);
      }
    },
    updatePage: function updatePage(pageIndex) {
      if (!this.searchWord) {
        this.total = this.saveTotal;
        this.pageInfo.pageNum = Math.ceil(this.total.length / this.perPage);
      } else {
        var searchTotal = [];

        for (var i = 0; i < this.saveTotal.length; i++) {
          var item = this.saveTotal[i];
          var copyItem = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, item);
          var name = item.alias || '';
          if (this.flagTypeFollow) {
            name = item.real_name || '';
          }
          var mobile = '';
          if (item.username.match(/^[\d]{11}$/)) {
            mobile = item.username;
          }

          if (name.indexOf(this.searchWord) >= 0 || mobile.indexOf(this.searchWord) >= 0) {
            if (this.flagTypeFollow) {
              copyItem.real_name = name.replace(this.searchWord, '<span style="color: lightcoral">' + this.searchWord + '</span>');
            } else {
              copyItem.alias = name.replace(this.searchWord, '<span style="color: lightcoral">' + this.searchWord + '</span>');
            }

            copyItem.username = mobile.replace(this.searchWord, '<span style="color: lightcoral">' + this.searchWord + '</span>');
            searchTotal.push(copyItem);
          }
        }
        this.total = searchTotal;
      }
      sessionStorage.setItem('WeitanReportInput', this.searchWord);

      var totalSe = [];
      if (this.typeSelect == 'all') {
        totalSe = this.total;
      } else {
        for (var k = 0; k < this.total.length; k++) {
          if (this.total[k].used == this.typeSelect) {
            totalSe.push(this.total[k]);
          }
        }
      }

      var size = totalSe.length;
      this.pageInfo.pageNum = Math.ceil(size / this.perPage);
      var curIndex = pageIndex;
      var perPage = this.perPage;
      this.pageInfo.curIndex = curIndex;
      sessionStorage.setItem('weitanCurIndex', curIndex);

      var patientList = [];
      for (var _i = 0; _i < perPage; _i++) {
        var pos = curIndex * perPage + _i;
        if (pos >= size) {
          break;
        }
        var itemSe = totalSe[pos];

        var patientInfo = {};
        patientInfo.name = itemSe.alias;
        patientInfo.uid = itemSe.uid;

        patientInfo.username = itemSe.username;
        patientInfo.followID = itemSe.follow_id || '';
        patientInfo.glucose = '--';


        if (itemSe.data) {
          if (itemSe.data.follow_gender) {
            patientInfo.sex = itemSe.data.follow_gender == '1' ? '男' : '女';
          } else {
            itemSe.data.follow_gender = '';
          }
          patientInfo.dept = itemSe.data.follow_department;
          patientInfo.cureNo = itemSe.data.HospitalNumber;
          patientInfo.follow_diagnosis = itemSe.data.follow_diagnosis;
          patientInfo.birthday = itemSe.data.birthday;
          patientInfo.bed = itemSe.data.bed;
          patientInfo.age = itemSe.data.age > 0 ? itemSe.data.age : '';
        }
        patientInfo.mobile = itemSe.username;

        if (this.flagTypeFollow) {
          patientInfo.name = itemSe.real_name;
          patientInfo.birthday = itemSe.birth_date;
          if (itemSe.gender == 'GDRM') {
            patientInfo.sex = '男';
          } else if (itemSe.gender == 'GDRF') {
            patientInfo.sex = '女';
          } else if (itemSe.gender == 'GDRNF') {
            patientInfo.sex = '';
          }
        }
        if (itemSe.sensor_status) {
          if (itemSe.sensor_status.updateTime) {
            var num = (new Date().getTime() - itemSe.sensor_status.updateTime * 1000) / 3600000;
            if (num < 1) {
              patientInfo.glucose = itemSe.sensor_status.glucose.toFixed(1) || '--';
              patientInfo.glucose = patientInfo.glucose == 0 ? '--' : patientInfo.glucose;
              patientInfo.glucose = patientInfo.glucose > 22.2 ? '偏高' : patientInfo.glucose;
              patientInfo.glucose = patientInfo.glucose < 2.2 ? '偏低' : patientInfo.glucose;
            }
          }
        }
        patientList.push(patientInfo);
      }
      this.patientList = patientList;
      this.tablist = this.patientList;
    },
    onBtnLogin: function onBtnLogin() {},
    viewReportPrepare: function viewReportPrepare(index) {
      var patientInfo = this.patientList[index];
      if (this.searchWord.length) {
        var keys = ['mobile', 'name'];
        keys.map(function (key) {
          if (patientInfo[key] && patientInfo[key].match(/[<>]/)) {
            var splitList = patientInfo[key].split(/[<>]/);
            patientInfo[key] = splitList[0] + splitList[2] + splitList[4];
          }
        });
      }
      sessionStorage.setItem('ReportPatientInfo', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(patientInfo));
      this.$store.commit('updatePatientPage', this.pageInfo.curIndex);
      this.$router.push('/reportPrepare');
    },
    getRequest: function getRequest() {
      var href = location.href;
      var theRequest = {};
      if (href.indexOf("?") != -1) {
        var search = href.substring(href.indexOf("?") + 1);
        var strs = search.split("&");
        for (var i = 0; i < strs.length; i++) {
          var pair = strs[i].split("=");
          theRequest[pair[0]] = unescape(pair[1]);
        }
      }
      return theRequest;
    }
  }
});

/***/ }),

/***/ 339:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            fileList: []
        };
    },

    methods: {
        handleChange: function handleChange(file) {
            var reader = new FileReader();
            if (typeof FileReader === "undefined") {
                this.$message({
                    type: "info",
                    message: "您的浏览器不支持文件读取。"
                });
                return;
            }
            reader.readAsText(file.raw, "UTF-8");
            var that = this;
            reader.onload = function (e) {
                var content = e.target.result;
                console.log("读取的内容如下：");
                console.log(content);
                if (content) {
                    localStorage.setItem('MachineCodeMZ', content);
                    that.$message({
                        type: "success",
                        message: "成功添加机器码"
                    });
                    that.$router.push('/login');
                }
            };
        }
    }
});

/***/ }),

/***/ 340:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_auth__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      contactURL: "",
      privacyURL: "",
      termsOfUseURL: "",
      username: "",
      password: ""
    };
  },

  computed: {},
  watch: {},
  mounted: function mounted() {},

  methods: {
    onBtnSelect: function onBtnSelect(signal) {
      if (signal === "cgms") {
        window.open("https://cgms.medtrum.cn", "_self");
      } else if (signal === "report") {
        this.$router.push("/login");
      }
    }
  }
});

/***/ }),

/***/ 341:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App_vue__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_router__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_resource__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_default_index_css__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_default_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuerify__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuerify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vuerify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_v_vuerify_next__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_v_vuerify_next___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_v_vuerify_next__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_i18n__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuex__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_locale_lang_zh_CN__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_locale_lang_zh_CN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_locale_lang_zh_CN__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_print_nb__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_print_nb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_print_nb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__static_login_css__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__static_login_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__static_login_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__auth_store__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__routes__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__lang_zh_js__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_crypto_js_core__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_crypto_js_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_crypto_js_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_crypto_js_hmac_sha256__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_crypto_js_hmac_sha256___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_crypto_js_hmac_sha256__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_crypto_js_enc_base64__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_crypto_js_enc_base64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_crypto_js_enc_base64__);

























__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vuerify___default.a, {
  icode: { test: /^\d{6}$/, message: '请输入6位数字' },
  mobile: { test: /\d{1,}/, message: 'Mobile must have 1 or more numbers' },
  realname: { test: /^[A-Za-z0-9][A-Za-z0-9\s]{2,18}[A-Za-z0-9]$/, message: '请输入正确姓名' },
  password: { test: /\S{6,20}/, message: '密码格式不对' },
  postcode: { test: /^\d{6}$/, message: '请输入6位数字' },
  height: { test: /^\d{2,}$/, message: 'Height must have 2 or more numbers' },
  weight: { test: /^\d{2,}$/, message: 'Weight must have 2 or more numbers' },
  email: { test: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/, message: 'Please enter a valid Email.' }
});
__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_v_vuerify_next___default.a);
__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue_i18n__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vuex__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15_vue_print_nb___default.a);

var i18n = new __WEBPACK_IMPORTED_MODULE_12_vue_i18n__["a" /* default */]({
  locale: 'zh',
  messages: {
    'zh': __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_19__lang_zh_js__["a" /* zhMessages */], __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_locale_lang_zh_CN___default.a)
  }
});
__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_element_ui___default.a, {});

var router = new __WEBPACK_IMPORTED_MODULE_6_vue_router__["a" /* default */]({
  routes: __WEBPACK_IMPORTED_MODULE_18__routes__["a" /* default */]
});

function generateNonce() {
  var array = new Uint8Array(32);

  if (window.crypto && window.crypto.getRandomValues) {
    window.crypto.getRandomValues(array);
  } else {
    for (var i = 0; i < 32; i++) {
      array[i] = Math.floor(Math.random() * 256);
    }
  }
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(array, function (byte) {
    return byte.toString(16).padStart(2, '0');
  }).join('');
}

function deobfuscateKey(obfuscatedKey) {
  var cleanKey = obfuscatedKey.replace(/"/g, '');

  try {
    var decoded = cleanKey;

    for (var i = 0; i < 3; i++) {
      try {
        decoded = atob(decoded);

        if (isReadableText(decoded)) {
          return decoded;
        }
      } catch (e) {
        break;
      }
    }
  } catch (e) {
    console.warn('多层Base64解码失败，尝试其他方法');
  }

  try {
    var aesKey = 'medtrum_secure_key_2024';
    var decrypted = decryptAES(cleanKey, aesKey);
    if (decrypted && decrypted.length > 0) {
      return decrypted;
    }
  } catch (e) {
    console.warn('AES解密失败，尝试其他方法');
  }

  try {
    var xorKey = 'medtrum_xor_key';
    var _decrypted = decryptXOR(cleanKey, xorKey);
    if (_decrypted && _decrypted.length > 0) {
      return _decrypted;
    }
  } catch (e) {
    console.warn('异或解密失败，尝试其他方法');
  }

  try {
    var _decrypted2 = decryptCaesar(cleanKey, 5);
    if (_decrypted2 && _decrypted2.length > 0) {
      return _decrypted2;
    }
  } catch (e) {
    console.warn('凯撒密码解密失败，尝试其他方法');
  }

  try {
    var _decrypted3 = decryptComplex(cleanKey);
    if (_decrypted3 && _decrypted3.length > 0) {
      return _decrypted3;
    }
  } catch (e) {
    console.warn('复杂解密失败，尝试其他方法');
  }

  console.warn('所有高级混淆解密方法失败，使用原始密钥');
  return cleanKey;
}

function isReadableText(str) {
  var readableRegex = /^[a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?\s]*$/;
  return readableRegex.test(str) && str.length >= 10;
}

function decryptAES(encryptedText, key) {
  try {
    var words = __WEBPACK_IMPORTED_MODULE_20_crypto_js_core___default.a.enc.Base64.parse(encryptedText);
    var keyBytes = __WEBPACK_IMPORTED_MODULE_20_crypto_js_core___default.a.enc.Utf8.parse(key);
    var decrypted = __WEBPACK_IMPORTED_MODULE_20_crypto_js_core___default.a.AES.decrypt({ ciphertext: words }, keyBytes, {
      mode: __WEBPACK_IMPORTED_MODULE_20_crypto_js_core___default.a.mode.ECB,
      padding: __WEBPACK_IMPORTED_MODULE_20_crypto_js_core___default.a.pad.Pkcs7
    });
    return decrypted.toString(__WEBPACK_IMPORTED_MODULE_20_crypto_js_core___default.a.enc.Utf8);
  } catch (e) {
    throw new Error('AES解密失败');
  }
}

function decryptXOR(encryptedText, key) {
  var result = '';
  for (var i = 0; i < encryptedText.length; i++) {
    var charCode = encryptedText.charCodeAt(i) ^ key.charCodeAt(i % key.length);
    result += String.fromCharCode(charCode);
  }
  return result;
}

function decryptCaesar(encryptedText, shift) {
  var result = '';
  for (var i = 0; i < encryptedText.length; i++) {
    var charCode = encryptedText.charCodeAt(i);
    if (charCode >= 65 && charCode <= 90) {
      charCode = (charCode - 65 - shift + 26) % 26 + 65;
    } else if (charCode >= 97 && charCode <= 122) {
      charCode = (charCode - 97 - shift + 26) % 26 + 97;
    }
    result += String.fromCharCode(charCode);
  }
  return result;
}

function decryptComplex(encryptedText) {
  var step1 = encryptedText.split('').reverse().join('');

  var step2 = '';
  for (var i = 0; i < step1.length; i++) {
    step2 += String.fromCharCode(step1.charCodeAt(i) - 3);
  }

  var replaceMap = {
    'a': 'w', 'b': 'e', 'c': 'b', 'd': '6', 'e': '3',
    'f': 'L', 'g': 'P', 'h': 'G', 'i': 'c', 'j': 'K',
    'k': 'U', 'l': 'L', 'm': 'i', 'n': 'n', 'o': 'v',
    'p': 'N', 'q': 'J', 'r': 'R', 's': 'C', 't': 'm',
    'u': 'b', 'v': 'Z', 'w': 'z', 'x': '8', 'y': 'y',
    'z': '4', '0': 'n', '1': 'M', '2': 'e', '3': 'd',
    '4': 't', '5': 'r', '6': 'u', '7': 'm', '8': '2',
    '9': '0', 'A': '2', 'B': '4'
  };

  var step3 = '';
  for (var _i = 0; _i < step2.length; _i++) {
    var char = step2[_i];
    step3 += replaceMap[char] || char;
  }

  return step3;
}

function obfuscateKeyAdvanced(originalKey) {
  var _reverseMap;

  var reverseMap = (_reverseMap = {
    'w': 'a', 'e': 'b', 'b': 'c', '6': 'd', '3': 'e',
    'L': 'f', 'P': 'g', 'G': 'h', 'c': 'i', 'K': 'j',
    'U': 'k' }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_reverseMap, 'L', 'l'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_reverseMap, 'i', 'm'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_reverseMap, 'n', 'n'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_reverseMap, 'v', 'o'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_reverseMap, 'N', 'p'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_reverseMap, 'J', 'q'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_reverseMap, 'R', 'r'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_reverseMap, 'C', 's'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_reverseMap, 'm', 't'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_reverseMap, 'b', 'u'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_reverseMap, 'Z', 'v'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_reverseMap, 'z', 'w'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_reverseMap, '8', 'x'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_reverseMap, 'y', 'y'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_reverseMap, '4', 'z'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_reverseMap, 'n', '0'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_reverseMap, 'M', '1'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_reverseMap, 'e', '2'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_reverseMap, 'd', '3'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_reverseMap, 't', '4'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_reverseMap, 'r', '5'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_reverseMap, 'u', '6'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_reverseMap, 'm', '7'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_reverseMap, '2', '8'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_reverseMap, '0', '9'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_reverseMap, '2', 'A'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_reverseMap, '4', 'B'), _reverseMap);

  var step1 = '';
  for (var i = 0; i < originalKey.length; i++) {
    var char = originalKey[i];
    step1 += reverseMap[char] || char;
  }

  var step2 = '';
  for (var _i2 = 0; _i2 < step1.length; _i2++) {
    step2 += String.fromCharCode(step1.charCodeAt(_i2) + 3);
  }

  var step3 = step2.split('').reverse().join('');

  var step4 = btoa(btoa(step3));

  return step4;
}

function generateSignature(config, timestamp, nonce, deviceId, secretKey) {
  var isDevelopment = "production" === 'development';
  var baseURL = isDevelopment ? 'https://crt.medtrum.cn' : window.location.origin;
  var url = config.url || '';
  var fullUrl = baseURL + url;

  var processedUrl = fullUrl;

  if (config.method === 'get' && config.body) {
    var queryString = new URLSearchParams(config.body).toString();
    processedUrl += '?' + queryString;
  }
  var urlLast128 = processedUrl.slice(-128).replace("http://", "https://");
  var requestParams = '';

  if (config.body) {
    requestParams = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(config.body);
  } else if (config.data) {
    requestParams = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(config.data);
  }
  if (config.method === 'get') {
    requestParams = '';
  }

  var dataPart = function () {
    var cleanStr = requestParams.replace(/\s+/g, '');

    var encoder = new TextEncoder();
    var utf8Bytes = encoder.encode(cleanStr);

    var slicedBytes = utf8Bytes.slice(0, 64);

    var decoder = new TextDecoder('utf-8');
    return decoder.decode(slicedBytes);
  }();


  var message = 'Med' + urlLast128 + dataPart + nonce + deviceId + timestamp;

  console.log('message', message);

  return __WEBPACK_IMPORTED_MODULE_21_crypto_js_hmac_sha256___default()(message, secretKey).toString(__WEBPACK_IMPORTED_MODULE_22_crypto_js_enc_base64___default.a);
}

function getDeviceId() {
  var deviceId = localStorage.getItem('device_id');
  if (!deviceId) {
    deviceId = 'device_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
    localStorage.setItem('device_id', deviceId);
  }
  return deviceId;
}
__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.pushRequest = function (request) {
  this.$store.commit('updateRequest', request);
};

__WEBPACK_IMPORTED_MODULE_4_vue__["default"].http.interceptors.push(function (request, next) {
  if (request.method === 'GET') {
    if (request.url.indexOf('?') > 0) {
      request.url += '&_=' + new Date().getTime();
    } else {
      request.url += '?_=' + new Date().getTime();
    }
  }
  var MachID = localStorage.getItem('MachineCodeMZ');
  request.headers.set('Token', 'C0NNqtiOd2BWElrR8W4l8c2t5O1NaX0D2c7cgGfFAyYykYTtgh6KUJTwA8WBSBkd');
  request.headers.set('AppTag', 'n=ccrt;v=1.0.6(6)');
  var timestamp = Math.floor(Date.now() / 1000).toString();
  var nonce = generateNonce();
  var deviceId = getDeviceId();

  var secretKey = deobfuscateKey("d2ViNjNMUEdjS1VMaW52TkpSQ21iWno4eTRu");
  var signature = generateSignature(request, timestamp, nonce, deviceId, secretKey);
  request.headers.set('X-Timestamp', timestamp);
  request.headers.set('X-Nonce', nonce);
  request.headers.set('X-Signature', signature);
  request.headers.set('X-DeviceId', deviceId);

  if (MachID) {
    request.headers.set('MachID', MachID);
  } else {
    request.headers.set('MachID', '');
  }

  next(function (response) {
    var ERROR = response.data.error;
    i18n.locale = __WEBPACK_IMPORTED_MODULE_17__auth_store__["a" /* default */].getters.getLang;

    if (ERROR) {
      switch (ERROR) {
        case 1061:
          router.push('/login');
          sessionStorage.setItem('1061Flag', 'true');
          break;
      }
    }
    return response;
  });
});
var vm = new __WEBPACK_IMPORTED_MODULE_4_vue__["default"]({
  router: router,
  store: __WEBPACK_IMPORTED_MODULE_17__auth_store__["a" /* default */],
  i18n: i18n,
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_5__App_vue___default.a);
  }
}).$mount('#app');

/***/ }),

/***/ 54:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);


var SERVER_URL = 'api';

/* harmony default export */ __webpack_exports__["a"] = ({
  data: {
    authenticated: false
  },
  login: function login(context, info) {
    var that = this;
    context.$http.post(SERVER_URL + '/v2.0/login', info).then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        sessionStorage.setItem('token', 'Header:' + res.bodyText);
        sessionStorage.setItem('uid', res.data.uid);
        sessionStorage.setItem('userType', res.data.user_type);
        sessionStorage.setItem('username', res.data.username);
        var country = res.data.country;
        if (country === 'FR' || country === 'DE' || country === 'IT' || country === 'PT' || country === 'ES' || country === 'TR' || country === 'AE' || country === 'Ro' || country === 'PL') {
          localStorage.setItem('unit', 'mg');
        } else {
          localStorage.setItem('unit', 'mmol');
        }
        if ('admin_login' == res.data.flag) {
          this.$router.push('CreateHCP');
          return;
        }
        if ('clinic_login' == res.data.flag) {
          this.$router.push('ClinicPatientList');
          return;
        }
        if (res.data.user_type === 'D') {
          this.$router.push('PatientList');
          var unread = res.data.unread_message;
          context.$store.commit('updateUnRead', unread);
        }
        if (res.data.user_type === 'P') {
          this.$router.push('monitor');
          var _unread = res.data.connection_request;
          context.$store.commit('updateUnRead', _unread);
        }
        if (res.data.user_type === 'M') {
          this.$router.push('carerConnection');
          var _unread2 = res.data.unread_message;
          context.$store.commit('updateUnRead', _unread2);
        }
      } else if (52 == err) {
        this.$message.error('Your account is not approved.');
      }
      if (err === 2) {
        var tip = context.$t('userNotExist');
        context.$message.error(tip);
      }
      if (err === 9) {
        var _tip = context.$t('Password incorrect');
        context.$message.error(_tip);
      }
      if (err === 10) {
        var _tip2 = context.$t('UserType incorrect');
        context.$message.error(_tip2);
      }
    }, function (err) {
      context.error = err.body.message;
    });
  },
  getPortrait: function getPortrait(context, uid) {
    context.$http.get(SERVER_URL + '/v2.0/person/' + uid + '/portrait').then(function (res) {
      var err = res.body.error;
      if (err === 0) {}
    });
  },
  getProfile: function getProfile(context) {
    var that = this;
    context.$http.get(SERVER_URL + '/v2.0/person/profile').then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        var profile = res.data.profile;
        that.initProfile2(context, profile);
        context.profile = profile;
      }
    });
  },
  modifyPersonProfile: function modifyPersonProfile(context, profile) {
    var that = this;
    var user = sessionStorage.getItem('userType');
    context.$http.post(SERVER_URL + '/v2.0/person/profile', { profile: profile }).then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        var tip = context.$t('saveTip');
        context.$message({
          type: 'success',
          message: tip
        });
        if (user === 'P') {
          context.$router.push('/monitor');
        }
        if (user === 'D') {
          context.$router.push('/PatientList');
        }
        if (user === 'M') {
          context.$router.push('/carerConnection');
        }
      } else {
        var _tip3 = context.$t('Input error');
        context.$message.error(_tip3);
      }
    });
  },
  getMessages: function getMessages(context, uid) {
    var that = this;
    context.$http.get(SERVER_URL + '/v2.0/messages').then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        context.messages = res.data.data.map(function (e, i) {
          if (e[1].message_type === 'RELATION_AUTH_PERMIT') {
            e[1] = e[1].username + context.accept;
          } else if (e[1].message_type === 'RELATION_AUTH_CANCEL') {
            e[1] = e[1].username + context.cancel;
          } else {
            e[1] = e[1].username + context.reject;
          }
          if (context.isZh) {
            e[2] = that.formateDate(new Date(e[2] * 1000));
          } else {
            var time = new Date(e[2] * 1000 + 8 * 3600000).toUTCString();
            var sp1 = time.split(',');
            var sp2 = sp1[1].split(' ');
            var sp3 = sp2[4].split(':');
            e[2] = sp2[2] + ' ' + sp2[1] + ' ' + sp2[3] + ', at ' + sp3[0] + ':' + sp3[1];
          }
          e[4] = '/api/v2.0/person/' + parseInt(e[4]) + '/portrait';
          return e;
        });
        if (context.messages.length === 0) {
          context.noMes = true;
        }
      }
    });
  },
  getUnread: function getUnread(context) {
    context.$http.get('api/v2.0/messages/unread').then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        var count = res.data.count;
        context.$store.commit('updateUnRead', count);
      }
    });
  },
  getUnread1: function getUnread1(context) {
    context.$http.get('api/v2.0/relations/auth/todo').then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        var count = res.data.count;
        context.$store.commit('updateUnRead', count);
      }
    });
  },
  goPatientProfile: function goPatientProfile(context, uid) {
    context.$http.get(SERVER_URL + '/v2.0/patients/' + uid + '/profile').then(function (res) {
      var err = res.body.error;

      if (err === 0) {
        var profile = res.data.profile;
        if (profile.created_by === 'register') {
          this.$router.push('/patientProfile2');
        } else {
          this.$router.push('/patientProfile');
        }
      }
    });
  },
  goClinicPatientProfile: function goClinicPatientProfile(context, uid) {
    context.$http.get(SERVER_URL + '/v2.0/patients/' + uid + '/profile').then(function (res) {
      var err = res.body.error;

      if (err === 0) {
        var profile = res.data.profile;
        if (profile.created_by === 'register') {
          this.$router.push('/clinic_patientProfile2');
        } else {
          this.$router.push('/clinic_patientProfile');
        }
      }
    });
  },
  getPatientProfile2: function getPatientProfile2(context, uid) {
    var that = this;
    context.$http.get(SERVER_URL + '/v2.0/patients/' + uid + '/profile').then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        var profile = res.data.profile;
        if (profile.created_by === 'register') {
          that.initProfile(context, profile);
        } else {
          that.initProfile2(context, profile);
        }
        context.profile = profile;
        context.alias = profile.alias ? profile.alias : profile.realname;
      }
    });
  },
  getPatientProfile3: function getPatientProfile3(context, uid) {
    var that = this;
    context.$http.get(SERVER_URL + '/v2.0/monitor/' + uid + '/profile').then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        var profile = res.data.profile;
        that.initProfile(context, profile);
        context.alias = profile.alias ? profile.alias : profile.realname;
        context.profile = profile;
      }
    });
  },
  initProfile: function initProfile(context, val) {
    val.username = val.username ? val.username : '--';
    val.realname = val.realname ? val.realname : '--';
    val.gender = val.gender ? context.$t(val.gender) : '--';
    val.height = val.height ? val.height + 'cm' : '--';
    val.weight = val.weight ? val.weight + 'kg' : '--';
    val.diabetes_type = val.diabetes_type ? context.$t(val.diabetes_type) : '--';
    val.address = val.address ? val.address : '--';
    val.zipcode = val.zipcode ? val.zipcode : '--';
    val.mobile = val.mobile ? val.mobile : '--';
    val.telephone = val.telephone ? val.telephone : '--';
    val.email = val.email ? val.email : '--';
    val.date = val.date ? val.date : '--';
    val.birthday = val.birthday ? val.birthday : '--';
    val.diabetes_diagnosis_date = val.diabetes_diagnosis_date ? val.diabetes_diagnosis_date : '--';
  },
  initProfile2: function initProfile2(context, val) {
    val.username = val.username ? val.username : ' ';
    val.realname = val.realname ? val.realname : '';
    val.gender = val.gender ? val.gender : '';
    val.height = val.height ? val.height : '';
    val.weight = val.weight ? val.weight : '';
    val.diabetes_type = val.diabetes_type ? val.diabetes_type : '';
    val.address = val.address ? val.address : '';
    val.zipcode = val.zipcode ? val.zipcode : '';
    val.mobile = val.mobile ? val.mobile : '';
    val.telephone = val.telephone ? val.telephone : '';
    val.email = val.email ? val.email : '';
    val.date = val.date ? val.date : '';
    val.serve_for = val.serve_for ? val.serve_for : '';
    val.major = val.major ? val.major : '';
    val.birthday = val.birthday ? val.birthday : '';
    context.birthdayShow = val.birthday;
    val.diabetes_diagonosis_date = val.diabetes_diagonosis_date ? val.diabetes_diagonosis_date : '';
    context.disDateShow = val.diabetes_diagonosis_date;
  },
  modifyPatientProfile: function modifyPatientProfile(context, pid, profile) {
    context.$http.post(SERVER_URL + '/v2.0/patients/' + pid + '/profile', { profile: profile }).then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        var tip = context.$t('saveTip');
        context.$message({
          type: 'success',
          message: tip
        });
        if (profile.alias) {
          sessionStorage.setItem('patientName', profile.alias);
          this.$store.commit('updatePatientName', profile.alias);
        } else {
          sessionStorage.setItem('patientName', profile.realname);
          this.$store.commit('updatePatientName', profile.realname);
        }
        context.$router.push('monitor');
      }
    });
  },
  modifyPatientProfile2: function modifyPatientProfile2(context, pid, profile) {
    context.$http.post('api/v2.0/monitor/' + pid + '/settings', profile).then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        var tip = context.$t('saveTip');
        context.$message({
          type: 'success',
          message: tip
        });
        context.$router.push('/carerConnection');
      } else {
        var _tip4 = context.$t('modifyFailed');
        context.$message.error(_tip4);
      }
    });
  },
  getUserList: function getUserList(context, info) {
    var that = this;
    context.$http.get(SERVER_URL + '/v2.0/patients', { params: info }).then(function (data) {
      var err = data.body.error;
      if (err === 0) {
        var isZh = sessionStorage.getItem('language') === 'zh' ? true : false;
        var dataObj = data.body.patients;
        var users = dataObj.items.map(function (e, i) {
          e.gender = context.$t(e.gender);
          e.diabetes_type = context.$t(e.diabetes_type);
          if (e.upload_time) {
            var upload_time = new Date(e.upload_time * 1000);
            e.upload_time = isZh ? that.formateDate(upload_time) : that.formatterDate1(upload_time);
          }
          if (e.created_by) {
            e.created_by = context.$t(e.created_by);
          }
          if (e.created_by === context.$t('register') && e.alias) {
            e.name = e.alias;
          }
          if (e.diabetes_diagnosis_date) {
            e.diabetes_diagnosis_date = that.getDuration(context, e.diabetes_diagnosis_date);
          }

          return e;
        });
        context.$store.commit('updateUsers', users);
        this.pages = dataObj.pages !== 0 ? dataObj.pages : 1;
        this.has_next = dataObj.has_next;
        this.has_prev = dataObj.has_prev;
      }
      if (err === 12) {
        context.$router.push('/hcpLogin');
      }
    });
  },
  getDuration: function getDuration(context, val) {
    var now = new Date().setHours(0, 0, 0, 0) / 1000;
    var time = new Date(val).getTime() / 1000;
    var st = now - time;
    var y = parseInt(st / (3600 * 24 * 365));
    var m = parseInt(st % (3600 * 24 * 365) / (3600 * 24 * 30));
    var lang = localStorage.getItem('language');
    var year = y > 1 ? context.$t('Years') : context.$t('Year');
    var month = m > 1 ? context.$t('Months') : context.$t('Month');
    return lang === 'zh' || lang === 'hk' ? y + ' 年 ' + m + ' 月' : y + ' ' + year + ' ' + m + ' ' + month;
  },
  sendSeccode: function sendSeccode(context, info) {
    context.$http.post(SERVER_URL + '/v2.0/seccode/send', info).then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        context.token = res.data.token;
      } else if (err === 1) {
        var tip = context.$t('userNotExist');
        context.$message.error(tip);
      } else {
        var _tip5 = context.$t('tryAgain');
        context.$message.error(_tip5);
      }
    }, function (err) {
      context.error = err.body.message;
    });
  },
  setTime: function setTime(context) {
    var count = 60;
    var t = setInterval(function () {
      if (count === 0) {
        clearInterval(t);
        context.send = context.$t('Getcode');
        context.canClick = false;
        context.showTime = false;
        count = 10;
        if (context.tryAgain) {
          context.tryAgain = false;
        }
      } else {
        context.canClick = true;
        context.showTime = true;
        context.time = count;
        context.send = 'S';
        if (context.tryAgain) {
          context.tryAgain = true;
        }
        count--;
      }
    }, 1000);
  },
  register: function register(context, info) {
    context.$http.post(SERVER_URL + '/v2.0/regist', info).then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        if ('yes' == info.test) {
          context.tabA = false;
          context.tabB = true;

          if ('CN' == info.country || 'HKF' == info.country || 'AE' == info.country) {
            context.isEU = false;
          }
        } else {
          var tip = context.$t('registSuccess');
          context.$message({
            type: 'success',
            message: tip
          });
          this.$router.push('login');
        }
      } else if (err === 26) {
        var _tip6 = context.$t('errtip3');
        context.$message.error(_tip6);
      } else {

        if ('yes' == info.test) {
          var _tip7 = context.$t('infoWrongTip');
          context.$message.error(_tip7);
        } else {
          var _tip8 = context.$t('registFailed');
          context.$message.error(_tip8);
        }
      }
    }, function (err) {
      if ('yes' == info.test) {
        var tip = context.$t('infoWrongTip');
        context.$message.error(tip);
      } else {
        var _tip9 = context.$t('registFailed');
        context.$message.error(_tip9);
      }
    });
  },
  HcpRegister: function HcpRegister(context, info) {
    context.$http.post(SERVER_URL + '/v2.0/hcp/apply', { 'info': info }).then(function (res) {
      var err = res.body.error;
      if ('yes' == info.test) {
        var user_type = res.body.user_type;

        if (0 == err) {
          context.tabA = false;
          context.tabB = true;
          if ('CN' == info.country || 'HKF' == info.country || 'AE' == info.country) {
            context.isEU = false;
          } else {
            context.isEU = true;
          }
        } else if (3 == err) {
          if ('D' == user_type) {
            this.$message.error("User exist");
          } else if ('P' == user_type || 'M' == user_type) {
            context.tabA = false;
            context.tabA1 = true;
          }
        }
      } else {

        var tip = context.$t('sentSuccess');
        context.$message({
          type: 'success',
          message: tip
        });
        this.$router.push('/hcpLogin');
      }
    }, function (err) {
      var tip = context.$t('sentFailed');
      context.$message.error('Sent failed!');
    });
  },
  adjustBasalRecord: function adjustBasalRecord(basalRecord, pumpStatus) {
    var AutoModeEnableNew = pumpStatus['AutoModeEnabledNew'];

    if (1) {
      var newBasalRecord = basalRecord.filter(function (record) {
        var recordId = record[0];
        var recordType = record[2];
        var recordIdSplit = recordId.split('-');
        var filterFlag = false;
        if (recordIdSplit[3] == '9999') {
          if (recordIdSplit[1] == pumpStatus.serial && recordIdSplit[2] == pumpStatus.pumpId) {
            if (AutoModeEnableNew) {
              filterFlag = true;
            } else {
              filterFlag = false;
            }
          } else {
            filterFlag = false;
          }
          return filterFlag;
        }

        filterFlag = 'BAAMS' != recordType && 'BAAME' != recordType && 'BAAMTarget120' != recordType && 'BAAMSnack' != recordType;
        return filterFlag;
      });
      basalRecord = newBasalRecord;
    }

    var i = 0;
    for (; i < basalRecord.length - 1; i++) {
      var curEnd = basalRecord[i][1] + basalRecord[i][3];
      var nextStart = basalRecord[i + 1][1];

      if (curEnd > nextStart) {
        basalRecord[i][3] = nextStart - basalRecord[i][1];
      }
    }

    var isSuspend = false;
    var inj_status = pumpStatus.status;
    if (0x40 <= inj_status && inj_status <= 0x4F) {
      isSuspend = true;
    }

    if (pumpStatus.basalDeliveriedTime && !isSuspend) {
      var size = basalRecord.length;
    }
    return basalRecord;
  },
  getMonData: function getMonData(context, param, Pid) {
    var that = this;
    var now = new Date() / 1000;
    context.$http.get('/api/v2.1/monitor/' + Pid + '/status', { params: { param: param } }).then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        var data = res.body.data;

        if (data.pump_status) {
          if (0x40 <= data.pump_status.state && data.pump_status.state <= 0x4F) {
            if (data.chart.basal && data.chart.basal.length > 0) {
              var last_basal = data.chart.basal[data.chart.basal.length - 1];
              if (last_basal[2].indexOf('SUS') == 0) {
                data.chart.basal.splice(data.chart.basal.length - 1, 1);
              }
            }
          } else {
            if (data.chart.basal && data.chart.basal.length > 0) {
              if (data.pump_status.AutoModeEnabledNew) {} else {
                var _last_basal2 = data.chart.basal[data.chart.basal.length - 1];
                if (_last_basal2[1] == data.pump_status.basalDeliveriedTime) {
                  data.chart.basal.splice(data.chart.basal.length - 1, 1);
                }
              }

              var _last_basal = data.chart.basal[data.chart.basal.length - 1];
              var recordIdSplit = _last_basal[0].split('-');
              data.pump_status.pumpId = recordIdSplit[2];
            }
          }
        }

        if (res.body.data.chart.transmtr) {
          context.transmtr = that.getTransmtr(context, res.body.data.chart.transmtr);
        } else {
          context.transmtr = [];
        }

        context.$store.commit('updateDataS', res.body.data.chart);

        if (false) {

          var sgData = res.body.data.chart.sg;
          var dataNum = sgData.length;
          var start = 0;
          var end = dataNum;
          if (dataNum > 50) {
            start = dataNum - 50;
            end = 50;
          }
          for (var i = start; i < dataNum; i++) {}

          for (var _i = 0; _i < end; _i++) {
            if (sgData[_i][1] > 5) {
              sgData[_i][1] += 18;
            }
          }
        }

        if (false) {
          var pump_status = { "wizardGlucose": 0, "updateTime": 1583292987.951734, "basalDuration": 150, "serial": 1256630150,
            "extendBolusSet": 0, "extendBolusDuration": 0, "basalType": 6, "extendBolusDeliveried": 0, "state": 32,
            "bolusSet": 6.2, "basalRate": 0.55, "wizardType": 0, "bolusType": 1, "lastBolusType": 0,
            "remainingTime": 4230.33433000048, "bolusDeliveried": 1.2, "wizardCorrSet": 0,
            "anotherBolusType": 0, "iob": 0, "basalDeliveriedTime": 1583288321, "wizardCarbSet": 0,
            "wizardIob": 0, "basalPercent": 90, "wizardCarb": 0, "bolusDeliveriedTime": 1583292938,
            "rssi": -50, "remainingDose": 120.95 };
          var pump_status2 = { "updateTime": 1583826009.216325, "wizardGlucose": 160.1999931335449, "basalDuration": 150,
            "serial": 1256630150, "extendBolusSet": 0.55, "suspendRemainingTime": 0, "extendBolusDuration": 30,
            "basalType": 1, "extendBolusDeliveried": 0, "state": 32, "basalDeliveried": 0.15, "bolusSet": 0.85,
            "basalRate": 0.9, "wizardType": 3, "bolusType": 3, "suspendTime": 1583825463, "lastBolusType": 0,
            "remainingTime": 4310.39661141634, "bolusDeliveried": 0.7000000000000001, "wizardCorrSet": 0.4,
            "anotherBolusType": 0, "iob": 0, "basalDeliveriedTime": 1583825463 + 3600, "wizardCarbSet": 1,
            "pumpId": 74, "wizardIob": 0, "basalPercent": 90, "wizardCarb": 15, "bolusDeliveriedTime": 1583825981,
            "rssi": -58, "remainingDose": 190.65 };

          pump_status['updateTime'] = new Date().getTime() / 1000;
          data.pump_status = pump_status2;
        }

        context.DataSG = that.getMoSG(context, res.body.data.chart.sg);

        context.st = res.body.data.chart.st;
        context.et = res.body.data.chart.et;
        var basalTotal = 0;
        var bolusTotal = 0;
        if (res.body.data.chart.basal.length > 0) {
          var originBasal = res.body.data.chart.basal;
          context.basal = that.adjustBasalRecord(originBasal, data.pump_status);
        }
        if (res.body.data.chart.bolus.length > 0) {
          var originBolus = res.body.data.chart.bolus;
          context.bolus = originBolus;
        }

        var t1 = now - data.sensor_status.updateTime;
        context.sensorTime = data.sensor_status.updateTime ? that.formatterDate1(new Date()) : '--';
        data.sensor_status.updateTime = data.sensor_status.updateTime ? that.formatterDate1(new Date(data.sensor_status.updateTime * 1000)) : '--';
        that.getSensor(context, data.sensor_status);

        var t2 = now - data.pump_status.updateTime;
        context.pumpTime = data.pump_status.updateTime ? that.formatterDate1(new Date()) : '--';
        data.pump_status.updateTime = data.pump_status.updateTime ? that.formatterDate1(new Date(data.pump_status.updateTime * 1000)) : '--';
        data.pump_status.bolusSum = bolusTotal;
        data.pump_status.basalSum = basalTotal;
        that.getPump(context, data.pump_status);

        if (1) {
          context.$store.commit('updateBasal', that.getBasal(context, context.st, context.basal));
          var bs = that.getBasal2(context.basal);
          context.newBasal = bs[0];
          context.stopBasal = bs[1];
          context.autoModeBasal = bs[2];
          context.autoModeCorrBolus = bs[3];
          var bs1 = that.getBasalSus4(context, context.st, context.basal);
          context.basal_suspend = bs1[0];
          context.tempBasal = bs1[1];
          context.basal_suspend2 = bs1[2];

          var normalBasal = context.DataBasal;
          var basalValue = normalBasal.map(function (e, i) {
            return e[1];
          });
          var autoBasalValue = context.autoModeBasal.map(function (e, i) {
            return e[2];
          });
          var basalValueAll = basalValue.concat(autoBasalValue);
          context.basalMax = that.getBasalYMax(basalValueAll);
        }

        if (1) {
          var bolus = that.getBolus(context, context.st, context.bolus);
          context.DataBolus = bolus[0];
          context.extend_bolus = bolus[1][0] ? bolus[1] : context.extend_bolus;
        }

        var alarm_display = data.chart.alarm_display;
        if (alarm_display === 'On') {
          context.sensor_alarm = that.getAlarm2(context, res.body.data.chart.sensor_alarm, 0);
          context.pump_alarm = that.getAlarm2(context, res.body.data.chart.pump_alarm, 1);
        }
        context.calib = that.getCalib2(res.body.data.chart.calibRecord);
        that.getSleepTime2(context, res.body.data.chart.st, res.body.data.chart.et, res.body.data.chart.sleeptime);

        if (t1 > 3600) {
          context.sensorTime = '--';
          that.clearSensor(context, data.sensor_status);
          context.showCGMStatus = false;
        } else {
          context.showCGMStatus = true;
        }
        if (t2 > 3600) {
          context.pumpTime = '--';
          that.clearPump(context, data.pump_status);
        }

        that.checkSgIcon(context);
        var sensor_serial = data.sensor_status.serial;
        if (102000000 <= sensor_serial && sensor_serial <= 103999999) {} else {}
        context.$store.commit('updateSensor', data.sensor_status);
        context.$store.commit('updatePump', data.pump_status);
        if (context.chart1) {
          context.chart1.dispose();
          context.chart2.dispose();
        }
        context.drawCharts();
      }
    }, function (err) {
      console.log(err + "," + err.body.message);
    });
  },
  getAlarm2: function getAlarm2(context, val, flag) {
    var alarm = [];
    for (var i = 0; i < val.length; i++) {
      alarm[i] = new Array(3);
      alarm[i][0] = new Date(val[i][0] * 1000);
      if (flag === 1) {
        alarm[i][1] = 0.2;
      } else {
        alarm[i][1] = localStorage.getItem('unit') === 'mg' ? Math.round(1.2 * 18) : 1.2;
      }
      alarm[i][2] = context.$t(val[i][1]);
    }
    return alarm;
  },
  getCalib2: function getCalib2(val) {
    var exe = [],
        j = 0;
    for (var i = 0; i < val.length; i++) {
      if (val[i].length > 0) {
        exe[j] = new Array(2);
        exe[j][0] = new Date(val[i][1] * 1000);
        exe[j][1] = localStorage.getItem('unit') === 'mg' ? Math.round(val[i][3] * 18) : val[i][3].toFixed(1);
        j++;
      }
    }
    return exe;
  },
  getMoSG: function getMoSG(context, val) {
    var sg = [],
        time = [],
        type = [],
        SG = [],
        max = context.isMg ? 400 : 22.2;
    for (var i = 0; i < val.length; i++) {
      sg[i] = val[i][1];
      sg[i] = sg[i] > 22.2 ? 22.2 : sg[i];
      if (sg[i] < 2.2 && (val[i][4] === 'C' || val[i][4] === 'CX' || val[i][4] === 'NC' && val[i][1] > 0)) {
        sg[i] = 2.2;
      }
      sg[i] = context.isMg ? Math.round(sg[i] * 18) : sg[i].toFixed(1);
      if (val[i][4] === 'DE') {
        sg[i] = 0;
      }
      time[i] = val[i][0];
      type[i] = val[i][4];
    }
    max = sg.length > 1 ? Math.max.apply(null, sg) : max;

    for (var m = 0; m < sg.length; m++) {
      SG[m] = new Array(3);
      time[m] = new Date(time[m] * 1000);
      SG[m][0] = time[m];
      SG[m][1] = sg[m];
      SG[m][2] = type[m];
    }
    return SG;
  },
  getSensor: function getSensor(context, val) {
    var cgm_status = val.status;
    var originVal = {};
    for (var p in val) {
      originVal[p] = val[p];
    }

    if (13 == cgm_status || 14 == cgm_status) {
      delete val.sensorLifetimeTotalCount;
      delete val.glucose;
      delete val.glucoseRate;
    }

    val.serial = val.serial ? this.deviceSNFormat(val.serial) : '--';
    var status = val.status;
    if (val.status === -1) {
      val.status = '--';
    } else {
      val.status = val.status ? context.status[val.status] : '--';
    }
    if (val.updateTime !== '--') {
      var sp = val.updateTime.split(' ');
      var sp1 = sp[0].split('-');
      var d = new Date().getDate();
      if (d === parseInt(sp1[0])) {
        context.updateTime1 = context.$t('Today') + ' ' + sp[1];
      } else if (d - 1 === parseInt(sp1[0])) {
        context.updateTime1 = context.$t('Yesterday') + ' ' + sp[1];
      } else {
        sp1 = sp1[0] + '/' + sp1[1] + '/' + sp1[2];
        context.updateTime1 = sp1 + ' ' + sp[1];
      }
    } else {
      context.updateTime1 = '--';
    }

    if (true) {
      val.sensorLifetimeTotalCount = val.sensorLifetimeTotalCount ? this.getTime(val.sensorLifetimeTotalCount - val.sequence) : '--';
    }

    if (val.batteryPercent) {
      var b = val.batteryPercent;
      if (b >= 0.8) {
        context.batteryIcon = '/static/battery/Battery_full.png';
      } else if (b >= 0.4) {
        context.batteryIcon = '/static/battery/Battery_three_quarters.png';
      } else if (b >= 0.2) {
        if ('TY012' == context.deviceType) {
          context.batteryIcon = '/static/battery/Battery_half.png';
        } else {
          context.batteryIcon = '/static/battery/Battery_half_2.png';
        }
      } else if (b >= 0.1) {
        context.batteryIcon = '/static/battery/Battery_quarter.png';
      } else {
        context.batteryIcon = '/static/battery/Battery_zero.png';
      }
    } else {
      context.batteryIcon = '/static/battery/Battery_nodata.png';
    }

    val.batteryPercent = val.batteryPercent ? (val.batteryPercent * 100).toFixed(1) + '%' : '--';
    var ratestatus = val.glucoseRate;
    if (ratestatus === 0 || ratestatus === 8) {
      context.sgIcon = '/static/SG ICON/Trend_smooth.png';
    }
    if (ratestatus === 1 || ratestatus === 2 || ratestatus === 3) {
      context.sgIcon = '/static/SG ICON/Trend_up ' + ratestatus + '.png';
    }
    if (ratestatus === 4 || ratestatus === 5 || ratestatus === 6) {
      context.sgIcon = '/static/SG ICON/Trend_down ' + (ratestatus - 3) + '.png';
    }
    if (ratestatus === 7) {
      context.sgIcon = '';
    }

    if (val.glucose) {
      if (!context.isMg) {
        val.glucose = val.glucose.toFixed(1) + 'mmol/L';
      } else {
        val.glucose = Math.round(val.glucose * 18) + 'mg/dL';
      }
    } else {
      val.glucose = '--';
    }

    if (status === 1 || status === 2 || status == 6 || 13 == status || 14 == status) {
      val.glucose = '--';
      context.updateTime1 = '--';
      context.sgIcon = '';
      context.sensorTime = '--';
    }
  },
  clearSensor: function clearSensor(context, val) {
    val.serial = '--';
    val.status = '--';

    val.sensorLifetimeTotalCount = '--';
    val.batteryPercent = '--';
    context.updateTime1 = '--';
    context.sgIcon = '';
    val.glucose = '--';
  },
  getPumpCurrentBolus: function getPumpCurrentBolus(context, pumpStatus) {
    var currentBolus = [];
    var record_id = context.uid + '-' + pumpStatus.serial;
    var bolusType = '';
    if (1 == pumpStatus.bolusType) {
      bolusType = 'NB';
      record_id += '-bolus-current-N';
    } else if (2 == pumpStatus.bolusType) {
      bolusType = 'EB';
      record_id += '-bolus-current-E';
    } else if (3 == pumpStatus.bolusType) {
      bolusType = 'CB';
      record_id += '-bolus-current-C';
    }
    var wizardInfo = {};
    if (0 == pumpStatus.wizardType) {
      bolusType += 'M';
    } else if (1 == pumpStatus.wizardType) {
      bolusType += 'CRW';
      wizardInfo = {
        'bg': pumpStatus.wizardGlucose / 18.0,
        'corr_bolus': pumpStatus.wizardCorrSet,
        'iob': pumpStatus.wizardIob
      };
    } else if (2 == pumpStatus.wizardType) {
      bolusType += 'CAW';
      wizardInfo = {
        'carb': pumpStatus.wizardCarb,
        'carb_bolus': pumpStatus.wizardCarbSet,
        'iob': pumpStatus.wizardIob
      };
    } else if (3 == pumpStatus.wizardType) {
      bolusType += 'CCW';
      wizardInfo = {
        'bg': pumpStatus.wizardGlucose / 18.0,
        'corr_bolus': pumpStatus.wizardCorrSet,
        'carb': pumpStatus.wizardCarb,
        'carb_bolus': pumpStatus.wizardCarbSet,
        'iob': pumpStatus.wizardIob
      };
    }

    currentBolus.push(record_id);
    currentBolus.push(pumpStatus.bolusDeliveriedTime);
    currentBolus.push(bolusType);
    currentBolus.push(pumpStatus.bolusSet);
    currentBolus.push(pumpStatus.bolusDeliveried);
    currentBolus.push(pumpStatus.extendBolusSet);
    currentBolus.push(pumpStatus.extendBolusDeliveried);
    currentBolus.push(pumpStatus.extendBolusDuration);
    currentBolus.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(wizardInfo));
    currentBolus.push(0);

    return currentBolus;
  },
  randomString: function randomString(len) {
    len = len || 32;
    var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
    var maxPos = $chars.length;
    var pwd = '';
    for (var i = 0; i < len; i++) {
      pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return pwd;
  },
  removePumpCurrentBolus: function removePumpCurrentBolus(context, pumpStatus) {
    var i = 0;
    for (; i < context.bolus.length; i++) {
      var record_id = context.bolus[i][0];
      if (record_id.indexOf('bolus-current') > 0) {
        if (record_id.indexOf('-fix-') < 0) {
          context.bolus[i][0] = record_id + '-fix-' + this.randomString(6);
        }
      }
    }
    if (i < context.bolus.length) {}
  },
  removePumpCurrentBasal: function removePumpCurrentBasal(context, record_id_key) {
    var i = 0;
    for (; i < context.basal.length; i++) {
      var record_id = context.basal[i][0];
      if (record_id.indexOf(record_id_key) > 0) {
        if (record_id.indexOf('-fix-') < 0) {
          context.basal[i][0] = record_id + '-fix-' + this.randomString(6);
        }
      }
    }
    if (i < context.basal.length) {}
  },
  getPumpCurrentBasal: function getPumpCurrentBasal(context, pumpStatus) {
    var currentBasal = [];

    var basalTypeMap = {
      0: 'BAS',
      1: 'BAE',
      2: 'BAH',
      3: 'BAPA',
      4: 'BAPB',
      27: 'BAPC',
      28: 'BAPD',
      29: 'BASK',
      30: 'BAAM'
    };
    var tempBasalTypeMap = {
      5: 'BART',
      6: 'BAAT'
    };
    var record_id = context.uid + '-' + pumpStatus.serial;
    var basalType = '';
    var tempBasalType = '';
    var basalDuration = 0;
    var curTime = new Date().getTime() / 1000;
    var basalRate = 0;
    var basalDeliveried = 0;
    var basalDeliveriedTime = pumpStatus.basalDeliveriedTime;

    if (!pumpStatus.basalDeliveriedTime) {
      return false;
    }

    if (0x20 <= pumpStatus.state && pumpStatus.state < 0x2F) {
      basalType = basalTypeMap[pumpStatus.basalType];
      tempBasalType = tempBasalTypeMap[pumpStatus.basalType];

      if (pumpStatus.AutoModeEnabledNew) {
        return false;
      }

      basalRate = pumpStatus.basalRate;


      basalDeliveried = pumpStatus.basalDeliveried || pumpStatus.basalDelivery;

      if (basalRate > 0) {
        basalDuration = basalDeliveried / basalRate * 3600;
      } else {
        basalDuration = 0;
      }

      if (basalType) {
        record_id += '-basal-current';
        this.removePumpCurrentBasal(context, 'suspend-current');
        this.removePumpCurrentBasal(context, 'basal-temp-current');
      } else if (tempBasalType) {
        basalType = tempBasalType;
        record_id += '-basal-temp-current';
        this.removePumpCurrentBasal(context, 'suspend-current');
        this.removePumpCurrentBasal(context, 'basal-current');
      }
    } else if (0x40 <= pumpStatus.state && pumpStatus.state < 0x4F) {
      record_id += '-suspend-current';

      if (0x40 == pumpStatus.state) {
        basalType = 'SUSLSG';
      } else if (0x41 == pumpStatus.state) {
        basalType = 'SUSPLSG';
      } else if (0x42 == pumpStatus.state) {
        basalType = 'SUSA';
      } else if (0x43 == pumpStatus.state) {
        basalType = 'SUSHM';
      } else if (0x44 == pumpStatus.state) {
        basalType = 'SUSDM';
      } else if (0x45 == pumpStatus.state) {
        basalType = 'SUSM';
      } else {
        basalType = 'SUSM';
      }
      basalDeliveriedTime = pumpStatus.suspendTime;

      if (curTime > basalDeliveriedTime) {
        basalDuration = curTime - basalDeliveriedTime;
      } else {
        basalDuration = 0;
      }

      this.removePumpCurrentBasal(context, 'basal-current');
      this.removePumpCurrentBasal(context, 'basal-temp-current');
    }

    currentBasal.push(record_id);
    currentBasal.push(basalDeliveriedTime);
    currentBasal.push(basalType);
    currentBasal.push(basalDuration);
    currentBasal.push(basalRate);
    currentBasal.push(basalDeliveried);
    currentBasal.push(0);

    return currentBasal;
  },
  getPump: function getPump(context, val) {
    var originVal = {};
    for (var k in val) {
      originVal[k] = val[k];
    }

    if (val.state < 0x20) {
      delete val.remainingDose;
      delete val.remainingTime;
    } else if (128 == val.state) {
      delete val.remainingDose;
      delete val.remainingTime;
    }

    var ins_unit2 = 'U';
    try {
      ins_unit2 = context.$t('ins_unit2');
    } catch (e) {
      console.log("ins_unit2 error:", e);
    }
    val.serial = val.serial ? this.deviceSNFormat(val.serial) : '--';
    var basal_active = false;
    if (val.state < 7) {
      val.state = val.state ? context.state1[val.state] : '--';
    } else if (val.state < 40) {
      val.state = val.state ? context.state2[val.state - 32] : '--';
      if (30 == val.basalType || val.AutoModeEnabledNew) {
        val.state = 'Auto Mode';
      }
      basal_active = true;

      if (val.bolusType && val.bolusType > 0) {
        val.state = context.injState['Bolus'];

        var currentBolusRecord = this.getPumpCurrentBolus(context, originVal);
        context.addBolusRecord(currentBolusRecord);
      } else if (6 == val.basalType) {
        val.state = context.injState['BART'];
      }
      var currentBasalRecord = this.getPumpCurrentBasal(context, originVal);
      if (currentBasalRecord) {
        context.addBasalRecord(currentBasalRecord);
      }
    } else if (val.state < 70) {
      val.state = val.state ? context.state3[val.state - 64] : '--';

      var _currentBasalRecord = this.getPumpCurrentBasal(context, originVal);
      if (_currentBasalRecord) {
        context.addBasalRecord(_currentBasalRecord);
      }
    } else if (val.state < 104) {
      val.state = val.state ? context.state4[val.state - 96] : '--';
    } else if (val.state === 128) {
      val.state = 'Delivery stopped';
    } else {
      val.state = '--';
    }

    if (!basal_active || !val.bolusType || 0 == val.bolusType) {
      this.removePumpCurrentBolus(context, originVal);
    }

    if (30 == val.basalType || val.AutoModeEnabledNew) {
      val.basalRate = 'Auto Mode';
    } else if (val.basalRate && basal_active) {
      val.basalRate = val.basalRate.toFixed(2) + context.$t('basal_unit2');
    } else {
      val.basalRate = '--';
    }

    val.remainingDose = val.remainingDose ? val.remainingDose.toFixed(2) + ins_unit2 : '--';
    val.iob = val.iob ? val.iob.toFixed(2) + ins_unit2 : '--';

    val.basalSum = context.calDayBasalTotal();
    val.bolusSum = context.calDayBolusTotal();
    var autoSum = context.calDayAutoModeTotal();
    val.basalSum += autoSum[0];
    val.bolusSum += autoSum[1];

    val.bolusSum = val.bolusSum ? val.bolusSum.toFixed(2) + ins_unit2 : '--';
    val.basalSum = val.basalSum ? val.basalSum.toFixed(2) + ins_unit2 : '--';

    var type = val.bolusType;
    if (0 == type) {
      type = val.lastBolusType;
    }
    if (type === 1) {
      context.lastBolus = 'N' + val.bolusDeliveried.toFixed(2) + ins_unit2 + '  ' + this.formatterDate7(context, val.bolusDeliveriedTime);
    } else if (type === 2) {
      context.lastBolus = 'E' + val.extendBolusDeliveried.toFixed(2) + ins_unit2 + '  ' + this.formatterDate7(context, val.bolusDeliveriedTime);
    } else if (type === 3) {
      context.lastBolus = 'C' + (val.extendBolusDeliveried + val.bolusDeliveried).toFixed(2) + ins_unit2 + '  ' + this.formatterDate7(context, val.bolusDeliveriedTime);
    } else {
      context.lastBolus = '--';
    }
    val.remainingTime = val.remainingTime ? this.getTime3(val.remainingTime) : '--';
  },
  clearPump: function clearPump(context, val) {
    val.state = '--';
    val.serial = '--';
    val.remainingTime = '--';

    val.remainingDose = '--';
    val.basalRate = '--';
    val.basalSum = '--';
    context.lastBolus = '--';
    val.iob = '--';
    val.bolusSum = '--';
  },
  getSleepTime2: function getSleepTime2(context, st, et, Stime) {
    var time1 = new Array(2),
        time2 = new Array(2);
    time1[0] = new Array(3);
    time1[0][0] = new Date((st + Stime[0] * 60) * 1000);
    time1[0][1] = new Date(et * 1000);
    time1[0][2] = context.sgMax ? context.sgMax : 20;
    time1[1] = new Array(3);
    time1[1][0] = new Date(st * 1000);
    time1[1][1] = new Date((st + Stime[1] * 60) * 1000);
    time1[1][2] = time1[0][2];

    time2[0] = new Array(3);
    time2[0][0] = new Date((st + Stime[0] * 60) * 1000);
    time2[0][1] = new Date(et * 1000);
    time2[0][2] = context.basalMax ? context.basalMax : 5;
    time2[1] = new Array(3);
    time2[1][0] = new Date(st * 1000);
    time2[1][1] = new Date((st + Stime[1] * 60) * 1000);
    time2[1][2] = time2[0][2];

    context.sleepTime1 = time1;
    context.sleepTime2 = time2;
  },
  updateBolusChart: function updateBolusChart(context) {
    var bolus_proc = this.getBolus(context, context.st, context.bolus);
    context.DataBolus = bolus_proc[0];
    context.extend_bolus = bolus_proc[1][0] ? bolus_proc[1] : context.extend_bolus;

    var chartOption = context.chart2.getOption();
    chartOption.series[4].data = context.DataBolus;
    chartOption.series[5].data = context.extend_bolus;
    context.chart2.setOption(chartOption);
  },
  updateBasalChart: function updateBasalChart(context) {
    var bolus_proc = this.getBolus(context, context.st, context.bolus);
    context.DataBolus = bolus_proc[0];
    context.extend_bolus = bolus_proc[1][0] ? bolus_proc[1] : context.extend_bolus;

    context.$store.commit('updateBasal', this.getBasal(context, context.st, context.basal));
    var bs = this.getBasal2(context.basal);
    context.newBasal = bs[0];
    context.stopBasal = bs[1];
    context.autoModeBasal = bs[2];
    context.autoModeCorrBolus = bs[3];

    var bs1 = this.getBasalSus4(context, context.st, context.basal);
    context.basal_suspend = bs1[0];
    context.tempBasal = bs1[1];
    context.basal_suspend2 = bs1[2];

    var chartOption = context.chart2.getOption();

    chartOption.series[4].data = context.DataBolus;
    chartOption.series[5].data = context.extend_bolus;

    chartOption.series[0].data = context.DataBasal;
    chartOption.series[1].data = context.basal_suspend;
    chartOption.series[2].data = context.tempBasal;
    chartOption.series[3].data = context.basal_suspend2;
    chartOption.series[6].data = context.newBasal;
    chartOption.series[7].data = context.stopBasal;
    context.chart2.setOption(chartOption);
  },
  getMonData1: function getMonData1(context, info) {
    var that = this;
    var flag = parseInt(sessionStorage.getItem('monitor'));
    var uid = parseInt(context.uid);
    var now = new Date() / 1000;
    if (flag === 1) {
      context.$http.post('api/v2.0/monitor/data', info, { _timeout: 118000, onTimeout: function onTimeout(request) {
          console.log('超时');
        },
        before: function before(request) {
          if (this.previousRequest) {
            this.previousRequest.abort();
          }
          this.previousRequest = request;
        }
      }).then(function (res) {
        var err = res.body.error;
        if (err === 0) {
          var data = res.body.data[uid];

          if (false) {
            data.pump = { "updateTime": 1583826009.216325, "wizardGlucose": 160.1999931335449, "basalDuration": 150,
              "serial": 1256630150, "extendBolusSet": 0.55, "suspendRemainingTime": 0, "extendBolusDuration": 30,
              "basalType": 1, "extendBolusDeliveried": 0.30000000001, "state": 32, "basalDeliveried": 0.15, "bolusSet": 0.85,
              "basalRate": 0.9, "wizardType": 3, "bolusType": 3, "suspendTime": 1583825463, "lastBolusType": 0,
              "remainingTime": 4310.39661141634, "bolusDeliveried": 0.7000000000000001, "wizardCorrSet": 0.4,
              "anotherBolusType": 0, "iob": 0, "basalDeliveriedTime": 1583825463, "wizardCarbSet": 1,
              "pumpId": 74, "wizardIob": 0, "basalPercent": 90, "wizardCarb": 15, "bolusDeliveriedTime": 1583825981 + 3600,
              "rssi": -58, "remainingDose": 190.65 };
          }

          if (data.sg) {
            var newSG = that.updateSg(context, data.sg);
            for (var i = 0; i < newSG.length; i++) {
              context.DataSG.push(newSG[i]);
            }
          }
          if (data.sg && context.chart1) {
            var option = context.chart1.getOption();
            option.series[0].data = context.DataSG;
            context.chart1.setOption(option);
          }
          if (data.sensor) {
            var t1 = now - data.sensor.update_time;
            context.sensorTime = data.sensor.update_time ? that.formatterDate1(new Date()) : '--';
            data.sensor.updateTime = data.sensor.update_time ? that.formatterDate1(new Date(data.sensor.update_time * 1000)) : '--';

            var sensor_serial = data.sensor.serial;
            if (102000000 <= sensor_serial && sensor_serial <= 103999999) {}

            that.getSensor(context, data.sensor);
            if (t1 > 3600) {
              context.sensorTime = '--';
              that.clearSensor(context, data.sensor);
              context.showCGMStatus = false;
            } else {
              context.showCGMStatus = true;
            }
            that.checkSgIcon(context);
            context.$store.commit('updateSensor', data.sensor);
          }
          var basalChartUpdate = false;
          var bolusChartUpdate = false;
          if (data.pump) {
            var originStatus = {};
            for (var k in data.pump) {
              originStatus[k] = data.pump[k];
            }
            context.pumpTime = data.pump.update_time ? that.formatterDate1(new Date()) : '--';
            data.pump.update_time = data.pump.update_time ? that.formatterDate1(new Date(data.pump.update_time * 1000)) : '--';
            that.getPump(context, data.pump);
            var t2 = now - data.pump.update_time;
            if (t2 > 3600) {
              context.pumpTime = '--';
              that.clearPump(context, data.pump);
            }
            context.$store.commit('updatePump', data.pump);

            if (data.pump && data.pump.bolusType > 0) {
              bolusChartUpdate = true;
            }

            if (0x20 <= originStatus.state && originStatus.state <= 0x2F || 0x40 <= originStatus.state && originStatus.state <= 0x4F) {
                basalChartUpdate = true;
              }
          }

          if (data.bolus && false) {
            console.log('data.bolus.1:', data.bolus, context.bolus.length);
            var needRefresh = false;
            for (var _i2 = 0; _i2 < data.bolus.length; _i2++) {
              var newBolusRecord = data.bolus[_i2];

              var flag = context.addBolusRecord(newBolusRecord);
              needRefresh = needRefresh || flag;
            }

            if (needRefresh) {
              console.log('data.bolus.2:', context.bolus.length);
              context.calDayBolusTotal();

              context.basal = that.adjustBasalRecord(context.basal, data.pump);

              bolusChartUpdate = true;
            }
          }

          if (data.basal && true) {
            console.log('data.basal.1:', data.basal, context.basal.length);
            var _needRefresh = false;
            for (var _i3 = 0; _i3 < data.basal.length; _i3++) {
              var newBasalRecord = data.basal[_i3];

              var flag = context.addBasalRecord(newBasalRecord);
              _needRefresh = _needRefresh || flag;
            }

            if (_needRefresh) {
              console.log('data.basal.2:', context.basal.length);
              context.calDayBasalTotal();

              basalChartUpdate = true;
            }
          }
          var chartUpdateTime = new Date().getTime() / 1000;
          console.log('basalChartUpdate:', basalChartUpdate, bolusChartUpdate);
          if (basalChartUpdate || bolusChartUpdate) {
            if (chartUpdateTime - context.basalChartUpdateTime > 1) {
              context.basalChartUpdateTime = chartUpdateTime;
              that.updateBasalChart(context);
            }
          }


          info.eventNo = res.body.eventNo;
          that.getMonData1(context, info);
        } else {
          that.getMonData1(context, info);
        }
      }, function (err) {
        if (context.$route.path === '/monitor') {
          context.timeout1 = setTimeout(that._getMonData1(context, info), 5000);
        } else {
          context.timeout1 = '';
        }
      });
    }
  },
  updateSg: function updateSg(context, val) {
    var SG = [];
    for (var m = 0; m < val.length; m++) {
      SG[m] = new Array(3);
      SG[m][0] = new Date(val[m][1] * 1000);
      SG[m][1] = context.isMg ? Math.round(val[m][3] * 18) : val[m][3].toFixed(1);
      SG[m][2] = val[m][4];
    }
    return SG;
  },
  checkSgIcon: function checkSgIcon(context) {
    var obj = document.getElementById('sgIcon');

    if (!context.sgIcon) {
      obj.style.display = 'none';
      'checkSgIcon.1:', context.sgIcon;
    } else {
      obj.style.display = 'auto';
    }
  },
  getDataMap: function getDataMap(context, uid, cb) {
    context.updateXhr = context.$http.get(SERVER_URL + '/v2.0/chart/' + uid + '/datamap').then(function (res) {
      cb(res.data);
    }, function (err) {
      context.error = err.body.message;
    });
  },
  getDs: function getDs(context, uid, param, i) {
    var that = this;
    context.updateXhr = context.$http.get(SERVER_URL + '/v2.1/chart/' + uid + '/data/ds', { params: { param: param } }).then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        var data_source = res.body.data.data_source;
        if (data_source) {
          sessionStorage.setItem('data_source', data_source);
        }
        context.$store.commit('updateDataS', res.body.data);
        context.timeSection = res.body.data.time_section[0];
        var st = context.timeSection[0];
        if (false) {
          var sgData = res.body.data.sensor_glucose[0];

          var dataNum = sgData.length;
          var start = 0;
          var end = dataNum;
          if (dataNum > 50) {
            start = dataNum - 50;
            end = 50;
          }
          for (var _i4 = start; _i4 < dataNum; _i4++) {}

          for (var _i5 = 0; _i5 < end; _i5++) {
            if (sgData[_i5][1] > 5) {
              sgData[_i5][1] += 18;
            }
          }
        }

        var SG = that.getSG(context, res.body.data);
        context.$store.commit('updateDataSG', SG[0]);

        if (res.body.data.transmtr) {
          context.transmtr = that.getTransmtr(context, res.body.data.transmtr[0]);
        } else {
          context.transmtr = [];
        }

        var alarm_display = res.body.data.alarm_display;
        if (alarm_display === 'On') {
          context.sensor_alarm = that.getAlarm(context, res.body.data.sensor_alarm, 0);
          context.pump_alarm = that.getAlarm(context, res.body.data.pump_alarm, 1);
        }

        context.calib = that.getCalib(res.body.data.calibRecord);
        var bg1 = that.getBg1(res.body.data.bg);
        context.bg = bg1[0];
        var bgMax = bg1[1];
        context.sgMax = context.sgMax > bgMax ? context.sgMax : bgMax;

        context.$store.commit('updateBasal', that.getBasal(context, st, res.body.data.basal[0]));

        var bs = that.getBasal2(res.body.data.basal[0]);
        context.newBasal = bs[0];
        context.stopBasal = bs[1];
        context.autoModeBasal = bs[2];
        context.autoModeCorrBolus = bs[3];

        var normalBasal = context.DataBasal;
        var basalValue = normalBasal.map(function (e, i) {
          return e[1];
        });
        var autoBasalValue = context.autoModeBasal.map(function (e, i) {
          return e[2];
        });
        var basalValueAll = basalValue.concat(autoBasalValue);
        context.basalMax = that.getBasalYMax(basalValueAll);

        var bs1 = that.getBasalSus4(context, st, res.body.data.basal[0]);
        context.basal_suspend = bs1[0];
        context.tempBasal = bs1[1];
        context.basal_suspend2 = bs1[2];

        that.getDailySummaryAutoModeStatistics(context, res.body.data, i);

        var bolus = that.getBolus(context, st, res.body.data.bolus[0]);
        context.$store.commit('updateBolus', bolus[0]);
        context.extend_bolus = bolus[1][0] ? bolus[1] : context.extend_bolus;

        context.bolusMax = bolus[2];

        var Carb = that.getCarb(res.body.data.carb_event);
        context.carb = Carb[0];
        context.carbMax = Carb[1];

        var exe = that.getExercise(context, res.body.data.exercise_event);
        context.exercise = exe ? exe : context.exercise;

        var autoMeal = that.getAutoMeal(context, res.body.data.auto_mode_event[0], context.carbMax);
        context.autoBreakfast = autoMeal[0];
        context.autoLunch = autoMeal[1];
        context.autoDinner = autoMeal[2];
        context.autoSnack = autoMeal[3];
        context.autoExercise = autoMeal[4];

        var sleep = that.getSleepTime(context, res.body.data.sleeptime, context.timeSection);
        context.sleepTime1 = sleep[0];
        context.sleepTime2 = sleep[1];
        context.sleepTime3 = sleep[2];

        if (context.chart1_2) {
          context.chartsDispose();
        }

        context.drawCharts(i);

        if (context.getStatistics) {
          context.getStatistics(res.data.report_data);
        } else if (context.getStatisticsQuick) {
          context.getStatisticsQuick(res.data.report_data, i);
        }
      }
    }, function (err) {
      console.log(err + "," + err.body.message);
      context.error = err.body.message;
    });
  },
  getSG: function getSG(context, val) {
    var sg = [],
        time = [],
        type = [],
        SG = [],
        max = context.isMg ? 400 : 22.2;
    for (var i = 0; i < val.sensor_glucose.length; i++) {
      for (var j = 0; j < val.sensor_glucose[i].length; j++) {
        sg[j] = val.sensor_glucose[i][j][1].toFixed(1);
        sg[j] = sg[j] > 22.2 ? 22.2 : sg[j];
        if (sg[j] < 2.2 && (val.sensor_glucose[i][j][4] === 'C' || val.sensor_glucose[i][j][4] === 'CX')) {
          sg[j] = 2.2;
        }
        sg[j] = context.isMg ? Math.round(sg[j] * 18) : sg[j];
        if (val.sensor_glucose[i][j][4] === 'DE') {
          sg[j] = 0;
        }
        time[j] = val.sensor_glucose[i][j][0];
        type[j] = val.sensor_glucose[i][j][4];
      }
    }
    max = sg.length > 1 ? Math.max.apply(null, sg) : max;
    max = this.getsgMax1(max);
    for (var m = 0; m < sg.length; m++) {
      SG[m] = new Array(3);
      time[m] = new Date(time[m] * 1000);
      SG[m][0] = time[m];
      SG[m][1] = sg[m];
      SG[m][2] = type[m];
    }
    return [SG, max];
  },
  getBasal: function getBasal(context, st, val) {
    var basal = [],
        j = 0,
        m1 = [],
        max = 0;
    for (var i = 0; i < val.length; i++) {
      if (val[i][2] === 'BAS' || val[i][2] === 'BAE' || val[i][2] === 'BAH' || val[i][2] === 'BAPB' || val[i][2] === 'BAPA' || val[i][2] === 'BAPC' || val[i][2] === 'BAPD' || val[i][2] === 'BASK') {
        if (val[i][3] !== 0) {
          basal[j] = new Array(2);
          basal[j][0] = st <= val[i][1] ? new Date(val[i][1] * 1000) : new Date(st * 1000);
          basal[j][1] = val[i][4] ? val[i][4].toFixed(2) : 0;
          j++;
          basal[j] = new Array(2);
          basal[j][0] = st + 86400 <= val[i][1] + val[i][3] ? new Date((st + 86400) * 1000) : new Date((val[i][1] + val[i][3]) * 1000);
          basal[j][1] = val[i][4] ? val[i][4].toFixed(2) : 0;

          if (i < val.length - 1) {
            var nextBasalType = val[i + 1][2];
            if (val[i + 1][2] !== 'BAS' && val[i + 1][2] !== 'BAE' && val[i + 1][2] !== 'BAH' && nextBasalType != 'BAPB' && nextBasalType != 'BAPA' && nextBasalType != 'BAPC' && nextBasalType != 'BAPD' && nextBasalType != 'BASK') {
              j++;
              basal[j] = new Array(2);
              basal[j][0] = st + 86400 <= val[i][1] + val[i][3] ? new Date((st + 86400) * 1000) : new Date((val[i][1] + val[i][3]) * 1000);
              basal[j][1] = null;
            }
          }
          j++;
        }
      }
      m1.push(val[i][4]);
    }
    max = m1.length > 1 ? Math.max.apply(null, m1) : 3;
    if (max < 1) {
      max = 1;
    } else if (max < 2) {
      max = 2;
    } else if (max < 5) {
      max = 5;
    } else if (max < 10) {
      max = 10;
    } else if (max < 15) {
      max = 15;
    } else if (max < 20) {
      max = 20;
    } else if (max < 25) {
      max = 25;
    }
    context.basalMax = max;

    return basal;
  },
  getBasalYMax: function getBasalYMax(val) {
    var m1 = val;
    var max = m1.length > 1 ? Math.max.apply(null, m1) : 3;
    if (max < 1) {
      max = 1;
    } else if (max < 2) {
      max = 2;
    } else if (max < 5) {
      max = 5;
    } else if (max < 10) {
      max = 10;
    } else if (max < 15) {
      max = 15;
    } else if (max < 20) {
      max = 20;
    } else if (max < 25) {
      max = 25;
    }

    return max;
  },
  getBasal2: function getBasal2(val) {
    var newBasal = [],
        stopBasal = [];
    var autoModeBasal = [];
    var autoModeCorrBolus = [];
    var j = 0,
        k = 0;
    for (var i = 0; i < val.length; i++) {
      if (val[i][2] === 'NEW') {
        newBasal[j] = new Array(2);
        newBasal[j][0] = new Date(val[i][1] * 1000);
        newBasal[j][1] = 0.2;
        j++;
      }
      if (val[i][2] === 'ENDM' || val[i][2] === 'ENDEM' || val[i][2] === 'ENDPE' || val[i][2] === 'ENDEP' || val[i][2] === 'ENDPB' || val[i][2] === 'ENDCE' || val[i][2] === 'ENDPBE' || val[i][2] === 'ENDD' || val[i][2] === 'ENDPE2') {
        stopBasal[j] = new Array(2);
        stopBasal[j][0] = new Date(val[i][1] * 1000);
        stopBasal[j][1] = 0.1;
        j++;
      }

      var basal_type = val[i][2];
      if (basal_type == 'BAAM') {
        var microBolus = val[i][7];
        var microBolusJson = [];
        try {
          microBolus = JSON.parse(microBolus);

          microBolusJson = microBolus['autoModeJSON'];
        } catch (e) {
          console.log('microBolus error:', e);
        }

        if (microBolusJson.length > 0) {
          var index = 0;
          while (index < microBolusJson.length) {
            var subRecord = microBolusJson.slice(index, index + 5);
            var startTime = new Date(val[i][1] * 1000 + index * 6 * 60 * 1000);
            var endTime = new Date(val[i][1] * 1000 + (index + subRecord.length) * 6 * 60 * 1000);
            var totalInject = 0;
            var totalCorrBolus = 0;
            subRecord.map(function (e, i) {
              totalInject += e['auto_basal_delivery'];
              totalCorrBolus += e['auto_corr_delivery'];
              totalCorrBolus += e['auto_food_delivery'];
            });
            var basalRate = totalInject * 0.05 / (subRecord.length * 6.0 / 60);

            var basal_record = [startTime, endTime, basalRate];

            if (basalRate > 0) {
              autoModeBasal.push(basal_record);
            }

            if (totalCorrBolus > 0) {
              autoModeCorrBolus.push([new Date((startTime.getTime() + endTime.getTime()) / 2), totalCorrBolus * 0.05]);
            }

            index += 5;
          }
        }
      }
    }
    return [newBasal, stopBasal, autoModeBasal, autoModeCorrBolus];
  },
  getDailySummaryAutoModeStatistics: function getDailySummaryAutoModeStatistics(context, data, index) {
    var basal = data.basal[0];
    var sg = data.sensor_glucose[0];
    var autoModeTime = 0;
    var autoModeTimeSection = [];
    var autoModeExits = 0;
    var autoModeStat = {};

    for (var i = 0; i < basal.length; i++) {
      var basalRecord = basal[i];
      var basalType = basalRecord[2];
      if ('BAAM' == basalType) {
        autoModeTime += basalRecord[3];

        if (autoModeTimeSection.length > 0) {
          var lastRecord = autoModeTimeSection[autoModeTimeSection.length - 1];

          if (basalRecord[1] > lastRecord[1]) {
            autoModeTimeSection.push([basalRecord[1], basalRecord[1] + basalRecord[3]]);
          } else if (basalRecord[1] == lastRecord[1]) {
            lastRecord[1] = basalRecord[1] + basalRecord[3];
          }
        } else {
          autoModeTimeSection.push([basalRecord[1], basalRecord[1] + basalRecord[3]]);
        }
      } else if ('BAAME' == basalType) {
        autoModeExits += 1;
      }
    }
    context.autoModeExits = autoModeExits;
    autoModeStat.autoModeExits = autoModeExits;

    var autoModeSG = [];
    var autoModeSGInTarget = [];
    var autoModeSGAboveTarget = [];
    var autoModeSGBelowTarget = [];

    var autoModeSGTargetHigh = 180 / 18.0;
    var autoModeSGTargetLow = 70 / 18.0;

    for (var _i6 = 0; _i6 < sg.length; _i6++) {
      var sgRecord = sg[_i6];
      var sgState = sgRecord[4];
      var sgValue = sgRecord[1];
      var sgTime = sgRecord[0];
      if ('CX' == sgState || 'C' == sgState || 'NC' == sgState) {
        if (sgValue > 0.000001) {
          var sgInAutoMode = false;
          for (var s = 0; s < autoModeTimeSection.length; s++) {
            if (sgTime >= autoModeTimeSection[s][0] && sgTime <= autoModeTimeSection[s][1]) {
              sgInAutoMode = true;
              break;
            }
          }

          if (sgInAutoMode) {
            autoModeSG.push(sgValue);
            if (sgValue >= autoModeSGTargetHigh) {
              autoModeSGAboveTarget.push(sgValue);
            } else if (sgValue < autoModeSGTargetLow) {
              autoModeSGBelowTarget.push(sgValue);
            } else {
              autoModeSGInTarget.push(sgValue);
            }
          } else {}
        }
      }
    }

    var statResult = this.getAvgSD(autoModeSG);
    if (statResult.num) {
      context.autoModeSGAvgSD = this.getGlucoseValText2(context.isMg, statResult.avg) + ' ± ' + this.getGlucoseSDValText(context.isMg, statResult.sd);
      var highPercent = parseInt((autoModeSGAboveTarget.length * 100.0 / autoModeSG.length).toFixed());
      var lowPercent = parseInt((autoModeSGBelowTarget.length * 100.0 / autoModeSG.length).toFixed());
      var inRangePercent = 100 - highPercent - lowPercent;
      context.autoModeSGInTargetRange = inRangePercent + '%';
      context.autoModeSGAboveRange = highPercent + '%';
      context.autoModeSGBelowRange = lowPercent + '%';

      autoModeStat.autoModeSGAvgSD = context.autoModeSGAvgSD;
      autoModeStat.autoModeSGInTargetRange = inRangePercent + '%';
      autoModeStat.autoModeSGAboveRange = highPercent + '%';
      autoModeStat.autoModeSGBelowRange = lowPercent + '%';
    } else {
      autoModeStat.autoModeSGAvgSD = '--';
      autoModeStat.autoModeSGInTargetRange = '--';
      autoModeStat.autoModeSGAboveRange = '--';
      autoModeStat.autoModeSGBelowRange = '--';
    }

    context.timeInAutoMode = parseInt((autoModeTime * 100.0 / (3600 * 24)).toFixed()) + '%';
    autoModeStat.timeInAutoMode = parseInt((autoModeTime * 100.0 / (3600 * 24)).toFixed()) + '%';
    context.autoModeStat[index] = autoModeStat;
  },
  getBolus: function getBolus(context, st, val) {
    var bolus = [],
        extend_bolus = [],
        m1 = [],
        max = 10,
        j = 0,
        k = 0;
    for (var i = 0; i < val.length; i++) {
      if (val[i][2] === 'EBCCW' || val[i][2] === 'EBM' || val[i][2] === 'EBCAW') {
        var partion_factor = val[i][5] ? 1.0 * val[i][6] / val[i][5] : 0;

        extend_bolus[j] = new Array(8);
        extend_bolus[j][0] = st < val[i][1] ? new Date(val[i][1] * 1000) : new Date(st * 1000);
        extend_bolus[j][1] = st + 86400 > val[i][1] + val[i][7] * 60 ? new Date((val[i][1] + val[i][7] * 60 * partion_factor) * 1000) : new Date((st + 86400) * 1000);
        extend_bolus[j][2] = val[i][6];
        extend_bolus[j][3] = Math.round(val[i][5] ? val[i][7] * 1.0 * val[i][6] / val[i][5] : 0);
        extend_bolus[j][4] = context.$t('E');
        extend_bolus[j][5] = val[i][8];
        extend_bolus[j][6] = val[i][5];
        extend_bolus[j][7] = val[i][5] == 0 ? 0 : Math.floor(val[i][6] / val[i][5] * val[i][7]);
        j++;
      } else if (val[i][2] === 'CBCCW' || val[i][2] === 'CBM' || val[i][2] === 'CBCAW') {
        extend_bolus[j] = new Array(8);
        extend_bolus[j][0] = st < val[i][1] ? new Date(val[i][1] * 1000) : new Date(st * 1000);
        extend_bolus[j][1] = st + 86400 > val[i][1] + val[i][7] * 60 ? new Date((val[i][1] + val[i][7] * 60) * 1000) : new Date((st + 86400) * 1000);
        extend_bolus[j][2] = val[i][6];
        extend_bolus[j][3] = val[i][7];
        extend_bolus[j][4] = context.$t('CE');
        extend_bolus[j][5] = val[i][8];
        extend_bolus[j][6] = val[i][5];
        extend_bolus[j][7] = val[i][5] == 0 ? 0 : Math.floor(val[i][6] / val[i][5] * val[i][7]);

        j++;
        bolus[k] = new Array(3);
        bolus[k][0] = new Date(val[i][1] * 1000);
        bolus[k][1] = val[i][4];
        bolus[k][2] = context.$t('CN1');
        k++;
      } else {
        bolus[k] = new Array(4);
        bolus[k][0] = new Date(val[i][1] * 1000);
        bolus[k][1] = val[i][4];
        bolus[k][2] = context.$t('N');
        bolus[k][3] = val[i][8];

        k++;
      }
      m1.push(val[i][4]);
      m1.push(val[i][6]);
    }
    max = Math.max.apply(null, m1);
    if (max < 5) {
      max = 5;
    } else if (max < 10) {
      max = 10;
    } else if (max < 15) {
      max = 15;
    } else if (max < 20) {
      max = 20;
    } else if (max < 25) {
      max = 25;
    }

    return [bolus, extend_bolus, max];
  },
  getExercise: function getExercise(context, val) {
    var exe = [],
        type = ['Light', 'Medium', 'Heavy'],
        j = 0,
        Num = [20, 60, 100];
    for (var i = 0; i < val[0].length; i++) {
      exe[j] = new Array(5);
      exe[j][0] = new Date(val[0][i][0] * 1000);
      exe[j][1] = new Date((val[0][i][0] + val[0][i][1] * 60) * 1000);
      exe[j][2] = Num[val[0][i][2]] * (context.carbMax / 100);
      exe[j][3] = val[0][i][1];
      exe[j][4] = type[val[0][i][2]];
      j++;
    }
    return exe;
  },
  getAutoMeal: function getAutoMeal(context, autoMeal, carbMax) {
    var autoBreakfast = autoMeal[0];
    var autoLunch = autoMeal[1];
    var autoDinner = autoMeal[2];
    var autoSnack = autoMeal[3];
    var autoExercise = autoMeal[4];

    if (1) {
      if (autoSnack.length) {
        autoSnack[0][1] = 50;
      }
    }

    autoBreakfast = autoBreakfast.map(function (e, i) {
      return [new Date(e[0] * 1000), carbMax + 2];
    });
    autoLunch = autoLunch.map(function (e, i) {
      return [new Date(e[0] * 1000), carbMax + 2];
    });
    autoDinner = autoDinner.map(function (e, i) {
      return [new Date(e[0] * 1000), carbMax + 2];
    });
    autoSnack = autoSnack.map(function (e, i) {
      return [new Date(e[0] * 1000), carbMax + 2];
    });
    autoExercise = autoExercise.map(function (e, i) {
      return [new Date(e[0] * 1000), carbMax + 2];
    });

    return [autoBreakfast, autoLunch, autoDinner, autoSnack, autoExercise];
  },
  getCalib: function getCalib(val) {
    var exe = [];
    for (var i = 0; i < val[0].length; i++) {
      exe[i] = new Array(2);
      exe[i][0] = new Date(val[0][i][1] * 1000);
      exe[i][1] = localStorage.getItem('unit') === 'mg' ? Math.round(val[0][i][3] * 18) : val[0][i][3].toFixed(1);
    }
    return exe;
  },
  getBg1: function getBg1(val) {
    var bg = [],
        max1 = [],
        max = 0;
    for (var i = 0; i < val[0].length; i++) {
      bg[i] = new Array(2);
      bg[i][0] = new Date(val[0][i][0] * 1000);
      bg[i][1] = localStorage.getItem('unit') === 'mg' ? Math.round(val[0][i][1] * 18) : val[0][i][1].toFixed(1);
      max1[i] = bg[i][1];
    }
    max = max1.length > 1 ? Math.max.apply(null, max1) : 0;
    max = this.getsgMax1(max);
    return [bg, max];
  },
  getCarb: function getCarb(val) {
    var carb = [],
        max = [],
        j = 0;
    for (var i = 0; i < val[0].length; i++) {
      if (val[0][i][1] !== 0) {
        carb[j] = new Array(2);
        carb[j][0] = new Date(val[0][i][0] * 1000);
        carb[j][1] = val[0][i][1];
        max[j] = val[0][i][1];
        j++;
      }
    }
    var max1 = Math.max.apply(null, max);
    if (max1 < 100) {
      max1 = 100;
    } else if (max1 < 200) {
      max1 = 200;
    } else if (max1 < 300) {
      max1 = 300;
    } else {
      max1 = 500;
    }
    return [carb, max1];
  },
  getAlarm: function getAlarm(context, val, flag) {
    var alarm = [];
    for (var i = 0; i < val[0].length; i++) {
      alarm[i] = new Array(3);
      alarm[i][0] = new Date(val[0][i][0] * 1000);
      if (flag === 1) {
        alarm[i][1] = 0.2;
      } else {
        alarm[i][1] = localStorage.getItem('unit') === 'mg' ? Math.round(1.2 * 18) : 1.2;
      }
      alarm[i][2] = context.$t(val[0][i][1]);
    }

    return alarm;
  },
  getsgMax1: function getsgMax1(max) {
    if (localStorage.getItem('unit') === 'mg') {
      if (max < 200) {
        max = 200;
      } else if (max < 300) {
        max = 300;
      } else if (max < 400) {
        max = 400;
      }
    } else {
      if (max < 15) {
        max = 15;
      } else if (max < 20) {
        max = 20;
      } else if (max < 25) {
        max = 25;
      }
    }
    return max;
  },
  getSleepTime: function getSleepTime(context, Stime, Dtime) {
    var time1 = new Array(2),
        time2 = new Array(2),
        time3 = new Array(2);
    time1[0] = new Array(3);
    time1[0][0] = new Date((Dtime[0] + Stime[0] * 60) * 1000);
    time1[0][1] = new Date(Dtime[1] * 1000);
    time1[0][2] = context.sgMax ? context.sgMax : 20;
    time1[1] = new Array(3);
    time1[1][0] = new Date(Dtime[0] * 1000);
    time1[1][1] = new Date((Dtime[0] + Stime[1] * 60) * 1000);
    time1[1][2] = time1[0][2];

    time2[0] = new Array(3);
    time2[0][0] = new Date((Dtime[0] + Stime[0] * 60) * 1000);
    time2[0][1] = new Date(Dtime[1] * 1000);
    time2[0][2] = context.basalMax ? context.basalMax : 5;
    time2[1] = new Array(3);
    time2[1][0] = new Date(Dtime[0] * 1000);
    time2[1][1] = new Date((Dtime[0] + Stime[1] * 60) * 1000);
    time2[1][2] = time2[0][2];

    time3[0] = new Array(3);
    time3[0][0] = new Date((Dtime[0] + Stime[0] * 60) * 1000);
    time3[0][1] = new Date(Dtime[1] * 1000);
    time3[0][2] = context.carbMax;
    time3[1] = new Array(3);
    time3[1][0] = new Date(Dtime[0] * 1000);
    time3[1][1] = new Date((Dtime[0] + Stime[1] * 60) * 1000);
    time3[1][2] = context.carbMax;

    return [time1, time2, time3];
  },
  getTransmtr: function getTransmtr(context, val) {
    var trans = [],
        j = 0;
    for (var i = 0; i < val.length; i++) {
      if (val[i].length > 0) {
        trans[j] = new Array(2);
        trans[j][0] = new Date(val[i][1] * 1000);
        trans[j][1] = 0.2;
        j++;
      }
    }
    return trans;
  },
  parseDeviceSN: function parseDeviceSN(context, basal_data) {
    var pump_sn = {};
    var transmitter_sn = {};
    basal_data.map(function (e, i) {
      var record_id = e[0];
      pump_sn[record_id.split('-')[1]] = 1;
    });

    var pump_sn_arr = [];
    for (var p in pump_sn) {
      pump_sn_arr.push(p);
    }

    if (pump_sn_arr.length > 0) {
      context.pump_device = 'MD-JN ' + this.deviceSNFormat(pump_sn_arr[0]);
    } else {
      context.pump_device = '--';
    }
  },
  getDd: function getDd(context, uid, param) {
    var that = this;
    context.$http.get('/api/v2.1/chart/' + uid + '/data/dd', { params: { param: param } }).then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        if (context.sgChart1 || context.chartColumn11) {
          context.chartsDispose2();
          this.sg = [];
          this.basal = [];
        }

        if (1) {
          var basal_data = [];

          for (var i in res.body.data.basal) {
            basal_data = basal_data.concat(res.body.data.basal[i]);
          }

          that.parseDeviceSN(context, basal_data);
        }

        context.$store.commit('updateDataD', res.body.data);
        if (false) {
          var dayNum = res.body.data.sg.length;
          var sgData = res.body.data.sg[dayNum - 1];
          var dataNum = sgData.length;
          var start = 0;
          var end = dataNum;
          if (dataNum > 50) {
            start = dataNum - 50;
            end = 50;
          }
          for (var _i7 = start; _i7 < dataNum; _i7++) {}

          for (var _i8 = 0; _i8 < end; _i8++) {
            if (sgData[_i8][1] > 5) {
              sgData[_i8][1] += 18;
            }
          }
        }
        context.sg = that.getDdSG(res.body.data.sg);
        context.calib = that.getCalib3(res.body.data.calib);
        context.bg = that.getBg3(res.body.data.bg);
        context.timeSection = res.body.data.time_sec;
        that.getBasal3(context, res.body.data.basal);
        that.getBasalSus3(context, res.body.data.basal);
        var mealTime = that.getMealTime(res.body.data.meal_time, res.body.data.time_sec);

        context.mealTime1 = mealTime[0];
        context.mealTime2 = mealTime[1];
        context.mealTime3 = mealTime[2];
        if (res.data.data.transmtr) {
          that.getTransmtr2(context, res.data.data.transmtr);
        }
        that.getBolus3(context, res.body.data.bolus);

        sessionStorage.setItem('dd_report_data', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res.body.report_data));
        if (context.getDdReportInfo) {
          context.getDdReportInfo(res.body.report_data);
        }
        context.carb = res.body.data.carb;

        context.autoBreakfast = res.body.data.auto_mode_event[0];
        context.autoLunch = res.body.data.auto_mode_event[1];
        context.autoDinner = res.body.data.auto_mode_event[2];
        context.autoSnack = res.body.data.auto_mode_event[3];

        context.drawCharts2();
      }
    }, function (err) {
      console.log(err + "," + err.body.message);
      context.error = err.body.message;
    });
  },
  getDdSG: function getDdSG(val) {
    var SG = new Array(7);
    for (var i = 0; i < val.length; i++) {
      SG[i] = [];
      for (var j = 0; j < val[i].length; j++) {
        SG[i][j] = new Array(2);
        SG[i][j][0] = new Date(val[i][j][0] * 1000);
        SG[i][j][1] = val[i][j][1] > 22.2 ? 22.2 : val[i][j][1].toFixed(1);
        if (SG[i][j][1] < 2.2 && (val[i][j][4] === 'C' || val[i][j][4] === 'CX')) {
          SG[i][j][1] = 2.2;
        }
        SG[i][j][1] = localStorage.getItem('unit') === 'mg' ? Math.round(SG[i][j][1] * 18) : SG[i][j][1];
        if (val[i][j][4] === 'DE') {
          SG[i][j][1] = 0;
        }
        SG[i][j][2] = val[i][j][4];
      }
    }
    return SG;
  },
  getBasal3: function getBasal3(context, val) {
    var basal = new Array(7);
    for (var i = 0; i < val.length; i++) {
      var st = context.timeSection[i][0];
      basal[i] = [];
      var j = 0;
      for (var k = 0; k < val[i].length; k++) {
        if (val[i][k][2] === 'BAS' || val[i][k][2] === 'BAE' || val[i][k][2] === 'BAH' || val[i][k][2] === 'BAPB' || val[i][k][2] === 'BAPA' || val[i][k][2] === 'BAPC' || val[i][k][2] === 'BAPD' || val[i][k][2] === 'BASK') {
          basal[i][j] = new Array(2);
          basal[i][j][0] = st <= val[i][k][1] ? new Date(val[i][k][1] * 1000) : new Date(st * 1000);
          basal[i][j][1] = val[i][k][4] ? val[i][k][4].toFixed(2) : 0;
          j++;
          basal[i][j] = new Array(2);
          basal[i][j][0] = st + 86400 <= val[i][k][1] + val[i][k][3] ? new Date((st + 86400) * 1000) : new Date((val[i][k][1] + val[i][k][3]) * 1000);
          basal[i][j][1] = val[i][k][4] ? val[i][k][4].toFixed(2) : 0;

          if (k < val[i].length - 1) {
            var nextBasalType = val[i][k + 1][2];
            if (val[i][k + 1][2] !== 'BAS' && val[i][k + 1][2] !== 'BAE' && val[i][k + 1][2] !== 'BAH' && nextBasalType != 'BAPA' && nextBasalType != 'BAPB' && nextBasalType != 'BAPC' && nextBasalType != 'BAPD' && nextBasalType != 'BASK') {
              j++;
              basal[i][j] = new Array(2);
              basal[i][j][0] = st + 86400 <= val[i][k][1] + val[i][k][3] ? new Date((st + 86400) * 1000) : new Date((val[i][k][1] + val[i][k][3]) * 1000);
              basal[i][j][1] = null;
            }
          }
          j++;
        }
      }
    }

    context.basal = basal;

    var autoModeBasalList = [];
    var autoModeCorrBolusList = [];

    for (var _i9 = 0; _i9 < val.length; _i9++) {
      var _st = context.timeSection[_i9][0];
      var autoModeBasal = [];
      var autoModeCorrBolus = [];
      for (var _k = 0; _k < val[_i9].length; _k++) {
        var basalType = val[_i9][_k][2];
        if ('BAAM' == basalType) {
          var microBolus = val[_i9][_k][7];

          var microBolusJson = [];
          try {
            microBolus = JSON.parse(microBolus);

            microBolusJson = microBolus['autoModeJSON'];
          } catch (e) {
            console.log('microBolus error:', e);
          }

          if (microBolusJson.length > 0) {

            var index = 0;
            while (index < microBolusJson.length) {
              var subRecord = microBolusJson.slice(index, index + 5);
              var startTime = new Date(val[_i9][_k][1] * 1000 + index * 6 * 60 * 1000);
              var endTime = new Date(val[_i9][_k][1] * 1000 + (index + subRecord.length) * 6 * 60 * 1000);
              var totalInject = 0;
              var totalCorrBolus = 0;
              subRecord.map(function (e, i) {
                totalInject += e['auto_basal_delivery'];
                totalCorrBolus += e['auto_corr_delivery'];
                totalCorrBolus += e['auto_food_delivery'];
              });
              var basalRate = totalInject * 0.05 / (subRecord.length * 6.0 / 60);

              var basal_record = [startTime, endTime, basalRate];
              autoModeBasal.push(basal_record);

              if (totalCorrBolus > 0) {
                autoModeCorrBolus.push([new Date((startTime.getTime() + endTime.getTime()) / 2), totalCorrBolus * 0.05]);
              }

              index += 5;
            }
          }
        }
      }

      autoModeBasalList.push(autoModeBasal);
      autoModeCorrBolusList.push(autoModeCorrBolus);
    }
    context.autoModeBasal = autoModeBasalList;
    context.autoModeCorrBolus = autoModeCorrBolusList;
  },
  getBasalSus3: function getBasalSus3(context, val) {
    var basal = new Array(7);
    var NewBasal = new Array(7);
    var stopBasal = new Array(7);
    var manualStop = new Array(7);
    var tempBasal = new Array(7);
    for (var i = 0; i < val.length; i++) {
      var data = this.getBasalSus4(context, context.timeSection[i][0], val[i]);
      basal[i] = data[0];
      tempBasal[i] = data[1];
      manualStop[i] = data[2];
      var data1 = this.getBasal2(val[i]);
      NewBasal[i] = data1[0];
      stopBasal[i] = data1[1];
    }
    context.basal_suspend = basal;
    context.manualStop = manualStop;
    context.tempBasal = tempBasal;
    context.NewBasal = NewBasal;
    context.stopBasal = stopBasal;
  },
  getBasalSus4: function getBasalSus4(context, st, val) {
    var TextFunc = context.$t;

    var basal = [],
        tempBasal = [],
        basa2 = [];
    var j = 0,
        k = 0,
        p = 0,
        et = st + 86400;
    for (var i = 0; i < val.length; i++) {
      if (val[i][2] === 'SUSHM' || val[i][2] === 'SUSDM' || val[i][2] === 'SUSLSG' || val[i][2] === 'SUSPLSG' || val[i][2] === 'SUSA') {
        basal[j] = [];
        basal[j][0] = st <= val[i][1] ? new Date(val[i][1] * 1000) : new Date(st * 1000);
        basal[j][1] = val[i - 1] ? val[i - 1][4] : 0;
        basal[j][2] = context.$t(val[i][2]);
        j++;
        basal[j] = [];
        basal[j][0] = st <= val[i][1] ? new Date(val[i][1] * 1000) : new Date(st * 1000);
        basal[j][1] = 0;
        basal[j][2] = context.$t(val[i][2]);
        j++;
        basal[j] = [];
        basal[j][0] = et <= val[i][1] + val[i][3] ? new Date(et * 1000) : new Date((val[i][1] + val[i][3]) * 1000);
        basal[j][1] = 0;
        basal[j][2] = context.$t(val[i][2]);
        j++;
        basal[j] = [];
        basal[j][0] = et <= val[i][1] + val[i][3] ? new Date(et * 1000) : new Date((val[i][1] + val[i][3]) * 1000);
        basal[j][1] = val[i + 1] ? val[i + 1][4] : 0;
        basal[j][2] = context.$t(val[i][2]);

        if (i < val.length - 1) {
          if (val[i + 1][2] !== 'SUSHM' && val[i + 1][2] !== 'SUSDM' && val[i + 1][2] !== 'SUSLSG' && val[i + 1][2] !== 'SUSPLSG' && val[i + 1][2] !== 'SUSA') {
            j++;
            basal[j] = new Array(2);
            basal[j][0] = et <= val[i][1] + val[i][3] ? new Date(et * 1000) : new Date((val[i][1] + val[i][3]) * 1000);
            basal[j][1] = null;
            basal[j][2] = context.$t(val[i][2]);
          }
        }
        j++;
      }
      if (val[i][2] === 'BART' || val[i][2] === 'BAAT') {
        tempBasal[k] = new Array(2);
        tempBasal[k][0] = st <= val[i][1] ? new Date(val[i][1] * 1000) : new Date(st * 1000);
        if (val[i - 1]) {
          if (val[i - 1][2] !== 'SUSM' && val[i - 1][2] !== 'SUSEB') {
            tempBasal[k][1] = val[i - 1][4];
          } else {
            if (val[i - 2]) {
              tempBasal[k][1] = val[i - 2][4];
            } else {
              tempBasal[k][1] = val[i][4];
            }
          }
        }
        k++;
        tempBasal[k] = new Array(2);
        tempBasal[k][0] = st <= val[i][1] ? new Date(val[i][1] * 1000) : new Date(st * 1000);
        tempBasal[k][1] = val[i][4];
        k++;
        tempBasal[k] = new Array(2);
        tempBasal[k][0] = et <= val[i][1] + val[i][3] ? new Date(et * 1000) : new Date((val[i][1] + val[i][3]) * 1000);
        tempBasal[k][1] = val[i][4];
        k++;
        tempBasal[k] = new Array(2);
        tempBasal[k][0] = et <= val[i][1] + val[i][3] ? new Date(et * 1000) : new Date((val[i][1] + val[i][3]) * 1000);
        if (val[i + 1]) {
          if (val[i + 1][2] !== 'SUSM' && val[i + 1][2] !== 'SUSEB' && val[i + 1][2] !== 'SUSHM' && val[i + 1][2] !== 'SUSDM' && val[i + 1][2] !== 'SUSLSG' && val[i + 1][2] !== 'SUSPLSG' && val[i + 1][2] !== 'SUSA') {
            tempBasal[k][1] = val[i + 1][4];
          } else {
            if (val[i + 2]) {
              tempBasal[k][1] = val[i + 2][4];
            } else {
              tempBasal[k][1] = val[i][4];
            }
          }
        }

        if (i < val.length - 1) {
          if (val[i + 1][2] !== 'BART' && val[i + 1][2] !== 'BAAT') {
            k++;
            tempBasal[k] = new Array(2);
            tempBasal[k][0] = et <= val[i][1] + val[i][3] ? new Date(et * 1000) : new Date((val[i][1] + val[i][3]) * 1000);
            tempBasal[k][1] = null;
          }
        }
        k++;
      }
      if (val[i][2] === 'SUSM' || val[i][2] === 'SUSEB') {
        basa2[p] = new Array(2);
        basa2[p][0] = st <= val[i][1] ? new Date(val[i][1] * 1000) : new Date(st * 1000);

        if (val[i - 1]) {
          if (val[i - 1][2] === 'BAS' || val[i - 1][2] === 'BAE' || val[i - 1][2] === 'BAH') {
            basa2[p][1] = val[i - 1][4];
          } else {
            if (val[i - 2]) {
              basa2[p][1] = val[i - 2][4];
            } else {
              basa2[p][1] = val[i][4];
            }
          }
        }
        p++;
        basa2[p] = new Array(2);
        basa2[p][0] = st <= val[i][1] ? new Date(val[i][1] * 1000) : new Date(st * 1000);
        basa2[p][1] = 0;
        p++;
        basa2[p] = new Array(2);
        basa2[p][0] = et <= val[i][1] + val[i][3] ? new Date(et * 1000) : new Date((val[i][1] + val[i][3]) * 1000);
        basa2[p][1] = 0;
        p++;
        basa2[p] = new Array(2);
        basa2[p][0] = et <= val[i][1] + val[i][3] ? new Date(et * 1000) : new Date((val[i][1] + val[i][3]) * 1000);
        basa2[p][1] = val[i + 1] ? val[i + 1][4] : 0;

        if (i < val.length - 1) {
          if (val[i + 1][2] !== 'SUSM' && val[i + 1][2] !== 'SUEB') {
            p++;
            basa2[p] = new Array(2);
            basa2[p][0] = et <= val[i][1] + val[i][3] ? new Date(et * 1000) : new Date((val[i][1] + val[i][3]) * 1000);
            basa2[p][1] = null;
          }
        }
        p++;
      }
    }

    return [basal, tempBasal, basa2];
  },
  getBolus3: function getBolus3(context, val) {
    var bolus = new Array(7);
    var extend_bolus = new Array(7);
    var max = new Array();
    for (var i = 0; i < val.length; i++) {
      var info = this.getBolus(context, context.timeSection[i][0], val[i]);
      bolus[i] = info[0];
      extend_bolus[i] = info[1];
      max[i] = info[2];
    }
    context.bolus = bolus;
    context.extend_bolus = extend_bolus;
    context.bolusMax = max.length > 0 ? Math.max.apply(null, max) : 5;
  },
  getCalib3: function getCalib3(val) {
    var calib = new Array(7);
    for (var i = 0; i < val.length; i++) {
      calib[i] = [];
      for (var j = 0; j < val[i].length; j++) {
        calib[i][j] = new Array(2);
        calib[i][j][0] = new Date(val[i][j][1] * 1000);
        calib[i][j][1] = localStorage.getItem('unit') === 'mg' ? Math.round(val[i][j][3] * 18) : val[i][j][3].toFixed(1);
      }
    }
    return calib;
  },
  getBg3: function getBg3(val) {
    var bg = new Array(7);
    for (var i = 0; i < val.length; i++) {
      bg[i] = [];
      for (var j = 0; j < val[i].length; j++) {
        bg[i][j] = new Array(2);
        bg[i][j][0] = new Date(val[i][j][0] * 1000);
        bg[i][j][1] = localStorage.getItem('unit') === 'mg' ? Math.round(val[i][j][1] * 18) : val[i][j][1].toFixed(1);
      }
    }
    return bg;
  },
  getMealTime: function getMealTime(Mtime, Dtime) {
    var timeb = [],
        timel = [],
        times = [],
        num = localStorage.getItem('unit') === 'mg' ? 400 : 25;
    for (var i = 0; i < Dtime.length; i++) {
      timeb[i] = new Array(3);
      timeb[i][0] = new Date((Dtime[i][0] + Mtime[0][0] * 60) * 1000);
      timeb[i][1] = new Date((Dtime[i][0] + Mtime[0][1] * 60) * 1000);
      timeb[i][2] = num;

      timel[i] = new Array(3);
      timel[i][0] = new Date((Dtime[i][0] + Mtime[1][0] * 60) * 1000);
      timel[i][1] = new Date((Dtime[i][0] + Mtime[1][1] * 60) * 1000);
      timel[i][2] = num;

      times[i] = new Array(3);
      times[i][0] = new Date((Dtime[i][0] + Mtime[2][0] * 60) * 1000);
      times[i][1] = new Date((Dtime[i][0] + Mtime[2][1] * 60) * 1000);
      times[i][2] = num;
    }
    return [timeb, timel, times];
  },
  getTransmtr2: function getTransmtr2(context, val) {
    var trans = [];
    for (var i = 0; i < val.length; i++) {
      trans[i] = this.getTransmtr(context, val[i]);
    }
    context.trans = trans;
  },
  formatterTip: function formatterTip(params, context, flag) {
    var data_source = sessionStorage.getItem('data_source');

    var basal_unit = 'U/H';
    var ins_unit2 = 'U';
    if (true) {
      try {
        var _basal_unit = context.$t('basal_unit2');
        var _ins_unit = context.$t('ins_unit2');
      } catch (e) {}
    }


    var that = this;
    var tipArray = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        tip = '',
        timeDetail = '';
    params.map(function (e, i) {

      if (e.value[0] !== 10) {
        var index = e.seriesIndex;
        var name = e.seriesName;
        var value = e.value[1];
        var date = e.value[0];
        var time = that.formatterDate5(date);
        var day = that.formatterDate4(date.getTime() / 1000);
        timeDetail = day + '  ' + time[0] + ':' + time[1] + '<br>';

        if (index === 0 || index === 2) {
          value = Math.round(value * 100) / 100;
          var icon = " <div style='background: #00ff4c;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
          tipArray[index] = icon + name + ' :  ' + value + basal_unit;
          if (!value) {
            tipArray[index] = 0;
          }
        }
        if (index === 1 && value) {
          var _icon = " <div style='background: #ff0000;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
          tipArray[1] = _icon + e.value[2];
        }
        if (index === 3 && value) {
          var _icon2 = " <div style='background: #ff0000;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
          tipArray[3] = _icon2 + name;
        }
        if (index === 4 && value) {
          var _icon3 = " <div style='background: #182f82;height: 8px;width: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
          tipArray[4] = _icon3 + name + ' :  ' + e.value[2] + ', ' + value.toFixed(2) + ins_unit2;

          try {
            var wizzard_info = e.value[3];
            wizzard_info = JSON.parse(wizzard_info);
            var wizzard_carb = wizzard_info['carb'];
            var wizzard_bg = wizzard_info['bg'];
            var wizzard_iob = wizzard_info['iob'];
            var adjustmentType = wizzard_info['adjustmentType'];

            var iobName = 'Active insulin:';
            if (wizzard_bg) {
              if (context.isMg) {
                wizzard_bg = round(wizzard_bg * 18) + ' mg/dL';
              } else {
                wizzard_bg = wizzard_bg.toFixed(1) + ' mmol/L';
              }
            }
            if (adjustmentType) {
              iobName = 'Adjustment:';
            } else {

              if (wizzard_iob > 100) {
                iobName = 'Adjustment:';
                if (wizzard_iob > 500) {
                  var val = Math.round(wizzard_iob / 0.05) & 0x3fff;
                  if (val > 0x1fff) {
                    wizzard_iob = (val - 0x4000) * 0.05;
                  } else if (val >= 0) {
                    wizzard_iob = val * 0.05;
                  }
                } else {
                  var _val = Math.round(wizzard_iob / 0.01) & 0x3fff;
                  if (_val > 0x1fff) {
                    wizzard_iob = (_val - 0x4000) * 0.01;
                  } else if (_val >= 0) {
                    wizzard_iob = _val * 0.01;
                  }
                }
              }
            }

            if (wizzard_carb && wizzard_bg) {
              tipArray[4] += '<br/>&nbsp;&nbsp;&nbsp;' + 'Carb:' + wizzard_carb + ' g, BG:' + wizzard_bg + '<br/>&nbsp;&nbsp;&nbsp;' + iobName + wizzard_iob.toFixed(2) + ' U';
            } else if (wizzard_carb) {
              tipArray[4] += '<br/>&nbsp;&nbsp;&nbsp;' + 'Carb:' + wizzard_carb + ' g' + '<br/>&nbsp;&nbsp;&nbsp;' + iobName + wizzard_iob.toFixed(2) + ' U';
            } else if (wizzard_bg) {
              tipArray[4] += '<br/>&nbsp;&nbsp;&nbsp;' + 'BG:' + wizzard_bg + '<br/>&nbsp;&nbsp;&nbsp;' + iobName + wizzard_iob.toFixed(2) + ' U';
            }
          } catch (e) {}
        }
        if (index === 5 && value) {
          var _icon4 = " <div style='background: #f9b4ff;height: 8px;width: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
          tipArray[5] = _icon4 + name + ' :  ' + e.value[4] + ', ' + e.value[2].toFixed(2) + ins_unit2 + '/' + e.value[7] + 'min';
          try {
            var _wizzard_info = e.value[5];
            _wizzard_info = JSON.parse(_wizzard_info);
            var _wizzard_carb = _wizzard_info['carb'];
            var _wizzard_bg = _wizzard_info['bg'];
            var _wizzard_iob = _wizzard_info['iob'];
            if (_wizzard_bg) {
              if (context.isMg) {
                _wizzard_bg = Math.round(_wizzard_bg * 18) + ' mg/dL';
              } else {
                _wizzard_bg = _wizzard_bg.toFixed(1) + ' mmol/L';
              }
            }
            if (_wizzard_carb && _wizzard_bg) {
              tipArray[5] += '<br/>&nbsp;&nbsp;&nbsp;' + 'Carb:' + _wizzard_carb + ' g, BG:' + _wizzard_bg + '<br/>&nbsp;&nbsp;&nbsp;Active insulin:' + _wizzard_iob.toFixed(2) + ' U';
            } else if (_wizzard_carb) {
              tipArray[5] += '<br/>&nbsp;&nbsp;&nbsp;' + 'Carb:' + _wizzard_carb + ' g' + '<br/>&nbsp;&nbsp;&nbsp;Active insulin:' + _wizzard_iob.toFixed(2) + ' U';
            } else if (_wizzard_bg) {
              tipArray[5] += '<br/>&nbsp;&nbsp;&nbsp;' + 'BG:' + _wizzard_bg + '<br/>&nbsp;&nbsp;&nbsp;Active insulin:' + _wizzard_iob.toFixed(2) + ' U';
            }
          } catch (e) {
            console.log('extend bolus tip:', e);
          }
        }
        if (index === 6 && value) {
          var _icon5 = " <div style='background:yellowgreen;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
          tipArray[6] = _icon5 + name;
        }
        if (index === 7 && value) {
          var _icon6 = " <div style='background: #ff0000;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
          tipArray[7] = _icon6 + name;
        }
        if (index === 8 && value) {
          if ('chart2' == flag) {
            value = Math.round(e.value[2] * 100) / 100;
            tipArray[8] = name + ':' + value + basal_unit;
          } else {
            var _icon7 = " <div style='height:0;width:0;margin-right:1px;border-width:6px;border-style:solid;border-color:transparent transparent #f00 transparent ;float:left;display: inline-block'></div>";
            tipArray[8] = _icon7 + name + ' :  ' + e.value[2];
          }
        }
        if (index === 9 && value) {
          if ('chart2' == flag) {
            tipArray[9] = name + ':' + value.toFixed(2) + ins_unit2;
          }
        }
        if (index === 10 && value) {
          if ('chart1' == flag || 'monitor' == flag) {
            value = Math.round(e.value[2] * 100) / 100;
            tipArray[10] = name + ':' + value + basal_unit;
          }
        }
        if (index === 11 && value) {
          if ('chart1' == flag || 'monitor' == flag) {
            tipArray[11] = name + ':' + value.toFixed(2) + ins_unit2;
          }
        }
      }
    });
    tip = tip + timeDetail;
    tipArray.map(function (e, i) {
      if (e) {
        tip = tip + e + '<br>';
      }
    });

    return tip;
  },
  formatterTip1: function formatterTip1(params, context, flag) {
    var that = this;
    var tipArray = [0, 0, 0, 0, 0],
        tip = '',
        timeDetail = '',
        unit = context.isMg ? 'mg/dL' : 'mmol/L ';
    var icon = " <div style='background: #2cd200;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    var icon1 = " <div style='background: #e6be00;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    var icon2 = " <div style='background: #ff5c5c;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    var icon3 = " <div style='background: #a4a4a4;height: 8px;width: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    var icon4 = " <div style='background: #ff5c5c;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    params.map(function (e, i) {
      if (e.value[0] !== 10) {
        var index = e.seriesIndex;
        var name = e.seriesName;
        var value = e.value[1];
        var date = e.value[0];
        var time = that.formatterDate5(date);
        var day = that.formatterDate3(date.getTime() / 1000);
        timeDetail = day + '  ' + time[0] + ':' + time[1] + '<br>';
        if (index === 0) {
          var type = e.value[2],
              tip0 = '';
          if (value > 0 && type != 'DE') {
            var value1 = '',
                ico = icon;

            var isHighLow = true;

            try {
              var sg_val = parseFloat(value);
              if (context.isMg) {
                if (sg_val >= 400) {
                  value = '偏高';
                } else if (sg_val <= 40) {
                  value = '偏低';
                } else {
                  isHighLow = false;
                }
              } else {
                if (sg_val >= 22.2) {
                  value = '偏高';
                } else if (sg_val <= 2.2) {
                  value = '偏低';
                } else {
                  isHighLow = false;
                }
              }
            } catch (e) {
              console.log('sg tip:', e);
            }

            if (type === 'CX' || type === 'NC') {
              value1 = '<span style="border-bottom: 1px solid #fff;display: inline-block">' + value + '</span>';
            } else {
              value1 = value;
            }
            if (context.isMg) {
              ico = value > context.DataS.blos_high * 18 ? icon1 : ico;
              ico = value < context.DataS.blos_low * 18 ? icon2 : ico;
            } else {
              ico = value > context.DataS.blos_high ? icon1 : ico;
              ico = value < context.DataS.blos_low ? icon2 : ico;
            }
            if (value == '偏高') {
              ico = icon1;
            } else if (value == '偏低') {
              ico = icon2;
            }
            if (isHighLow) {
              tip0 = ico + context.$t(name) + ' : ' + value1;
            } else {
              tip0 = ico + context.$t(name) + ' : ' + value1 + unit;
            }
          } else {
            var _ico = icon4,
                text = '';
            if (type === 'NC') {
              text = context.$t('Not Calibrated');
            }
            if (type === 'DE') {
              text = context.$t('noReadings');
            }
            if (type === 'CE0' || type === 'CE1') {
              text = context.$t('Calibration Error');
            }
            if (type === 'H') {
              _ico = icon3;text = context.$t('warm');
            }
            tip0 = _ico + text;
          }
          tipArray[0] = tip0;
        }
        if (index === 1) {
          var icon5 = " <div style='background: #f00;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
          tipArray[1] = icon5 + context.$t('calib') + ' : ' + value + unit;
        }

        if ('ds' == flag) {
          if (index === 2) {
            var _icon8 = " <div style='background: #f00;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
            tipArray[2] = _icon8 + context.$t('BG') + ' : ' + value + unit;
          }
          if (index === 3) {
            var _icon9 = " <div style='background: #00a107;height: 8px;width: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
            tipArray[3] = _icon9 + context.$t('newSen');
          }
          if (index === 4) {
            var _icon10 = " <div style='height:0;width:0;margin-right:1px;border-width:6px;border-style:solid;border-color:transparent transparent #f00 transparent ;float:left;display: inline-block'></div>";
            tipArray[4] = _icon10 + context.$t('alert') + ' : ' + e.value[2];
          }
        } else if ('rt' == flag) {
          if (index === 2) {
            var _icon11 = " <div style='height:0;width:0;margin-right:1px;border-width:6px;border-style:solid;border-color:transparent transparent #f00 transparent ;float:left;display: inline-block'></div>";
            tipArray[2] = _icon11 + context.$t('alert') + ' : ' + e.value[2];
          }
          if (index === 3) {
            var _icon12 = " <div style='background: #00a107;height: 8px;width: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
            tipArray[3] = _icon12 + context.$t('newSen');
          }
        }
      }
    });
    tip = tip + timeDetail;
    tipArray.map(function (e, i) {
      if (e) {
        tip = tip + e + '<br>';
      }
    });

    return tip;
  },
  formatterTip2: function formatterTip2(params, context) {
    var that = this;
    var tipArray = [0, 0, 0, 0],
        tip = '',
        timeDetail = '',
        unit = context.isMg ? 'mg/dL' : 'mmol/L ';
    var icon = " <div style='background: #2cd200;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    var icon1 = " <div style='background: #e6be00;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    var icon2 = " <div style='background: #ff5c5c;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    var icon3 = " <div style='background: #a4a4a4;height: 8px;width: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    var icon4 = " <div style='background: #ff5c5c;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    params.map(function (e, i) {
      if (e.value[0] !== 10) {
        var index = e.seriesIndex;
        var name = e.seriesName;
        var value = e.value[1];
        var date = e.value[0];
        var time = that.formatterDate5(date);
        var day = that.formatterDate3(date.getTime() / 1000);
        timeDetail = day + '  ' + time[0] + ':' + time[1] + '<br>';

        if (index === 3) {
          var type = e.value[2],
              tip0 = '';
          if (value > 0) {
            var value1 = '',
                ico = icon;

            var isHighLow = true;

            try {
              var sg_val = parseFloat(value);
              if (context.isMg) {
                if (sg_val >= 400) {
                  value = '偏高';
                } else if (sg_val <= 40) {
                  value = '偏低';
                } else {
                  isHighLow = false;
                }
              } else {
                if (sg_val >= 22.2) {
                  value = '偏高';
                } else if (sg_val <= 2.2) {
                  value = '偏低';
                } else {
                  isHighLow = false;
                }
              }
            } catch (e) {
              console.log('sg tip:', e);
            }

            if (type === 'CX' || type === 'NC') {
              var hr1 = '<hr style="width: 25px;background:#FFF;height:1px;border:none;left:45px;top: 45px;position: absolute">';
              var hr2 = '<hr style="width: 25px;background:#FFF;height:1px;border:none;left:70px;top: 45px;position: absolute">';
              var hr3 = '<hr style="width: 25px;background:#FFF;height:1px;border:none;left:140px;top: 45px;position: absolute">';
              value1 = context.isEn ? value + hr1 : value + hr2;
              if (context.isFr) {
                value1 = value + hr3;
              }
            } else {
              value1 = value;
            }
            if (context.isMg) {
              ico = value > context.DataD.target_high * 18 ? icon1 : ico;
              ico = value < context.DataD.target_low * 18 ? icon2 : ico;
            } else {
              ico = value > context.DataD.target_high ? icon1 : ico;
              ico = value < context.DataD.target_low ? icon2 : ico;
            }
            if (value == '偏高') {
              ico = icon1;
            } else if (value == '偏低') {
              ico = icon2;
            }
            if (isHighLow) {
              tip0 = ico + context.$t(name) + ' : ' + value1;
            } else {
              tip0 = ico + context.$t(name) + ' : ' + value1 + unit;
            }
          } else {
            var _ico2 = icon4,
                text = '';
            if (type === 'NC') {
              text = context.$t('Not Calibrated');
            }
            if (type === 'DE') {
              text = context.$t('noReadings');
            }
            if (type === 'CE0' || type === 'CE1') {
              text = context.$t('Calibration Error');
            }
            if (type === 'H') {
              _ico2 = icon3;text = context.$t('warm');
            }
            tip0 = _ico2 + text;
          }
          tipArray[0] = tip0;
        }
        if (index === 0) {
          var icon5 = " <div style='background: #f00;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
          tipArray[1] = icon5 + context.$t('calib') + ' : ' + value + unit;
        }
        if (index === 1) {
          var _icon13 = " <div style='background: #f00;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
          tipArray[2] = _icon13 + context.$t('BG') + ' : ' + value + unit;
        }
        if (index === 2) {
          var _icon14 = " <div style='background: #00a107;height: 8px;width: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
          tipArray[3] = _icon14 + context.$t('newSen');
        }
      }
    });
    tip = tip + timeDetail;
    tipArray.map(function (e, i) {
      if (e) {
        tip = tip + e + '<br>';
      }
    });
    return tip;
  },
  formatterTip3: function formatterTip3(params, context) {
    var that = this;
    var tipArray = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        tip = '',
        timeDetail = '',
        unit = context.isMg ? 'mg/dL' : 'mmol/L ';
    var icon0 = " <div style='background: #3ce8dc;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    var icon1 = " <div style='background: #2842d2;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    var icon2 = " <div style='background: #79bd39;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    var icon3 = " <div style='background: #dce573;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    var icon4 = " <div style='background: #e61795;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    var icon5 = " <div style='background: #c9711e;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    var icon6 = " <div style='background: #a922d9;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    var icon7 = " <div style='background: #464646;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    params.map(function (e, i) {
      var index = e.seriesIndex;
      var value = e.value[1];
      var date = e.value[0];
      var time = that.formatterDate5(date);
      var t1 = '';
      timeDetail = context.$t('SG') + ' ' + time[0] + ':' + time[1] + '<br>';
      if (index < 8) {
        var type = e.value[2],
            tip0 = '',
            ico = icon0;
        if (index < 7) {
          var t2 = context.legendDate[index].split('-');
          t1 = t2[0] + '/' + t2[1];
        } else {
          t1 = context.$t('Avg');
        }
        ico = index === 1 ? icon1 : ico;ico = index === 2 ? icon2 : ico;ico = index === 3 ? icon3 : ico;
        ico = index === 4 ? icon4 : ico;ico = index === 5 ? icon5 : ico;ico = index === 6 ? icon6 : ico;ico = index === 7 ? icon7 : ico;
        if (value > 0) {
          var value1 = '';

          var isHighLow = true;

          try {
            var sg_val = parseFloat(value);
            if (context.isMg) {
              if (sg_val >= 400) {
                value = '偏高';
              } else if (sg_val <= 40) {
                value = '偏低';
              } else {
                isHighLow = false;
              }
            } else {
              if (sg_val >= 22.2) {
                value = '偏高';
              } else if (sg_val <= 2.2) {
                value = '偏低';
              } else {
                isHighLow = false;
              }
            }
          } catch (e) {
            console.log('sg tip:', e);
          }

          if (type === 'CX' || type === 'NC') {
            var top1 = 45 * (index + 1) + 'px';
            var hr1 = '<hr style="width: 25px;background:#FFF;height:1px;border:none;left:65px;;position: absolute;top:"' + top1 + '>';
            var hr2 = '<hr style="width: 25px;background:#FFF;height:1px;border:none;left:90px;;position: absolute;top:"' + top1 + '>';
            value1 = context.isEn ? value + hr1 : value + hr1;
          } else {
            value1 = value;
          }
          if (isHighLow) {
            tip0 = ico + t1 + ' : ' + value1;
          } else {
            tip0 = ico + t1 + ' : ' + value1 + unit;
          }
        } else {
          var text = '';
          if (type === 'NC') {
            text = context.$t('Not Calibrated');
          }
          if (type === 'DE') {
            text = context.$t('noReadings');
          }
          if (type === 'CE0' || type === 'CE1') {
            text = context.$t('Calibration Error');
          }
          if (type === 'H') {
            text = context.$t('warm');
          }
          tip0 = ico + t1 + ' : ' + text;
        }
        tipArray[index] = tip0;
      }
      if (index === 8) {
        var icon8 = " <div style='background: #f00;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
        tipArray[8] = icon8 + context.$t('calib') + ' : ' + value + unit;
      }
      if (index === 9) {
        var _icon15 = " <div style='background: #f00;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
        tipArray[9] = _icon15 + context.$t('BG') + ' : ' + value + unit;
      }
    });
    tip = tip + timeDetail;
    tipArray.map(function (e, i) {
      if (e) {
        tip = tip + e + '<br>';
      }
    });
    return tip;
  },
  getOl: function getOl(context, uid, param) {
    var that = this;
    var t1 = new Date();
    context.$http.get('/api/v2.1/chart/' + uid + '/data/ol', { params: { param: param } }).then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        if (context.chart3_1) {
          context.chart3_1.dispose();
          context.chart3_1 = null;
          context.DataSG = [];
        }
        context.$store.commit('updateDataS', res.body.data);

        if (false) {
          var dayNum = res.body.data.sg.length;
          var sgData = res.body.data.sg[dayNum - 1];

          var dataNum = sgData.length;
          var start = 0;
          var end = dataNum;
          if (dataNum > 50) {
            start = dataNum - 50;
            end = 50;
          }
          for (var i = start; i < dataNum; i++) {}

          for (var _i10 = 0; _i10 < end; _i10++) {
            if (sgData[_i10][1] > 5) {
              sgData[_i10][1] += 18;
            }
          }
        }
        context.DataSG = that.getSG2(context, res.body.data);
        context.calib = that.getCalib5(context, res.body.data.calib);
        context.bg = that.getBg5(context, res.body.data.bg);
        var t2 = new Date();

        context.drawChart3_1();

        context.checkLegend();

        if (context.getOlReportInfo) {
          context.getOlReportInfo(res.body.report_data);
        }
      }
    }, function (err) {
      var tip = context.$t('tryAgain');
      context.$message.error(tip);
    });
  },
  getSG2: function getSG2(context, val) {
    var time = [],
        SG = [],
        k = 0,
        kday = [],
        flag = 0,
        f1 = 0,
        p = 0,
        isEn = localStorage.getItem('unit') === 'mg';
    var length = val.sg.length;

    for (var i = 0; i < length; i++) {
      if (val.sg[i].length > 0 && flag === 0) {
        f1 = i;
        flag = 1;
        break;
      }
    }
    for (var _i11 = 0; _i11 < length; _i11++) {
      if (val.sg[_i11].length > 0) {
        if (false) {
          var t0 = this.formatterDate3(val.sg[f1][0][0]).split('-');
          var t1 = this.formatterDate3(val.sg[_i11][0][0]).split('-');
          var m = parseInt(t0[1]);
          if (m === 1 || m === 3 || m === 5 || m === 7 || m === 8 || m === 10 || m === 12) {
            k = (parseInt(t1[1]) - m) * 31 + parseInt(t1[2]) - parseInt(t0[2]);
          } else if (m === 2) {
            k = (parseInt(t1[1]) - m) * 28 + parseInt(t1[2]) - parseInt(t0[2]);
          } else {
            k = (parseInt(t1[1]) - m) * 30 + parseInt(t1[2]) - parseInt(t0[2]);
          }
        } else {
          var _t = val.sg[f1][0][0];
          var _t2 = val.sg[_i11][0][0];
          var d0 = new Date(_t * 1000);
          var d1 = new Date(_t2 * 1000);
          d0 = new Date(d0.getFullYear(), d0.getMonth(), d0.getDate());
          d1 = new Date(d1.getFullYear(), d1.getMonth(), d1.getDate());
          _t = d0.getTime() / 1000;
          _t2 = d1.getTime() / 1000;
          k = (_t2 - _t) / 86400;
        }

        kday.push(k);
        SG[p] = new Array(720);
        var length1 = val.sg[_i11].length;
        for (var j = 0; j < length1; j++) {
          time[j] = new Date((val.sg[_i11][j][0] - k * 3600 * 24) * 1000);
          SG[p][j] = new Array(3);
          SG[p][j][0] = time[j];
          SG[p][j][1] = val.sg[_i11][j][1] > 22.2 ? 22.2 : val.sg[_i11][j][1].toFixed(1);
          if (SG[p][j][1] < 2.2 && (val.sg[_i11][j][4] === 'C' || val.sg[_i11][j][4] === 'CX')) {
            SG[p][j][1] = 2.2;
          }
          SG[p][j][1] = isEn ? Math.round(SG[p][j][1] * 18) : parseFloat(SG[p][j][1]);
          if (val.sg[_i11][j][4] === 'DE') {
            SG[p][j][1] = 0;
          }
          SG[p][j][2] = val.sg[_i11][j][4];
        }
        p++;
      }
    }
    var st = 0;
    if (val.sg[f1].length > 1) {
      st = this.formatterDate3(val.sg[f1][0][0]) + ' 00:00:00';
      st = Date.parse(st.replace(/-/g, "/"));
    } else {
      st = val.time_sec[0][0] * 1000;
    }
    context.startTime = st;
    context.Kday = kday;

    if (length > 1) {
      context.getAverage(SG);
    }
    return SG;
  },
  getCalib5: function getCalib5(context, val) {
    var startDate = this.formatterDate9(context.startTime / 1000);
    var calib = [];
    var p = 0;
    for (var i = 0; i < val.length; i++) {
      if (val[i].length > 0) {
        for (var j = 0; j < val[i].length; j++) {
          var nt = this.formatterDate10(val[i][j][1]);
          calib[p] = new Array(3);
          calib[p][0] = new Date(startDate[0], startDate[1], startDate[2], nt[0], nt[1], nt[2]);
          calib[p][1] = localStorage.getItem('unit') === 'mg' ? Math.round(val[i][j][3] * 18) : val[i][j][3].toFixed(1);
          calib[p][2] = this.formatterDate2(val[i][j][1]);
          p++;
        }
      }
    }

    return calib;
  },
  getBg5: function getBg5(context, val) {
    var startDate = this.formatterDate9(context.startTime / 1000);
    var bg = [];
    var p = 0;
    for (var i = 0; i < val.length; i++) {
      if (val[i].length > 0) {
        for (var j = 0; j < val[i].length; j++) {
          bg[p] = new Array(3);

          var nt = this.formatterDate10(val[i][j][0]);
          bg[p][0] = new Date(startDate[0], startDate[1], startDate[2], nt[0], nt[1], nt[2]);
          bg[p][1] = localStorage.getItem('unit') === 'mg' ? Math.round(val[i][j][1] * 18) : val[i][j][1].toFixed(1);
          bg[p][2] = this.formatterDate2(val[i][j][0]);
          p++;
        }
      }
    }

    return bg;
  },
  getTa: function getTa(context, uid, param) {
    var that = this;
    context.$http.get('/api/v2.1/chart/' + uid + '/data/ta', { params: { param: param } }).then(function (res) {
      var err = res.body.error;

      if (err === 0) {
        context.$store.commit('updateDataS', res.body.data);
        var ba0 = that.getTaData1(res.body.data.glucose_analysis);
        context.TaData1 = ba0[0];
        context.bgMax = ba0[1];
        var ba = that.getTaData2(res.body.data.inject_summary);
        context.TaData2 = ba[0];
        context.basalMax = ba[1];
        context.TaData3 = that.getTaData3(res.body.data.glucose_analysis);
        if (context.chart4_1) {
          context.chartsDispose();
        }
        context.drwCharts();

        if (context.getTaReportInfo) {
          context.getTaReportInfo(res.body.report_data);
        }
      }
    }, function (err) {
      console.log(err + "," + err.body.message);
      this.error = err.body.message;
    });
  },
  getTaData1: function getTaData1(val) {
    var length = val.length,
        max = [];
    var TaData1 = [];
    var bg = new Array(3);bg[0] = new Array(length);bg[1] = new Array(length);bg[2] = new Array(length);
    var sg = new Array(3);sg[0] = new Array(length);sg[1] = new Array(length);sg[2] = new Array(length);
    for (var i = 0; i < length; i++) {
      bg[0][i] = val[i].bgdist[0];
      bg[1][i] = val[i].bgdist[1];
      bg[2][i] = val[i].bgdist[2];
      sg[0][i] = (val[i].sgdist[0] * 100).toFixed(1);
      sg[1][i] = (val[i].sgdist[1] * 100).toFixed(1);
      sg[2][i] = (val[i].sgdist[2] * 100).toFixed(1);
    }
    TaData1[0] = bg;TaData1[1] = sg;
    max[0] = bg[0].length > 1 ? Math.max.apply(null, bg[0]) : 5;
    max[1] = bg[1].length > 1 ? Math.max.apply(null, bg[1]) : 5;
    max[2] = bg[2].length > 1 ? Math.max.apply(null, bg[2]) : 5;
    var max1 = Math.max.apply(null, max);
    if (max1 < 10) {
      max1 = 10;
    } else if (max1 < 20) {
      max1 = 20;
    } else if (max1 < 30) {
      max1 = 30;
    } else if (max1 < 40) {
      max1 = 40;
    }
    return [TaData1, max1];
  },
  getTaData2: function getTaData2(val) {
    var length = val.length,
        max = 25,
        max2 = 0,
        max1 = 0;
    var data2 = new Array(2);data2[0] = new Array(length);data2[1] = new Array(length);
    for (var i = 0; i < length; i++) {
      data2[0][i] = val[i][1];
      data2[1][i] = val[i][2];
    }
    max1 = data2[0].length > 1 ? Math.max.apply(null, data2[0]) : 25;
    max2 = data2[1].length > 1 ? Math.max.apply(null, data2[1]) : 25;
    max = max1 > max2 ? max1 : max2;

    if (max < 20) {
      max = 20;
    } else if (max < 30) {
      max = 30;
    } else if (max < 40) {
      max = 40;
    } else if (max < 50) {
      max = 50;
    } else if (max < 100) {
      max = 100;
    } else if (max < 150) {
      max = 150;
    } else if (max < 200) {
      max = 200;
    } else {
      max = 250;
    }
    return [data2, max];
  },
  getTaData3: function getTaData3(val) {
    var length = val.length,
        j = 0,
        k = 0,
        data3 = [],
        flag = localStorage.getItem('unit') === 'mg';
    data3[0] = new Array(length);
    data3[1] = new Array(length);
    for (var i = 0; i < length; i++) {
      if (val[i].sgbs.length > 0) {
        data3[0][i] = flag ? Math.round(val[i].sgbs[0] * 18) : val[i].sgbs[0].toFixed(1);
        data3[1][i] = new Array(5);
        data3[1][i][0] = flag ? Math.round(val[i].sgbs[4] * 18) : val[i].sgbs[4].toFixed(1);
        data3[1][i][1] = flag ? Math.round(val[i].sgbs[2] * 18) : val[i].sgbs[2].toFixed(1);
        data3[1][i][2] = flag ? Math.round(val[i].sgbs[1] * 18) : val[i].sgbs[1].toFixed(1);
        data3[1][i][3] = flag ? Math.round(val[i].sgbs[3] * 18) : val[i].sgbs[3].toFixed(1);
        data3[1][i][4] = flag ? Math.round(val[i].sgbs[5] * 18) : val[i].sgbs[5].toFixed(1);
      } else {
        data3[0][i] = null;
        data3[1][i] = new Array(5);
      }
    }

    return data3;
  },
  getBg: function getBg(val) {
    var bg = [];
    for (var i = 0; i < val.length; i++) {
      bg[i] = [];
      var k = 0;
      for (var j = 0; j < val[i].length; j++) {
        if (val[i][j].disp !== '') {
          bg[i][k] = new Array(3);
          bg[i][k][0] = j;
          bg[i][k][1] = val[i][j].disp;
          bg[i][k][2] = val[i][j].color;
          k++;
        }
      }
    }
    return bg;
  },
  getIns: function getIns(context, val) {
    var bg = [],
        autoStop = [],
        manualStop = [],
        stop = [],
        Newer = [];
    for (var i = 0; i < val.length; i++) {
      bg[i] = [];autoStop[i] = [];manualStop[i] = [];stop[i] = [];Newer[i] = [];
      var k = 0,
          p = 0,
          q = 0,
          o = 0,
          s = 0;
      for (var j = 0; j < val[i].length; j++) {
        if (val[i][j].disp !== 0) {
          bg[i][k] = new Array(2);
          bg[i][k][0] = j;
          bg[i][k][1] = val[i][j].disp;
          k++;
        }
        if (val[i][j].basal) {
          for (var w = 0; w < val[i][j].basal.length; w++) {
            var va = val[i][j].basal[w];
            if (va[2] === 'SUSHM' || va[2] === 'SUSDM' || va[2] === 'SUSLSG' || va[2] === 'SUSPLSG' || va[2] === 'SUSA') {
              autoStop[i][p] = j;
              p++;
            }
            if (va[2] === 'SUSM' || va[2] === 'SUSEB') {
              manualStop[i][q] = j;
              q++;
            }
            if (va[2] === 'ENDM' || va[2] === 'ENDEM' || va[2] === 'ENDPE' || va[2] === 'ENDEP' || va[2] === 'ENDPB' || va[2] === 'ENDCE' || va[2] === 'ENDPBE') {
              stop[i][o] = j;
              o++;
            }
            if (va[2] === 'NEW') {
              Newer[i][s] = j;
              s++;
            }
          }
        }
      }
    }
    context.autoStop = autoStop;
    context.manualStop = manualStop;
    context.stop = stop;
    context.Newer = Newer;
    return bg;
  },
  getNoMeal: function getNoMeal(context, mt, val) {
    var noMeal = [];
    for (var i = 0; i < val.length; i++) {
      noMeal[i] = [0, 0, 0];
      if (val[i].length !== 0) {
        for (var j = 0; j < val[i].length; j++) {
          for (var k = 0; k < 3; k++) {
            if (val[i][j][0] >= mt[k][0] && val[i][j][0] <= mt[k][1]) {
              noMeal[i][k] = 1;
            }
          }
        }
      }
    }
    context.mt = mt;
    context.noMeal = noMeal;
  },
  getLgb1: function getLgb1(context, uid, param) {
    var that = this;
    context.$http.get('/api/v2.1/chart/' + uid + '/data/lgb', { params: { param: param } }).then(function (res) {
      var err = res.body.error;

      if (err === 0) {
        context.initTable();
        var data = res.data.data;

        if (1) {
          var basal_data = [];

          for (var i in res.body.data.basal) {
            basal_data = basal_data.concat(res.body.data.basal[i]);
          }
          that.parseDeviceSN(context, basal_data);
        }

        var mt1 = [];
        var mt = data.meal_time.map(function (e, i) {
          mt1[i] = [];
          mt1[i][0] = (e[0] / 60).toFixed(1);
          mt1[i][1] = (e[1] / 60).toFixed(1);
          e[0] = Math.round(e[0] / 60);
          e[1] = Math.round(e[1] / 60);
          return e;
        });

        context.mt1 = mt1;
        that.getLbg(context, data.bg_event, data.calib, data.bolus, data.target_high, data.target_low);
        var carb = that.getLcarb(context, data.carb_event, data.bolus);
        that.getLnoMeal(context, mt, carb);
        that.getLexer(context, data.exr_event);
        that.getLother(context, data.other_event);

        that.getAutoModeEvent(context, data.auto_mode_event, data.basal);
        var autoModeInject = that.getAutoModeInject(context, data.basal);
        var bolusTotal = that.getLbolus(context, data.bolus, data.ins_event);
        var basalTotal = that.getLbasal(context, data.basal);
        for (var _i12 = 0; _i12 < basalTotal.length; _i12++) {
          basalTotal[_i12] += autoModeInject[_i12][0];
          bolusTotal[_i12] += autoModeInject[_i12][1];

          var total = basalTotal[_i12] + bolusTotal[_i12];
          var percent = bolusTotal[_i12] / total * 100;
          if (total !== 0) {
            context.ins[_i12].total = parseFloat(total).toFixed(2);
            context.ins[_i12].percent = parseFloat(percent).toFixed(1);
          }
        }

        that.getLbolus2(context, data.ins_event);
        if (context.getLgbReportInfo) {
          context.getLgbReportInfo(res.data.report_data);
        }
      }
    }, function (err) {
      this.error = err.body.message;
    });
  },
  getLbg: function getLbg(context, val, val2, val3, high, low) {
    var _this = this;

    var length = val.length,
        bg = [],
        bgNew = [];
    var middle = (high + low) / 2;
    high = context.isMg ? parseInt(high * 18) : parseFloat(high.toFixed(1));
    low = context.isMg ? parseInt(low * 18) : parseFloat(low.toFixed(1));
    middle = context.isMg ? parseInt(middle * 18) : parseFloat(middle.toFixed(1));

    var _loop = function _loop(i) {
      var length1 = val[i].length,
          length2 = val2[i].length,
          length3 = val3[i].length,
          sum = 0,
          num = 0,
          m = 0,
          st = context.ts[i][0];
      bg[i] = [];
      bgNew[i] = new Array(24);
      if (length1 !== 0) {
        val[i].map(function (e, j) {
          var k = parseInt((e[0] - st) / 3600);
          if (k >= 0) {
            bg[i][m] = [];
            bg[i][m][0] = k;
            bg[i][m][1] = e[1];
            m++;
          }
        });
      }
      if (length2 !== 0) {
        val2[i].map(function (e, j) {
          var k = parseInt((e[0] - st) / 3600);
          if (k >= 0) {
            bg[i][m] = [];
            bg[i][m][0] = k;
            bg[i][m][1] = e[1];
            m++;
          }
        });
      }
      if (length3 !== 0) {
        val3[i].map(function (e, j) {
          if (e[8].bg) {
            var k = parseInt((e[1] - st) / 3600);
            if (k >= 0) {
              bg[i][m] = [];
              bg[i][m][0] = k;
              bg[i][m][1] = e[8].bg;
              m++;
            }
          }
        });
      }

      for (var p = 0; p < 24; p++) {
        bgNew[i][p] = [];
      }
      bg[i].map(function (e) {
        e[1] = context.isMg ? parseInt(e[1] * 18) : parseFloat(e[1].toFixed(1));
        bgNew[i][e[0]].push(e[1]);
        sum += e[1];
        num++;
      });

      bgNew[i] = _this.getShowBg(bgNew[i], high, low, middle);
      if (sum > 0) {
        context.bgAvg[i].avg = context.isMg ? parseInt(sum / num) + 'mg/dL' : parseFloat(sum / num).toFixed(1) + 'mmol/L';
      } else {
        context.bgAvg[i].avg = context.isMg ? '--mg/dL' : '--mmol/L';
      }
    };

    for (var i = 0; i < length; i++) {
      _loop(i);
    }

    context.makebg1(bgNew, high, low);
  },
  getShowBg: function getShowBg(bgNew, high, low, middle) {
    for (var q = 0; q < 24; q++) {
      var leng = bgNew[q].length;
      if (leng > 1) {
        var _ret2 = function () {
          var v1 = [],
              v2 = [],
              v3 = [];
          bgNew[q].map(function (e, i) {
            if (e < low) {
              v1.push(e);
            } else if (e > high) {
              v2.push(e);
            } else {
              v3.push(e);
            }
          });
          if (v1.length > 0) {
            var min = Math.min.apply(null, v1);
            bgNew[q] = [];
            bgNew[q][0] = min;
            bgNew[q][1] = 2;
            return 'continue';
          } else if (v2.length > 0) {
            var max = Math.max.apply(null, v2);
            bgNew[q] = [];
            bgNew[q][0] = max;
            bgNew[q][1] = 2;
            return 'continue';
          } else if (v3.length > 0) {
            var diff = [],
                k = 0;
            v3.map(function (e, i) {
              diff[i] = Math.abs(e - middle);
            });
            k = diff.indexOf(Math.max.apply(null, diff));
            bgNew[q] = [];
            bgNew[q][0] = v3[k];
            bgNew[q][1] = 2;
          }
        }();

        if (_ret2 === 'continue') continue;
      }
    }
    return bgNew;
  },
  getLcarb: function getLcarb(context, val, val2) {
    var length = val.length,
        carb = [],
        newCarb = [];

    var _loop2 = function _loop2(i) {
      var length1 = val[i].length,
          length2 = val2[i].length,
          m = 0;
      var st = context.ts[i][0],
          sum = 0;
      carb[i] = [];newCarb[i] = [];
      if (length1 !== 0) {
        val[i].map(function (e, j) {
          sum += e[1];
          var k = parseInt((e[0] - st) / 3600);
          if (k >= 0) {
            carb[i][m] = [];
            carb[i][m][0] = k;
            carb[i][m][1] = e[1];
            m++;
          }
        });
      }
      if (length2 !== 0) {
        val2[i].map(function (e, j) {
          if (e[8].carb) {
            var k = parseInt((e[1] - st) / 3600);
            if (k >= 0) {
              carb[i][m] = [];
              carb[i][m][0] = k;
              carb[i][m][1] = e[8].carb;
              sum += e[8].carb;
              m++;
            }
          }
        });
      }
      context.carb[i].total = sum ? parseInt(sum) + 'g' : '--g';
      for (var p = 0; p < 24; p++) {
        newCarb[i][p] = 0;
      }
      carb[i].map(function (e) {
        if (e[0] < 24) {
          newCarb[i][e[0]] = newCarb[i][e[0]] + e[1];
        }
      });
    };

    for (var i = 0; i < length; i++) {
      _loop2(i);
    }

    if (carb.length > 0) {
      context.makecarb(newCarb);
    }
    return carb;
  },
  getLnoMeal: function getLnoMeal(context, mt, val) {
    var noMeal = [];
    for (var i = 0; i < val.length; i++) {
      noMeal[i] = [0, 0, 0];
      var leng = val[i].length;
      if (leng > 0) {
        for (var j = 0; j < leng; j++) {
          for (var k = 0; k < 3; k++) {
            if (val[i][j][0] >= mt[k][0] && val[i][j][0] <= mt[k][1]) {
              noMeal[i][k] = 1;
            }
          }
        }
      }
    }
    context.mt = mt;
    context.noMeal = noMeal;
    context.makeNoMeal();
  },
  getLbasal: function getLbasal(context, val) {
    var autoStop = [],
        manualStop = [],
        stop = [],
        Newer = [],
        basalTotal = [],
        noPump = [],
        tempBasal = [];
    for (var i = 0; i < val.length; i++) {
      autoStop[i] = [];manualStop[i] = [];stop[i] = [];Newer[i] = [];basalTotal[i] = [];noPump[i] = 0;tempBasal[i] = [];
      var p = 0,
          q = 0,
          o = 0,
          s = 0,
          _sum = 0,
          t = 0;
      var _st2 = context.ts[i][0],
          et = context.ts[i][1];
      for (var j = 0; j < val[i].length; j++) {
        var va = val[i][j];
        if (va[2] === 'SUSHM' || va[2] === 'SUSDM' || va[2] === 'SUSLSG' || va[2] === 'SUSPLSG' || va[2] === 'SUSA') {
          var k1 = 0,
              k2 = 0;
          if (va[1] < _st2) {
            k1 = 0;
            k2 = parseInt((va[1] + va[3] - _st2) / 3600);
          } else if (va[1] + va[3] > et) {
            k1 = parseInt((va[1] - _st2) / 3600);
            k2 = 23;
          } else {
            k1 = parseInt((va[1] - _st2) / 3600);
            k2 = parseInt((va[1] + va[3] - _st2) / 3600);
          }
          for (var k = k1; k < k2 + 1; k++) {
            autoStop[i][p] = k;
            p++;
          }
        } else if (va[2] === 'SUSM' || va[2] === 'SUSEB') {
          var _k2 = 0,
              _k3 = 0;
          if (va[1] < _st2) {
            _k2 = 0;
            _k3 = parseInt((va[1] + va[3] - _st2) / 3600);
          } else if (va[1] + va[3] > et) {
            _k2 = parseInt((va[1] - _st2) / 3600);
            _k3 = 23;
          } else {
            _k2 = parseInt((va[1] - _st2) / 3600);
            _k3 = parseInt((va[1] + va[3] - _st2) / 3600);
          }
          for (var _k4 = _k2; _k4 < _k3 + 1; _k4++) {
            manualStop[i][q] = _k4;
            q++;
          }
        } else if (va[2] === 'BART' || va[2] === 'BAAT') {
          var _k5 = 0,
              _k6 = 0;

          if (va[1] < _st2) {
            _k5 = 0;
            _k6 = parseInt((va[1] + va[3] - _st2) / 3600);
          } else if (va[1] + va[3] > et) {
            _k5 = parseInt((va[1] - _st2) / 3600);
            _k6 = 23;
          } else {
            _k5 = parseInt((va[1] - _st2) / 3600);
            _k6 = parseInt((va[1] + va[3] - _st2) / 3600);
          }
          for (var _k7 = _k5; _k7 < _k6 + 1; _k7++) {
            tempBasal[i][t] = _k7;
            t++;
          }
        } else if (va[2] === 'ENDM' || va[2] === 'ENDEM' || va[2] === 'ENDPE' || va[2] === 'ENDEP' || va[2] === 'ENDPB' || va[2] === 'ENDCE' || va[2] === 'ENDPBE' || va[2] === 'ENDD' || va[2] === 'ENDPE2') {
          var _k8 = parseInt((va[1] - _st2) / 3600);
          if (_k8 >= 0) {
            stop[i][o] = _k8;
            o++;
          }
        } else if (va[2] === 'NEW') {
          var _k9 = parseInt((va[1] - _st2) / 3600);
          if (_k9 >= 0) {
            Newer[i][s] = _k9;
            s++;
          }
        }

        {
          if (va[1] < _st2) {
            var value = (va[1] + va[3] - _st2) / va[3] * parseFloat(va[5]);
            _sum = _sum + value;
          } else if (va[1] + va[3] > _st2 + 86400) {
            var _value = (_st2 + 86400 - va[1]) / va[3] * parseFloat(va[5]);
            _sum = _sum + _value;
          } else {
            _sum = _sum + va[5];
          }
        }
      }
      basalTotal[i] = _sum;
      if (val[i].length === 0) {
        noPump[i] = 1;
      }
    }
    context.makeNoPump(noPump);
    context.makeOth1(this.getLnewBasal(autoStop), 0);
    context.makeOth1(this.getLnewBasal(manualStop), 1);
    context.makeOth1(this.getLnewBasal(stop), 2);
    context.makeOth1(this.getLnewBasal(Newer), 3);
    context.makeOth1(this.getLnewBasal(tempBasal), 6);
    return basalTotal;
  },
  getLnewBasal: function getLnewBasal(val) {
    var length = val.length,
        newBasal = [];

    var _loop3 = function _loop3(i) {
      newBasal[i] = new Array(24);
      for (var p = 0; p < 24; p++) {
        newBasal[i][p] = 0;
      }
      if (val[i].length > 0) {
        val[i].map(function (e) {
          if (e < 24) {
            newBasal[i][e] = 1;
          }
        });
      }
    };

    for (var i = 0; i < length; i++) {
      _loop3(i);
    }
    return newBasal;
  },
  getLbolus: function getLbolus(context, val, val2) {
    var bolus = [],
        newBolus = [],
        bolusTotal = [];
    var bolusMarkFlag = [];
    var bolusNoMark = [];

    var _loop4 = function _loop4(i) {
      var length1 = val[i].length,
          st = context.ts[i][0],
          length2 = val2[i].length,
          sum = 0;
      bolus[i] = [];newBolus[i] = new Array(24);bolusTotal[i] = [];
      if (length1 > 0) {
        val[i].map(function (e, j) {
          var k = parseInt((e[1] - st) / 3600);
          if (k >= 0) {
            bolus[i][j] = [];
            bolus[i][j][0] = k;
            if (e[2] === 'EBCCW' || e[2] === 'EBM' || e[2] === 'EBCAW') {
              bolus[i][j][1] = e[6];
            } else if (e[2] === 'CBCCW' || e[2] === 'CBM' || e[2] === 'CBCAW') {
              bolus[i][j][1] = e[4] + e[6];
            } else {
              bolus[i][j][1] = e[4];
            }

            bolus[i][j][2] = true;

            if (e[2] === 'EBCAW' || e[2] === 'CBCAW' || e[2] === 'NBCAW') {
              var wizzard_info = e[8];
              var carb_bolus = wizzard_info['carb_bolus'];
              var iob = wizzard_info['iob'];

              var set_total = 0;
              if (e[3]) {
                set_total += e[3];
              }
              if (e[5]) {
                set_total += e[5];
              }
              if (set_total == carb_bolus) {
                bolus[i][j][2] = false;
              }
            }

            sum += bolus[i][j][1];
          }
        });
      }
      bolusMarkFlag[i] = new Array(24);
      bolusNoMark[i] = new Array(24);
      for (var p = 0; p < 24; p++) {
        newBolus[i][p] = 0;
        bolusMarkFlag[i][p] = false;
        bolusNoMark[i][p] = 0;
      }

      bolus[i].map(function (e) {
        var hour = e[0];
        bolusMarkFlag[i][hour] = bolusMarkFlag[i][hour] || e[2];
        newBolus[i][e[0]] = newBolus[i][e[0]] + parseFloat(e[1]);
        bolusNoMark[i][hour] = newBolus[i][hour];
      });

      bolusMarkFlag[i].map(function (e, h) {
        if (e) {} else {}
      });

      if (length2 > 0) {
        val2[i].map(function (e) {
          sum += e[1];
        });
      }
      bolusTotal[i] = sum;
    };

    for (var i = 0; i < val.length; i++) {
      _loop4(i);
    }
    context.makeBolus(newBolus, bolusMarkFlag);
    return bolusTotal;
  },
  getLbolus2: function getLbolus2(context, val) {
    var length = val.length,
        bolus2 = [];

    var _loop5 = function _loop5(i) {
      var length1 = val[i].length,
          st = context.ts[i][0];
      bolus2[i] = [];
      if (length1 !== 0) {
        val[i].map(function (e, j) {
          var k = parseInt((e[0] - st) / 3600);
          if (k >= 0) {
            bolus2[i][j] = [];
            bolus2[i][j][0] = k;
            bolus2[i][j][1] = e[1];
          }
        });
      }
    };

    for (var i = 0; i < length; i++) {
      _loop5(i);
    }
    context.makeBolus2(bolus2);
  },
  getLexer: function getLexer(context, val) {
    var exe = [];
    for (var i = 0; i < val.length; i++) {
      exe[i] = [];
      var _st3 = context.ts[i][0],
          et = context.ts[i][1],
          length = val[i].length,
          p = 0;
      if (length > 0) {
        for (var j = 0; j < length; j++) {
          var k1 = 0,
              k2 = 0;
          var va = val[i][j];
          if (va[0] < _st3) {
            k1 = 0;
            k2 = parseInt(va[1] / 60);
          } else if (va[0] + va[1] * 60 > et) {
            k1 = parseInt((va[0] - _st3) / 3600);
            k2 = 23;
          } else {
            k1 = parseInt((va[0] - _st3) / 3600);
            k2 = parseInt((va[0] + va[1] * 60 - _st3) / 3600);
          }
          for (var k = k1; k < k2 + 1; k++) {
            exe[i][p] = k;
            p++;
          }
        }
      }
    }

    context.makeOth1(this.getLnewBasal(exe), 4);
  },
  getLother: function getLother(context, val) {
    var oth = [];
    for (var i = 0; i < val.length; i++) {
      oth[i] = [];
      var _st4 = context.ts[i][0],
          length = val[i].length,
          p = 0;
      if (length > 0) {
        var k = 0;
        for (var j = 0; j < length; j++) {
          k = parseInt((val[i][j][0] - _st4) / 3600);
          oth[i][p] = k;
          p++;
        }
      }
    }
    context.makeOth1(this.getLnewBasal(oth), 5);
  },
  getAutoModeInject: function getAutoModeInject(context, basal_data) {
    var injectResult = [];
    for (var d = 0; d < basal_data.length; d++) {
      var autoBasalTotal = 0;
      var autoBolusTotal = 0;
      for (var i = 0; i < basal_data[d].length; i++) {
        var basalRecord = basal_data[d][i];
        var basalType = basalRecord[2];
        if ('BAAM' == basalType) {
          var autoModeData = basalRecord[7];
          try {
            autoModeData = JSON.parse(autoModeData);
            var autoModeJson = autoModeData['autoModeJSON'];
            autoModeJson.map(function (e, i) {
              autoBasalTotal += e['auto_basal_delivery'] * 0.05;
              autoBolusTotal += (e['auto_food_delivery'] + e['auto_corr_delivery']) * 0.05;
            });
          } catch (e) {}
        }
      }
      injectResult.push([autoBasalTotal, autoBolusTotal]);
    }
    return injectResult;
  },
  getAutoModeEvent: function getAutoModeEvent(context, auto_mode_event, basal_record) {
    for (var _m = 0; _m < 5; _m++) {

      var autoMeal = auto_mode_event[_m];
      var autoMealFlag = [];

      for (var i = 0; i < autoMeal.length; i++) {
        var tmp = [];
        for (var j = 0; j < 24; j++) {
          tmp.push(0);
        }

        var _st5 = context.ts[i][0];
        for (var _j = 0; _j < autoMeal[i].length; _j++) {
          var hour = parseInt((autoMeal[i][_j][0] - _st5) / 3600);
          tmp[hour] = 1;
        }

        autoMealFlag.push(tmp);
      }
      context.makeOth1(autoMealFlag, 7 + _m);
    }

    var autoModeStartFlag = [];
    var autoModeExitFlag = [];
    for (var _i13 = 0; _i13 < basal_record.length; _i13++) {
      var startFlag = [];
      var exitFlag = [];
      for (var _j2 = 0; _j2 < 24; _j2++) {
        startFlag.push(0);
        exitFlag.push(0);
      }

      var _st6 = context.ts[_i13][0];
      for (var _j3 = 0; _j3 < basal_record[_i13].length; _j3++) {
        var basalType = basal_record[_i13][_j3][2];
        var _hour = parseInt((basal_record[_i13][_j3][1] - _st6) / 3600);

        if ('BAAMS' == basalType) {
          startFlag[_hour] = 1;
        } else if ('BAAME' == basalType) {
          exitFlag[_hour] = 1;
        }
      }

      autoModeStartFlag.push(startFlag);
      autoModeExitFlag.push(exitFlag);
    }
    context.makeOth1(autoModeStartFlag, 12);
    context.makeOth1(autoModeExitFlag, 13);
  },
  getPdm1: function getPdm1(context, uid, param) {
    var that = this;
    function addPreZero(pdm_sn_hex, num) {
      var pre = '';
      for (var i = 0; i < num; i++) {
        pre += '0';
      }
      return pre + pdm_sn_hex;
    }

    context.$http.get(SERVER_URL + '/v2.0/pdm/' + uid + '/settings', { params: param }).then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        var data = res.data.settings;
        context.PDM = data.items.map(function (e, i) {
          e[1] = new Date(e[1] * 1000);
          e[1] = that.formatterDate1(e[1]);

          if (false) {
            var pdm_sn = parseInt(e[2]);
            if (100000000 <= pdm_sn && pdm_sn <= 101999999 || 109000000 <= pdm_sn && pdm_sn <= 109999999 || 112000000 <= pdm_sn && pdm_sn <= 112999999) {} else {
              var pdm_sn_hex = pdm_sn.toString(16);
              var lackZeroDigit = 8 - pdm_sn_hex.length;

              pdm_sn_hex = addPreZero(pdm_sn_hex, lackZeroDigit);

              e[2] = pdm_sn_hex.toUpperCase();
            }
          }

          e[2] = that.deviceSNFormat(e[2]);

          return e;
        });
        context.pages = data.pages;
        context.has_next = data.has_next;
        context.has_prev = data.has_prev;
        if (context.PDM.length > 0 && context.first) {
          context.index = '0';
          context.selectId = context.PDM[0][0];
          context.tempSelectId = context.selectId;

          context.apply();
          context.first = false;
        }
      }
    }, function (err) {
      alert(err + "," + err.body.message);
    });
  },
  getPdmSG: function getPdmSG(context, val, flag) {
    var time = [],
        sg = [],
        SG = [],
        max = 0;
    var sta = val[0][0].split(":")[0] * 3600 + val[0][0].split(":")[1] * 60 + new Date().setHours(0, 0, 0, 0) / 1000;
    var k = 0;
    for (var i = 0; i < val.length; i++) {
      var et = 0;
      if (i < val.length - 1) {
        et = val[i + 1][0].split(':');
      } else {
        et = [24, 0];
      }
      var _st7 = val[i][0].split(':');
      var h = et[0] - _st7[0],
          _m2 = et[1] - _st7[1];
      var s = h * 3600 + _m2 * 60;
      for (var j = 0; j < parseInt(s / 120); j++) {
        sta = sta + 120;
        time[k] = sta;
        sg[k] = val[i][1];
        k++;
      }
    }
    max = sg.length > 0 ? Math.max.apply(null, sg) : 3;
    if (max < 2) {
      max = 2;
    } else if (max < 4) {
      max = 4;
    } else if (max < 10) {
      max = 10;
    }
    if (context.sgMax < max) {
      context.sgMax = max;
    }
    for (var _m3 = 0; _m3 < sg.length; _m3++) {
      SG[_m3] = new Array(2);
      SG[_m3][1] = sg[_m3].toFixed(2);
      time[_m3] = new Date(time[_m3] * 1000);
      SG[_m3][0] = time[_m3];
    }
    return SG;
  },
  getRatio: function getRatio(context, val, flag) {
    var length = val.length;
    var Ratio = new Array(length),
        sumCol = 0;
    for (var i = 0; i < length - 1; i++) {
      var _st8 = val[i][0].split(':');
      var et = val[i + 1][0].split(':');
      var h = et[0] - _st8[0],
          _m4 = et[1] - _st8[1];
      var col = h * 2 + _m4 / 30;
      sumCol = sumCol + col;
      Ratio[i] = new Array(2);
      Ratio[i][0] = col;
      Ratio[i][1] = val[i][1];
    }
    Ratio[length - 1] = new Array(2);
    Ratio[length - 1][0] = 48 - sumCol;
    Ratio[length - 1][1] = val[length - 1][1];
    return Ratio;
  },
  getMaxBolus: function getMaxBolus(val) {
    var length = val.length,
        j = 0;
    var Ratio = [],
        sumCol = 0;
    if (length === 0) {
      Ratio[0] = 0;
    }
    if (length === 1) {
      var _st9 = val[0][0].split(':');
      var et = val[0][1].split(':');
      var h = et[0] - _st9[0],
          _m5 = et[1] - _st9[1];
      var col = h * 2 + _m5 / 30;
      var staCol = _st9[0] * 2 + _st9[1] / 30;
      sumCol = sumCol + col + staCol;

      Ratio[0] = [];
      Ratio[0][1] = col;
      Ratio[0][0] = _st9[0] * 2 + _st9[1] / 30;
    } else {
      for (var i = 0; i < length; i++) {
        if (i > 0 && i < length - 1 && val[i][0] === val[i + 1][0] && val[i][1] === val[i + 1][1]) {
          continue;
        }
        var _st10 = val[i][0].split(':');
        var _et = val[i][1].split(':');
        var _h = _et[0] - _st10[0],
            _m6 = _et[1] - _st10[1];
        var _col = _h * 2 + _m6 / 30;
        sumCol = sumCol + _col;
        Ratio[j] = [];
        Ratio[j][1] = _col;
        Ratio[j][0] = _st10[0] * 2 + _st10[1] / 30;
        j++;
      }
    }
    return Ratio;
  },
  getGlucoseLimit: function getGlucoseLimit(context, val) {
    var length = val.length;
    var Ratio = new Array(length),
        sumCol = 0;
    for (var i = 0; i < length - 1; i++) {
      var _st11 = val[i][0].split(':');
      var et = val[i + 1][0].split(':');
      var h = et[0] - _st11[0],
          _m7 = et[1] - _st11[1];
      var col = h * 2 + _m7 / 30;
      sumCol = sumCol + col;
      Ratio[i] = new Array(3);
      Ratio[i][0] = col;
      Ratio[i][1] = val[i][1];
      Ratio[i][2] = val[i][2];
    }
    Ratio[length - 1] = new Array(3);
    Ratio[length - 1][0] = 48 - sumCol;
    Ratio[length - 1][1] = val[length - 1][1];
    Ratio[length - 1][2] = val[length - 1][2];
    return Ratio;
  },
  getDashboard: function getDashboard(context, uid, param) {
    var that = this;
    context.$http.post('/api/v2.1/data/' + uid, param).then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        var data = res.data.data;
        if (data.devices) {
          context.devices = data.devices;
        }

        if (data.sg) {
          context.sg = data.sg;
          that.getDashboardSg(context, data.sg);
          that.getDashboardSgStat(context, data);
        }

        that.getDashboardBG(context, data);

        that.getDashboardMiscInfo(context, data);

        var bolus_stat_result = {};
        if (data.bolus) {
          bolus_stat_result = that.getDashboardInsulinStat(context, data);
        }
        var ins_use_duration_day = bolus_stat_result['use_duration_day'];
        var ins_use_duration_day_pre = bolus_stat_result['use_duration_day_pre'];

        that.getDashboardCarbStat(context, data, ins_use_duration_day);
        that.getDashboardExerciseStat(context, data, ins_use_duration_day);

        if (data.device_setting) {}
        if (data.device_setting) {
          var t = that.formatterDate1(new Date(data.device_setting.update_time * 1000));
          context.update_time = t + ', ' + data.device_setting.pdm_sn;
        }
        context.target_high = context.isMg ? parseInt(data.target_high * 18) : data.target_high.toFixed(1);
        context.target_low = context.isMg ? parseInt(data.target_low * 18) : data.target_low.toFixed(1);
        if (this.chart1_2) {
          this.chartsDispose();
        }
        this.drawCharts();
      }
    }, function (err) {
      this.error = err.body.message;
    });
  },
  getAvgSD: function getAvgSD(data) {
    if (!(data instanceof Array) || data.length == 0) {
      return { 'sd': 0, 'avg': 0, 'num': 0 };
    }
    var size = data.length;
    var total = 0;
    var avg = 0;

    var diffTotal = 0;
    data.map(function (e, i) {
      total += e;
    });
    avg = total / size;
    data.map(function (e, i) {
      diffTotal += Math.pow(e - avg, 2);
    });
    var sd = Math.sqrt(diffTotal / size);
    return {
      'sd': sd,
      'avg': avg,
      'num': size
    };
  },
  getInsulinVal: function getInsulinVal(ins) {
    var num = Math.round(ins / 0.05);
    return (0.05 * num).toFixed(2);
  },
  getInsulinValText: function getInsulinValText(ins) {
    if (ins < 0.00001) return '0';

    var txt = Math.round(ins * 100) / 100;
    txt = txt.toFixed(2);
    return txt;
  },
  getGlucoseValText: function getGlucoseValText(isMg, mmol_val) {
    var txt = isMg ? Math.round(mmol_val * 18) + ' mg/dL' : parseFloat(mmol_val.toFixed(1)) + ' mmol/L';
    return txt;
  },
  getGlucoseValText2: function getGlucoseValText2(isMg, mmol_val) {
    var txt = isMg ? Math.round(mmol_val * 18) + '' : parseFloat(mmol_val.toFixed(1)) + '';
    return txt;
  },
  getGlucoseSDValText: function getGlucoseSDValText(isMg, mmol_val) {
    var txt = isMg ? (mmol_val * 18).toFixed(1) + '' : parseFloat(mmol_val.toFixed(2)) + '';
    return txt;
  },
  getNumText: function getNumText(num, use_days) {
    if (num * 1.0 / use_days < 0.00001) {
      return 0 + '';
    }

    if (num % use_days) {
      return (num * 1.0 / use_days).toFixed(1);
    } else {
      return Math.round(num * 1.0 / use_days);
    }
  },
  getNumText3: function getNumText3(num, use_days, digit) {
    if (num % use_days) {
      return (num * 1.0 / use_days).toFixed(digit);
    } else {
      return Math.round(num * 1.0 / use_days);
    }
  },
  getMinuteText: function getMinuteText(minutes, use_days, digit) {
    var avg_minute = Math.round(minutes / use_days);
    if (avg_minute < 60) {
      return {
        'minute': avg_minute,
        'hour': 0
      };
    } else {
      var h = Math.floor(avg_minute / 60);
      var _m8 = avg_minute % 60;
      return {
        'minute': _m8,
        'hour': h
      };
    }
  },
  getNumText2: function getNumText2(num, use_days) {
    return Math.round(num * 1.0 / use_days);
  },
  getDashboardMiscInfo: function getDashboardMiscInfo(context, data) {
    context.highLevelText = this.getGlucoseValText(context.isMg, data.target_high);
    context.lowLevelText = this.getGlucoseValText(context.isMg, data.target_low);
  },
  getDashboardBG: function getDashboardBG(context, data) {
    var bg_day_data = [];
    var bg_data = [];
    var calib = data.calib;
    var bolus = data.bolus;
    var event = data.event;
    var use_days = 0;
    var calib_day_data = [];
    var calib_use_days = 0;
    var calib_data = [];

    if (calib) {
      calib.map(function (d, n) {
        bg_day_data.push([]);
        calib_day_data.push([]);
      });
      calib.map(function (d, n) {
        if (d.length > 0) {
          d.map(function (e, i) {
            bg_day_data[n].push(e[1]);
            bg_data.push(e[1]);

            calib_day_data[n].push(e[1]);
            calib_data.push(e[1]);
          });
        }
      });
    } else {
      return;
    }

    if (bolus) {
      bolus.map(function (d, n) {
        if (d.length > 0) {
          d.map(function (e, i) {
            if (e[8] && e[8].length > 0) {
              var w = JSON.parse(e[8]);
              if (w.bg) {
                bg_day_data[n].push(w.bg);
                bg_data.push(w.bg);
              }
            }
          });
        }
      });
    }

    if (event) {
      event.map(function (d, n) {
        if (d.length > 0) {
          d.map(function (e, i) {
            if ('BG' == e[2]) {
              var content = e[3];
              if (content.value) {
                var bg_value = content.value;

                bg_value = bg_value / 18.0;

                bg_day_data[n].push(bg_value);
                bg_data.push(bg_value);
              }
            }
          });
        }
      });
    }

    bg_day_data.map(function (d, n) {
      if (d.length > 0) {
        use_days += 1;
      }
    });

    calib_day_data.map(function (d, n) {
      if (d.length > 0) {
        calib_use_days += 1;
      }
    });

    var result = this.getAvgSD(bg_data);
    result.use_days = use_days;
    if (result.num && result.use_days) {
      context.bgAvg = this.getGlucoseValText2(context.isMg, result.avg);
      context.bgSD = this.getGlucoseSDValText(context.isMg, result.sd);
      context.bgPerDay = this.getNumText(result.num, result.use_days);
      context.bgNum = result.num;

      context.calibPerDay = this.getNumText(calib_data.length, calib_use_days);
    } else {
      context.bgAvg = '--';
      context.bgSD = '--';
      context.bgPerDay = '--';
      context.bgNum = '--';
      context.calibPerDay = '--';
    }
  },
  truncateBasal: function truncateBasal(basal, ts) {
    basal.map(function (d, n) {
      var size = d.length;
      if (size > 0) {
        var first = d[0];
        var last = d[size - 1];

        var t = first[1];
        var duration = first[3];
        var inject = first[5];
        if (t < ts[n][0]) {
          first[1] = ts[n][0];
          first[3] = duration - (ts[n][0] - t);
          first[5] = inject * 1.0 * first[3] / duration;
        }

        t = last[1];
        duration = last[3];
        inject = last[5];

        if (t + duration > ts[n][1]) {
          last[3] = ts[n][1] - t;
          last[5] = inject * 1.0 * first[3] / duration;
        }
      }
    });
    return basal;
  },
  getDashboardCarbStat: function getDashboardCarbStat(context, data, ins_use_duration_day) {
    var carb_day_data = [];
    var carb_data = [];
    var carb_total = 0;
    var use_days = 0;
    var event = data.event;
    var bolus = data.bolus;

    event.map(function (e, i) {
      carb_day_data.push([]);
    });

    if (event) {
      event.map(function (d, n) {
        if (d.length > 0) {
          d.map(function (e, i) {
            if ('CARB' == e[2]) {
              var content = e[3];
              if (content.value) {
                carb_day_data[n].push(content.value);
                carb_data.push(content.value);
              }
            }
          });
        }
      });
    } else {
      return;
    }

    if (bolus) {
      bolus.map(function (d, n) {
        if (d.length > 0) {
          d.map(function (e, i) {
            var recordId = e[0];
            var recordIdSplit = recordId.split('-');
            var recordSeq = recordIdSplit[3];
            try {
              if (recordSeq >= 8888) {
                return;
              }
            } catch (e) {}

            if (e[8] && e[8].length > 0) {
              var w = JSON.parse(e[8]);
              if (w.carb) {
                carb_day_data[n].push(w.carb);
                carb_data.push(w.carb);
              }
            }
          });
        }
      });
    }

    carb_data = [];
    ins_use_duration_day.map(function (ins_day_use, n) {
      if (ins_day_use > 23.5 * 3600) {
        use_days += 1;

        carb_data = carb_data.concat(carb_day_data[n]);
      } else {}
    });

    carb_data.map(function (d, n) {
      carb_total += d;
    });

    if (carb_data.length) {
      var result = this.getAvgSD(carb_data);
      if (result.num) {
        context.carbSD = result.sd.toFixed(1);

        context.carbNum = result.num;
        context.carbAvg = this.getNumText3(carb_total, use_days, 1);
      }
    }
  },
  getDashboardExerciseStat: function getDashboardExerciseStat(context, data, ins_use_duration_day) {
    var exercise_day_data = [];
    var exercise_data = [];
    var exercise_total = 0;
    var use_days = 0;
    var event = data.event;

    event.map(function (e, i) {
      exercise_day_data.push([]);
    });

    if (event) {
      event.map(function (d, n) {
        if (d.length > 0) {
          d.map(function (e, i) {
            if ('EXR' == e[2] || 'AutoExercise' == e[2]) {
              var content = e[3];
              if (content.value) {
                exercise_day_data[n].push(content.value);
                exercise_data.push(content.value);
              } else if (content.duration) {
                exercise_day_data[n].push(content.duration);
                exercise_data.push(content.duration);
              }
            }
          });
        }
      });
    } else {
      return;
    }

    exercise_data = [];
    ins_use_duration_day.map(function (ins_day_use, n) {
      if (ins_day_use > 0) {
        use_days += 1;
        exercise_data = exercise_data.concat(exercise_day_data[n]);
      }
    });

    exercise_data.map(function (d, n) {
      exercise_total += d;
    });

    if (exercise_data.length) {
      var result = this.getAvgSD(exercise_data);
      if (result.num) {
        context.exerSD = result.sd.toFixed(1);

        context.exerNum = result.num;
        var exerAvgRes = this.getMinuteText(exercise_total, use_days, 1);
        context.exerAvg = exerAvgRes['minute'];
        context.exerAvgHour = exerAvgRes['hour'];
      }
    }
  },
  getDashboardInsulinStat: function getDashboardInsulinStat(context, data) {
    var basal = this.truncateBasal(data.basal, context.ts);
    var ins_unit2 = context.$t('ins_unit2');
    var insulin_data = [];
    var insulinUsage = [];
    var use_days = 0;
    var use_duration_day = [];
    var use_duration_day_pre = [];
    var use_duration = 0;
    var basal_total = 0;
    var auto_basal_total = 0;
    var auto_bolus_total = 0;
    var bolus_total = 0;
    var basalUsage = [];
    var bolusUsage = [];

    var usePatchInfo = {};
    var usePatchNum = 0;

    var inject_total = 0;
    var bolus_num = 0;
    var suspend_duration = 0;
    var manual_bolus = 0;
    var manual_bolus_num = 0;
    var manual_normal_bolus = 0;
    var manual_normal_bolus_num = 0;
    var manual_extend_bolus = 0;
    var manual_extend_bolus_num = 0;
    var manual_combo_bolus = 0;
    var manual_combo_bolus_num = 0;
    var wizzard_bolus = 0;
    var wizzard_bolus_num = 0;
    var food_wizzard_bolus = 0;
    var food_wizzard_bolus_num = 0;
    var corr_wizzard_bolus = 0;
    var corr_wizzard_bolus_num = 0;
    var wizzard_override_add = 0;
    var wizzard_override_add_num = 0;
    var wizzard_override_sub = 0;
    var wizzard_override_sub_num = 0;

    function getBolusWizzardSuggest(wizzard, fromPDM) {
      var iob = wizzard.iob;
      var carb_bolus = 0;
      var bg_bolus = 0;

      if (false) {
        carb_bolus = wizzard.carb_bolus;
        bg_bolus = wizzard.bg_bolus;
      } else {
        carb_bolus = wizzard.bg_bolus;
        bg_bolus = wizzard.carb_bolus;
      }
      if (bg_bolus > 400) {
        bg_bolus = -(655.36 - bg_bolus);
      }

      if (bg_bolus > 0) {
        if (bg_bolus < iob) {
          return carb_bolus;
        } else {
          return carb_bolus + bg_bolus - iob;
        }
      } else if (bg_bolus < 0) {
        return carb_bolus + bg_bolus;
      } else {
        return carb_bolus;
      }

      return carb_bolus + bg_bolus - iob;
    }

    data.basal.map(function (d, n) {
      insulinUsage.push(0);
      insulin_data.push([]);
      basalUsage.push(0);
      bolusUsage.push(0);
      use_duration_day.push(0);
      use_duration_day_pre.push(0);
    });

    data.basal.map(function (d, n) {
      if (d.length) {
        d.map(function (e, i) {
          use_duration_day_pre[n] += e[3];
        });
      }
    });

    data.basal.map(function (d, n) {
      if (d.length) {
        use_days += 1;
        d.map(function (e, i) {
          var recordId = e[0];
          var basalType = e[2];
          var recordIdPart = recordId.split('-');
          if ('9999' == recordIdPart[3] || '65535' == recordIdPart[3]) {
            return;
          }
          if ('BAAM' == basalType) {
            var autoModeData = e[7];
            try {
              if (autoModeData) {
                autoModeData = JSON.parse(autoModeData);
                var microBolusJson = autoModeData['autoModeJSON'];
                var cur_auto_basal_total = 0;
                var cur_auto_bolus_total = 0;

                microBolusJson.map(function (e, i) {
                  cur_auto_basal_total += e['auto_basal_delivery'];
                  cur_auto_bolus_total += e['auto_food_delivery'] + e['auto_corr_delivery'];
                });

                insulin_data[n].push(cur_auto_basal_total * 0.05 + cur_auto_bolus_total * 0.05);
                insulinUsage[n] += cur_auto_basal_total * 0.05 + cur_auto_bolus_total * 0.05;
                auto_basal_total += cur_auto_basal_total * 0.05;
                auto_bolus_total += cur_auto_bolus_total * 0.05;
                basalUsage[n] += cur_auto_basal_total * 0.05;
                bolusUsage[n] += cur_auto_bolus_total * 0.05;
              }
            } catch (e) {
              console.log('auto mode json error:', e);
            }
          } else {
            insulin_data[n].push(e[5]);
            insulinUsage[n] += e[5];
            basal_total += e[5];
            basalUsage[n] += e[5];
          }
          var patchId = recordIdPart[1] + '-' + recordIdPart[2];
          if (usePatchInfo[patchId]) {} else {
            usePatchInfo[patchId] = 1;
            usePatchNum += 1;
          }

          use_duration_day[n] += e[3];
          use_duration += e[3];

          if (0 == e[2].indexOf('SUS')) {
            suspend_duration += e[3];
          }
        });
      }
    });
    data.bolus.map(function (d, n) {
      if (d.length) {
        d.map(function (e, i) {
          var recordId = e[0];
          var recordIdSplit = recordId.split('-');
          if (recordIdSplit[3] >= 8888) {
            return;
          }

          insulin_data[n].push(e[4] + e[6]);
          insulinUsage[n] += e[4] + e[6];
          bolus_total += e[4] + e[6];
          bolusUsage[n] += e[4] + e[6];

          bolus_num += 1;

          var bolusType = e[2];
          var bolusInject = e[4] + e[6];
          var bolusSet = e[3] + e[5];
          var wizzard = e[8];

          if (bolusType.indexOf('M') >= 0) {
            manual_bolus += bolusInject;
            manual_bolus_num += 1;
            if (0 == bolusType.indexOf('NB')) {
              manual_normal_bolus += bolusInject;
              manual_normal_bolus_num += 1;
            } else if (0 == bolusType.indexOf('EB')) {
              manual_extend_bolus += bolusInject;
              manual_extend_bolus_num += 1;
            } else if (0 == bolusType.indexOf('CB')) {
              manual_combo_bolus += bolusInject;
              manual_combo_bolus_num += 1;
            }
          }

          if (bolusType.indexOf('W') >= 0) {
            wizzard_bolus += bolusInject;
            wizzard_bolus_num += 1;

            if (bolusType.indexOf('CCW') >= 0 || bolusType.indexOf('CAW') >= 0) {
              food_wizzard_bolus += bolusInject;
              food_wizzard_bolus_num += 1;
            } else if (bolusType.indexOf('CRW') >= 0) {
              corr_wizzard_bolus += bolusInject;
              corr_wizzard_bolus_num += 1;
            }

            if (wizzard && wizzard.length > 0) {
              wizzard = JSON.parse(wizzard);
              var suggest_bolus = getBolusWizzardSuggest(wizzard);
              if (bolusSet > suggest_bolus) {
                wizzard_override_add += bolusSet - suggest_bolus;
                wizzard_override_add_num += 1;
              } else if (bolusSet < suggest_bolus) {
                wizzard_override_sub += suggest_bolus - bolusSet;
                wizzard_override_sub_num += 1;
              }
            }
          }
        });
      }
    });

    if (data.event) {
      data.event.map(function (d, n) {
        if (d.length > 0) {
          d.map(function (e, i) {
            if ('INS' == e[2]) {
              var content = e[3];
              if (content.value) {
                insulin_data[n].push(content.value);
              }
            }
          });
        }
      });
    }

    var insulinUsage2 = [];

    if (use_duration > context.ts.length * 86400) {}

    basal_total = 0;
    bolus_total = 0;

    insulin_data.map(function (d, n) {
      if (use_duration_day[n] > 23.5 * 86400 / 24.0) {
        var dayTotal = 0;
        d.map(function (e, i) {
          dayTotal += e;
        });
        insulinUsage2.push(dayTotal);

        basal_total += basalUsage[n];
        bolus_total += bolusUsage[n];
      }
    });
    use_days = insulinUsage2.length;
    basal_total = Math.round(basal_total * 1000000) / 1000000;

    var result = this.getAvgSD(insulinUsage2);
    result.use_days = use_days;
    if (result.num && result.use_days) {
      context.insAvg = this.getInsulinValText(result.avg);
      context.insSD = this.getInsulinValText(result.sd);

      context.insNum = use_days.toFixed(1);
      context.patchAvgLife = (use_duration / 86400.0 / usePatchNum).toFixed(2);
      context.avgBolusNum = this.getNumText3(bolus_num, result.use_days, 1);

      inject_total = basal_total + bolus_total;
      if (inject_total) {
        var basalPercent = (basal_total * 100 / inject_total).toFixed(1);
        context.basalPercent = this.getInsulinValText(basal_total / use_days) + 'U/' + basalPercent + ' %';
        context.bolusPercent = this.getInsulinValText(bolus_total / use_days) + 'U/' + (100 - basalPercent).toFixed(1) + ' %';
      }
      context.insPieData = [{ value: Math.round(bolus_total / use_days * 100) / 100, name: 'Bolus' }, { value: Math.round(basal_total / use_days * 100) / 100, name: 'Basal' }];

      if (bolus_total + basal_total) {
        context.chart6NoData = false;
        context.chart7NoData = false;
      } else {
        context.chart6NoData = true;
        context.chart7NoData = true;
      }
      console.log('chart6NoData:', context.chart6NoData);

      var avgSuspendTime = suspend_duration / result.use_days;
      if (avgSuspendTime < 3600) {
        context.avgSuspendTime = Math.round(avgSuspendTime % 3600 / 60) + ' min';
      } else {
        context.avgSuspendTime = Math.floor(avgSuspendTime / 3600) + ' h ' + Math.round(avgSuspendTime % 3600 / 60) + ' min';
      }

      context.avgManualBolus = this.getInsulinValText(manual_bolus / use_days) + ins_unit2 + '/' + this.getNumText(manual_bolus_num, use_days);
      context.avgManualNormalBolus = this.getInsulinValText(manual_normal_bolus / use_days) + ins_unit2 + '/' + this.getNumText(manual_normal_bolus_num, use_days);
      context.avgManualExtendBolus = this.getInsulinValText(manual_extend_bolus / use_days) + ins_unit2 + '/' + this.getNumText(manual_extend_bolus_num, use_days);
      context.avgManualComboBolus = this.getInsulinValText(manual_combo_bolus / use_days) + ins_unit2 + '/' + this.getNumText(manual_combo_bolus_num, use_days);

      context.avgWizzardBolus = this.getInsulinValText(wizzard_bolus / use_days) + ins_unit2 + '/' + this.getNumText3(wizzard_bolus_num, use_days, 1);
      context.avgFoodWizzardBolus = this.getInsulinValText(food_wizzard_bolus / use_days) + ins_unit2 + '/' + this.getNumText3(food_wizzard_bolus_num, use_days, 1);
      context.avgCorrWizzardBolus = this.getInsulinValText(corr_wizzard_bolus / use_days) + ins_unit2 + '/' + this.getNumText3(corr_wizzard_bolus_num, use_days, 1);
      context.avgWizzardOverrideAdd = this.getInsulinValText(wizzard_override_add / use_days) + ins_unit2 + '/' + this.getNumText3(wizzard_override_add_num, use_days, 2);
      context.avgWizzardOverrideSub = this.getInsulinValText(wizzard_override_sub / use_days) + ins_unit2 + '/' + this.getNumText3(wizzard_override_sub_num, use_days, 2);
    } else {
      context.chart6NoData = true;
    }

    var autoModeTime = 0;
    var autoModeTimeSection = [];

    var dayNum = use_days;

    var autoModeInject = [];

    var autoModeBasalInject = 0;
    var autoModeBolusInject = 0;

    for (var d = 0; d < data.basal.length; d++) {
      var autoModeBasalTotal = 0;
      var autoModeBolusTotal = 0;

      for (var i = 0; i < data.basal[d].length; i++) {
        var basalType = data.basal[d][i][2];
        var basalRecord = data.basal[d][i];
        if ('BAAM' == basalType) {
          autoModeTime += basalRecord[3];
          if (autoModeTimeSection.length > 0) {
            var lastRecord = autoModeTimeSection[autoModeTimeSection.length - 1];

            if (basalRecord[1] > lastRecord[1]) {
              autoModeTimeSection.push([basalRecord[1], basalRecord[1] + basalRecord[3]]);
            } else if (basalRecord[1] == lastRecord[1]) {
              lastRecord[1] = basalRecord[1] + basalRecord[3];
            }
          } else {
            autoModeTimeSection.push([basalRecord[1], basalRecord[1] + basalRecord[3]]);
          }

          var autoModeData = basalRecord[7];
          try {
            if (autoModeData) {
              autoModeData = JSON.parse(autoModeData);
              var microBolusJson = autoModeData['autoModeJSON'];
              microBolusJson.map(function (e, i) {
                autoModeBasalTotal += e['auto_basal_delivery'];
                autoModeBolusTotal += e['auto_food_delivery'] + e['auto_corr_delivery'];
              });
            }
          } catch (e) {
            console.log('autoModeData error:', e, basalRecord[7]);
          }
        }
      }
      autoModeInject.push([autoModeBasalTotal * 0.05, autoModeBolusTotal * 0.05]);
      autoModeBasalInject += autoModeBasalTotal * 0.05;
      autoModeBolusInject += autoModeBolusTotal * 0.05;
    }

    if (dayNum) {
      context.autoModeBasalPerDay = this.getInsulinValText(autoModeBasalInject / dayNum) + context.$t('ins_unit2');
      context.autoModeBolusPerDay = this.getInsulinValText(autoModeBolusInject / dayNum) + context.$t('ins_unit2');
    } else {
      context.autoModeBasalPerDay = '--';
      context.autoModeBolusPerDay = '--';
    }

    var autoModeSGTargetHigh = 180 / 18.0;
    var autoModeSGTargetLow = 70 / 18.0;
    var autoModeSG = [];
    var notAutoModeSG = [];
    var autoModeSGInTarget = [];
    var autoModeSGAboveTarget = [];
    var autoModeSGBelowTarget = [];
    for (var _d = 0; _d < data.sg.length; _d++) {
      for (var _i14 = 0; _i14 < data.sg[_d].length; _i14++) {
        var sgRecord = data.sg[_d][_i14];
        var sgState = sgRecord[4];
        var sgValue = sgRecord[3];
        var sgTime = sgRecord[1];
        if ('CX' == sgState || 'C' == sgState || 'NC' == sgState) {
          if (sgValue > 0.000001) {
            var sgInAutoMode = false;
            for (var s = 0; s < autoModeTimeSection.length; s++) {
              if (sgTime >= autoModeTimeSection[s][0] && sgTime <= autoModeTimeSection[s][1]) {
                sgInAutoMode = true;
                break;
              }
            }
            if (sgInAutoMode) {
              autoModeSG.push(sgValue);
              if (sgValue >= autoModeSGTargetHigh) {
                autoModeSGAboveTarget.push(sgValue);
              } else if (sgValue < autoModeSGTargetLow) {
                autoModeSGBelowTarget.push(sgValue);
              } else {
                autoModeSGInTarget.push(sgValue);
              }
            } else {
              notAutoModeSG.push(sgValue);
            }
          }
        }
      }
    }
    var statResult = this.getAvgSD(autoModeSG);
    if (statResult.num) {
      context.autoModeSGAvgSD = this.getGlucoseValText2(context.isMg, statResult.avg) + ' ± ' + this.getGlucoseSDValText(context.isMg, statResult.sd);
      var highPercent = parseInt((autoModeSGAboveTarget.length * 100.0 / autoModeSG.length).toFixed());
      var lowPercent = parseInt((autoModeSGBelowTarget.length * 100.0 / autoModeSG.length).toFixed());
      var inRangePercent = 100 - highPercent - lowPercent;
      context.autoModeSGInTargetRange = inRangePercent + '%';
      context.autoModeSGAboveRange = highPercent + '%';
      context.autoModeSGBelowRange = lowPercent + '%';

      context.autoModeSGDistPie = {
        'legendData': ['high', 'target', 'low'],
        'selected': { 'low': true, 'target': true, 'high': true },
        'seriesData': [{ name: 'high', value: autoModeSGAboveTarget.length }, { name: 'target', value: autoModeSGInTarget.length }, { name: 'low', value: autoModeSGBelowTarget.length }],
        'dataNum': autoModeSGAboveTarget.length + autoModeSGInTarget.length + autoModeSGBelowTarget.length
      };
    }

    if (dayNum) {
      context.timeInAutoMode = (autoModeTime * 100.0 / (dayNum * 3600 * 24)).toFixed() + '%';
    } else {
      context.timeInAutoMode = '--';
    }

    return {
      'use_duration_day': use_duration_day,
      'use_duration_day_pre': use_duration_day_pre
    };
  },
  getDashboardSgStat: function getDashboardSgStat(context, data) {
    var sg_day_data = [];
    var sg_data = [];
    var use_days = 0;
    var sg_day = data.sg;
    var sgMax = 0;
    var sgMin = 100;
    var hypoNum = 0;
    var lowNum = 0;
    var targetNum = 0;
    var highNum = 0;
    var target_low = data.target_low;
    var target_high = data.target_high;

    var daySelectSpan = sg_day.length;

    sg_day.map(function (d, n) {
      sg_day_data.push([]);
    });

    sg_day.map(function (d, n) {
      if (d.length > 0) {
        use_days += 1;
        d.map(function (e, i) {
          if (e[4] == 'C' || (e[4] == 'NC' || e[4] == 'CX') && e[3] > 0.00001) {
            var val = e[3];
            val = val > 22.2 ? 22.2 : val;
            val = val < 2.2 ? 2.2 : val;
            sg_day_data[n].push(val);
            sg_data.push(val);
            if (val > sgMax) {
              sgMax = val;
            }
            if (val < sgMin) {
              sgMin = val;
            }
            if (val <= 3.1) {
              hypoNum += 1;
            } else if (val > 3.1 && val < target_low) {
              lowNum += 1;
            } else if (val >= target_low && val <= target_high) {
              targetNum += 1;
            } else if (val > target_high) {
              highNum += 1;
            }
          }
        });
      }
    });

    var result = this.getAvgSD(sg_data);
    result.use_days = use_days;
    if (result.num && result.use_days) {
      context.sgAvg = this.getGlucoseValText2(context.isMg, result.avg);
      context.sgSD = this.getGlucoseSDValText(context.isMg, result.sd);
      context.sgNum = this.getNumText2(result.num, 1);

      context.est_a1c = ((result.avg * 18 + 46.7) / 28.7).toFixed(1) + '%';
      if (result.num > daySelectSpan * 720 * 0.8) {
        context.a1c_available = true;
      }

      var aucu = 0;
      var aucl = 0;
      sg_data.map(function (e, i) {
        if (e > data.target_high) {
          aucu += e - data.target_high;
        }
        if (e < data.target_low) {
          aucl += data.target_low - e;
        }
      });
      context.aucu = this.getGlucoseValText2(context.isMg, aucu / (720 * use_days));
      context.aucl = this.getGlucoseValText2(context.isMg, aucl / (720 * use_days));
      context.sgHighest = this.getGlucoseValText(context.isMg, sgMax);
      context.sgLowest = this.getGlucoseValText(context.isMg, sgMin);

      context.sgDistPie = {
        'legendData': ['high', 'target', 'low', 'hypo'],
        'selected': { 'hypo': true, 'low': true, 'target': true, 'high': true },
        'seriesData': [{ name: 'high', value: highNum }, { name: 'target', value: targetNum }, { name: 'low', value: lowNum }, { name: 'hypo', value: hypoNum }],
        'dataNum': highNum + targetNum + lowNum + hypoNum
      };

      var hypoRangeLabel = '< ' + this.getGlucoseValText(context.isMg, 3.1);
      var lowRangeLabel = this.getGlucoseValText2(context.isMg, 3.1) + ' - ' + this.getGlucoseValText(context.isMg, target_low);
      var targetRangeLabel = this.getGlucoseValText2(context.isMg, target_low) + ' - ' + this.getGlucoseValText(context.isMg, target_high);
      var highRangeLabel = '> ' + this.getGlucoseValText(context.isMg, target_high);

      context.sgDistPieLabels = [hypoRangeLabel, lowRangeLabel, targetRangeLabel, highRangeLabel];
    } else {
      context.sgAvg = '--';
      context.sgSD = '--';
      context.sgNum = '--';
    }
  },
  getDashboardSg: function getDashboardSg(context, val) {

    var that = this;
    var sg1 = new Array(144),
        sg2 = new Array(144),
        length1 = val.length,
        sgHalf = new Array(144);
    for (var i = 0; i < 144; i++) {
      sg1[i] = [];
      sg2[i] = [];
    }

    var _loop6 = function _loop6(_i15) {
      var length2 = val[_i15].length,
          st = context.ts[_i15][0];
      if (length2 > 0) {
        val[_i15].map(function (e, i) {
          if ((e[4] === 'C' || e[4] === 'CX' || e[4] === 'NC') && e[3] > 0.0001 && e[1] >= st) {
            var count = Math.floor(parseInt(e[1] - st) / 600);
            if (count >= 144 || count < 0) return;
            e[3] = e[3] > 22.2 ? 22.2 : e[3];
            e[3] = e[3] < 2.2 ? 2.2 : e[3];
            sg1[count].push(e[3]);
          }
        });
      }
    };

    for (var _i15 = 0; _i15 < length1; _i15++) {
      _loop6(_i15);
    }

    sg1.map(function (e, i) {
      if (e.length > 0) {
        e.sort(that.compare);
        var length3 = e.length;
        var d1 = Math.floor(0.05 * length3);
        var d2 = Math.floor(0.25 * length3);
        var d3 = Math.floor(0.5 * length3);
        var d4 = Math.floor(0.75 * length3);
        var d5 = Math.floor(0.95 * length3);
        sg2[i].push(e[0]);
        sg2[i].push(e[d1]);
        sg2[i].push(e[d2]);
        sg2[i].push(e[d3]);
        sg2[i].push(e[d4]);
        sg2[i].push(e[d5]);
        sg2[i].push(e[length3 - 1]);
        sgHalf[i] = context.isMg ? Math.round(e[d3] * 18) : parseFloat(e[d3].toFixed(1));
      }
    });

    var YDataMin = new Array(144);
    var YData10P = new Array(144);
    var YDataQ1 = new Array(144);
    var YDataMed = new Array(144);
    var YDataQ3 = new Array(144);
    var YData90P = new Array(144);
    var YDataMax = new Array(144);
    var sel_time = new Date(2019, 0, 1).getTime();

    var sg3 = sg2.map(function (e, i) {
      if (e && e.length > 0) {
        var d0 = context.isMg ? Math.round(e[0] * 18) : parseFloat(e[0].toFixed(1));
        var d1 = context.isMg ? Math.round((e[1] - e[0]) * 18) : parseFloat((e[1] - e[0]).toFixed(1));
        var d2 = context.isMg ? Math.round((e[2] - e[1]) * 18) : parseFloat((e[2] - e[1]).toFixed(1));
        var d3 = context.isMg ? Math.round((e[3] - e[2]) * 18) : parseFloat((e[3] - e[2]).toFixed(1));
        var d4 = context.isMg ? Math.round((e[4] - e[3]) * 18) : parseFloat((e[4] - e[3]).toFixed(1));
        var d5 = context.isMg ? Math.round((e[5] - e[4]) * 18) : parseFloat((e[5] - e[4]).toFixed(1));
        var d6 = context.isMg ? Math.round((e[6] - e[5]) * 18) : parseFloat((e[6] - e[5]).toFixed(1));

        var v0 = context.isMg ? Math.round(e[0] * 18) : parseFloat(e[0].toFixed(1));
        var v1 = context.isMg ? Math.round(e[1] * 18) : parseFloat(e[1].toFixed(1));
        var v2 = context.isMg ? Math.round(e[2] * 18) : parseFloat(e[2].toFixed(1));
        var v3 = context.isMg ? Math.round(e[3] * 18) : parseFloat(e[3].toFixed(1));
        var v4 = context.isMg ? Math.round(e[4] * 18) : parseFloat(e[4].toFixed(1));
        var v5 = context.isMg ? Math.round(e[5] * 18) : parseFloat(e[5].toFixed(1));
        var v6 = context.isMg ? Math.round(e[6] * 18) : parseFloat(e[6].toFixed(1));

        YDataMin[i] = [sel_time + i * 10 * 60 * 1000 + 5 * 60 * 1000, d0, v0];
        YData10P[i] = [sel_time + i * 10 * 60 * 1000 + 5 * 60 * 1000, d1, v1];
        YDataQ1[i] = [sel_time + i * 10 * 60 * 1000 + 5 * 60 * 1000, d2, v2];
        YDataMed[i] = [sel_time + i * 10 * 60 * 1000 + 5 * 60 * 1000, d3, v3];
        YDataQ3[i] = [sel_time + i * 10 * 60 * 1000 + 5 * 60 * 1000, d4, v4];
        YData90P[i] = [sel_time + i * 10 * 60 * 1000 + 5 * 60 * 1000, d5, v5];
        YDataMax[i] = [sel_time + i * 10 * 60 * 1000 + 5 * 60 * 1000, d6, v6];

        return [d0, d1, d2, d3, d4, d5, d6];
      }
    });


    context.YDataMin = YDataMin;
    context.YData10P = YData10P;
    context.YDataQ1 = YDataQ1;
    context.YDataMed = YDataMed;
    context.YDataQ3 = YDataQ3;
    context.YData90P = YData90P;
    context.YDataMax = YDataMax;
  },
  getSegment: function getSegment(context, uid, param) {
    var that = this;
    context.$http.post('/api/v2.1/data/' + uid, param).then(function (res) {
      var err = res.body.error;

      if (err === 0) {
        var data = res.data.data;

        if (data.sg) {
          context.sg = data.sg;
          that.getSegmentSg(context, data.sg);
        }
        if (data.bolus) {
          that.getSegmentBolus(context, data.bolus, data.event);
        }
        if (data.device_setting) {
          that.getSegmentBasal(context, data.device_setting.basal_pattern.seg);
        }
        if (data.device_setting) {
          var t = that.formatterDate1(new Date(data.device_setting.update_time * 1000));
          context.update_time = t + ', ' + data.device_setting.pdm_sn;
        }
        context.target_high = context.isMg ? parseInt(data.target_high * 18) : data.target_high.toFixed(1);
        context.target_low = context.isMg ? parseInt(data.target_low * 18) : data.target_low.toFixed(1);
        if (this.chart1_2) {
          this.chartsDispose();
        }
        this.drawCharts();
      }
    }, function (err) {
      this.error = err.body.message;
    });
  },
  getSegmentSg: function getSegmentSg(context, val) {
    var that = this;
    var sg1 = new Array(48),
        sg2 = new Array(48),
        length1 = val.length,
        sgHalf = new Array(48);
    for (var i = 0; i < 48; i++) {
      sg1[i] = [];
      sg2[i] = [];
    }

    var _loop7 = function _loop7(_i16) {
      var length2 = val[_i16].length,
          st = context.ts[_i16][0];
      if (length2 > 0) {
        val[_i16].map(function (e, i) {
          if (e[4] === 'C' && e[1] >= st) {
            var count = Math.floor(parseInt(e[1] - st) / 1800);
            e[3] = e[3] > 22.2 ? 22.2 : e[3];
            e[3] = e[3] < 2.2 ? 2.2 : e[3];
            sg1[count].push(e[3]);
          }
        });
      }
    };

    for (var _i16 = 0; _i16 < length1; _i16++) {
      _loop7(_i16);
    }

    sg1.map(function (e, i) {
      if (e.length > 0) {
        e.sort(that.compare);
        var length3 = e.length;
        var d1 = Math.floor(0.1 * length3);
        var d2 = Math.floor(0.25 * length3);
        var d3 = Math.floor(0.5 * length3);
        var d4 = Math.floor(0.75 * length3);
        var d5 = Math.floor(0.9 * length3);
        sg2[i].push(e[d1]);
        sg2[i].push(e[d2]);
        sg2[i].push(e[d3]);
        sg2[i].push(e[d4]);
        sg2[i].push(e[d5]);
        sgHalf[i] = context.isMg ? Math.round(e[d3] * 18) : parseFloat(e[d3].toFixed(1));
      }
    });

    var newSg1 = new Array(4);
    for (var _i17 = 0; _i17 < 4; _i17++) {
      newSg1[_i17] = [];
    }
    sg2.map(function (e, i) {
      if (e.length > 0) {
        var d0 = context.isMg ? Math.round(e[0] * 18) : parseFloat(e[0].toFixed(1));
        var d1 = context.isMg ? Math.round((e[1] - e[0]) * 18) : parseFloat((e[1] - e[0]).toFixed(1));
        var d2 = context.isMg ? Math.round((e[3] - e[1]) * 18) : parseFloat((e[3] - e[1]).toFixed(1));
        var d3 = context.isMg ? Math.round((e[4] - e[3]) * 18) : parseFloat((e[4] - e[3]).toFixed(1));
        newSg1[0][i] = d0;
        newSg1[1][i] = d1;
        newSg1[2][i] = d2;
        newSg1[3][i] = d3;
      }
    });
    context.sg1 = newSg1;
    context.sgHalf = sgHalf;
  },
  getSegmentBolus: function getSegmentBolus(context, val, val2) {
    var that = this;
    var bolus1 = new Array(48),
        bolus2 = new Array(48),
        length1 = val.length,
        length3 = val2.length,
        countArray = new Array(48),
        maxGroup = [];
    for (var i = 0; i < 48; i++) {
      bolus1[i] = [];
      bolus2[i] = new Array(5);
      countArray[i] = 0;
    }

    var _loop8 = function _loop8(_i18) {
      var length2 = val[_i18].length,
          st = context.ts[_i18][0];
      if (length2 > 0) {
        val[_i18].map(function (e, i) {
          if (e[2] === 'EBCCW' || e[2] === 'EBM' || e[2] === 'EBCAW') {
            if (e[1] >= st) {
              var _k10 = Math.floor(parseInt(e[1] - st) / 1800);
              var end = e[1] + e[7] * 60;
              var half = st + (_k10 + 1) * 1800;
              var value = e[6];

              if (end > half) {
                value = (half - e[1]) / (e[7] * 60) * e[6];
                if (_k10 + 1 < 48) {
                  bolus1[_k10 + 1].push(e[6] - value);
                }
              }
              bolus1[_k10].push(value);
              countArray[_k10]++;
            }
          } else if (e[2] === 'CBCCW' || e[2] === 'CBM' || e[2] === 'CBCAW') {
            if (e[1] >= st) {
              var _k11 = Math.floor(parseInt(e[1] - st) / 1800);
              var _end = e[1] + e[7] * 60;
              var _half = st + (_k11 + 1) * 1800;
              var _value2 = e[6];
              if (_end > _half) {
                _value2 = (_half - e[1]) / (e[7] * 60) * e[6];
                if (_k11 + 1 < 48) {
                  bolus1[_k11 + 1].push(e[6] - _value2);
                }
              }
              bolus1[_k11].push(_value2 + e[4]);
              countArray[_k11]++;
            }
          } else {
            if (e[1] >= st) {
              var _k12 = Math.floor(parseInt(e[1] - st) / 1800);
              bolus1[_k12].push(e[4]);
              countArray[_k12]++;
            }
          }
        });
      }
    };

    for (var _i18 = 0; _i18 < length1; _i18++) {
      _loop8(_i18);
    }

    var _loop9 = function _loop9(_i19) {
      var length2 = val2[_i19].length,
          st = context.ts[_i19][0];
      if (length2 > 0) {
        val2[_i19].map(function (e, i) {
          if (e[2] === 'INS' && e[1] >= st && e[3].value) {
            var _k13 = Math.floor(parseInt(e[1] - st) / 1800);
            bolus1[_k13].push(e[3].value);
            countArray[_k13]++;
          }
        });
      }
    };

    for (var _i19 = 0; _i19 < length3; _i19++) {
      _loop9(_i19);
    }

    bolus1.map(function (e, i) {
      if (e.length > 0) {
        e.sort(that.compare);
        var _length = e.length;
        var d1 = Math.floor(0.1 * _length);
        var d2 = Math.floor(0.25 * _length);
        var d3 = Math.floor(0.5 * _length);
        var d4 = Math.floor(0.75 * _length);
        var d5 = Math.floor(0.9 * _length);
        bolus2[i][0] = e[d1].toFixed(1);
        bolus2[i][1] = e[d2].toFixed(1);
        bolus2[i][2] = e[d3].toFixed(1);
        bolus2[i][3] = e[d4].toFixed(1);
        bolus2[i][4] = e[d5].toFixed(1);
        maxGroup.push(parseFloat(e[d5].toFixed(1)));
      }
    });
    context.bolus1 = bolus2;

    var max = maxGroup.length > 2 ? Math.max.apply(null, maxGroup) : 10;
    if (max < 10) {
      max = 10;
    } else if (max < 15) {
      max = 15;
    } else if (max < 20) {
      max = 20;
    } else if (max < 30) {
      max = 30;
    } else if (max < 50) {
      max = 50;
    }
    context.bolusMax = max;

    var bolCount = [],
        k = 0;
    countArray.map(function (e, i) {
      if (e !== 0) {
        bolCount[k] = [];
        bolCount[k][0] = i;
        bolCount[k][1] = e;
        k++;
      }
    });
    context.bolCount = bolCount;
  },
  compare: function compare(value1, value2) {
    return value1 - value2;
  },
  getSegmentBasal: function getSegmentBasal(context, val) {
    var st = context.ts[0][0],
        et = context.ts[0][1],
        basal = [],
        p = 0,
        length = val.length,
        value = [];
    for (var i = 0; i < length; i++) {
      var t1 = val[i][0].split(':');
      var t = st + parseInt(t1[0]) * 3600 + parseInt(t1[1]) * 60;
      basal[p] = [];
      basal[p][0] = new Date(t * 1000);
      basal[p][1] = val[i][1];
      if (i < length - 1) {
        basal[p][2] = val[i][0] + ' - ' + val[i + 1][0];
      } else {
        basal[p][2] = val[i][0] + ' - ' + '24:00';
      }

      value.push(val[i][1]);
      p++;
      if (i < length - 1) {
        t1 = val[i + 1][0].split(':');
        t = st + parseInt(t1[0]) * 3600 + parseInt(t1[1]) * 60;
      } else {
        t = et;
      }
      basal[p] = [];
      basal[p][0] = new Date(t * 1000);
      basal[p][1] = val[i][1];
      if (i < length - 1) {
        basal[p][2] = val[i][0] + ' - ' + val[i + 1][0];
      } else {
        basal[p][2] = val[i][0] + ' - ' + '24:00';
      }
      p++;
    }
    var max = value.length > 0 ? Math.max.apply(null, value) : 5;
    if (max <= 2) {
      max = 2.5;
    } else if (max <= 4) {
      max = 4;
    } else if (max <= 5) {
      max = 5;
    } else {
      max = 10;
    }
    context.basal = basal;
    context.basalMax = max;
  },
  getSettingData: function getSettingData(context, uid) {
    context.$http.get(SERVER_URL + '/v2.0/settings/' + uid).then(function (res) {
      var err = res.body.error;
      context.En = localStorage.getItem('unit') === 'mg' ? true : false;
      if (err === 0) {
        var settings = res.data.settings;

        if (context.En) {
          settings.glucose_unit = 'mg/dL';
          settings.blos_low_before_b = Math.round(settings.blos_low_before_b * 18);
          settings.blos_low_before_b = settings.blos_low_before_b < 60 ? 60 : settings.blos_low_before_b;
          settings.blos_low_before_b = settings.blos_low_before_b > 100 ? 100 : settings.blos_low_before_b;

          settings.blos_high_before_b = Math.round(settings.blos_high_before_b * 18);
          settings.blos_low_after_b = Math.round(settings.blos_low_after_b * 18);
          settings.blos_low_after_b = settings.blos_low_after_b < 60 ? 60 : settings.blos_low_after_b;
          settings.blos_low_after_b = settings.blos_low_after_b > 100 ? 100 : settings.blos_low_after_b;

          settings.blos_high_after_b = Math.round(settings.blos_high_after_b * 18);
          settings.blos_low_before_l = Math.round(settings.blos_low_before_l * 18);
          settings.blos_low_before_l = settings.blos_low_before_l < 60 ? 60 : settings.blos_low_before_l;
          settings.blos_low_before_l = settings.blos_low_before_l > 100 ? 100 : settings.blos_low_before_l;

          settings.blos_high_before_l = Math.round(settings.blos_high_before_l * 18);
          settings.blos_low_after_l = Math.round(settings.blos_low_after_l * 18);
          settings.blos_low_after_l = settings.blos_low_after_l < 60 ? 60 : settings.blos_low_after_l;
          settings.blos_low_after_l = settings.blos_low_after_l > 100 ? 100 : settings.blos_low_after_l;

          settings.blos_high_after_l = Math.round(settings.blos_high_after_l * 18);
          settings.blos_low_before_s = Math.round(settings.blos_low_before_s * 18);
          settings.blos_low_before_s = settings.blos_low_before_s < 60 ? 60 : settings.blos_low_before_s;
          settings.blos_low_before_s = settings.blos_low_before_s > 100 ? 100 : settings.blos_low_before_s;

          settings.blos_high_before_s = Math.round(settings.blos_high_before_s * 18);
          settings.blos_low_after_s = Math.round(settings.blos_low_after_s * 18);
          settings.blos_low_after_s = settings.blos_low_after_s < 60 ? 60 : settings.blos_low_after_s;
          settings.blos_low_after_s = settings.blos_low_after_s > 100 ? 100 : settings.blos_low_after_s;

          settings.blos_high_after_s = Math.round(settings.blos_high_after_s * 18);
          settings.blos_low_night = Math.round(settings.blos_low_night * 18);
          settings.blos_low_night = settings.blos_low_night < 60 ? 60 : settings.blos_low_night;
          settings.blos_low_night = settings.blos_low_night > 100 ? 100 : settings.blos_low_night;

          settings.blos_high_night = Math.round(settings.blos_high_night * 18);
          settings.blos_low = Math.round(settings.blos_low * 18);
          settings.blos_low = settings.blos_low < 60 ? 60 : settings.blos_low;

          settings.blos_high = Math.round(settings.blos_high * 18);
          settings.hypo = Math.round(settings.hypo * 18);
        } else {
          settings.glucose_unit = 'mmol/L';
          settings.blos_low_before_b = settings.blos_low_before_b.toFixed(1);
          settings.blos_high_before_b = settings.blos_high_before_b.toFixed(1);
          settings.blos_low_after_b = settings.blos_low_after_b.toFixed(1);
          settings.blos_high_after_b = settings.blos_high_after_b.toFixed(1);
          settings.blos_low_before_l = settings.blos_low_before_l.toFixed(1);
          settings.blos_high_before_l = settings.blos_high_before_l.toFixed(1);
          settings.blos_low_after_l = settings.blos_low_after_l.toFixed(1);
          settings.blos_high_after_l = settings.blos_high_after_l.toFixed(1);
          settings.blos_low_before_s = settings.blos_low_before_s.toFixed(1);
          settings.blos_high_before_s = settings.blos_high_before_s.toFixed(1);
          settings.blos_low_after_s = settings.blos_low_after_s.toFixed(1);
          settings.blos_high_after_s = settings.blos_high_after_s.toFixed(1);
          settings.blos_low_night = settings.blos_low_night.toFixed(1);
          settings.blos_high_night = settings.blos_high_night.toFixed(1);
          settings.blos_low = settings.blos_low.toFixed(1);
          settings.blos_high = settings.blos_high.toFixed(1);
          settings.hypo = settings.hypo.toFixed(1);
        }
        context.$store.commit('updateSettingData', settings);
        context.$store.commit('updateAlarm', settings.alarm_display);
      }
    }, function (err) {
      alert(err + "," + err.body.message);
    });
  },
  getSessions: function getSessions(context, uid) {
    var that = this;
    function addPreZero(pdm_sn_hex, num) {
      var pre = '';
      for (var i = 0; i < num; i++) {
        pre += '0';
      }
      return pre + pdm_sn_hex;
    }

    context.$http.get(SERVER_URL + '/v2.0/pdm/' + uid + '/sessions').then(function (res) {
      var err = res.body.error;

      if (err === 0) {

        var sessions = res.body.sessions;
        for (var i = 0; i < sessions.length; i++) {
          for (var j = 0; j < sessions[i].length; j++) {
            for (var k = 0; k < 8; k++) {
              if (k === 3 || k === 4 || k === 5) {
                var time = new Date(sessions[i][j][k] * 1000);
                sessions[i][j][k] = context.isZh ? that.formateDate(time) : that.formatterDate1(time);
              } else if (k === 6) {
                var pdm_sn = sessions[i][j][k];
                pdm_sn = parseInt(pdm_sn);

                if (100000000 <= pdm_sn && pdm_sn <= 101999999 || 109000000 <= pdm_sn && pdm_sn <= 109999999 || 112000000 <= pdm_sn && pdm_sn <= 112999999) {} else {
                  var pdm_sn_hex = pdm_sn.toString(16);
                  sessions[i][j][k] = addPreZero(pdm_sn_hex.toUpperCase(), 8 - pdm_sn_hex.length);
                }
              } else if (k === 1) {
                var ty_jn_sn = sessions[i][j][k];
                ty_jn_sn = parseInt(ty_jn_sn);

                if (102000000 <= ty_jn_sn && ty_jn_sn <= 103999999 || 114000000 <= ty_jn_sn && ty_jn_sn <= 115999999 || 118000000 <= ty_jn_sn && ty_jn_sn <= 119999999 || 106000000 <= ty_jn_sn && ty_jn_sn <= 106999999) {} else {
                  var ty_jn_sn_hex = ty_jn_sn.toString(16);
                  sessions[i][j][k] = addPreZero(ty_jn_sn_hex.toUpperCase(), 8 - ty_jn_sn_hex.length);
                }
              }
            }
          }
        }
        context.Sessions = sessions;

        var data = res.data.options;
        context.cgms = data.cgms ? data.cgms : [];
        context.pump = data.pump ? data.pump : [];

        if (context.Sessions[0].length) {
          context.haveSensorData = true;
        } else {
          context.haveSensorData = false;
        }
        if (context.Sessions[1].length) {
          context.havePumpData = true;
        } else {
          context.havePumpData = false;
        }
        console.log('havePumpData:', context.havePumpData, context.haveSensorData);

        if (data.option === 'daopapp') {
          context.isA = true;
          context.isB = false;
          sessionStorage.setItem('dateViewA', 1);
          sessionStorage.setItem('dateViewB', 0);
        } else {
          context.isB = true;
          context.isA = false;
          sessionStorage.setItem('dateViewA', 0);
          sessionStorage.setItem('dateViewB', 1);
        }

        if (context.isB) {
          setTimeout(context.checkSet, 50);
        }
      }
    }, function (err) {
      alert(err + "," + err.body.message);
    });
  },
  setData: function setData(context, uid, param) {
    var that = this;
    context.$http.post(SERVER_URL + '/v2.0/options/' + uid + '/data', param).then(function (res) {
      var err = res.body.error;
      console.log('save options:', err);
      if (err === 0) {
        var tip = context.$t('saveTip');
        context.$message({
          type: 'success',
          message: tip
        });
      }
      if (err === 34) {
        var _tip10 = context.$t('Time overlapped');
        context.$message.error(_tip10);
      }
    });
  },
  getSet: function getSet(context, uid) {
    context.$http.get(SERVER_URL + '/v2.0/options/' + uid + '/data').then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        var data = res.data.data;
        console.log('options.data:', data);
        context.cgms = data.cgms ? data.cgms : [];
        context.pump = data.pump ? data.pump : [];

        if (data.option === 'daopapp') {
          context.isA = true;
          context.isB = false;
          sessionStorage.setItem('dateViewA', 1);
          sessionStorage.setItem('dateViewB', 0);
          context.isRealtime = true;
          context.isPDM = false;
        } else {
          context.isB = true;
          context.isA = false;
          sessionStorage.setItem('dateViewA', 0);
          sessionStorage.setItem('dateViewB', 1);
          context.isRealtime = false;
          context.isPDM = true;
        }
      }
    });
  },
  getEvents: function getEvents(context, uid, param) {
    var that = this;
    var ins_unit2 = context.$t('ins_unit2');
    context.$http.get(SERVER_URL + '/v2.0/events/' + uid, { params: param }).then(function (res) {
      var err = res.data.error;

      if (err === 0) {
        var dataObj = res.data.data;
        context.defaultDate2 = dataObj.st ? that.formatterDate4(dataObj.st) : that.formatterDate4(new Date().setHours(0, 0, 0, 0) / 1000 - 86400 * 6);
        console.log('event:', dataObj.items);
        var isEn = sessionStorage.getItem('language') !== 'zh' ? true : false;
        var events = dataObj.items.map(function (e, i) {
          e[1] = isEn ? that.formatterDate1(new Date(e[1] * 1000)) : that.formateDate(new Date(e[1] * 1000));
          if (e[3]) {
            if (e[2] === 'BG') {
              e[3].value = context.isMg ? e[3].value : (e[3].value / 18).toFixed(1);
              e[3].value = e[3].value + ' ' + context.unit;
            }
            if (e[2] === 'CARB') {
              e[3].value = e[3].value + ' g';
            }
            if (e[2] === 'INS') {
              e[3].value = e[3].value + ' ' + ins_unit2;
            }
            if (e[2] === 'EXR') {
              e[3].value = e[3].value + ' min';
              var exercise = ["Light", "Medium", "Heavy"];
              e[3].value = e[3].value + ' ' + exercise[e[3].exerciseIntensity];
            }
            if (e[2] === 'AutoExercise') {
              if (e[3].value) {
                e[3].value = e[3].value + ' min';
              } else {
                e[3].value = e[3].duration + ' min';
              }
            }
            if (e[2] === 'HBA1C') {
              e[3].value = e[3].value + ' %';
            }
            if (e[2] === 'URINEK') {
              var urinekType = ['Negative', 'Macro', '+', '++', '+++', '++++'];
              e[3].value = urinekType[e[3].value - 1];
            }
            if (e[2] === 'OTR') {
              e[3].value = '...';
            }
          }
          e[2] = context.$t(e[2]);
          e[4] = e[4] === 'pdm' ? context.$t('pdm') : e[4];
          return e;
        });
        context.$store.commit('updateEvents', events);
        this.pages = dataObj.pages;
        this.has_next = dataObj.has_next;
        this.has_prev = dataObj.has_prev;
      }
    });
  },
  newEvents: function newEvents(context, uid, param) {
    context.$http.post(SERVER_URL + '/v2.0/events/' + uid + '/data/new', { data: [param] }).then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        var tip = context.$t('saveTip');
        context.$message({
          type: 'success',
          message: tip
        });
        context.getEvents();
        context.isA = false;
      } else {
        var _tip11 = context.$t('createFailed');
        context.$message.error(_tip11);
      }
    });
  },
  deleteEvents: function deleteEvents(context, uid, param) {
    context.$http.post(SERVER_URL + '/v2.0/events/' + uid + '/data/delete', { eids: param }).then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        var tip = context.$t('deleteSuccess');
        context.$message({
          type: 'success',
          message: tip
        });
        context.eids = [];
        context.getEvents();
      } else {
        var _tip12 = context.$t('deleteFailed');
        context.$message.error(_tip12);
      }
    });
  },
  deleteData: function deleteData(context) {
    context.$http.post(SERVER_URL + '/v2.0/data/delete').then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        var tip = context.$t('deleteSuccess');
        context.$message({
          type: 'success',
          message: tip
        });

        context.Sessions = [];
      } else {
        var _tip13 = context.$t('deleteFailed');
        context.$message.error(_tip13);
      }
    });
  },
  editEvents: function editEvents(context, uid, eid, param) {
    context.$http.post(SERVER_URL + '/v2.0/events/' + uid + '/data/' + eid, { event: param }).then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        var tip = context.$t('editSuccess');
        context.$message({
          type: 'success',
          message: tip
        });
        context.isB = false;
        context.getEvents();
      } else {
        var _tip14 = context.$t('editFailed');
        context.$message.error(_tip14);
      }
    });
  },
  getRecords: function getRecords(context, uid) {
    var that = this;
    context.$http.get(SERVER_URL + '/v2.0/records/' + uid).then(function (res) {
      var err = res.data.error;
      if (err === 0) {
        var dataObj = res.data.data;

        dataObj.profile.diabetes_type = context.$t(dataObj.profile.diabetes_type);
        if (dataObj.profile.height) {
          dataObj.profile.height = dataObj.profile.height + ' cm';
        }
        if (dataObj.profile.weight) {
          dataObj.profile.weight = dataObj.profile.weight + ' kg';
        }
        if (dataObj.profile.birthday) {
          var y = parseInt(dataObj.profile.birthday.split('-')[0]);
          var y1 = new Date().getFullYear();
          dataObj.profile.birthday = y1 - y;
        }
        if (dataObj.profile.diabetes_diagnosis_date) {
          var t = dataObj.profile.diabetes_diagnosis_date.split('-');
          var _y = new Date().getFullYear();
          var m1 = new Date().getMonth() + 1;
          var _y2 = _y - parseInt(t[0]);
          var _m9 = m1 - parseInt(t[1]);
          if (_m9 < 0) {
            _y2--;
            _m9 += 12;
          }
          var year = _y2 > 1 ? context.$t('Years') : context.$t('Year');
          var month = _m9 > 1 ? context.$t('Months') : context.$t('Month');
          var lang = localStorage.getItem('language');
          dataObj.profile.diabetes_diagnosis_date = lang === 'zh' || lang === 'hk' ? _y2 + ' 年 ' + _m9 + ' 月' : _y2 + ' ' + year + ' ' + _m9 + ' ' + month;
        }
        context.profile = dataObj.profile;
        var isEn = sessionStorage.getItem('language') !== 'zh' ? true : false;
        context.complications = dataObj.complications.map(function (e, i) {
          e[2] = isEn ? that.formatterDate4(e[2]) : that.formatterDate3(e[2]);
          return e;
        });
        context.prescription = dataObj.prescription;
        context.suggestions = dataObj.suggestions.map(function (e, i) {
          e[1] = isEn ? that.formatterDate4(e[1]) : that.formatterDate3(e[1]);
          return e;
        });

        sessionStorage.setItem('Rpro', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(context.profile));
        sessionStorage.setItem('Rcop', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(context.complications));
        sessionStorage.setItem('Rpre', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(context.prescription));
        sessionStorage.setItem('Rsug', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(context.suggestions));
      }
    });
  },
  newRecords: function newRecords(context, uid, param) {
    var that = this;

    context.$http.post(SERVER_URL + '/v2.0/records/' + uid + '/data/new', { data: param }).then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        console.log(res);
        var tip = context.$t('createSuccess');
        context.$message({
          type: 'success',
          message: tip
        });
        this.CreateVisible = false;
        that.getRecords(context, uid);
      } else {
        var _tip15 = context.$t('createFailed');
        context.$message.error(_tip15);
      }
    }, function (err) {
      var tip = context.$t('createFailed');
      context.$message.error(tip);
    });
  },
  deleteRecords: function deleteRecords(context, uid, param) {
    var that = this;
    context.$http.post(SERVER_URL + '/v2.0/records/' + uid + '/data/delete', { rids: param }).then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        var tip = context.$t('deleteSuccess');
        context.$message({
          type: 'success',
          message: tip
        });
        that.getRecords(context, uid);
      } else {
        var _tip16 = context.$t('deleteFailed');
        context.$message.error(_tip16);
      }
    });
  },
  editRecords: function editRecords(context, uid, param) {
    var that = this;
    context.$http.post(SERVER_URL + '/v2.0/records/' + uid + '/data/edit', { data: param }).then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        context.EditVisible = false;
        var tip = context.$t('editSuccess');
        context.$message({
          type: 'success',
          message: tip
        });
        that.getRecords(context, uid);
      } else {
        var _tip17 = context.$t('editFailed');
        context.$message.error(_tip17);
      }
    });
  },
  getConnections: function getConnections(context, info) {
    var that = this;
    var now = new Date() / 1000;
    context.$http.get(SERVER_URL + '/v2.1/monitor/connections', { params: info }).then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        var data = res.body.data;

        var dataObj = data.items;
        context.connections = dataObj.map(function (e, i) {
          var t1 = now - e.sensor_status.updateTime;
          var t2 = now - e.pump_status.updateTime;
          if (e.sensor_status.glucose) {
            console.log('connection.glucose:', e.alias, e.sensor_status.glucose);
            e.sensor_status.glucose = e.sensor_status.glucose.toFixed(1);
          } else {
            e.sensor_status.glucose = '--';
          }
          if (e.pump_status.basalRate) {
            e.pump_status.basalRate = e.pump_status.basalRate.toFixed(1);
          }
          if (e.pump_status.iob) {
            e.pump_status.iob = e.pump_status.iob.toFixed(2);
          }
          if (t1 > 3600) {
            e.sensor_status.glucose = '--';
          }
          if (t2 > 3600) {
            e.pump_status.basalRate = '--';
            e.pump_status.iob = '--';
          }
          e.alias = e.alias ? e.alias : e.real_name;
          return e;
        });
        this.pages = data.pages !== 0 ? data.pages : 1;
        this.has_next = data.has_next;
        this.has_prev = data.has_prev;
      }
      if (err === 14) {
        context.$router.push('/login');
      }
    });
  },
  getPatientConnections: function getPatientConnections(context) {
    context.$http.get(SERVER_URL + '/v2.0/relations/auth').then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        var data = res.data.data;
        context.hcp = [];context.carer = [];context.hcpApply = [];context.carerApply = [];
        context.oauth2 = data.oauth2;
        data.hcp.map(function (e, i) {
          if (e.state === 'ACCEPT') {
            context.hcp.push(e);
          } else {
            context.hcpApply.push(e);
          }
        });
        data.carer.map(function (e, i) {
          if (e.state === 'ACCEPT') {
            context.carer.push(e);
          } else {
            context.carerApply.push(e);
          }
        });
        console.log('connection.data:', data);
        if (data.hcp.length === 0 && data.carer.length === 0) {
          context.noMes = true;
        }
      }
      if (err === 14) {
        context.$router.push('/login');
      }
    });
  },
  deleteConnection: function deleteConnection(context, id) {
    var that = this;
    context.$http.post(SERVER_URL + '/v2.0/relations/auth/cancel', { uid: id }).then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        var tip = context.$t('deleteSuccess');
        context.$message({
          type: 'success',
          message: tip
        });
      } else {
        var _tip18 = context.$t('deleteFailed');
        context.$message.error(_tip18);
      }
      that.getPatientConnections(context);
    });
  },
  addConnection: function addConnection(context, id) {
    var that = this;
    context.$http.post(SERVER_URL + '/v2.0/relations/auth/permit', { uid: id }).then(function (res) {
      var err = res.body.error;
      console.log(res);
      if (err === 0) {
        var tip = context.$t('acceSu');
        context.$message({
          type: 'success',
          message: tip
        });
      } else {
        var _tip19 = context.$t('acceEr');
        context.$message.error(_tip19);
      }
      that.getPatientConnections(context);
      that.getUnread1(context);
    });
  },
  rejectConnection: function rejectConnection(context, id) {
    var that = this;
    context.$http.post(SERVER_URL + '/v2.0/relations/auth/reject', { uid: id }).then(function (res) {
      var err = res.body.error;
      console.log(res);
      if (err === 0) {
        var tip = context.$t('rejeSu');
        context.$message({
          type: 'success',
          message: tip
        });
      } else {
        var _tip20 = context.$t('rejeEr');
        context.$message.error(_tip20);
      }
      that.getPatientConnections(context);
      that.getUnread1(context);
    });
  },
  formateDate: function formateDate(date) {
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    var d = date.getDate();
    var h = date.getHours();
    var mi = date.getMinutes();
    var s = date.getSeconds();
    m = m < 10 ? '0' + m : m;
    d = d < 10 ? '0' + d : d;
    mi = mi < 10 ? '0' + mi : mi;
    return y + '-' + m + '-' + d + ' ' + h + ':' + mi + ':' + s;
  },
  formatterDate1: function formatterDate1(date) {
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    var d = date.getDate();
    var h = date.getHours();
    var mi = date.getMinutes();
    var s = date.getSeconds();
    m = m < 10 ? '0' + m : m;
    d = d < 10 ? '0' + d : d;
    h = h < 10 ? '0' + h : h;
    mi = mi < 10 ? '0' + mi : mi;
    s = s < 10 ? '0' + s : s;
    return d + '-' + m + '-' + y + ' ' + h + ':' + mi + ':' + s;
  },
  formatterDate1a: function formatterDate1a(date) {
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    var d = date.getDate();
    var h = date.getHours();
    var mi = date.getMinutes();
    var s = date.getSeconds();
    m = m < 10 ? '0' + m : m;
    d = d < 10 ? '0' + d : d;
    h = h < 10 ? '0' + h : h;
    mi = mi < 10 ? '0' + mi : mi;
    s = s < 10 ? '0' + s : s;
    return y + '-' + m + '-' + d + ' ' + h + ':' + mi + ':' + s;
  },
  formatterDate1b: function formatterDate1b(date) {
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    var d = date.getDate();
    var h = date.getHours();
    var mi = date.getMinutes();
    var s = date.getSeconds();
    m = m < 10 ? '0' + m : m;
    d = d < 10 ? '0' + d : d;
    h = h < 10 ? '0' + h : h;
    mi = mi < 10 ? '0' + mi : mi;
    s = s < 10 ? '0' + s : s;
    return y + '-' + m + '-' + d;
  },
  formatterDate1c: function formatterDate1c(date) {
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    var d = date.getDate();
    var h = date.getHours();
    var mi = date.getMinutes();
    var s = date.getSeconds();
    m = m < 10 ? '0' + m : m;
    d = d < 10 ? '0' + d : d;
    h = h < 10 ? '0' + h : h;
    mi = mi < 10 ? '0' + mi : mi;
    s = s < 10 ? '0' + s : s;
    return y + '' + m + '' + d;
  },
  formatterDate2: function formatterDate2(val) {
    var time = new Date(val * 1000);
    var y = time.getFullYear();
    var m = time.getMonth() + 1;
    var d = time.getDate();
    m = m < 10 ? '0' + m : m;
    d = d < 10 ? '0' + d : d;
    return d + '/' + m + '/' + y;
  },
  formatterDate3: function formatterDate3(val) {
    var time = new Date(val * 1000);
    var y = time.getFullYear();
    var m = time.getMonth() + 1;
    var d = time.getDate();
    m = m < 10 ? '0' + m : m;
    d = d < 10 ? '0' + d : d;
    return y + '-' + m + '-' + d;
  },
  formatterDate4: function formatterDate4(val) {
    var time = new Date(val * 1000);
    var y = time.getFullYear();
    var m = time.getMonth() + 1;
    var d = time.getDate();
    m = m < 10 ? '0' + m : m;
    d = d < 10 ? '0' + d : d;
    return d + '-' + m + '-' + y;
  },
  formatterDate4_1: function formatterDate4_1(val) {
    var time = new Date(val * 1000);
    var y = time.getFullYear();
    var m = time.getMonth() + 1;
    var d = time.getDate();

    return d + '-' + m;
  },
  formatterDate5: function formatterDate5(val) {
    var h = val.getHours();
    var mi = val.getMinutes();
    h = h < 10 ? '0' + h : h;
    mi = mi < 10 ? '0' + mi : mi;
    return [h, mi];
  },
  formatterDate6: function formatterDate6(val) {
    var date = new Date(val * 1000);
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    var d = date.getDate();
    var h = date.getHours();
    var mi = date.getMinutes();
    m = m < 10 ? '0' + m : m;
    d = d < 10 ? '0' + d : d;
    h = h < 10 ? '0' + h : h;
    mi = mi < 10 ? '0' + mi : mi;
    return d + '/' + m + '/' + y + ' ' + h + ':' + mi;
  },
  formatterDate7: function formatterDate7(context, val) {
    if (!val) {
      return '--';
    }
    var date = new Date(val * 1000);
    var now = new Date().getDate();
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    var d = date.getDate();
    var h = date.getHours();
    var mi = date.getMinutes();
    m = m < 10 ? '0' + m : m;
    d = d < 10 ? '0' + d : d;
    h = h < 10 ? '0' + h : h;
    mi = mi < 10 ? '0' + mi : mi;
    if (now === parseInt(d)) {
      return context.$t('Today') + ' ' + h + ':' + mi;
    } else if (now - 1 === parseInt(d)) {
      return context.$t('Yesterday') + ' ' + h + ':' + mi;
    } else {
      return d + '/' + m + '/' + y + ' ' + h + ':' + mi;
    }
  },
  formatterDate8: function formatterDate8(val) {
    var time = new Date(val * 1000);
    var m = time.getMonth() + 1;
    var d = time.getDate();
    m = m < 10 ? '0' + m : m;
    d = d < 10 ? '0' + d : d;
    return d + '/' + m;
  },
  formatterDate9: function formatterDate9(val) {
    var time = new Date(val * 1000);
    var y = time.getFullYear();
    var m = time.getMonth();
    var d = time.getDate();
    return [parseInt(y), parseInt(m), parseInt(d)];
  },
  formatterDate10: function formatterDate10(val) {
    var time = new Date(val * 1000);
    var h = time.getHours();
    var m = time.getMinutes();
    var s = time.getSeconds();
    return [parseInt(h), parseInt(m), parseInt(s)];
  },
  formatterDay: function formatterDay(context, val) {
    var time = new Date(val * 1000);
    var week = new Array(context.$t('Sun'), context.$t('Mon'), context.$t('Tue'), context.$t('Wed'), context.$t('Thur'), context.$t('Fri'), context.$t('Sat'));
    var day = time.getDay();
    return week[day];
  },
  getTime: function getTime(val) {
    var isEn = localStorage.getItem('language') === 'zh' || localStorage.getItem('language') === 'hk' ? true : false;

    if (val < 0) {
      return '--';
    } else {
      var d = parseInt(val * 2 / 1440);
      var h = parseInt(val * 2 % 1440 / 60);
      var mi = parseInt(val * 2 % 60);
      if (d === 0) {
        return isEn ? h + ' 小时 ' + mi + ' 分钟' : h + ' h ' + mi + ' min';
      } else {
        return isEn ? d + ' 天 ' + h + ' 小时 ' + mi + ' 分钟' : d + ' day ' + h + ' h ' + mi + ' min';
      }
    }
  },
  getTime2: function getTime2(val) {
    var h = parseInt(val / 60);
    var mi = val % 60;
    h = h < 10 ? '0' + h : h;
    mi = mi < 10 ? '0' + mi : mi;
    return [h, mi];
  },
  getTime3: function getTime3(val) {
    var isEn = localStorage.getItem('language') === 'zh' || localStorage.getItem('language') === 'hk' ? true : false;
    if (val < 0) {
      return '--';
    } else {
      var d = parseInt(val / 1440);
      var h = parseInt(val % 1440 / 60);
      var mi = parseInt(val % 60);
      if (d === 0) {
        return isEn ? h + ' 小时 ' + mi + ' 分钟' : h + ' h ' + mi + ' min';
      } else {
        return isEn ? d + ' 天 ' + h + ' 小时 ' + mi + ' 分钟' : d + ' day ' + h + ' h ' + mi + ' min';
      }
    }
  },
  modifyPassword: function modifyPassword(context, param) {
    context.$http.post(SERVER_URL + '/v2.0/password/modify', param).then(function (res) {
      var err = res.body.error;

      if (err === 0) {
        var tip = context.$t('saveTip');
        context.$message({
          type: 'success',
          message: tip
        });
        var user = sessionStorage.getItem('userType');
        if (user === 'P') {
          context.$router.push('/monitor');
        }
        if (user === 'D') {
          context.$router.push('/PatientList');
        }
        if (user === 'M') {
          context.$router.push('/carerConnection');
        }
      } else {
        var _tip21 = context.$t('oldErr');
        context.$message.error(_tip21);
      }
    });
  },
  getToken: function getToken(context, param) {
    context.$http.get(SERVER_URL + '/v2.0/password/reset/token', { params: { param: param } }).then(function (res) {
      var err = res.body.error;

      if (err === 0) {
        context.passwordToken = res.data.token;
        context.isB = false;
        context.isC = true;
        sessionStorage.setItem('B', 0);
        sessionStorage.setItem('C', 1);
      } else {
        var tip = context.$t('verErrTip');
        context.$message.error(tip);
      }
    });
  },
  resetPassword: function resetPassword(context, param) {
    context.$http.post(SERVER_URL + '/v2.0/password/reset', param).then(function (res) {
      var err = res.body.error;

      if (err === 0) {
        this.isC = false;
        this.isD = true;
        sessionStorage.setItem('C', 0);
        sessionStorage.setItem('D', 1);
      } else {
        var tip = context.$t('modifyFailed');
        context.$message.error(tip);
      }
    });
  },
  init: function init() {
    var height = window.innerHeight;
    var width = window.innerWidth;
    var body = document.getElementsByTagName('body')[0];
    body.style.height = height + 'px';
    body.style.width = width + 'px';
  },
  getAuthHeader: function getAuthHeader() {
    return {
      'Authorization': 'Bearer ' + sessionStorage.getItem('token')
    };
  },
  checkAuth: function checkAuth() {
    var token = sessionStorage.getItem('token');
    if (token) {
      this.authenticated = true;
    } else {
      this.authenticated = false;
    }
  },
  clearSession: function clearSession() {
    var tz = parseInt(sessionStorage.getItem('tz'));
    var uid = parseInt(sessionStorage.getItem('uid'));
    var userType = sessionStorage.getItem('userType');
    var username = sessionStorage.getItem('username');
    var token = sessionStorage.getItem('token');
    var lang = sessionStorage.getItem('language');
    sessionStorage.clear();
    sessionStorage.setItem('tz', tz);
    sessionStorage.setItem('uid', uid);
    sessionStorage.setItem('userType', userType);
    sessionStorage.setItem('username', username);
    sessionStorage.setItem('token', token);
    sessionStorage.setItem('language', lang);
  },
  getTs: function getTs(st, et) {
    var ts = [],
        k = 0;
    var days = parseInt((et - st) / 86400) + 1;
    for (var i = 0; i < days; i++) {
      ts[k] = [];
      ts[k][0] = st + i * 86400;
      ts[k][1] = st + (i + 1) * 86400;
      k++;
    }
    return ts;
  },
  getTs2: function getTs2(context, st, et) {
    var ts = [],
        days = (et - st) / 86400 + 1,
        k = 0;
    var No = this.chekcNoDate(context.weekmode);
    for (var i = 0; i < days; i++) {
      var day = new Date((st + i * 86400) * 1000).getDay();
      if (No.indexOf(day) === -1) {
        ts[k] = [];
        ts[k][0] = st + i * 86400;
        ts[k][1] = st + (i + 1) * 86400;
        k++;
      }
    }
    return ts;
  },
  chekcNoDate: function chekcNoDate(weekmode) {
    var No = [],
        no = weekmode.split('');
    no.map(function (e, i) {
      if (e === 'n') {
        var d = i + 1;
        if (d > 6) {
          d = 0;
        }
        No.push(d);
      }
    });
    return No;
  },
  checkWeekMode: function checkWeekMode(context) {
    context.weekModeSp = [];
    context.weekM1 = false;
    context.weekM2 = false;
    var week = context.weekmode.split('');

    week.map(function (e, i) {
      if (e === 'n') {
        context.weekModeSp[i] = true;
        if (i < 5) {
          context.weekM1 = true;
        } else {
          context.weekM2 = true;
        }
      } else {
        context.weekModeSp[i] = false;
      }
    });
  },
  open: function open(url) {
    window.open(url, '_blank');
  },
  _open: function _open(url) {
    return function () {
      this.open(url);
    };
  },
  checkPrint: function checkPrint(context, start, now) {
    var that = this;
    var report = JSON.parse(sessionStorage.getItem('Reports'));
    var length = report.length;
    document.onreadystatechange = function () {
      if (document.readyState === 'complete') {
        for (var i = start; i < length; i++) {
          if (report[i] === 1) {
            var key = 'qFirst' + now;
            sessionStorage.setItem(key, 0);
            var path = '/#/quickPrint' + i;
            var open = window.open(path, '_blank');
            if (open === null) {
              context.$message.error('popup window intercepted');
            }
            break;
          }
        }
      }
    };
  },
  _printPdf: function _printPdf() {
    var that = this;
    return function () {
      that.print_page();
    };
  },
  print_page: function print_page() {
    if (!!window.ActiveXObject || "ActiveXObject" in window) {
      var hkey_root = void 0,
          hkey_path = void 0,
          hkey_key = void 0;
      hkey_path = "HKEY_CURRENT_USER\\Software\\Microsoft\\Internet Explorer\\PageSetup\\";
      try {
        var RegWsh = new ActiveXObject("WScript.Shell");
        RegWsh.RegWrite(hkey_path + "header", "");
        RegWsh.RegWrite(hkey_path + "footer", "");
      } catch (e) {}
    }
    window.print();
  },
  _getMonData1: function _getMonData1(context, info) {
    var that = this;
    return function () {
      that.getMonData1(context, info);
    };
  },
  initLanguages: function initLanguages(context) {
    context.hostname = window.location.hostname.split('.')[2];
    var href = window.location.href;
    var search = href.split('=')[1],
        info = [];

    if (!search) {
      if (context.hostname === 'cn') {
        info = [1, 1];
      } else if (context.hostname === 'eu') {
        var countryIndex = localStorage.getItem('index');
        if (!countryIndex) {
          info = [0, 0];
        } else {
          var index = parseInt(countryIndex);
          var index2 = parseInt(localStorage.getItem('languageIndex'));
          info = [index, index2];
        }
      } else {
        info = [0, 0];
      }
    } else {
      var _index = 0;
      context.country.map(function (e, i) {
        if (e === search) {
          _index = i;
        }
      });
      if (search === 'DE') {
        _index = 3;
      }
      info = [_index, _index];
    }

    info.push(1);
    context.$store.commit('changLanguage', info);
  },
  xx_initLanguages: function xx_initLanguages(context) {
    context.hostname = window.location.hostname.split('.')[2];
    var href = window.location.href;
    var search = href.split('=')[1],
        info = [];
    var countryIndex = localStorage.getItem('index');
    if (!countryIndex) {
      if (!search) {
        if (context.hostname === 'cn') {
          info = [1, 1];
        } else if (context.hostname === 'eu') {
          info = [0, 0];
        } else {
          info = [0, 0];
        }
      } else {
        var index = 0;
        context.country.map(function (e, i) {
          if (e === search) {
            index = i;
          }
        });
        if (search === 'DE') {
          index = 3;
        }
        info = [index, index];
      }
    } else {
      var _index2 = parseInt(countryIndex);
      var index2 = parseInt(localStorage.getItem('languageIndex'));
      info = [_index2, index2];
    }
    info.push(1);
    context.$store.commit('changLanguage', info);
  },
  changeServer: function changeServer(context, country, route) {
    var index = 0;
    if (country !== 'DE') {
      context.country.map(function (e, i) {
        if (e === country) {
          index = i;
        }
      });
    } else {
      index = 3;
    }
    var hostname = window.location.hostname.split('.')[2];
    var flag = 1;
    if (index === 1 && hostname !== 'cn') {
      window.location = 'https://easyview.medtrum.cn/#/' + route + '?country=' + country;
      flag = 0;
    } else {
        window.location = 'https://easyview.medtrum.eu/#/' + route + '?country=' + country;
      }
    context.$store.commit('changLanguage', [index, index, flag]);
  },
  getBrowserInfo: function getBrowserInfo() {
    var agent = navigator.userAgent.toLowerCase();
    var regStr_ie = /msie [\d.]+;/gi;
    var regStr_ff = /firefox\/[\d.]+/gi;
    var regStr_chrome = /chrome\/[\d.]+/gi;
    var regStr_saf = /safari\/[\d.]+/gi;
    var regStr_safVersion = /version\/[\d.]+/gi;
    var regStr_edge = /edge\/[\d.]+/gi;

    if (agent.indexOf("msie") > 0) {
      return agent.match(regStr_ie);
    }

    if (agent.indexOf("edge") > 0) {
      return agent.match(regStr_edge);
    }

    if (agent.indexOf("firefox") > 0) {
      return agent.match(regStr_ff);
    }

    if (agent.indexOf("chrome") > 0) {
      return agent.match(regStr_chrome);
    }

    if (agent.indexOf("safari") > 0 && agent.indexOf("chrome") < 0) {
      var bro = agent.match(regStr_saf)[0].split('/')[0];
      var ver = agent.match(regStr_safVersion)[0].split('/')[1];
      var user = bro + '/' + ver;
      return [user];
    }
  },
  checkBrowser: function checkBrowser(context) {
    var info = this.getBrowserInfo()[0].split('/');
    var browser = info[0];
    var version = info[1];
    sessionStorage.setItem('Browser', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(info));
    if (browser === 'chrome') {
      var flag = this.compareBrowser(version, '61.0');
      if (!flag) {
        context.$router.push('/error');
      }
    } else if (browser === 'edge') {
      var _flag = this.compareBrowser(version, '16.0');
      if (!_flag) {
        context.$router.push('/error');
      }
    } else if (browser === 'firefox') {
      var _flag2 = this.compareBrowser(version, '55.0');
      if (!_flag2) {
        context.$router.push('/error');
      }
    } else if (browser === 'safari') {
      var _flag3 = this.compareBrowser(version, '8.08');
      if (!_flag3) {
        context.$router.push('/error');
      }
    } else {
      context.$router.push('/error');
    }
  },
  compareBrowser: function compareBrowser(ver1, ver2) {
    var version1pre = parseFloat(ver1);
    var version2pre = parseFloat(ver2);
    var version1next = ver1.replace(version1pre + ".", "");
    var version2next = ver2.replace(version2pre + ".", "");
    if (version1pre > version2pre) {
      return true;
    } else if (version1pre < version2pre) {
      return false;
    } else {
      if (version1next >= version2next) {
        return true;
      } else {
        return false;
      }
    }
  },
  detectOS: function detectOS() {
    var sUserAgent = navigator.userAgent;
    var isWin = navigator.platform == "Win32" || navigator.platform == "Windows";
    var isMac = navigator.platform == "Mac68K" || navigator.platform == "MacPPC" || navigator.platform == "Macintosh" || navigator.platform == "MacIntel";
    if (isMac) return "Mac";
    if (isWin) {
      var isWin2K = sUserAgent.indexOf("Windows NT 5.0") > -1 || sUserAgent.indexOf("Windows 2000") > -1;
      if (isWin2K) return "Win2000";
      var isWinXP = sUserAgent.indexOf("Windows NT 5.1") > -1 || sUserAgent.indexOf("Windows XP") > -1;
      if (isWinXP) return "WinXP";
      var isWin2003 = sUserAgent.indexOf("Windows NT 5.2") > -1 || sUserAgent.indexOf("Windows 2003") > -1;
      if (isWin2003) return "Win2003";
      var isWinVista = sUserAgent.indexOf("Windows NT 6.0") > -1 || sUserAgent.indexOf("Windows Vista") > -1;
      if (isWinVista) return "WinVista";
      var isWin7 = sUserAgent.indexOf("Windows NT 6.1") > -1 || sUserAgent.indexOf("Windows 7") > -1;
      if (isWin7) return "Windows 7";
      var isWin8 = sUserAgent.indexOf("Windows NT 6.2") > -1 || sUserAgent.indexOf("Windows 8") > -1;
      if (isWin8) return "Windows 8";
      var isWin8_1 = sUserAgent.indexOf("Windows NT 6.3") > -1 || sUserAgent.indexOf("Windows 8.1") > -1;
      if (isWin8_1) return "Windows 8.1";
      var isWin10 = sUserAgent.indexOf("Windows NT 10") > -1 || sUserAgent.indexOf("Windows 10") > -1;
      if (isWin10) return "Windows 10";
    }
    return "other";
  },
  deviceSNFormatV2: function deviceSNFormatV2(device_sn, deviceKind, deviceType) {

    function addPreZero(pdm_sn_hex, num) {
      var pre = '';
      for (var i = 0; i < num; i++) {
        pre += '0';
      }
      return pre + pdm_sn_hex;
    }

    var pdm_sn = parseInt(device_sn);

    if (isNaN(pdm_sn)) {
      return device_sn;
    }
    var sn_val = pdm_sn;
    var trans_device = {
      'TY012': [102],
      'TY015': [103],
      'TY025': [115],
      'TY026': [123, 118],
      'TY027': [103, 119],
      'TG158': [120],
      'TG159': [121],
      'TG160': [150]
    };
    var pump_device = {
      'JN012': [106],
      'JN022': [114],
      'JN026': [125],
      'KR201': [126, 127],
      'KR202': [130, 131],
      'KR401': [135],
      'KR8201': [128],
      'KR402': [145, 146]
    };
    var pdm_device = {
      'all': [100, 101, 108, 109]
    };
    var sn_pre_list = [];
    if ('TRANS' == deviceKind) {
      sn_pre_list = trans_device[deviceType] || [];

      for (var p in trans_device) {
        sn_pre_list = sn_pre_list.concat(trans_device[p]);
      }
    } else if ('PUMP' == deviceKind) {
      sn_pre_list = pump_device[deviceType] || [];

      for (var _p in pump_device) {
        sn_pre_list = sn_pre_list.concat(pump_device[_p]);
      }
    } else if ('PDM' == deviceKind) {
      sn_pre_list = pdm_device[deviceType] || [];

      for (var _p2 in pdm_device) {
        sn_pre_list = sn_pre_list.concat(pdm_device[_p2]);
      }
    } else {
      for (var _p3 in trans_device) {
        sn_pre_list = sn_pre_list.concat(trans_device[_p3]);
      }
      for (var _p4 in pump_device) {
        sn_pre_list = sn_pre_list.concat(pump_device[_p4]);
      }
      for (var _p5 in pdm_device) {
        sn_pre_list = sn_pre_list.concat(pdm_device[_p5]);
      }
    }

    var sn_pre = parseInt(sn_val / 1000000);
    var is_decimal = false;
    if (sn_pre_list.indexOf(sn_pre) >= 0) {
      is_decimal = true;
    }

    if (is_decimal) {
      return pdm_sn;
    } else {
      var pdm_sn_hex = pdm_sn.toString(16);
      var lackZeroDigit = 8 - pdm_sn_hex.length;
      pdm_sn_hex = addPreZero(pdm_sn_hex, lackZeroDigit);

      return pdm_sn_hex.toUpperCase();
    }
  },
  deviceSNFormat: function deviceSNFormat(device_sn) {

    function addPreZero(pdm_sn_hex, num) {
      var pre = '';
      for (var i = 0; i < num; i++) {
        pre += '0';
      }
      return pre + pdm_sn_hex;
    }

    var pdm_sn = parseInt(device_sn);
    if (isNaN(pdm_sn)) {
      return device_sn;
    }

    if (100000000 <= pdm_sn && pdm_sn <= 103999999 || 106000000 <= pdm_sn && pdm_sn <= 108999999 || 109000000 <= pdm_sn && pdm_sn <= 109999999 || 112000000 <= pdm_sn && pdm_sn <= 112999999) {
      return pdm_sn;
    } else {
      var pdm_sn_hex = pdm_sn.toString(16);
      var lackZeroDigit = 8 - pdm_sn_hex.length;
      pdm_sn_hex = addPreZero(pdm_sn_hex, lackZeroDigit);
      return pdm_sn_hex.toUpperCase();
    }
  }
});

/***/ }),

/***/ 686:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 687:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 688:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 689:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 690:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 691:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 692:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 693:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 697:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/daily_legend.bd9fc01.png";

/***/ }),

/***/ 698:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 699:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 700:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 701:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAASCAYAAACNdSR1AAAAAXNSR0IArs4c6QAAAXdJREFUKBWFkT1LA0EQht+NFyWihelUbBTEwkIIMYWFoiiCjYofoIIgxKCNhQiSKrGwSJUqhZ2l+B/sbLTWHxALmxARxezuJRln93IhHycOzM7czvO+c8cBAUGpQpZOb2Y6R6HOCzoqjEO5l6jIfOesC4b6yUCrXig5Twe51VZBG0y715MM7kO7sKnc7J8wKjoNpUIsYJhT6VnayC77gqYzbaaHoeWe56oZNsmCijzvgvGpkgyEPdcGrKxghRYvJozAOtNCxoFUKetmAd/ZVsEbTwwszEGJ1BaI7k0fGAJlREZGHTuU+pAlgVzjMgpdXBMUO+6H/C4xG7G82RWoE7cOvj6mUatHrINgkpg01YTfezXuQFejqFW9Ydfpr+EqxBDD9RfU+I/9G+LV7qPoUpFXjrWtNeIWY+6vPHhgboc/6q59yrD/zsA7+ganLGxMKBzPs+Cs6WYurbMow8G2kE8PTdgKEFsH6kmmEvxc4nwEejICz29m/gt6j6YxZWz1KwAAAABJRU5ErkJggg=="

/***/ }),

/***/ 702:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAASCAYAAACNdSR1AAAAAXNSR0IArs4c6QAAAdRJREFUKBVtkk9IVFEUxr/7TCZcJChuXFkZgUiQbVwozVIXMhSMEwglCP6DdCGBIMqTKGEUCsFFUSsjRA2GWojVIhQ3QYjMooSC2Ua2MJzwvXvuPZ558uY54zx43Hu+73e/d9+5Fyh7ePBFLfc9WymTg9I5Jx7+c0GU4nvzA+WeOitwKn0V1n4H23dg3EZN9TW1/CgfMqXJvv9YUj+irv4+jM0j742HYGEswpxwW0B+r0DT6uWQhqVZ+DTBfe6lcEERhqYpSf2g3s/sBmYb3sLoP/irR0tg7ppsgta9kjYXGsp1LcgswOpx7l6MFfTTZI8egvSO2kx/DeFgvNC4DG2A41wqgDnuXpTP9cOapRJQCrUx5oH1a/GGAxje7x75McL1lkw5fFo7r+D77RwfbXZk1V3pQCboQAVafXmegzHf8J/uOLLXdhj/UwUukgx9LnACm3oQH0ROhZnVB9KpOkdSs/K2VkAiiUwrDGUdOYxt6fEDTiarIjea8c1kA7TfI6e5Jcmxp9K6RuzRE2YuvVi3BmtwJK0jyqr9tfXA5MuJTrBZhVL7kvkGjvoFgxtQPCK1h1hVQv3I5IpJ3NzdIPKMXM0OOdcrAmWhsIlqpNXPDa+wsRNoh9OHaWwsBgAAAABJRU5ErkJggg=="

/***/ }),

/***/ 703:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAACCAYAAACpDacGAAAAAXNSR0IArs4c6QAAABtJREFUCB1j/M/AYM/AwOAAxLQGB5hobQOy+QCWbgJCJpGLywAAAABJRU5ErkJggg=="

/***/ }),

/***/ 704:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAPCAYAAADzun+cAAAAAXNSR0IArs4c6QAAAC5JREFUOBFjXPpixX+GAQBMA2An2MpRi+kW8qNBPRrUNAuB0cRFs6BFN3jkBTUAIAwDUuAPn7QAAAAASUVORK5CYII="

/***/ }),

/***/ 705:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAKCAYAAABi8KSDAAAAAXNSR0IArs4c6QAAACFJREFUGBljZFjEsYrh//9QBkKAkSmMiZAaZPlRxfQJDQD4yQQU6WQ0pQAAAABJRU5ErkJggg=="

/***/ }),

/***/ 706:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAPCAYAAADzun+cAAAAAXNSR0IArs4c6QAAAC5JREFUOBFjXLJkyX+GAQBMA2An2MpRi+kW8qNBPRrUNAuB0cRFs6BFN3jkBTUAGvQDCcqlF08AAAAASUVORK5CYII="

/***/ }),

/***/ 707:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAARCAYAAADdRIy+AAAAAXNSR0IArs4c6QAAAaBJREFUOBGllLtOgkEQhZdLCD/hVhAqpNEWCQmxAqSHkhfAzmdAW3gBHwBqiL2+AgmJQkNPBQkmIkhAOJ75ucgKiuAmG2Znz/lm8u8EpfYsKGXnxnLb98iVdZ9AWa3XKpF4M7fE/1nsyg+n8xXNJswtMXNHM+Fy3SGfH2G1JGbuKCA7OYVhvKPbBRoNoNWCGRvGiHdnB0Ph9T6gWJxixAbdbiAQAGYzoFSa8u7xICA7uEQwOMR4DPR6qxcGplOYObmj5k9QCi3weNqo1RZfbjJZAF2u1ZcEqlWwy7Zo90IpukIsNvhyM/L5gHBYS5kaan8FEubmK76gXtfN0SiQSuk50YiWnk2oPtiGcaMyGYeKxzc1ikOtVDKp50STzTqUYdzqF8sTK51wiEfodPRO5NTvAwP9K5gi0YqH3i0oH+IehQJfYMfK5YB0GpjPty/FQ68GZIUL+P1DDIfbBslEIkAotBib7wrxiJeMNZQVmqhUdpRfumUefyomknJ5TsazAC0kn/P3SdlsH+sKxwSzmfy1Rc3BJNTBg/7ih0PnhE0+AfsI0E6dPreFAAAAAElFTkSuQmCC"

/***/ }),

/***/ 708:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(686)
}
var Component = __webpack_require__(46)(
  /* script */
  __webpack_require__(333),
  /* template */
  __webpack_require__(715),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-011893fc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 709:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(691)
}
var Component = __webpack_require__(46)(
  /* script */
  __webpack_require__(334),
  /* template */
  __webpack_require__(721),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c541dbca",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 710:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(693)
}
var Component = __webpack_require__(46)(
  /* script */
  __webpack_require__(335),
  /* template */
  __webpack_require__(723),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d519f0b4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 711:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(692)
}
var Component = __webpack_require__(46)(
  /* script */
  __webpack_require__(337),
  /* template */
  __webpack_require__(722),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ceb3c8f0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 712:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(688)
}
var Component = __webpack_require__(46)(
  /* script */
  __webpack_require__(338),
  /* template */
  __webpack_require__(717),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-365b544e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 713:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(687)
}
var Component = __webpack_require__(46)(
  /* script */
  __webpack_require__(339),
  /* template */
  __webpack_require__(716),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1fb5f008",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 714:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(689)
}
var Component = __webpack_require__(46)(
  /* script */
  __webpack_require__(340),
  /* template */
  __webpack_require__(718),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-391a59e8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 715:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "container",
    attrs: {
      "element-loading-text": "加载中"
    }
  }, [_c('div', {
    staticClass: "chart-container",
    attrs: {
      "id": "chart-container"
    }
  }, [_c('div', {
    staticClass: "noprint",
    on: {
      "click": _vm.printPdf
    }
  }, [_vm._v("打印")]), _vm._v(" "), _c('div', {
    staticClass: "noprint",
    on: {
      "click": _vm.routeBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "printMe"
    }
  }, [(_vm.pageOneOpen) ? _c('div', {
    staticClass: "page page1"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('p', [_vm._v(_vm._s(_vm.org_name))]), _vm._v(" "), _c('p', [_vm._v("持续葡萄糖监测（CGM）综合报表")])]), _vm._v(" "), _c('div', {
    staticClass: "table-head"
  }, [_c('table', [_c('tr', [_c('td', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("姓名：" + _vm._s(_vm.patient_info.Name) + " ")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "25%"
    }
  }, [_vm._v("性别：" + _vm._s(_vm.patient_info.Sex))]), _vm._v(" "), _c('td', [_vm._v("年龄：" + _vm._s(_vm.patient_info.Age))]), _vm._v(" "), _c('td', [_vm._v("手机号：" + _vm._s(_vm.patient_info.Mobile))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("科室：" + _vm._s(_vm.patient_info.Dept))]), _vm._v(" "), _c('td', [_vm._v("住院号/门诊号：" + _vm._s(_vm.patient_info.AdmitNo) + " ")]), _vm._v(" "), _c('td', [_vm._v("床号:" + _vm._s(_vm.patient_info.bed))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("监测周期：" + _vm._s(_vm.time_range) + " ")]), _vm._v(" "), _c('td', [_vm._v("临床诊断：" + _vm._s(_vm.patient_info.Diag))]), _vm._v(" "), _c('td', [_vm._v("报告编号：" + _vm._s(_vm.reportNum))])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.startRender) ? _c('div', {
    staticClass: "content"
  }, [_c('table', [_c('tr', [_c('td', {
    attrs: {
      "width": "25%"
    }
  }, [_vm._v("项目")]), _vm._v(" "), _vm._l((_vm.date_list), function(item) {
    return _c('td', {
      key: item,
      attrs: {
        "width": "5%"
      }
    }, [_vm._v(_vm._s(item))])
  })], 2), _vm._v(" "), _vm._l((_vm.statistics), function(row) {
    return _c('tr', {
      key: row,
      staticClass: "stat_res"
    }, _vm._l((row), function(col) {
      return _c('td', {
        key: col,
        domProps: {
          "innerHTML": _vm._s(col)
        }
      })
    }))
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.startRender) ? _c('div', {
    staticClass: "text-wrap"
  }, [_c('p', [_vm._v("CGM提示：共测定" + _vm._s(_vm.total_stat['num'][0]) + "个血糖值，平均值为" + _vm._s(_vm.total_stat['avg'][0]) + "mmol/L，\n            标准差为" + _vm._s(_vm.total_stat['sd'][0]) + "mmol/L，变异系数为" + _vm._s(_vm.total_stat['cv'][0]) + "，\n            最高值和最低值分别为" + _vm._s(_vm.total_stat['max'][0]) + "mmol/L和" + _vm._s(_vm.total_stat['min'][0]) + "mmol/L。")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.target_low) + "-" + _vm._s(_vm.target_high) + "mmol/L (TIR)的时长和百分比为" + _vm._s(_vm.total_stat['bt_3d9_10'][0]) + "。")]), _vm._v(" "), _c('p', [_vm._v("≥7.8mmol/L、≥" + _vm._s(_vm.target_high) + "mmol/L和≥13.9mmol/L的时长和百分比分别为\n            " + _vm._s(_vm.total_stat['ge_7d8'][0]) + "，" + _vm._s(_vm.total_stat['ge_10'][0]) + "，" + _vm._s(_vm.total_stat['ge_13d9'][0]) + "。")]), _vm._v(" "), _c('p', [_vm._v("≤" + _vm._s(_vm.target_low) + "mmol/L、≤2.8mmol/L的时长和百分比分别为" + _vm._s(_vm.total_stat['le_3d9'][0]) + "，" + _vm._s(_vm.total_stat['le_2d8'][0]) + "。\n          ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.pageOneOpen) ? _c('div', {
    staticClass: "footer"
  }, [_c('hr'), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.pageTwoOpen) ? _c('div', {
    staticClass: "page agp-report",
    staticStyle: {
      "page-break-before": "always"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_c('p', [_vm._v(_vm._s(_vm.org_name))]), _vm._v(" "), _c('p', [_vm._v("持续葡萄糖监测（CGM）AGP图表")])]), _vm._v(" "), _c('div', {
    staticClass: "table-head"
  }, [_c('table', [_c('tr', [_c('td', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("姓名：" + _vm._s(_vm.patient_info.Name) + " ")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "25%"
    }
  }, [_vm._v("性别：" + _vm._s(_vm.patient_info.Sex))]), _vm._v(" "), _c('td', [_vm._v("年龄：" + _vm._s(_vm.patient_info.Age))]), _vm._v(" "), _c('td', [_vm._v("手机号：" + _vm._s(_vm.patient_info.Mobile))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("科室：" + _vm._s(_vm.patient_info.Dept))]), _vm._v(" "), _c('td', [_vm._v("住院号/门诊号：" + _vm._s(_vm.patient_info.AdmitNo) + " ")]), _vm._v(" "), _c('td', [_vm._v("床号:" + _vm._s(_vm.patient_info.bed))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("监测周期：" + _vm._s(_vm.time_range) + " ")]), _vm._v(" "), _c('td', [_vm._v("临床诊断：" + _vm._s(_vm.patient_info.Diag))]), _vm._v(" "), _c('td', [_vm._v("报告编号：" + _vm._s(_vm.reportNum))])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row1"
  }, [_c('div', {
    staticClass: "col1"
  }, [_c('p', [_vm._v("葡萄糖统计")]), _vm._v(" "), _c('table', [_c('tr', [_c('td', [_vm._v("CGM使用时间占比"), _c('br'), _vm._v(_vm._s(_vm.AGPStat.cgmUse) + "%")]), _vm._v(" "), _c('td', [_vm._v("平均值±标准差"), _c('br'), _vm._v("MG±SD"), _c('br'), _vm._v(_vm._s(_vm.AGPStat.avgSD) + " mmol/L")]), _vm._v(" "), _c('td', [_vm._v("葡萄糖管理指标"), _c('br'), _vm._v("（GMI）"), _c('br'), _vm._v(_vm._s(_vm.AGPStat.hba1c))]), _vm._v(" "), _c('td', [_vm._v("变异系数"), _c('br'), _vm._v("CV"), _c('br'), _vm._v(_vm._s(_vm.AGPStat.cv))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("平均波动幅度"), _c('br'), _vm._v("MAGE"), _c('br'), _vm._v(_vm._s(_vm.AGPStat.avgMage))]), _vm._v(" "), _c('td', [_vm._v("平均日间差异"), _c('br'), _vm._v("(MODD)"), _c('br'), _vm._v(_vm._s(_vm.AGPStat.avgModd))]), _vm._v(" "), _c('td', [_vm._v("高血糖事件次数"), _c('br'), _vm._v("（每天）"), _c('br'), _vm._v(_vm._s(_vm.AGPStat.highSGNum))]), _vm._v(" "), _c('td', [_vm._v("低血糖事件次数"), _c('br'), _vm._v("（每天）"), _c('br'), _vm._v(_vm._s(_vm.AGPStat.lowSGNum))])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col3"
  }, [_c('div', {
    staticClass: "target",
    attrs: {
      "id": "dist_very_high_label"
    }
  }, [_c('p', [_vm._v("2级高血糖 : >" + _vm._s(_vm.target_veryhigh) + " mmol/L (" + _vm._s(_vm.target_over_13d9) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "target",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "id": "dist_high_label"
    }
  }, [_c('p', [_vm._v("1级高血糖 : " + _vm._s((_vm.target_high + 0.1).toFixed(1)) + "-" + _vm._s(_vm.target_veryhigh) + " mmol/L (" + _vm._s(_vm.target_ge_10) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "target",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "id": "dist_target_label"
    }
  }, [_c('p', [_vm._v("目标范围 : " + _vm._s(_vm.target_low) + "-" + _vm._s(_vm.target_high) + " mmol/L (" + _vm._s(_vm.target_bt_3d9_10) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "target",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "id": "dist_low_label"
    }
  }, [_c('p', [_vm._v("1级低血糖 :" + _vm._s(_vm.target_verylow) + "-" + _vm._s((_vm.target_low - 0.1).toFixed(1)) + " mmol/L (" + _vm._s(_vm.target_le_3d9) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "target",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "id": "dist_very_low_label"
    }
  }, [_c('p', [_vm._v("2级低血糖 : <" + _vm._s(_vm.target_verylow) + " mmol/L (" + _vm._s(_vm.target_low_3) + ")")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row2"
  }, [(_vm.dayNum > 2) ? _c('p', [_vm._v("AGP图谱")]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "agp-chart"
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.pageTwoOpen) ? _c('div', {
    staticClass: "footer"
  }, [_c('hr'), _vm._v(" "), _vm._m(2)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.chartIndexStart), function(pos, pageIndex) {
    return (_vm.pageThrOpen) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (pageIndex < _vm.totalPage),
        expression: "pageIndex < totalPage"
      }],
      key: pos,
      staticClass: "page",
      staticStyle: {
        "page-break-before": "always"
      }
    }, [_c('div', {
      staticClass: "title"
    }, [_c('p', [_vm._v(_vm._s(_vm.org_name))]), _vm._v(" "), _c('p', [_vm._v("持续葡萄糖监测（CGM）每日报告")])]), _vm._v(" "), _c('div', {
      staticClass: "table-head"
    }, [_c('table', [_c('tr', [_c('td', {
      attrs: {
        "width": "20%"
      }
    }, [_vm._v("姓名：" + _vm._s(_vm.patient_info.Name) + " ")]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "25%"
      }
    }, [_vm._v("性别：" + _vm._s(_vm.patient_info.Sex))]), _vm._v(" "), _c('td', [_vm._v("年龄：" + _vm._s(_vm.patient_info.Age))]), _vm._v(" "), _c('td', [_vm._v("手机号：" + _vm._s(_vm.patient_info.Mobile))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("科室：" + _vm._s(_vm.patient_info.Dept))]), _vm._v(" "), _c('td', [_vm._v("住院号/门诊号：" + _vm._s(_vm.patient_info.AdmitNo) + " ")]), _vm._v(" "), _c('td', [_vm._v("床号:" + _vm._s(_vm.patient_info.bed))])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("监测周期：" + _vm._s(_vm.time_range) + " ")]), _vm._v(" "), _c('td', [_vm._v("临床诊断：" + _vm._s(_vm.patient_info.Diag))]), _vm._v(" "), _c('td', [_vm._v("报告编号：" + _vm._s(_vm.reportNum))])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
      staticClass: "chart-wrap"
    }, [_vm._l((_vm.ds_title.slice(pos, pos + 7)), function(item, index) {
      return _c('div', {
        key: item.title
      }, [_c('p', [_vm._v(_vm._s(item.title) + "   平均值：" + _vm._s(item.avg) + " mmol/L TIR：" + _vm._s(item.TIR))]), _vm._v(" "), _c('div', {
        staticClass: "chart",
        attrs: {
          "id": 'chart' + (index + pos)
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "event-list",
        attrs: {
          "id": 'event' + (index + pos)
        }
      }, [_c('p', {
        staticClass: "event-title"
      }, [_vm._v("事件：")]), _vm._v(" "), _vm._l((_vm.event['carb'][index]), function(data, carbIndex) {
        return _c('el-tooltip', {
          key: carbIndex + Math.random(),
          attrs: {
            "effect": "dark",
            "content": _vm.getCarb(data),
            "placement": "top-start"
          }
        }, [_c('img', {
          staticClass: "carb img",
          attrs: {
            "src": __webpack_require__(698)
          }
        })])
      }), _vm._v(" "), _vm._l((_vm.event['exercise'][index]), function(data, exeriseIndex) {
        return _c('el-tooltip', {
          key: exeriseIndex + Math.random(),
          attrs: {
            "effect": "dark",
            "content": _vm.getExerciseTooltip(data),
            "placement": "top-start"
          }
        }, [_c('img', {
          staticClass: "exe img",
          attrs: {
            "src": __webpack_require__(699)
          }
        })])
      }), _vm._v(" "), _vm._l((_vm.event['ins'][index]), function(data, insIndex) {
        return _c('el-tooltip', {
          key: insIndex + Math.random(),
          attrs: {
            "effect": "dark",
            "content": _vm.getInstip(data),
            "placement": "top-start"
          }
        }, [_c('img', {
          staticClass: "ins img",
          attrs: {
            "src": __webpack_require__(700)
          }
        })])
      })], 2)])
    }), _vm._v(" "), _c('div', [(false) ? _c('div', {
      staticClass: "xx_legend-wrap"
    }, [_vm._m(3, true), _vm._v(" "), _vm._m(4, true), _vm._v(" "), _vm._m(5, true), _vm._v(" "), _vm._m(6, true), _vm._v(" "), _vm._m(7, true), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both",
        "margin-left": "0",
        "float": "none"
      }
    }), _vm._v(" "), _vm._m(8, true), _vm._v(" "), _vm._m(9, true), _vm._v(" "), _vm._m(10, true), _vm._v(" "), _vm._m(11, true)]) : _vm._e(), _vm._v(" "), _vm._m(12, true)])], 2)]) : _vm._e()
  }), _vm._v(" "), (_vm.pageThrOpen) ? _c('div', {
    staticClass: "footer"
  }, [_c('hr'), _vm._v(" "), _vm._m(13)]) : _vm._e()], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('tr', [_c('td', {
    attrs: {
      "width": "45%"
    }
  }, [_vm._v("报告者：")]), _vm._v(" "), _c('td', [_vm._v("审核者：")]), _vm._v(" "), _c('td', {
    staticClass: "right"
  }, [_vm._v("报告日期：")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col2"
  }, [_c('div', {
    staticClass: "veryhigh",
    attrs: {
      "id": "dist_very_high"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "high",
    attrs: {
      "id": "dist_high"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "target",
    attrs: {
      "id": "dist_target"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "low",
    attrs: {
      "id": "dist_low"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "veryLow",
    attrs: {
      "id": "dist_very_low"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('tr', [_c('td', {
    attrs: {
      "width": "45%"
    }
  }, [_vm._v("报告者：")]), _vm._v(" "), _c('td', [_vm._v("审核者：")]), _vm._v(" "), _c('td', {
    staticClass: "right"
  }, [_vm._v("报告日期：")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(705)
    }
  }), _c('span', [_vm._v("新探头")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(706)
    }
  }), _c('span', [_vm._v("初始化")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(170)
    }
  }), _c('span', [_vm._v("血糖读数")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(703)
    }
  }), _c('span', [_vm._v("低限")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(704)
    }
  }), _c('span', [_vm._v("目标范围")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-left": "0"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(701)
    }
  }), _c('span', [_vm._v("校准")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(702)
    }
  }), _c('span', [_vm._v("指间血糖")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(170)
    }
  }), _c('span', [_vm._v("餐食")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(170)
    }
  }), _c('span', [_vm._v("运动")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "legend-wrap"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(697)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('tr', [_c('td', {
    attrs: {
      "width": "45%"
    }
  }, [_vm._v("报告者：")]), _vm._v(" "), _c('td', [_vm._v("审核者：")]), _vm._v(" "), _c('td', {
    staticClass: "right"
  }, [_vm._v("报告日期：")])])])
}]}

/***/ }),

/***/ 716:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('span', {
    staticClass: "title2"
  }, [_vm._v("请上传机器码文件TXT")]), _vm._v(" "), _c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "action": "",
      "on-change": _vm.handleChange,
      "auto-upload": false,
      "limit": 1
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("上传文件")])], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "title"
  }, [_vm._v("UploadMachine")])])
}]}

/***/ }),

/***/ 717:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "main"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card",
    attrs: {
      "id": "table_card"
    }
  }, [_c('div', {
    staticClass: "row1"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "text"
  }, [_vm._v("科室")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.typeSelect),
      expression: "typeSelect"
    }],
    staticClass: "sel",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.typeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "used"
    }
  }, [_vm._v("使用中")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "noused"
    }
  }, [_vm._v("未使用")])]), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchWord),
      expression: "searchWord"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入姓名或手机号"
    },
    domProps: {
      "value": (_vm.searchWord)
    },
    on: {
      "keyup": _vm.startSearch,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchWord = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/report/icon_search.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "table_wrap"
  }, [_c('table', [_c('tr', {
    staticClass: "header"
  }, _vm._l((_vm.headerList), function(item, index) {
    return _c('td', {
      attrs: {
        "width": "15%"
      }
    }, [_vm._v("\n              " + _vm._s(item.label) + "\n            ")])
  })), _vm._v(" "), _vm._l((_vm.tablist), function(item, index) {
    return _c('tr', {
      key: item.name,
      staticClass: "content",
      class: {
        'gray': !(index % 2)
      }
    }, [_c('td', {
      domProps: {
        "innerHTML": _vm._s(item.name)
      }
    }), _vm._v(" "), (!_vm.flagTypeFollow) ? _c('td', [_vm._v(_vm._s(item.dept))]) : _vm._e(), _vm._v(" "), _c('td', {
      domProps: {
        "innerHTML": _vm._s(item.username)
      }
    }), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.glucose))]), _vm._v(" "), (!_vm.flagTypeFollow) ? _c('td', [_vm._v(_vm._s(item.cureNo))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "op",
      on: {
        "click": function($event) {
          _vm.viewReportPrepare(index)
        }
      }
    }, [_vm._v("查看")])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "page_row"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.prevPage()
      }
    }
  }, [_vm._v("上一页\n        ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.pageInfo.curIndex + 1) + "/" + _vm._s(_vm.pageInfo.pageNum))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.nextPage()
      }
    }
  }, [_vm._v("下一页\n        ")])], 1)])]), _vm._v(" "), _c('ReportFooter')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('p', [_vm._v("患者列表")])])
}]}

/***/ }),

/***/ 718:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('div', [_vm._v(" ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "sep"
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "boxContainer"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticStyle: {
      "height": "1px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "userTypeSelect"
  }, [_vm._v("医院版用户")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "btn_row"
  }, [_c('div', {
    staticClass: "login-btn",
    on: {
      "click": function($event) {
        _vm.onBtnSelect('cgms')
      }
    }
  }, [_c('p', [_vm._v("医院版报表系统")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticStyle: {
      "height": "1px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "userTypeSelect"
  }, [_vm._v("门诊版用户")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "btn_row"
  }, [_c('div', {
    staticClass: "login-btn",
    on: {
      "click": function($event) {
        _vm.onBtnSelect('report')
      }
    }
  }, [_c('p', [_vm._v("门诊版报表系统")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": _vm.contactURL
    }
  }, [_vm._v(" 联系我们 ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.privacyURL
    }
  }, [_vm._v("| 隐私政策 ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.termsOfUseURL
    }
  }, [_vm._v("| 服务协议 | ")]), _vm._v("\n\n      ©2021 上海移宇科技有限公司 版权所有"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://beian.miit.gov.cn/"
    }
  }, [_vm._v("\n        沪ICP备08013753号-3\n      ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/beian.png"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"
    }
  }, [_vm._v("\n        沪公网安备 31011502014155号\n      ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-wrap"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": "static/report/logo_zyw.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('p', [_vm._v("移宇在线报表系统")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "userType"
  }, [_c('p', [_vm._v("请选择用户类型")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('p', [_vm._v("我使用移宇医院版App管理患者")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('p', [_vm._v("我使用移宇门诊版App管理患者")])])
}]}

/***/ }),

/***/ 719:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer_wrap"
  }, [_c('div', {
    staticClass: "footer"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": _vm.contactURL
    }
  }, [_vm._v(" 联系我们 ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.privacyURL
    }
  }, [_vm._v("|  隐私政策 ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.termsOfUseURL
    }
  }, [_vm._v("|  服务协议 | ")]), _vm._v("\n\n        ©2021 上海移宇科技有限公司 版权所有"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://beian.miit.gov.cn/"
    }
  }, [_vm._v(" 沪ICP备08013753号-3  ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/beian.png"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"
    }
  }, [_vm._v(" 沪公网安备 31011502014155号 ")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "50px"
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 720:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    key: _vm.key,
    attrs: {
      "name": "header"
    }
  }), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "footer"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 721:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "container"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('p', {
    on: {
      "click": _vm.backToList
    }
  }, [_vm._v("< 返回列表")])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    attrs: {
      "id": "table_card"
    }
  }, [_c('div', {
    staticClass: "content_wrap"
  }, [_c('div', {
    staticClass: "row1"
  }, [_c('table', {
    staticClass: "info_tbl"
  }, [_c('tr', {
    staticClass: "head"
  }, _vm._l((_vm.headList), function(item, index) {
    return _c('td', [_vm._v("\n                " + _vm._s(item.label) + "\n              ")])
  })), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.patient_info.Name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.patient_info.Mobile))]), _vm._v(" "), (!_vm.flagTypeFollow) ? _c('td', [_vm._v(_vm._s(_vm.patient_info.AdmitNo))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.patient_info.Age))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.patient_info.Sex))]), _vm._v(" "), (!_vm.flagTypeFollow) ? _c('td', [_vm._v(_vm._s(_vm.patient_info.Dept))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row3"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("日期范围：")]), _vm._v(" "), _c('span', {
    staticClass: "st"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "clearable": _vm.clearDateEnable,
      "picker-options": _vm.startDatePickerOptions
    },
    model: {
      value: (_vm.startDate),
      callback: function($$v) {
        _vm.startDate = $$v
      },
      expression: "startDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "hour-select"
  }, [_c('el-select', {
    key: _vm.startHourSelectKey,
    on: {
      "change": function($event) {
        _vm.setEndHourSelectOptions()
      }
    },
    model: {
      value: (_vm.startHour),
      callback: function($$v) {
        _vm.startHour = $$v
      },
      expression: "startHour"
    }
  }, _vm._l((_vm.startHourSelectOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "disabled": item.disable
      }
    })
  })), _vm._v("\n            时\n          ")], 1), _vm._v(" "), _c('span', [_vm._v("至")]), _vm._v(" "), _c('span', [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "clearable": _vm.clearDateEnable,
      "picker-options": _vm.endDatePickerOptions
    },
    on: {
      "focus": _vm.change
    },
    model: {
      value: (_vm.endDate),
      callback: function($$v) {
        _vm.endDate = $$v
      },
      expression: "endDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "hour-select"
  }, [_c('el-select', {
    key: _vm.endHourSelectKey,
    on: {
      "change": function($event) {
        _vm.setStartHourSelectOptions()
      }
    },
    model: {
      value: (_vm.endHour),
      callback: function($$v) {
        _vm.endHour = $$v
      },
      expression: "endHour"
    }
  }, _vm._l((_vm.endHourSelectOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "disabled": item.disable
      }
    })
  })), _vm._v("\n            时\n          ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "range"
  }, [_c('span', [_vm._v("血糖低限：")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "number",
      "min": "3.1",
      "max": "13.8",
      "step": "0.1",
      "size": "small"
    },
    on: {
      "input": function($event) {
        _vm.debounce(_vm.checkInputValue, 1000, [_vm.low_glucose, 'low_glucose'])
      },
      "blur": function($event) {
        _vm.checkInputValue(_vm.low_glucose, 'low_glucose', true)
      }
    },
    model: {
      value: (_vm.low_glucose),
      callback: function($$v) {
        _vm.low_glucose = $$v
      },
      expression: "low_glucose"
    }
  }), _vm._v(" "), _c('span', [_vm._v("mmol/L")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("血糖高限：")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "number",
      "min": "3.1",
      "max": "13.8",
      "step": "0.1",
      "size": "small"
    },
    on: {
      "input": function($event) {
        _vm.debounce(_vm.checkInputValue, 1000, [_vm.high_glucose, 'high_glucose'])
      },
      "blur": function($event) {
        _vm.checkInputValue(_vm.high_glucose, 'high_glucose', true)
      }
    },
    model: {
      value: (_vm.high_glucose),
      callback: function($$v) {
        _vm.high_glucose = $$v
      },
      expression: "high_glucose"
    }
  }), _vm._v(" "), _c('span', [_vm._v("mmol/L")])], 1), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('div', {
    staticClass: "t2 news"
  }, [_c('span', [_vm._v("血糖监测记录")]), _vm._v(" "), _c('div', [_c('el-checkbox', {
    model: {
      value: (_vm.radio1),
      callback: function($$v) {
        _vm.radio1 = $$v
      },
      expression: "radio1"
    }
  }, [_vm._v("综合报告")]), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.radio2),
      callback: function($$v) {
        _vm.radio2 = $$v
      },
      expression: "radio2"
    }
  }, [_vm._v("AGP图谱")]), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.radio3),
      callback: function($$v) {
        _vm.radio3 = $$v
      },
      expression: "radio3"
    }
  }, [_vm._v("每日详情")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "id": "export_pdf",
      "type": "primary",
      "disabled": _vm.exportBtnEnable
    },
    on: {
      "click": _vm.exportPDF
    }
  }, [_vm._v("导出报告")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "sep"
  }), _vm._v(" "), (_vm.hasData) ? _c('div', [_c('div', {
    staticClass: "device_wrap"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.data_map), function(item, index) {
    return _c('div', {
      key: item,
      staticClass: "table-row"
    }, [_c('div', {
      class: [index == _vm.selectIndex ? 'selecttableColoum' : 'tableColoum'],
      on: {
        "click": function($event) {
          _vm.changeStartDate(item[1], item[2], index)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.pageInfo.curIndex * _vm.perPage + index + 1))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item[0]))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item[1]))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item[2]))])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "page_row"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.prevPage()
      }
    }
  }, [_vm._v("上一页\n              ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.pageInfo.curIndex + 1) + "/" + _vm._s(_vm.pageInfo.pageNum))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.nextPage()
      }
    }
  }, [_vm._v("下一页\n              ")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.noData) ? _c('div', [_vm._m(1)]) : _vm._e()])])])]), _vm._v(" "), _c('ReportFooter')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-row table-head"
  }, [_c('span', [_vm._v("序号")]), _vm._v(" "), _c('span', [_vm._v("SN")]), _vm._v(" "), _c('span', [_vm._v("开始时间")]), _vm._v(" "), _c('span', [_vm._v("结束时间")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-row table-head"
  }, [_c('span', [_vm._v("无数据")])])
}]}

/***/ }),

/***/ 722:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "main"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "icon_out_wrap fr",
    on: {
      "click": _vm.logout
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/report/icon_out.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fr username"
  }, [_vm._v(_vm._s(_vm.username))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-wrap fl"
  }, [_c('img', {
    attrs: {
      "src": "/static/report/logo_zyw.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title fl"
  }, [_c('p', [_vm._v("移宇在线报表系统")])])
}]}

/***/ }),

/***/ 723:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('div', [_vm._v(" ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "sep"
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticStyle: {
      "height": "1px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    attrs: {
      "type": "text",
      "placeholder": "账号"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "alert",
    class: _vm.flag ? 'dis' : ''
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(707),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("检测到您已离开该医院所在城市，为了医院数据安全，请确保您的设备处于所登录医院的所在地。")])]), _vm._v(" "), _c('el-button', {
    staticClass: "login-btn",
    on: {
      "click": _vm.onBtnLogin
    }
  }, [_vm._v("登录 ")])], 1)]), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": _vm.contactURL
    }
  }, [_vm._v(" 联系我们 ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.privacyURL
    }
  }, [_vm._v("|  隐私政策 ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.termsOfUseURL
    }
  }, [_vm._v("|  服务协议 | ")]), _vm._v("\n\n        ©2021 上海移宇科技有限公司 版权所有"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://beian.miit.gov.cn/"
    }
  }, [_vm._v(" 沪ICP备08013753号-3  ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/beian.png"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"
    }
  }, [_vm._v(" 沪公网安备 31011502014155号 ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-wrap"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": "static/report/logo_zyw.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("门诊版")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('p', [_vm._v("移宇在线报表系统")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-wrap"
  }, [_c('img', {
    attrs: {
      "src": "/static/report/icon_user.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-wrap"
  }, [_c('img', {
    attrs: {
      "src": "/static/report/icon_password.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "remember_pwd_row"
  }, [_c('div', {
    staticClass: "fl c1"
  }, [_c('input', {
    attrs: {
      "id": "remember_pwd_check",
      "type": "checkbox"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fl c2"
  }, [_c('span', [_vm._v("记住密码")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "out_link"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "https://cgms.medtrum.cn"
    }
  }, [_vm._v("切换到医院版")])])])
}]}

/***/ }),

/***/ 757:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 758:
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},[341]);


// WEBPACK FOOTER //
// static/js/app.e47df268cb04a46f5dc5.js